webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var colorPalette = {
  baseBlue: '#00224c',
  baseGreen: '#009d00',
  hexDanger: '#FF0046',
  hexDangerOpa: '#FFF5F5',
  hexWarning: '#FFBC4F',
  hexWarningOpa: '#FFFAF3',
  hexSuccess: '#02D65F',
  hexSuccessOpa: '#CCF7DF',
  rgbError: 'rgba(255, 0, 70, 100)',
  rgbErrorOpa: 'rgba(255, 0, 70, 0.5)',
  rgbWarning: 'rgba(255, 127, 39, 100)',
  rgbWarningOpa: 'rgba(255, 127, 39, 0.5)',
  rgbSuccess: 'rgba(34, 177, 76, 100)',
  rgbSuccessOpa: 'rgba(34, 177, 76, 0.5)',
  TemporaryDepositReceived: '#2196F3',
  TemporaryDepositShipped: '#0E4498',
  TransportEntered: '#EC407A',
  TransportDelivered: '#651FFF',
  WarehouseReceived: '#F69B72',
  WarehouseShipped: '#C631E4',
  WarehouseReturned: '#5292FF',
  Projected: '#5f697a'
};

var dashboardFilterModes = {
  today: 'today',
  week: 'week',
  month: 'month',
  date: 'date'
};

var minimunValues = {
  success: 90,
  warning: 70
};

var defaultChartLabels = {
  day: ['12 am', '1 am', '2 am', '3 am', '4 am', '5 am', '6 am', '7 am', '8 am', '9 am', '10 am', '11 am', '12 pm', '1 pm', '2 pm', '3 pm', '4 pm', '5 pm', '6 pm', '7 pm', '8 pm', '9 pm', '10 pm', '11 pm'],
  week: ['Lunes', 'Martes', 'Miécoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo']
};

var defaultEriTypes = [{
  code: 'Cyclical',
  name: 'Eri Clíclico'
}, {
  code: 'Location',
  name: 'Eri Ubicaciones'
}, {
  code: 'Unit',
  name: 'Eri Unidades'
}];

var defaultSelectItem = {
  code: 'All',
  name: 'Todos'
};

var tableCSS = {
  table: {
    tableClass: 'table table-striped table-bordered table-hovered font-color-table'
  },
  pagination: {
    infoClass: 'pull-left',
    wrapperClass: 'vuetable-pagination pull-right',
    activeClass: 'btn-primary',
    disabledClass: 'disabled',
    pageClass: 'btn btn-border btn-table',
    linkClass: 'btn btn-border btn-table',
    icons: {
      first: '',
      prev: '',
      next: '',
      last: ''
    }
  }
};

var tableCSSOra = {
  table: {
    tableClass: 'table table-striped table-hovered font-color-table tr-ora'
  },
  pagination: {
    infoClass: 'pull-left',
    wrapperClass: 'vuetable-pagination pull-right',
    activeClass: 'btn-primary',
    disabledClass: 'disabled',
    pageClass: 'btn btn-border btn-table',
    linkClass: 'btn btn-border btn-table',
    icons: {
      first: '',
      prev: '',
      next: '',
      last: ''
    }
  }
};

var datePickerLocale = {
  format: 'DD/MM/YYYY',
  separator: ' - ',
  applyLabel: 'Aplicar',
  cancelLabel: 'Cancelar',
  fromLabel: 'De',
  toLabel: 'A',
  customRangeLabel: 'Custom',
  daysOfWeek: ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa'],
  monthNames: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
  firstDay: 1
};

var ordersProgressFilterModes = {
  all: 'all',
  pending: 'pending',
  attended: 'attended'
};

var apiKeyGoogle = {
  vitz: 'AIzaSyCYjRwVJO2jwb7xOoccVjtOFo7nh1YRREM',
  b2b: 'AIzaSyArtPY-pPYmLgeM9pLWZeSG7Csj0JoiMFU',
  b2c: 'AIzaSyDNbqxtkRoz1UejcvnHYPvjzOfZ__NvL-Q'

};

var defaultGeneral = {
  urlHelp: 'https://share.hsforms.com/1_m56eLa5QFixJW86gb7wpg4tj7e'
};

var ubigeoType = {
  departament: 'DEP',
  province: 'PROV',
  district: 'DIST'
};

/* harmony default export */ __webpack_exports__["a"] = ({
  colorPalette: colorPalette,
  dashboardFilterModes: dashboardFilterModes,
  minimunValues: minimunValues,
  defaultChartLabels: defaultChartLabels,
  defaultEriTypes: defaultEriTypes,
  defaultSelectItem: defaultSelectItem,
  tableCSS: tableCSS,
  datePickerLocale: datePickerLocale,
  ordersProgressFilterModes: ordersProgressFilterModes,
  apiKeyGoogle: apiKeyGoogle,
  defaultGeneral: defaultGeneral,
  ubigeoType: ubigeoType,
  tableCSSOra: tableCSSOra
});

/***/ }),
/* 6 */,
/* 7 */,
/* 8 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return http; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return httpi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios_retry__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_router__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_store_js__ = __webpack_require__(37);






__WEBPACK_IMPORTED_MODULE_1_axios___default.a.interceptors.request.use(function (config) {
  if (!__WEBPACK_IMPORTED_MODULE_4_vuex_store_js__["a" /* default */].getters.loggedIn) {
    __WEBPACK_IMPORTED_MODULE_3_router__["a" /* default */].push({ name: 'Logout' });
  }
  return config;
}, function (error) {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

var http = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.create({
  baseURL: 'https://vitztest.azurewebsites.net/api/v1',

  headers: {
    'x-functions-key': 'aZevJvIcb4jnNxTsUwTmm2332kjOzVEQznlM2UETuk5Dstaefv/djQ=='
  }
});

var httpi = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.create({
  baseURL: 'https://dinet-e-tracking-test.azurewebsites.net/api/v1',

  headers: {
    'x-functions-key': 'OWwm8cT-gTyjFILAITrAcOoUnIerg5umsiil0KMI9WcGAzFuVb-FNg=='
  }
});

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_axios_retry__["a" /* default */])(httpi, { retries: 1, retryCondition: function retryCondition() {
    return true;
  } });

/***/ }),
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_moment_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_moment_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment_moment_js__);



function formatSlideMenuItems(permissions) {
  var showDashboard = (permissions.ServiceMonitoring || []).length > 0;
  var showReception = (permissions.ReceptionAppointments || []).length > 0;
  var showDispatch = (permissions.DispatchAppointments || []).length > 0;
  var showInventory = (permissions.Inventory || []).length > 0;
  var showSearchDocuments = (permissions.SearchDocuments || []).length > 0;
  var showOrders = (permissions.Orders || []).length > 0;
  var showInventoryStates = (permissions.InventoryStates || []).length > 0;
  var showExpiringProducts = (permissions.ExpiringProducts || []).length > 0;
  var showDistributionService = (permissions.DistributionService || []).length > 0;
  var showBusinessRules = (permissions.BusinessRules || []).length > 0;
  var showEcommerceSearchDocumentss = (permissions.EcommerceSearchDocuments || []).length > 0;

  var formattedMenu = [];

  var itemDashboard = {
    type: 'item',
    icon: 'monitor-icon',
    name: 'Monitoreo de Servicios',
    router: {
      name: 'ServiceMonitoring'
    }
  };

  var itemInfoUpload = {
    type: 'tree',
    icon: 'cargar-icon',
    name: 'Cargar Información',
    items: []
  };

  var itemReception = {
    type: 'item',
    icon: 'citas-r-icon',
    name: 'Citas de Recepción',
    router: {
      name: 'ReceptionAppointments'
    }
  };

  var itemDispatch = {
    type: 'item',
    icon: 'citas-d-icon',
    name: 'Citas de Despacho',
    router: {
      name: 'DispatchAppointments'
    }
  };

  var itemInventory = {
    type: 'item',
    icon: 'invetario-s-icon',
    name: 'Inventario',
    router: {
      name: 'Inventory'
    }
  };

  var itemDocumentSearch = {
    type: 'item',
    icon: 'seguimiento-icon',
    name: 'Seguimiento de Documento',
    router: {
      name: 'DocumentSearch'
    }
  };

  var itemLogisticaEcommerce = {
    type: 'tree',
    icon: 'ecommerce-icon',
    name: 'Logística Ecommerce',
    items: []
  };

  var itemDocumentoEcommerce = {
    type: 'item',
    icon: 'ecommerce-icon',
    name: 'Documentos Ecommerce',
    router: {
      name: 'EcommerceSearchDocuments'
    }
  };

  var itemRules = {
    type: 'item',
    icon: 'reglas-icon',
    name: 'Reglas de Negocio',
    router: {
      name: 'AlertRules'
    }
  };

  var itemPerishable = {
    type: 'item',
    icon: 'productos-icon',
    name: 'Productos Perecibles',
    router: {
      name: 'PerishableProducts'
    }
  };

  var itemOrdersProgress = {
    type: 'item',
    icon: 'avance-icon',
    name: 'Avance de Pedidos',
    router: {
      name: 'OrdersProgress'
    }
  };

  var itemInventoryProductStatus = {
    type: 'item',
    icon: 'inventario-e-icon',
    name: 'Inventario por Estado',
    router: {
      name: 'InventoryProductStatus'
    }
  };

  var itemDispatchTrcking = {
    type: 'item',
    icon: 'servicio-icon',
    name: 'Servicio de Distribución',
    router: {
      name: 'DispatchTracking'
    }
  };

  if (showDashboard) {
    formattedMenu.push(itemDashboard);
  }

  if (showReception) {
    itemInfoUpload.items.push(itemReception);
  }

  if (showDispatch) {
    itemInfoUpload.items.push(itemDispatch);
  }

  if (showInventory) {
    itemInfoUpload.items.push(itemInventory);
  }

  if (showReception || showDispatch || showInventory) {
    formattedMenu.push(itemInfoUpload);
  }

  if (showSearchDocuments) {
    formattedMenu.push(itemDocumentSearch);
  }

  if (showEcommerceSearchDocumentss) {
    itemLogisticaEcommerce.items.push(itemDocumentoEcommerce);
  }

  if (showEcommerceSearchDocumentss) {
    formattedMenu.push(itemLogisticaEcommerce);
  }

  if (showBusinessRules) {
    formattedMenu.push(itemRules);
  }

  if (showExpiringProducts) {
    formattedMenu.push(itemPerishable);
  }

  if (showOrders) {
    formattedMenu.push(itemOrdersProgress);
  }

  if (showInventoryStates) {
    formattedMenu.push(itemInventoryProductStatus);
  }

  if (showDistributionService) {
    formattedMenu.push(itemDispatchTrcking);
  }

  return formattedMenu;
}

function getChartLabels(mode, startDate, endDate) {
  var labels = [];

  switch (mode) {
    case __WEBPACK_IMPORTED_MODULE_0__constants_js__["a" /* default */].dashboardFilterModes.today:
      labels = __WEBPACK_IMPORTED_MODULE_0__constants_js__["a" /* default */].defaultChartLabels.day;
      break;
    default:
      var objStartDate = __WEBPACK_IMPORTED_MODULE_1_moment_moment_js___default()(startDate);
      var objEndDate = __WEBPACK_IMPORTED_MODULE_1_moment_moment_js___default()(endDate);

      var objCurrentDate = objStartDate;

      while (objCurrentDate <= objEndDate) {
        labels.push(objCurrentDate.format('DD/MM'));
        objCurrentDate = objCurrentDate.add(1, 'days');
      }

      break;
  }

  return labels;
}

function getChartData(mode, startDate, endDate, data) {
  var finalData = [];
  var rawData = void 0;
  var chartLabels = void 0;

  switch (mode) {
    case __WEBPACK_IMPORTED_MODULE_0__constants_js__["a" /* default */].dashboardFilterModes.today:
      chartLabels = __WEBPACK_IMPORTED_MODULE_0__constants_js__["a" /* default */].defaultChartLabels.day;
      rawData = formatChartObject(data, 'h a');
      break;
    default:
      chartLabels = getChartLabels(mode, startDate, endDate);
      rawData = formatChartObject(data, 'DD/MM');
      break;
  }

  for (var index = 0; index < chartLabels.length; index++) {
    var rawDataIndex = rawData.labels.indexOf(chartLabels[index]);

    if (rawDataIndex !== -1) {
      finalData.push(rawData.data[rawDataIndex]);
    } else {
      finalData.push(0);
    }
  }

  return finalData;
}

function formatChartObject(data, format) {
  var obj = {
    labels: [],
    data: []
  };

  var lastDate = void 0,
      currentDate = void 0;
  var totalAmount = void 0,
      currentAmount = void 0;

  data.sort(function (a, b) {
    return new Date(a.dateTime) - new Date(b.dateTime);
  });

  for (var index = 0; index < data.length; index++) {
    currentDate = __WEBPACK_IMPORTED_MODULE_1_moment_moment_js___default()(data[index].dateTime).format(format);
    currentAmount = data[index].value;

    if (index === 0) {
      lastDate = currentDate;
      totalAmount = 0;
    }

    if (lastDate === currentDate) {
      totalAmount += currentAmount;
    } else {
      obj.labels.push(lastDate);
      obj.data.push(totalAmount);

      lastDate = currentDate;
      totalAmount = currentAmount;
    }

    if (index === data.length - 1) {
      obj.labels.push(lastDate);
      obj.data.push(totalAmount);
    }
  }

  return obj;
}

function getChartColors(value) {
  var solid = void 0,
      opaque = void 0;

  if (value >= __WEBPACK_IMPORTED_MODULE_0__constants_js__["a" /* default */].minimunValues.success) {
    opaque = __WEBPACK_IMPORTED_MODULE_0__constants_js__["a" /* default */].colorPalette.hexSuccessOpa;
    solid = __WEBPACK_IMPORTED_MODULE_0__constants_js__["a" /* default */].colorPalette.hexSuccess;
  } else if (value >= __WEBPACK_IMPORTED_MODULE_0__constants_js__["a" /* default */].minimunValues.warning) {
    opaque = __WEBPACK_IMPORTED_MODULE_0__constants_js__["a" /* default */].colorPalette.hexWarningOpa;
    solid = __WEBPACK_IMPORTED_MODULE_0__constants_js__["a" /* default */].colorPalette.hexWarning;
  } else {
    opaque = __WEBPACK_IMPORTED_MODULE_0__constants_js__["a" /* default */].colorPalette.hexDangerOpa;
    solid = __WEBPACK_IMPORTED_MODULE_0__constants_js__["a" /* default */].colorPalette.hexDanger;
  }
  return { solid: solid, opaque: opaque };
}

function getYearList(start, end) {
  var obj = {
    current: __WEBPACK_IMPORTED_MODULE_1_moment_moment_js___default()().year(),
    list: []
  };

  if (!end) {
    end = obj.current;
  }

  for (var index = start; index <= end; index++) {
    obj.list.push(index);
  }

  return obj;
}

function getMonthList() {
  var obj = {
    current: null,
    list: []
  };

  __WEBPACK_IMPORTED_MODULE_1_moment_moment_js___default.a.locale('es');

  var monthList = __WEBPACK_IMPORTED_MODULE_1_moment_moment_js___default.a.months();

  for (var index = 0; index < monthList.length; index++) {
    obj.list.push({
      name: monthList[index].charAt(0).toUpperCase() + monthList[index].slice(1),
      value: (index + 1).toString().padStart(2, '0')
    });
  }

  obj.current = obj.list[__WEBPACK_IMPORTED_MODULE_1_moment_moment_js___default()().month()];

  return obj;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  formatSlideMenuItems: formatSlideMenuItems,
  getChartLabels: getChartLabels,
  getChartData: getChartData,
  getChartColors: getChartColors,
  getYearList: getYearList,
  getMonthList: getMonthList
});

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AUTH_LOGGED_IN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AUTH_LOGGED_OUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return USER_FETCH_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return USER_FETCH_CLIENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return USER_SET_PERMISSIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return USER_SET_DEFAULT_MENU_ITEM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return USER_SET_SLIDE_MENU_ITEMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return DASHBOARD_RESET_FILTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return DASHBOARD_SET_FILTER_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return DASHBOARD_SET_FILTER_CLIENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return INVENTORY_SET_ITEMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return INVENTORY_SET_LINES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return INVENTORY_RESET_VALUES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return INVENTORY_SET_STATUSES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return PRODUCT_SET_MODES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return PRODUCT_RESET_VALUES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return MONITORING_DOCUMENT_TYPES_RESET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return MONITORING_SET_DOCUMENT_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return MONITORING_DOCUMENT_SEARCH_RESET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return MONITORING_SET_DOCUMENT_SEARCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return MONITORING_SET_DOCUMENT_SEARCH_PAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return MONITORING_SET_DOCUMENT_IMAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return ORDERPROGRESS_DOCUMENT_SUPPLIERCUSTOMER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return ORDERPROGRESS_TYPES_ORDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return ORDERPROGRESS_DOCUMENT_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return ORDERPROGRESS_SET_ORDER_SEARCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return ORDERPROGRESS_SET_ORDER_RESET; });
/* unused harmony export TRACKING_SET_ORDER_TYPES */

var AUTH_LOGGED_IN = 'AUTH_LOGGED_IN';
var AUTH_LOGGED_OUT = 'AUTH_LOGGED_OUT';

var USER_FETCH_INFO = 'USER_FETCH_INFO';
var USER_FETCH_CLIENTS = 'USER_FETCH_CLIENTS';
var USER_SET_PERMISSIONS = 'USER_SET_PERMISSIONS';
var USER_SET_DEFAULT_MENU_ITEM = 'USER_SET_DEFAULT_MENU_ITEM';
var USER_SET_SLIDE_MENU_ITEMS = 'USER_SET_SLIDE_MENU_ITEMS';

var DASHBOARD_RESET_FILTER = 'DASHBOARD_RESET_FILTER';
var DASHBOARD_SET_FILTER_DATE = 'DASHBOARD_SET_FILTER';
var DASHBOARD_SET_FILTER_CLIENT = 'DASHBOARD_SET_FILTER_CLIENT';

var INVENTORY_SET_ITEMS = 'INVENTORY_SET_ITEMS';
var INVENTORY_SET_LINES = 'INVENTORY_SET_LINES';
var INVENTORY_RESET_VALUES = 'INVENTORY_RESET_VALUES';
var INVENTORY_SET_STATUSES = 'INVENTORY_SET_STATUSES';

var PRODUCT_SET_MODES = 'PRODUCT_MODES';
var PRODUCT_RESET_VALUES = 'PRODUCT_RESET_VALUES';

var MONITORING_DOCUMENT_TYPES_RESET = 'MONITORING_DOCUMENT_TYPES_RESET';
var MONITORING_SET_DOCUMENT_TYPES = 'MONITORING_SET_DOCUMENT_TYPES';
var MONITORING_DOCUMENT_SEARCH_RESET = 'MONITORING_DOCUMENT_SEARCH_RESET';
var MONITORING_SET_DOCUMENT_SEARCH = 'MONITORING_SET_DOCUMENT_SEARCH';
var MONITORING_SET_DOCUMENT_SEARCH_PAGE = 'MONITORING_SET_DOCUMENT_SEARCH_PAGE';
var MONITORING_SET_DOCUMENT_IMAGE = 'MONITORING_SET_DOCUMENT_IMAGE';

var ORDERPROGRESS_DOCUMENT_SUPPLIERCUSTOMER = 'ORDERPROGRESS_DOCUMENT_SUPPLIERCUSTOMER';
var ORDERPROGRESS_TYPES_ORDER = 'ORDERPROGRESS_TYPES_ORDER';
var ORDERPROGRESS_DOCUMENT_STATUS = 'ORDERPROGRESS_DOCUMENT_STATUS';
var ORDERPROGRESS_SET_ORDER_SEARCH = 'ORDERPROGRESS_SET_ORDER_SEARCH';
var ORDERPROGRESS_SET_ORDER_RESET = 'ORDERPROGRESS_SET_ORDER_RESET';

var TRACKING_SET_ORDER_TYPES = 'TRACKING_SET_ORDER_TYPES';

/***/ }),
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 27 */,
/* 28 */,
/* 29 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(421)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(314),
  /* template */
  __webpack_require__(520),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(43);

var reactiveProp = __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["a" /* mixins */].reactiveProp;


/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["d" /* Line */],
  mixins: [reactiveProp],
  mounted: function mounted() {
    this.options = {
      legend: {
        display: true
      },
      maintainAspectRatio: false,
      scales: {
        xAxes: [{
          categoryPercentage: 0.5,
          barPercentage: 0.5
        }],
        yAxes: [{
          ticks: {
            beginAtZero: false,
            userCallback: function userCallback(label, index, labels) {
              if (Math.floor(label) === label) {
                return label;
              }
            }
          }
        }]
      }
    };

    this.renderChart(this.chartData, this.options);
  }
});

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getters__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules__ = __webpack_require__(72);







__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* default */].Store({
  getters: __WEBPACK_IMPORTED_MODULE_3__getters__,
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__,
  modules: __WEBPACK_IMPORTED_MODULE_4__modules__["default"],
  strict: "production" !== 'production'
}));

/***/ }),
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(43);

var reactiveProp = __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["a" /* mixins */].reactiveProp;


/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["b" /* Doughnut */],
  mixins: [reactiveProp],
  mounted: function mounted() {
    this.options = {
      legend: {
        display: false
      },
      tooltips: {
        enabled: false,

        custom: function custom(tooltipModel) {
          var tooltipEl = document.getElementById('chartjs-tooltip');

          if (!tooltipEl) {
            tooltipEl = document.createElement('div');
            tooltipEl.id = 'chartjs-tooltip';
            tooltipEl.innerHTML = '<table></table>';
            document.body.appendChild(tooltipEl);
          }

          if (tooltipModel.opacity === 0) {
            tooltipEl.style.opacity = 0;
            return;
          }

          tooltipEl.classList.remove('above', 'below', 'no-transform');
          if (tooltipModel.yAlign) {
            tooltipEl.classList.add(tooltipModel.yAlign);
          } else {
            tooltipEl.classList.add('no-transform');
          }

          function getBody(bodyItem) {
            return bodyItem.lines;
          }

          if (tooltipModel.body) {
            var titleLines = tooltipModel.title || [];
            var bodyLines = tooltipModel.body.map(getBody);

            var innerHtml = '<thead>';

            titleLines.forEach(function (title) {
              innerHtml += '<tr><th>' + title + '</th></tr>';
            });
            innerHtml += '</thead><tbody>';

            bodyLines.forEach(function (body, i) {
              var colors = tooltipModel.labelColors[i];
              var style = 'background:' + colors.backgroundColor;
              style += '; border-color:' + colors.borderColor;
              style += '; border-width: 2px';
              var span = '<span style="' + style + '"></span>';
              innerHtml += '<tr><td>' + span + body + '%' + '</td></tr>';
            });
            innerHtml += '</tbody>';

            var tableRoot = tooltipEl.querySelector('table');
            tableRoot.innerHTML = innerHtml;
          }

          var position = this._chart.canvas.getBoundingClientRect();

          tooltipEl.style.opacity = 1;
          tooltipEl.style.borderRadius = '5px';
          tooltipEl.style.height = '60px';
          tooltipEl.style.width = '98px';
          tooltipEl.style.boxShadow = '0px 0px 10px';
          tooltipEl.style.backgroundColor = 'white';
          tooltipEl.style.position = 'absolute';
          tooltipEl.style.padding = '10px';
          tooltipEl.style.fontWeight = 'bold';
          tooltipEl.style.margin = '0 0 10px';
          tooltipEl.style.left = position.left + window.pageXOffset + tooltipModel.caretX + 'px';
          tooltipEl.style.top = position.top + window.pageYOffset + tooltipModel.caretY + 'px';
          tooltipEl.style.fontFamily = tooltipModel._bodyFontFamily;
          tooltipEl.style.fontSize = tooltipModel.bodyFontSize + 'px';
          tooltipEl.style.fontStyle = tooltipModel._bodyFontStyle;
          tooltipEl.style.pointerEvents = 'none';
        }
      },
      maintainAspectRatio: false
    };

    this.addPlugin({
      afterDraw: function afterDraw(chart) {
        var width = chart.chart.width;
        var height = chart.chart.height;
        var ctx = chart.chart.ctx;

        ctx.restore();
        var fontSize = (height / 120).toFixed(2);
        ctx.font = fontSize + 'em sans-serif';
        ctx.fillStyle = chart.data.centerTextColor;
        ctx.textBaseline = 'middle';

        var text = chart.data.centerTextValue;
        var textX = Math.round((width - ctx.measureText(text).width) / 2);
        var textY = height / 2;

        ctx.fillText(text, textX, textY);
        ctx.save();

        if (chart.data.postRender) {
          chart.data.postRender(chart);
        }
      }
    });

    this.renderChart(this.chartData, this.options);
  },

  methods: {
    update: function update(centerTextValue, centerTextColor) {
      this.chartData.centerTextValue = centerTextValue;
      this.chartData.centerTextColor = centerTextColor;
      this.renderChart(this.chartData, this.options);
    }
  }
});

/***/ }),
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(430)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(333),
  /* template */
  __webpack_require__(530),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_store_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_auth_Login2_vue__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_auth_Login2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_auth_Login2_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_auth_Logout_vue__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_auth_Logout_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_auth_Logout_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Home_vue__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Home_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_components_Home_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_dashboard_DashboardServices_vue__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_dashboard_DashboardServices_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_components_dashboard_DashboardServices_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_reception_ReceptionAppointments_vue__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_reception_ReceptionAppointments_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_components_reception_ReceptionAppointments_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_reception_ReceptionAppointmentsUpload_vue__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_reception_ReceptionAppointmentsUpload_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_components_reception_ReceptionAppointmentsUpload_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_dispatch_DispatchAppointments_vue__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_dispatch_DispatchAppointments_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_components_dispatch_DispatchAppointments_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_dispatch_DispatchAppointmentsUpload_vue__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_dispatch_DispatchAppointmentsUpload_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_components_dispatch_DispatchAppointmentsUpload_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_inventory_Inventory_vue__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_inventory_Inventory_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_components_inventory_Inventory_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_inventory_InventoryEntry_vue__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_inventory_InventoryEntry_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_components_inventory_InventoryEntry_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_inventory_InventoryDetail_vue__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_inventory_InventoryDetail_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_components_inventory_InventoryDetail_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_monitoring_DocumentSearch_vue__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_monitoring_DocumentSearch_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_components_monitoring_DocumentSearch_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_monitoring_DocumentMonitoring_vue__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_monitoring_DocumentMonitoring_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_components_monitoring_DocumentMonitoring_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_rules_AlertRules_vue__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_rules_AlertRules_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_components_rules_AlertRules_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_components_rules_AlertRulesEntry_vue__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_components_rules_AlertRulesEntry_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_components_rules_AlertRulesEntry_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_components_products_perishable_PerishableProducts_vue__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_components_products_perishable_PerishableProducts_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_components_products_perishable_PerishableProducts_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_components_orders_OrdersProgress_vue__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_components_orders_OrdersProgress_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_components_orders_OrdersProgress_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_components_orders_OrdersProgressDetail_vue__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_components_orders_OrdersProgressDetail_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_components_orders_OrdersProgressDetail_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_components_inventory_InventoryProductStatus_vue__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_components_inventory_InventoryProductStatus_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_components_inventory_InventoryProductStatus_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_components_dispatch_DispatchTracking_vue__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_components_dispatch_DispatchTracking_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_components_dispatch_DispatchTracking_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_components_tracking_Tracking_vue__ = __webpack_require__(486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_components_tracking_Tracking_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_components_tracking_Tracking_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_components_tracking_TrackingNumber_vue__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_components_tracking_TrackingNumber_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_components_tracking_TrackingNumber_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_components_tracking_TrackingOrder_vue__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_components_tracking_TrackingOrder_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_components_tracking_TrackingOrder_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_components_tracking_OrderSearch_vue__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_components_tracking_OrderSearch_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_components_tracking_OrderSearch_vue__);







































__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var routes = [{
  path: '/Login',
  name: 'Login',
  component: __WEBPACK_IMPORTED_MODULE_3_components_auth_Login2_vue___default.a
}, {
  path: '/Logout',
  name: 'Logout',
  component: __WEBPACK_IMPORTED_MODULE_4_components_auth_Logout_vue___default.a
}, {
  path: '/Tracking',
  name: 'Tracking',
  component: __WEBPACK_IMPORTED_MODULE_23_components_tracking_Tracking_vue___default.a
}, {
  path: '/Tracking/:id',
  name: 'Tracking',
  component: __WEBPACK_IMPORTED_MODULE_23_components_tracking_Tracking_vue___default.a
}, {
  path: '/Tracking/:id/:name',
  name: 'Tracking',
  component: __WEBPACK_IMPORTED_MODULE_23_components_tracking_Tracking_vue___default.a
}, {
  path: '/TrackingNumber/:tracking',
  name: 'TrackingNumber',
  component: __WEBPACK_IMPORTED_MODULE_24_components_tracking_TrackingNumber_vue___default.a
}, {
  path: '/TrackingNumber/:tracking/:name',
  name: 'TrackingNumber',
  component: __WEBPACK_IMPORTED_MODULE_24_components_tracking_TrackingNumber_vue___default.a
}, {
  path: '/TrackingOrder/:order',
  name: 'TrackingOrder',
  component: __WEBPACK_IMPORTED_MODULE_25_components_tracking_TrackingOrder_vue___default.a
}, {
  path: '/TrackingOrder/:order/:name',
  name: 'TrackingOrder',
  component: __WEBPACK_IMPORTED_MODULE_25_components_tracking_TrackingOrder_vue___default.a
}, {
  path: '/TrackingOrder/:order/:acc',
  name: 'TrackingOrder',
  component: __WEBPACK_IMPORTED_MODULE_25_components_tracking_TrackingOrder_vue___default.a
}, {
  path: '/TrackingOrder/:order/:name/:acc',
  name: 'TrackingOrder',
  component: __WEBPACK_IMPORTED_MODULE_25_components_tracking_TrackingOrder_vue___default.a
}, {
  path: '/Home',
  name: 'Home',
  component: __WEBPACK_IMPORTED_MODULE_5_components_Home_vue___default.a,
  meta: {
    auth: true
  }
}, {
  path: '/Monitoreo/Dashboard',
  name: 'ServiceMonitoring',
  component: __WEBPACK_IMPORTED_MODULE_6_components_dashboard_DashboardServices_vue___default.a,
  meta: {
    auth: true
  }
}, {
  path: '/Recepcion/Citas',
  name: 'ReceptionAppointments',
  component: __WEBPACK_IMPORTED_MODULE_7_components_reception_ReceptionAppointments_vue___default.a,
  meta: {
    auth: true
  }
}, {
  path: '/Recepcion/Citas/Carga/:accountCode',
  name: 'ReceptionAppointmentsUpload',
  component: __WEBPACK_IMPORTED_MODULE_8_components_reception_ReceptionAppointmentsUpload_vue___default.a,
  meta: {
    auth: true
  }
}, {
  path: '/Despacho/Citas',
  name: 'DispatchAppointments',
  component: __WEBPACK_IMPORTED_MODULE_9_components_dispatch_DispatchAppointments_vue___default.a,
  meta: {
    auth: true
  }
}, {
  path: '/Despacho/Citas/Carga/:accountCode',
  name: 'DispatchAppointmentsUpload',
  component: __WEBPACK_IMPORTED_MODULE_10_components_dispatch_DispatchAppointmentsUpload_vue___default.a,
  meta: {
    auth: true
  }
}, {
  path: '/Inventario',
  name: 'Inventory',
  component: __WEBPACK_IMPORTED_MODULE_11_components_inventory_Inventory_vue___default.a,
  meta: {
    auth: true
  }
}, {
  path: '/Inventario/Detalle/:period/:accountCode',
  name: 'InventoryDetail',
  component: __WEBPACK_IMPORTED_MODULE_13_components_inventory_InventoryDetail_vue___default.a,
  meta: {
    auth: true
  }
}, {
  path: '/Inventario/Registro/:period/:accountCode?',
  name: 'InventoryEntry',
  component: __WEBPACK_IMPORTED_MODULE_12_components_inventory_InventoryEntry_vue___default.a,
  meta: {
    auth: true
  }
}, {
  path: '/Inventario/Estado',
  name: 'InventoryProductStatus',
  component: __WEBPACK_IMPORTED_MODULE_21_components_inventory_InventoryProductStatus_vue___default.a,
  meta: {
    auth: true
  }
}, {
  path: '/Documento/Busqueda',
  name: 'DocumentSearch',
  component: __WEBPACK_IMPORTED_MODULE_14_components_monitoring_DocumentSearch_vue___default.a,
  meta: {
    auth: true
  }
}, {
  path: '/Documento/Seguimiento',
  name: 'DocumentMonitoring',
  component: __WEBPACK_IMPORTED_MODULE_15_components_monitoring_DocumentMonitoring_vue___default.a,
  meta: {
    auth: true
  }
}, {
  path: '/Documento/DocumentoEcommerce',
  name: 'EcommerceSearchDocuments',
  component: __WEBPACK_IMPORTED_MODULE_26_components_tracking_OrderSearch_vue___default.a,
  meta: {
    auth: true
  }
}, {
  path: '/Reglas/:accountCode?',
  name: 'AlertRules',
  component: __WEBPACK_IMPORTED_MODULE_16_components_rules_AlertRules_vue___default.a,
  meta: {
    auth: true
  }
}, {
  path: '/Reglas/Registro/:accountCode/:ruleCode?',
  name: 'AlertRulesEntry',
  component: __WEBPACK_IMPORTED_MODULE_17_components_rules_AlertRulesEntry_vue___default.a,
  meta: {
    auth: true
  }
}, {
  path: '/ProductosPerecibles',
  name: 'PerishableProducts',
  component: __WEBPACK_IMPORTED_MODULE_18_components_products_perishable_PerishableProducts_vue___default.a,
  meta: {
    auth: true
  }
}, {
  path: '/AvancePedidos',
  name: 'OrdersProgress',
  component: __WEBPACK_IMPORTED_MODULE_19_components_orders_OrdersProgress_vue___default.a,
  meta: {
    auth: true
  }
}, {
  path: '/AvancePedidos/DetallePedido',
  name: 'OrdersProgressDetail',
  component: __WEBPACK_IMPORTED_MODULE_20_components_orders_OrdersProgressDetail_vue___default.a,
  meta: {
    auth: true
  }
}, {
  path: '/ServicioDistribucion',
  name: 'DispatchTracking',
  component: __WEBPACK_IMPORTED_MODULE_22_components_dispatch_DispatchTracking_vue___default.a,
  meta: {
    auth: true
  }
}];

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  base: '/',
  mode: 'history',
  routes: routes,
  linkActiveClass: 'active'
});

router.beforeEach(function (to, from, next) {
  $('#slider').removeClass('div-view');
  $('#slider').removeClass('div-display');
  $('.close-slider').removeClass('div-display');
  $('.main-header').removeClass('div-none');

  if (__WEBPACK_IMPORTED_MODULE_2_vuex_store_js__["a" /* default */].getters.loggedIn) {
    var link = routes.find(function (x) {
      return x.name === __WEBPACK_IMPORTED_MODULE_2_vuex_store_js__["a" /* default */].getters.userDefaultMenu.permission;
    });
    var rou = routes.find(function (x) {
      return x.name === to.name;
    });

    if ((to.name === undefined || rou === undefined) && to.name !== 'Login') {
      next(link.path);
    } else {
      if (to.name === 'Logout') {
        next();
      } else if (to.name === 'Login') {
        next(link.path);
      } else {
        var allow = false;
        switch (to.name) {
          case 'InventoryDetail':
            if (__WEBPACK_IMPORTED_MODULE_2_vuex_store_js__["a" /* default */].getters.userPermissions['Inventory'] !== undefined && __WEBPACK_IMPORTED_MODULE_2_vuex_store_js__["a" /* default */].getters.userPermissions['Inventory'].length > 0) {
              allow = true;
            }
            break;
          case 'InventoryEntry':
            if (__WEBPACK_IMPORTED_MODULE_2_vuex_store_js__["a" /* default */].getters.userPermissions['Inventory'] !== undefined && __WEBPACK_IMPORTED_MODULE_2_vuex_store_js__["a" /* default */].getters.userPermissions['Inventory'].length > 0) {
              allow = true;
            }
            break;
          case 'ReceptionAppointmentsUpload':
            if (__WEBPACK_IMPORTED_MODULE_2_vuex_store_js__["a" /* default */].getters.userPermissions['ReceptionAppointments'] !== undefined && __WEBPACK_IMPORTED_MODULE_2_vuex_store_js__["a" /* default */].getters.userPermissions['ReceptionAppointments'].length > 0) {
              allow = true;
            }
            break;
          case 'DispatchAppointmentsUpload':
            if (__WEBPACK_IMPORTED_MODULE_2_vuex_store_js__["a" /* default */].getters.userPermissions['DispatchAppointments'] !== undefined && __WEBPACK_IMPORTED_MODULE_2_vuex_store_js__["a" /* default */].getters.userPermissions['DispatchAppointments'].length > 0) {
              allow = true;
            }
            break;
          default:
            if (__WEBPACK_IMPORTED_MODULE_2_vuex_store_js__["a" /* default */].getters.userPermissions[to.name] !== undefined && __WEBPACK_IMPORTED_MODULE_2_vuex_store_js__["a" /* default */].getters.userPermissions[to.name].length > 0) {
              allow = true;
            } else {
              allow = true;
            }
            break;
        }

        if (allow) {
          next();
        } else {
          next(link.path);
        }
      }
    }
  } else {
    if (to.meta.auth) {
      next('Login');
    } else {
      if (to.path === '/' && to.name === null) {
        next('Login');
      } else {
        next();
      }
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 64 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACkAAAApCAQAAAACach9AAACMUlEQVR4Ae3ShY7jQBAE0Aoz/f9/HTMzhg1zrdKUrJbdx+Kd2nD8VNudfsL/Th///dyQN2TH6f3y/BGpC379rV+S+qqetBOxImNQXL8JCAr2V4iMQXHGNJxeCfZXhSRBcQMfvkOWUdtfzlLgAENmZDcmo2TVmt8OSM2eXxBp3DjHSMFutqS7SbmemzBiR+xpKCNUIRkdkkYxhAkyGoBvyQFEJEefwSmmvBfJuJ6aKqKWnAkvGZOaZXTUgFqYULWNSHUckZuR1HIIimUExutRxwzOLROIG4vKmCKQt364mIlhSyzAf1m9lHZHJZrlAOMMztRRiKimp/rpdJDc9Awry5xTZCte7FHtuS8wJgeYGrex28xNTd086Dik7vUMscQOa8y4DoGtCCSkAKlNwpgNtphjrC6MIHUkR6YWxxs6Sc5xqn222mmCRFzIt8lEdKx+ikCtg91qS2WpwVfBelJCiQJwvzixfI9cxZQWgiSJelKnwBElKYtDOb2MFbhmUigbReQBV0Cg4+qMXSxXSyGUn4UbF8l+7qdSGnTC0XLCmahIgUHLhLOhpVCtw4CzYXvLQWQbJNmxoCsOKAxSgBJno75avolkRw8iIAFcsdc02e9iyCd8tHwmeSSoKTowIgvscSGZUOA7PuCN5b2BX9mQM7S0wYhMNU74zgsPBj3HU7wguAfnxxjFQGBE6pwN+GjME9zHY7zGp8wVxMShYX9NXvEWD3HbwJf4giO4CFIQxXScH1/TM+04kkBiAAAAAElFTkSuQmCC"

/***/ }),
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var files = __webpack_require__(594);
var modules = {};

files.keys().forEach(function (key) {
  if (key === './index.js') return;
  modules[key.replace(/(\.\/|\.js)/g, '')] = files(key).default;
});

/* harmony default export */ __webpack_exports__["default"] = (modules);

/***/ }),
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(413)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(317),
  /* template */
  __webpack_require__(509),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap_dist_css_bootstrap_min_css__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap_dist_css_bootstrap_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_bootstrap_dist_css_bootstrap_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_admin_lte_dist_css_AdminLTE_min_css__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_admin_lte_dist_css_AdminLTE_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_admin_lte_dist_css_AdminLTE_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_admin_lte_dist_css_skins_all_skins_min_css__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_admin_lte_dist_css_skins_all_skins_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_admin_lte_dist_css_skins_all_skins_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_font_awesome_css_font_awesome_min_css__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_font_awesome_css_font_awesome_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_font_awesome_css_font_awesome_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_inner_image_zoom_lib_vue_inner_image_zoom_css__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_inner_image_zoom_lib_vue_inner_image_zoom_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_inner_image_zoom_lib_vue_inner_image_zoom_css__);






/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);


var EventBus = new __WEBPACK_IMPORTED_MODULE_0_vue___default.a();

/* harmony default export */ __webpack_exports__["a"] = (EventBus);

/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_expose_loader_expose_loader_jQuery_jquery__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_expose_loader_expose_loader_jQuery_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_expose_loader_expose_loader_jQuery_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_bootstrap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery_slimscroll__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery_slimscroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery_slimscroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_admin_lte__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_admin_lte___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_admin_lte__);







/***/ }),
/* 237 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 238 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 239 */,
/* 240 */,
/* 241 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(416)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(292),
  /* template */
  __webpack_require__(515),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(43);

var reactiveProp = __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["a" /* mixins */].reactiveProp;


/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["c" /* Bar */],
  mixins: [reactiveProp],
  mounted: function mounted() {
    this.options = {
      legend: {
        display: false
      },
      maintainAspectRatio: false,
      scales: {
        xAxes: [{
          display: false,
          stacked: true,
          id: 'bar-x-axis1',
          barThickness: 70,
          barPercentage: 0.2
        }],
        yAxes: [{
          display: false,
          stacked: false,
          ticks: {
            beginAtZero: true
          }
        }]
      }
    };

    this.renderChart(this.chartData, this.options);
  }
});

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(43);
var horizonalLinePlugin = {
  id: 'horizontalLine',
  afterDraw: function afterDraw(chartInstance) {
    var yValue;
    var yScale = chartInstance.scales['y-axis-0'];
    var canvas = chartInstance.chart;
    var ctx = canvas.ctx;
    var index;
    var line;
    var style;

    if (chartInstance.options.horizontalLine) {
      for (index = 0; index < chartInstance.options.horizontalLine.length; index++) {
        line = chartInstance.options.horizontalLine[index];

        if (!line.style) {
          style = '#080808';
        } else {
          style = line.style;
        }

        if (line.y) {
          yValue = yScale.getPixelForValue(line.y);
        } else {
          yValue = 0;
        }
        ctx.lineWidth = 3;

        if (yValue) {
          window.chart = chartInstance;
          ctx.beginPath();
          ctx.moveTo(0, yValue);
          ctx.lineTo(canvas.width, yValue);
          ctx.strokeStyle = style;
          ctx.stroke();
        }

        if (line.text) {
          ctx.fillStyle = style;
          ctx.fillText(line.text, 0, yValue + ctx.lineWidth);
        }
      }

      return;
    }
  }
};


var reactiveProp = __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["a" /* mixins */].reactiveProp;


/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["c" /* Bar */],
  mixins: [reactiveProp],
  beforeMount: function beforeMount() {
    this.addPlugin(horizonalLinePlugin);
  },
  mounted: function mounted() {
    this.options = {
      legend: {
        display: false
      },
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        xAxes: [{
          stacked: true,
          categoryPercentage: 0.5,
          barPercentage: 1
        }],
        yAxes: [{
          stacked: true
        }]
      }
    };

    this.renderChart(this.chartData, this.options);
  }
});

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_css__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_script__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_eventBus_js__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_js_constants_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment_moment_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment_moment_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment_moment_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_loading_overlay_dist_vue_loading_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue2_google_maps__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue2_google_maps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_carousel__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_currency_filter__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_currency_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_currency_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_js_modal__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_js_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue_js_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue2_leaflet__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_leaflet_dist_leaflet_css__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_leaflet_dist_leaflet_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_leaflet_dist_leaflet_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_leaflet_dist_images_marker_shadow_png__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_leaflet_dist_images_marker_shadow_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_leaflet_dist_images_marker_shadow_png__);






















__WEBPACK_IMPORTED_MODULE_2_vue___default.a.component('l-map', __WEBPACK_IMPORTED_MODULE_14_vue2_leaflet__["a" /* LMap */]);
__WEBPACK_IMPORTED_MODULE_2_vue___default.a.component('l-tile-layer', __WEBPACK_IMPORTED_MODULE_14_vue2_leaflet__["b" /* LTileLayer */]);
__WEBPACK_IMPORTED_MODULE_2_vue___default.a.component('l-marker', __WEBPACK_IMPORTED_MODULE_14_vue2_leaflet__["c" /* LMarker */]);

__WEBPACK_IMPORTED_MODULE_2_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_13_vue_js_modal___default.a, { dynamic: true });

__WEBPACK_IMPORTED_MODULE_2_vue___default.a.prototype.$bus = __WEBPACK_IMPORTED_MODULE_5__lib_eventBus_js__["a" /* default */];

__WEBPACK_IMPORTED_MODULE_2_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay___default.a, {
  color: __WEBPACK_IMPORTED_MODULE_6__assets_js_constants_js__["a" /* default */].colorPalette.baseBlue
});

__WEBPACK_IMPORTED_MODULE_2_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_12_vue_currency_filter___default.a, {
  symbol: '',
  thousandsSeparator: ',',
  fractionCount: 2,
  fractionSeparator: '.',
  symbolPosition: 'front',
  symbolSpacing: false
});

__WEBPACK_IMPORTED_MODULE_2_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_11_vue_carousel___default.a);

__WEBPACK_IMPORTED_MODULE_2_vue___default.a.filter('formatFirstLetter', function (value) {
  if (typeof value !== 'string') {
    return value;
  }
  value = value.toLocaleLowerCase();
  return value.charAt(0).toUpperCase() + value.slice(1);
});

__WEBPACK_IMPORTED_MODULE_2_vue___default.a.filter('formatAmount', function (value) {
  if (typeof value !== 'number') {
    return value;
  }

  return new Intl.NumberFormat('es-pe').format(value);
});

__WEBPACK_IMPORTED_MODULE_2_vue___default.a.filter('formatPercentage', function (value) {
  if (typeof value !== 'number') {
    return value;
  }
  var formatter = new Intl.NumberFormat('es-pe', {
    style: 'decimal',
    minimumFractionDigits: 2
  });

  return formatter.format(value);
});

__WEBPACK_IMPORTED_MODULE_2_vue___default.a.filter('formatDecimal', function (value) {
  if (typeof value !== 'number') {
    return value;
  }

  return String(parseFloat(Math.round(value * 100) / 100).toFixed(2)).replace('.', ',');
});

__WEBPACK_IMPORTED_MODULE_2_vue___default.a.filter('formatMiles', function (value) {
  if (typeof value !== 'number') {
    return value;
  }

  var _out = value;

  if (_out > 1000) {
    _out = _out / 1000;
    return String(parseFloat(Math.round(_out * 100) / 100).toFixed(2)).replace('.', ',') + 'K';
  } else {
    return String(parseFloat(Math.round(_out * 100) / 100).toFixed(2)).replace('.', ',');
  }
});

__WEBPACK_IMPORTED_MODULE_2_vue___default.a.filter('formatDate', function (value, format, iftable) {
  if (value) {
    if (iftable) {
      return __WEBPACK_IMPORTED_MODULE_8_moment_moment_js___default()(String(value)).add(1, 'day').locale('es-pe').format(format);
    }
    return __WEBPACK_IMPORTED_MODULE_8_moment_moment_js___default()(String(value)).locale('es-pe').format(format);
  }
});

__WEBPACK_IMPORTED_MODULE_2_vue___default.a.filter('formatDateOnly', function (value, format, iftable) {
  if (value) {
    if (iftable) {
      return __WEBPACK_IMPORTED_MODULE_8_moment_moment_js___default()(String(value)).format(format);
    }
    return __WEBPACK_IMPORTED_MODULE_8_moment_moment_js___default()(String(value)).format(format);
  }
});

__WEBPACK_IMPORTED_MODULE_2_vue___default.a.filter('formatWeightKg', function (value, precision) {
  var isNumber = !isNaN(+value) && isFinite(value);

  if (!(!isNaN(+precision) && isFinite(precision))) precision = 2;

  var _out = value;
  if (isNumber) {
    _out = value.toFixed(precision) + ' Kg';
  }

  return _out;
});

__WEBPACK_IMPORTED_MODULE_2_vue___default.a.filter('formatVolM', function (value, precision) {
  var isNumber = !isNaN(+value) && isFinite(value);

  if (!(!isNaN(+precision) && isFinite(precision))) precision = 2;

  var _out = value;
  if (isNumber) {
    if (value > 1) {
      _out = value.toFixed(precision) + ' m³';
    } else {
      _out = value.toFixed(precision) + ' m³';
    }
  }

  return _out;
});

__WEBPACK_IMPORTED_MODULE_2_vue___default.a.filter('formatVolM1', function (value, precision) {
  var isNumber = !isNaN(+value) && isFinite(value);

  if (!(!isNaN(+precision) && isFinite(precision))) precision = 2;

  var _out = value;
  if (isNumber) {
    if (value > 1) {
      _out = value.toFixed(precision) + ' m³';
    } else {
      _out = value.toFixed(precision) + ' m³';
    }
  }

  return _out;
});

__WEBPACK_IMPORTED_MODULE_2_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_10_vue2_google_maps__);

new __WEBPACK_IMPORTED_MODULE_2_vue___default.a({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
  template: '<App/>',
  components: {
    App: __WEBPACK_IMPORTED_MODULE_3__App___default.a
  }
});

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "logIn", function() { return logIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "logOut", function() { return logOut; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setFilterDate", function() { return setFilterDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setFilterClient", function() { return setFilterClient; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchDashboardData", function() { return fetchDashboardData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchReceptionAppointmentDocumentList", function() { return fetchReceptionAppointmentDocumentList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "uploadReceptionApointmentFile", function() { return uploadReceptionApointmentFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "saveReceptionApointmentFile", function() { return saveReceptionApointmentFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchDispatchAppointmentDocumentList", function() { return fetchDispatchAppointmentDocumentList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "uploadDispatchApointmentFile", function() { return uploadDispatchApointmentFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "saveDispatchApointmentFile", function() { return saveDispatchApointmentFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchDispatchVehicleList", function() { return fetchDispatchVehicleList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchDispatchVehicleLocation", function() { return fetchDispatchVehicleLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "searchDocument", function() { return searchDocument; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "searchDocument2", function() { return searchDocument2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "searchDocumentPage", function() { return searchDocumentPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDocument", function() { return getDocument; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDocumentTypes", function() { return getDocumentTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDocumentImage", function() { return getDocumentImage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTracking", function() { return getTracking; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPointTracking", function() { return getPointTracking; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUbigeo", function() { return getUbigeo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getOrderType", function() { return getOrderType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getOrderStatus", function() { return getOrderStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getOrderZone", function() { return getOrderZone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getOrderFollow", function() { return getOrderFollow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getOrderFollowDetail", function() { return getOrderFollowDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getOrderReport", function() { return getOrderReport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchAlertRulesList", function() { return fetchAlertRulesList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchAlertRulesItemTypes", function() { return fetchAlertRulesItemTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchAlertRulesOperators", function() { return fetchAlertRulesOperators; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "saveAlertRule", function() { return saveAlertRule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchPerishableProductsModes", function() { return fetchPerishableProductsModes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchPerishableProductsList", function() { return fetchPerishableProductsList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDocumentStatus", function() { return getDocumentStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSupplierCustomer", function() { return getSupplierCustomer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchOrdersProgressData", function() { return fetchOrdersProgressData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchEriSummaryData", function() { return fetchEriSummaryData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchEriDetailData", function() { return fetchEriDetailData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exportEriDetailData", function() { return exportEriDetailData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "inventoryEntry", function() { return inventoryEntry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getItemsForInventory", function() { return getItemsForInventory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchInventoryProductStatusList", function() { return fetchInventoryProductStatusList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchInventoryLines", function() { return fetchInventoryLines; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchInventoryStatus", function() { return fetchInventoryStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchDocumentTypes", function() { return fetchDocumentTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getItemsForAccountConfiguration", function() { return getItemsForAccountConfiguration; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_assets_js_util_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex_store_js__ = __webpack_require__(37);







var logIn = function logIn(context, parameters) {
  return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* services */].auth.retrieveToken(parameters).then(function (response) {
    if (response.data.success) {
      var data = response.data.data;
      context.commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* AUTH_LOGGED_IN */], data);
      setPermissions(context, data.accounts);
      setUserInfo(context, data, parameters);
      setUserAccounts(context, data.accounts);
    } else {
      response.data.errors.forEach(function (error) {
        console.log(error);
      });
    }
  }).catch(function (error) {
    console.error(error);
  });
};

var logOut = function logOut(context) {
  context.commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["b" /* AUTH_LOGGED_OUT */]);
  context.commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["y" /* DASHBOARD_RESET_FILTER */]);
  context.commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["u" /* INVENTORY_RESET_VALUES */]);
  context.commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["i" /* PRODUCT_RESET_VALUES */]);
  context.commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["o" /* MONITORING_DOCUMENT_TYPES_RESET */]);
  context.commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["q" /* MONITORING_DOCUMENT_SEARCH_RESET */]);
  context.commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["h" /* ORDERPROGRESS_SET_ORDER_RESET */]);
};

function setUserInfo(context, data, parameters) {
  var userinfo = {
    userID: data.username,
    name: data.name,
    position: '',
    createdAt: '',
    encodedToken: btoa(parameters.Username + ':' + parameters.Password)
  };
  context.commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["f" /* USER_FETCH_INFO */], userinfo = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(userinfo));
}

function setUserAccounts(context, accounts) {
  accounts = accounts.map(function (account) {
    return {
      code: account.accountCode,
      name: __WEBPACK_IMPORTED_MODULE_4_vue___default.a.options.filters.formatFirstLetter(account.description),
      hasWarehouseService: account.hasWarehouseService,
      hasTransportService: account.hasTransportService,
      hasTemporaryDepositService: account.hasTemporaryDepositService
    };
  });

  context.commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["g" /* USER_FETCH_CLIENTS */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(accounts));
  context.commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["A" /* DASHBOARD_SET_FILTER_CLIENT */], accounts[0]);
}

function setPermissions(context, data) {
  var permissions = {};
  var defaultMenu = {};
  data.forEach(function (account) {
    var accountItem = { code: account.accountCode, name: account.description };
    account.permissions.forEach(function (item) {
      if (!permissions[item.permission]) {
        permissions[item.permission] = [];
      }
      permissions[item.permission].push(accountItem);
    });
  });

  defaultMenu = data[0].permissions[0];

  context.commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["c" /* USER_SET_PERMISSIONS */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(permissions));
  context.commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["d" /* USER_SET_DEFAULT_MENU_ITEM */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(defaultMenu));
  context.commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["e" /* USER_SET_SLIDE_MENU_ITEMS */], __WEBPACK_IMPORTED_MODULE_3_assets_js_util_js__["a" /* default */].formatSlideMenuItems(permissions));
}

var setFilterDate = function setFilterDate(context, parameters) {
  context.commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["z" /* DASHBOARD_SET_FILTER_DATE */], parameters);
};

var setFilterClient = function setFilterClient(context, client) {
  context.commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["A" /* DASHBOARD_SET_FILTER_CLIENT */], client);
};

var fetchDashboardData = function fetchDashboardData(context, parameters) {
  return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* services */].dashboard.retrieveDashboardData(parameters).then(function (response) {
    if (response.data.success) {
      return response.data.data;
    } else {
      response.data.errors.forEach(function (error) {
        console.log(error);
      });
    }
  }).catch(function (error) {
    console.error(error);
  });
};

var fetchReceptionAppointmentDocumentList = function fetchReceptionAppointmentDocumentList(context, accountCode) {
  return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* services */].reception.retrieveAppointmentDocumentList(accountCode).then(function (response) {
    if (response.data.success) {
      return response.data.data;
    } else {
      response.data.errors.forEach(function (error) {
        console.log(error);
      });
    }
  }).catch(function (error) {
    console.error(error);
  });
};

var uploadReceptionApointmentFile = function uploadReceptionApointmentFile(context, parameters) {
  return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* services */].reception.uploadApointmentFile(parameters).then(function (response) {
    if (!response.data.success) {
      response.data.errors.forEach(function (error) {
        console.log(error);
      });
    }
    return response.data;
  }).catch(function () {
    return { data: { success: false } };
  });
};

var saveReceptionApointmentFile = function saveReceptionApointmentFile(context, parameters) {
  return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* services */].reception.saveApointmentFile(parameters).then(function (response) {
    if (!response.data.success) {
      response.data.errors.forEach(function (error) {
        console.log(error);
      });
    }
    return response.data;
  }).catch(function () {
    return { data: { success: false } };
  });
};

var fetchDispatchAppointmentDocumentList = function fetchDispatchAppointmentDocumentList(context, accountCode) {
  return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* services */].dispatch.retrieveAppointmentDocumentList(accountCode).then(function (response) {
    if (response.data.success) {
      return response.data.data;
    } else {
      response.data.errors.forEach(function (error) {
        console.log(error);
      });
    }
  }).catch(function (error) {
    console.error(error);
  });
};

var uploadDispatchApointmentFile = function uploadDispatchApointmentFile(context, parameters) {
  return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* services */].dispatch.uploadApointmentFile(parameters).then(function (response) {
    if (!response.data.success) {
      response.data.errors.forEach(function (error) {
        console.log(error);
      });
    }
    return response.data;
  }).catch(function () {
    return { data: { success: false } };
  });
};

var saveDispatchApointmentFile = function saveDispatchApointmentFile(context, parameters) {
  return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* services */].dispatch.saveApointmentFile(parameters).then(function (response) {
    if (!response.data.success) {
      response.data.errors.forEach(function (error) {
        console.log(error);
      });
    }
    return response.data;
  }).catch(function () {
    return { data: { success: false } };
  });
};

var fetchDispatchVehicleList = function fetchDispatchVehicleList(context, accountCode) {
  return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* services */].dispatch.retrieveVehicleList(accountCode).then(function (response) {
    if (response.data.success) {
      return response.data.data;
    } else {
      response.data.errors.forEach(function (error) {
        console.log(error);
      });
    }
  }).catch(function (error) {
    console.error(error);
  });
};

var fetchDispatchVehicleLocation = function fetchDispatchVehicleLocation(context, vehiclePlate) {
  return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* services */].dispatch.retrieveVehicleLocation(vehiclePlate).then(function (response) {
    if (response.data.success) {
      return response.data.data;
    } else {
      response.data.errors.forEach(function (error) {
        console.log(error);
      });
    }
  }).catch(function (error) {
    console.error(error);
  });
};

var searchDocument = function searchDocument(context, parameters) {
  return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* services */].monitoring.retrieveDocumentList(parameters).then(function (response) {
    if (response.data.success) {
      context.commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["r" /* MONITORING_SET_DOCUMENT_SEARCH */], {
        filter: parameters,
        result: response.data.data.documents
      });

      return response.data.data.documents;
    } else {
      response.data.errors.forEach(function (error) {
        console.log(error);
      });
    }
  }).catch(function (error) {
    console.error(error);
  });
};

var searchDocument2 = function searchDocument2(context, parameters) {
  return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* services */].monitoring.retrieveDocumentList(parameters).then(function (response) {
    if (response.data.success) {
      context.commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["q" /* MONITORING_DOCUMENT_SEARCH_RESET */]);
      context.commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["r" /* MONITORING_SET_DOCUMENT_SEARCH */], {
        filter: parameters,
        result: response.data.data.documents,
        pages: response.data.data.totalPages
      });
      return response.data.data;
    } else {
      response.data.errors.forEach(function (error) {
        console.log(error);
      });
    }
  }).catch(function (error) {
    console.error(error);
  });
};

var searchDocumentPage = function searchDocumentPage(context, page) {
  context.commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["s" /* MONITORING_SET_DOCUMENT_SEARCH_PAGE */], page);
};

var getDocument = function getDocument(context, parameters) {
  return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* services */].monitoring.retrieveDocument(parameters).then(function (response) {
    if (response.data.success) {
      return response.data.data;
    } else {
      response.data.errors.forEach(function (error) {
        console.log(error);
      });
    }
  }).catch(function (error) {
    console.error(error);
  });
};

var getDocumentTypes = function getDocumentTypes(context, parameters) {
  return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* services */].monitoring.retrieveDocumentTypes(parameters).then(function (response) {
    if (response.data.success) {
      context.commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["p" /* MONITORING_SET_DOCUMENT_TYPES */], response.data.data.items);
      return response.data.data.items;
    } else {
      response.data.errors.forEach(function (error) {
        console.log(error);
      });
    }
  }).catch(function (error) {
    console.error(error);
  });
};

var getDocumentImage = function getDocumentImage(context, parameters) {
  return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* services */].monitoring.retrieveDocumentImages(parameters).then(function (response) {
    if (response.data.success) {
      context.commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["t" /* MONITORING_SET_DOCUMENT_IMAGE */], response.data.data);
      return response.data.data;
    } else {
      response.data.errors.forEach(function (error) {
        console.log(error);
      });
    }
  }).catch(function (error) {
    console.error(error);
  });
};

var getTracking = function getTracking(context, parameters) {
  return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* services */].tracking.retrieveTracking(parameters).then(function (response) {
    if (response.data !== undefined) {
      return response.data;
    } else {
      console.log(response.data.errorDescription);
    }
  }).catch(function (error) {
    if (error.status === 400) {
      return error.data;
    } else {
      console.error(error);
    }
  });
};

var getPointTracking = function getPointTracking(context, parameters) {
  return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* services */].tracking.retrievePointTracking(parameters).then(function (response) {
    if (response.data !== undefined) {
      return response.data;
    } else {
      console.log(response.data.errorDescription);
    }
  }).catch(function (error) {
    if (error.status === 400) {
      return error.data;
    } else {
      console.error(error);
    }
  });
};

var getUbigeo = function getUbigeo(context, parameters) {
  return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* services */].tracking.retrieveUbigeoList(parameters).then(function (response) {
    if (response.data !== undefined) {
      return response.data;
    } else {
      console.log(response.data.errorDescription);
    }
  }).catch(function (error) {
    console.error(error);
  });
};

var getOrderType = function getOrderType() {
  return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* services */].tracking.retrieveOrderTypeList().then(function (response) {
    if (response.data !== undefined) {
      return response.data;
    } else {
      console.log(response.data.errorDescription);
    }
  }).catch(function (error) {
    console.error(error);
  });
};

var getOrderStatus = function getOrderStatus() {
  return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* services */].tracking.retrieveStatusList().then(function (response) {
    if (response.data !== undefined) {
      return response.data;
    } else {
      console.log(response.data.errorDescription);
    }
  }).catch(function (error) {
    console.error(error);
  });
};

var getOrderZone = function getOrderZone() {
  return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* services */].tracking.retrieveZoneList().then(function (response) {
    if (response.data !== undefined) {
      return response.data;
    } else {
      console.log(response.data.errorDescription);
    }
  }).catch(function (error) {
    console.error(error);
  });
};

var getOrderFollow = function getOrderFollow(context, parameters) {
  return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* services */].tracking.retrieveOrderFollowUpList(parameters, parameters.Page, parameters.PageSize).then(function (response) {
    if (response.data !== undefined) {
      return response.data;
    } else {
      console.log(response.data.errorDescription);
    }
  }).catch(function (error) {
    if (error.status === 400) {
      return error.data;
    } else {
      console.error(error);
    }
  });
};

var getOrderFollowDetail = function getOrderFollowDetail(context, parameters) {
  return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* services */].tracking.retrieveOrderDetail(parameters).then(function (response) {
    if (response.data !== undefined) {
      return response.data;
    } else {
      console.log(response.data.errorDescription);
    }
  }).catch(function (error) {
    console.error(error);
  });
};

var getOrderReport = function getOrderReport(context, parameters) {
  return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* services */].tracking.retrieveGenerateReport(parameters).then(function (response) {
    if (response.data !== undefined) {
      return response.data;
    } else {
      console.log(response.data.errorDescription);
    }
  }).catch(function (error) {
    if (error.status === 400) {
      return error.data;
    } else {
      console.error(error);
    }
  });
};

var fetchAlertRulesList = function fetchAlertRulesList(context, accountCode) {
  return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* services */].rules.retrieveRuleList(accountCode).then(function (response) {
    if (response.data.success) {
      return response.data.data;
    } else {
      response.data.errors.forEach(function (error) {
        console.log(error);
      });
    }
  }).catch(function (error) {
    console.error(error);
  });
};

var fetchAlertRulesItemTypes = function fetchAlertRulesItemTypes(context) {
  return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* services */].rules.retrieveRuleItemTypes().then(function (response) {
    if (response.data.success) {
      return response.data.data.items;
    } else {
      response.data.errors.forEach(function (error) {
        console.log(error);
      });
    }
  }).catch(function (error) {
    console.error(error);
  });
};

var fetchAlertRulesOperators = function fetchAlertRulesOperators(context) {
  return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* services */].rules.retrieveRuleOperators().then(function (response) {
    if (response.data.success) {
      return response.data.data.items;
    } else {
      response.data.errors.forEach(function (error) {
        console.log(error);
      });
    }
  }).catch(function (error) {
    console.error(error);
  });
};

var saveAlertRule = function saveAlertRule(context, parameters) {
  return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* services */].rules.saveAlertRule(parameters).then(function (response) {
    if (!response.data.success) {
      response.data.errors.forEach(function (error) {
        console.log(error);
      });
    }
    return response.data;
  }).catch(function () {
    return { data: { success: false } };
  });
};

var fetchPerishableProductsModes = function fetchPerishableProductsModes(context) {
  if (__WEBPACK_IMPORTED_MODULE_5_vuex_store_js__["a" /* default */].getters.productModes) {
    return __WEBPACK_IMPORTED_MODULE_5_vuex_store_js__["a" /* default */].getters.productModes;
  } else {
    return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* services */].products.retrievePerishableProductsModes().then(function (response) {
      if (response.data.success) {
        context.commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["j" /* PRODUCT_SET_MODES */], response.data.data.items);
        return response.data.data.items;
      } else {
        response.data.errors.forEach(function (error) {
          console.log(error);
        });
      }
    }).catch(function (error) {
      console.error(error);
    });
  }
};

var fetchPerishableProductsList = function fetchPerishableProductsList(context, parameters) {
  return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* services */].products.retrievePerishableProductsList(parameters).then(function (response) {
    if (response.data.success) {
      return response.data.data.products;
    } else {
      response.data.errors.forEach(function (error) {
        console.log(error);
      });
    }
  }).catch(function (error) {
    console.error(error);
  });
};

var getDocumentStatus = function getDocumentStatus(context) {
  return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* services */].orders.retrieveDocumentStatusData().then(function (response) {
    if (response.data.success) {
      context.commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["m" /* ORDERPROGRESS_DOCUMENT_STATUS */], response.data.data.items);
      return response.data.data.items;
    } else {
      response.data.errors.forEach(function (error) {
        console.log(error);
      });
    }
  }).catch(function (error) {
    console.error(error);
  });
};

var getSupplierCustomer = function getSupplierCustomer(context, parameters) {
  return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* services */].orders.retrieveSupplierCustomerData(parameters).then(function (response) {
    if (response.data.success) {
      context.commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["l" /* ORDERPROGRESS_DOCUMENT_SUPPLIERCUSTOMER */], response.data.data.items);
      return response.data.data.items;
    } else {
      response.data.errors.forEach(function (error) {
        console.log(error);
      });
    }
  }).catch(function (error) {
    console.error(error);
  });
};

var fetchOrdersProgressData = function fetchOrdersProgressData(context, parameters) {
  return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* services */].orders.retrieveProgressData(parameters).then(function (response) {
    if (response.data.success) {
      context.commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["k" /* ORDERPROGRESS_SET_ORDER_SEARCH */], {
        result: response.data.data,
        params: parameters
      });
      return response.data.data;
    } else {
      response.data.errors.forEach(function (error) {
        console.log(error);
      });
    }
  }).catch(function (error) {
    console.error(error);
  });
};

var fetchEriSummaryData = function fetchEriSummaryData(context, parameters) {
  return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* services */].inventory.retrieveEriSummaryData(parameters).then(function (response) {
    if (response.data.success) {
      return response.data.data.eris;
    } else {
      response.data.errors.forEach(function (error) {
        console.log(error);
      });
    }
  }).catch(function (error) {
    console.error(error);
  });
};

var fetchEriDetailData = function fetchEriDetailData(context, parameters) {
  return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* services */].inventory.retrieveEriDetailData(parameters).then(function (response) {
    if (response.data.success) {
      return response.data.data;
    } else {
      response.data.errors.forEach(function (error) {
        console.log(error);
      });
    }
  }).catch(function (error) {
    console.error(error);
  });
};

var exportEriDetailData = function exportEriDetailData(context, parameters) {
  return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* services */].inventory.exportEriDetailData(parameters).then(function (response) {
    if (response.data) {
      return response.data;
    } else {
      response.data.errors.forEach(function (error) {
        console.log(error);
      });
    }
  }).catch(function (error) {
    console.error(error);
  });
};

var inventoryEntry = function inventoryEntry(context, data) {
  return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* services */].inventory.eriEntry(data).then(function (response) {
    if (response.data.success) {
      return true;
    } else {
      response.data.errors.forEach(function (error) {
        console.log(error);
      });
    }
  }).catch(function (error) {
    console.error(error);
  });
};

var getItemsForInventory = function getItemsForInventory(context, accountCode) {
  return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* services */].inventory.retrieveItemsForInventoryData(accountCode).then(function (response) {
    if (response.data.success) {
      context.commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["v" /* INVENTORY_SET_ITEMS */], response.data.data.items);
      return response.data.data.items;
    } else {
      response.data.errors.forEach(function (error) {
        console.log(error);
      });
    }
  }).catch(function (error) {
    console.error(error);
  });
};

var fetchInventoryProductStatusList = function fetchInventoryProductStatusList(context, parameters) {
  return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* services */].inventory.retrieveInventoryProductStatusData(parameters).then(function (response) {
    if (response.data.success) {
      return response.data.data;
    } else {
      response.data.errors.forEach(function (error) {
        console.log(error);
      });
    }
  }).catch(function (error) {
    console.error(error);
  });
};

var fetchInventoryLines = function fetchInventoryLines(context, accountCode) {
  if (__WEBPACK_IMPORTED_MODULE_5_vuex_store_js__["a" /* default */].getters.inventoryLines[accountCode]) {
    return __WEBPACK_IMPORTED_MODULE_5_vuex_store_js__["a" /* default */].getters.inventoryLines[accountCode];
  } else {
    return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* services */].inventory.retrieveInventoryLines(accountCode).then(function (response) {
      if (response.data.success) {
        context.commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["w" /* INVENTORY_SET_LINES */], {
          accountCode: accountCode,
          data: response.data.data.lines
        });
        return response.data.data.lines;
      } else {
        response.data.errors.forEach(function (error) {
          console.log(error);
        });
      }
    }).catch(function (error) {
      console.error(error);
    });
  }
};

var fetchInventoryStatus = function fetchInventoryStatus(context, accountCode) {
  if (__WEBPACK_IMPORTED_MODULE_5_vuex_store_js__["a" /* default */].getters.inventoryStatuses[accountCode]) {
    return __WEBPACK_IMPORTED_MODULE_5_vuex_store_js__["a" /* default */].getters.inventoryStatuses[accountCode];
  } else {
    return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* services */].inventory.retrieveInventoryStatus(accountCode).then(function (response) {
      if (response.data.success) {
        context.commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["x" /* INVENTORY_SET_STATUSES */], {
          accountCode: accountCode,
          data: response.data.data.items
        });
        return response.data.data.items;
      } else {
        response.data.errors.forEach(function (error) {
          console.log(error);
        });
      }
    }).catch(function (error) {
      console.error(error);
    });
  }
};

var fetchDocumentTypes = function fetchDocumentTypes(context) {
  return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* services */].documents.retrieveTypesData().then(function (response) {
    if (response.data.success) {
      return response.data.data.items;
    } else {
      response.data.errors.forEach(function (error) {
        console.log(error);
      });
    }
  }).catch(function (error) {
    console.error(error);
  });
};

var getItemsForAccountConfiguration = function getItemsForAccountConfiguration(context, parameters) {
  return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* services */].documents.retrieveAccountConfigurationData(parameters).then(function (response) {
    if (response.data.success) {
      return response.data.data.items;
    } else {
      response.data.errors.forEach(function (error) {
        console.log(error);
      });
    }
  }).catch(function (error) {
    console.error(error);
  });
};

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return services; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services__ = __webpack_require__(272);

var services = __WEBPACK_IMPORTED_MODULE_0__services__["a" /* default */];

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_httpAxios__ = __webpack_require__(14);



/* harmony default export */ __webpack_exports__["a"] = ({
  retrieveToken: function retrieveToken(data) {
    return __WEBPACK_IMPORTED_MODULE_1_lib_httpAxios__["b" /* http */].post('/authentication', data).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  }
});

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_httpAxios__ = __webpack_require__(14);



/* harmony default export */ __webpack_exports__["a"] = ({
  retrieveDashboardData: function retrieveDashboardData(data) {
    var url = '/dashboard/' + data.client.code + '/' + data.startDate + '/' + data.endDate;
    return __WEBPACK_IMPORTED_MODULE_1_lib_httpAxios__["b" /* http */].get(url).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  }
});

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_httpAxios__ = __webpack_require__(14);



/* harmony default export */ __webpack_exports__["a"] = ({
  retrieveAppointmentDocumentList: function retrieveAppointmentDocumentList(accountCode) {
    return __WEBPACK_IMPORTED_MODULE_1_lib_httpAxios__["b" /* http */].get('/appointments/dispatch/' + accountCode + '/files').then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },
  uploadApointmentFile: function uploadApointmentFile(parameters) {
    return __WEBPACK_IMPORTED_MODULE_1_lib_httpAxios__["b" /* http */].post('/appointments/dispatch/' + parameters.accountCode, parameters.file).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },
  saveApointmentFile: function saveApointmentFile(parameters) {
    return __WEBPACK_IMPORTED_MODULE_1_lib_httpAxios__["b" /* http */].post('/appointments/dispatch/' + parameters.accountCode + '/save', parameters.data).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },
  retrieveVehicleList: function retrieveVehicleList(accountCode) {
    return __WEBPACK_IMPORTED_MODULE_1_lib_httpAxios__["b" /* http */].get('/distribution/vehicles/' + accountCode).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },
  retrieveVehicleLocation: function retrieveVehicleLocation(plate) {
    return __WEBPACK_IMPORTED_MODULE_1_lib_httpAxios__["b" /* http */].get('/distribution/vehicle/' + plate + '/location').then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  }
});

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_httpAxios__ = __webpack_require__(14);



/* harmony default export */ __webpack_exports__["a"] = ({
  retrieveTypesData: function retrieveTypesData(parameters) {
    return __WEBPACK_IMPORTED_MODULE_1_lib_httpAxios__["b" /* http */].get('/documents/types/all').then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },
  retrieveAccountConfigurationData: function retrieveAccountConfigurationData(parameters) {
    return __WEBPACK_IMPORTED_MODULE_1_lib_httpAxios__["b" /* http */].post('/documents/configuration/' + parameters.accountCode, parameters).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  }
});

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__auth__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dashboard__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__inventory__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reception__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__dispatch__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__monitoring__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__orders__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__products__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__documents__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__rules__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__tracking__ = __webpack_require__(279);












/* harmony default export */ __webpack_exports__["a"] = ({
  auth: __WEBPACK_IMPORTED_MODULE_0__auth__["a" /* default */],
  dashboard: __WEBPACK_IMPORTED_MODULE_1__dashboard__["a" /* default */],
  inventory: __WEBPACK_IMPORTED_MODULE_2__inventory__["a" /* default */],
  reception: __WEBPACK_IMPORTED_MODULE_3__reception__["a" /* default */],
  dispatch: __WEBPACK_IMPORTED_MODULE_4__dispatch__["a" /* default */],
  monitoring: __WEBPACK_IMPORTED_MODULE_5__monitoring__["a" /* default */],
  orders: __WEBPACK_IMPORTED_MODULE_6__orders__["a" /* default */],
  products: __WEBPACK_IMPORTED_MODULE_7__products__["a" /* default */],
  documents: __WEBPACK_IMPORTED_MODULE_8__documents__["a" /* default */],
  rules: __WEBPACK_IMPORTED_MODULE_9__rules__["a" /* default */],
  tracking: __WEBPACK_IMPORTED_MODULE_10__tracking__["a" /* default */]
});

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_httpAxios__ = __webpack_require__(14);



/* harmony default export */ __webpack_exports__["a"] = ({
  retrieveEriSummaryData: function retrieveEriSummaryData(parameters) {
    return __WEBPACK_IMPORTED_MODULE_1_lib_httpAxios__["b" /* http */].post('/eri/summary', parameters).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },
  retrieveEriDetailData: function retrieveEriDetailData(parameters) {
    var url = '/eri/' + parameters.accountCode + '/' + parameters.period;
    return __WEBPACK_IMPORTED_MODULE_1_lib_httpAxios__["b" /* http */].get(url).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },
  exportEriDetailData: function exportEriDetailData(parameters) {
    var url = '/eri/export/' + parameters.accountCode + '/' + parameters.period;
    var headers = {
      responseType: 'blob'
    };
    return __WEBPACK_IMPORTED_MODULE_1_lib_httpAxios__["b" /* http */].get(url, headers).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },
  eriEntry: function eriEntry(data) {
    var formattedData = {
      Eris: []
    };
    formattedData.Eris.push(data);

    return __WEBPACK_IMPORTED_MODULE_1_lib_httpAxios__["b" /* http */].post('/eri', formattedData).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },
  retrieveItemsForInventoryData: function retrieveItemsForInventoryData(accountCode) {
    return __WEBPACK_IMPORTED_MODULE_1_lib_httpAxios__["b" /* http */].get('/inventories/items/' + accountCode).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },
  retrieveInventoryProductStatusData: function retrieveInventoryProductStatusData(parameters) {
    return __WEBPACK_IMPORTED_MODULE_1_lib_httpAxios__["b" /* http */].post('/inventories/states/' + parameters.accountCode, parameters).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },
  retrieveInventoryLines: function retrieveInventoryLines(accountCode) {
    return __WEBPACK_IMPORTED_MODULE_1_lib_httpAxios__["b" /* http */].get('/inventories/lines/' + accountCode).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },
  retrieveInventoryStatus: function retrieveInventoryStatus(accountCode) {
    return __WEBPACK_IMPORTED_MODULE_1_lib_httpAxios__["b" /* http */].get('/inventories/status/' + accountCode).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  }
});

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_httpAxios__ = __webpack_require__(14);



/* harmony default export */ __webpack_exports__["a"] = ({
  retrieveDocumentList: function retrieveDocumentList(parameters) {
    return __WEBPACK_IMPORTED_MODULE_1_lib_httpAxios__["b" /* http */].post('/documents/search/' + parameters.page.Page + '/10', parameters.params).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },
  retrieveDocument: function retrieveDocument(parameters) {
    return __WEBPACK_IMPORTED_MODULE_1_lib_httpAxios__["b" /* http */].get('/documents/' + parameters.documentId + '/' + parameters.documentType).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },
  retrieveDocumentTypes: function retrieveDocumentTypes(parameters) {
    return __WEBPACK_IMPORTED_MODULE_1_lib_httpAxios__["b" /* http */].get('/documentstypes/' + parameters.params.AccountCode).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },
  retrieveDocumentImages: function retrieveDocumentImages(parameters, headerToken) {
    return __WEBPACK_IMPORTED_MODULE_1_lib_httpAxios__["b" /* http */].get('/documents/' + parameters.AccountCode + '/' + parameters.documentId + '/' + parameters.documentType + '/' + parameters.eventCode + '/images', { headers: { 'Authorization': 'Basic ' + parameters.headerToken } }).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  }
});

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_httpAxios__ = __webpack_require__(14);



/* harmony default export */ __webpack_exports__["a"] = ({
  retrieveDocumentStatusData: function retrieveDocumentStatusData() {
    return __WEBPACK_IMPORTED_MODULE_1_lib_httpAxios__["b" /* http */].post('/order/status').then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },
  retrieveSupplierCustomerData: function retrieveSupplierCustomerData(parameters) {
    return __WEBPACK_IMPORTED_MODULE_1_lib_httpAxios__["b" /* http */].post('/orders/suppliercustomer/', parameters).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },
  retrieveProgressData: function retrieveProgressData(parameters) {
    return __WEBPACK_IMPORTED_MODULE_1_lib_httpAxios__["b" /* http */].post('/orders/search/', parameters).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  }
});

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_httpAxios__ = __webpack_require__(14);



/* harmony default export */ __webpack_exports__["a"] = ({
  retrievePerishableProductsModes: function retrievePerishableProductsModes() {
    return __WEBPACK_IMPORTED_MODULE_1_lib_httpAxios__["b" /* http */].get('/products/expiring/modes/').then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },
  retrievePerishableProductsList: function retrievePerishableProductsList(parameters) {
    return __WEBPACK_IMPORTED_MODULE_1_lib_httpAxios__["b" /* http */].post('/products/expiring/', parameters).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  }
});

/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_httpAxios__ = __webpack_require__(14);



/* harmony default export */ __webpack_exports__["a"] = ({
  retrieveAppointmentDocumentList: function retrieveAppointmentDocumentList(accountCode) {
    return __WEBPACK_IMPORTED_MODULE_1_lib_httpAxios__["b" /* http */].get('/appointments/reception/' + accountCode + '/files').then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },
  uploadApointmentFile: function uploadApointmentFile(parameters) {
    return __WEBPACK_IMPORTED_MODULE_1_lib_httpAxios__["b" /* http */].post('/appointments/reception/' + parameters.accountCode, parameters.file).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },
  saveApointmentFile: function saveApointmentFile(parameters) {
    return __WEBPACK_IMPORTED_MODULE_1_lib_httpAxios__["b" /* http */].post('/appointments/reception/' + parameters.accountCode + '/save', parameters.data).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  }
});

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_httpAxios__ = __webpack_require__(14);



/* harmony default export */ __webpack_exports__["a"] = ({
  retrieveRuleList: function retrieveRuleList(accountCode) {
    return __WEBPACK_IMPORTED_MODULE_1_lib_httpAxios__["b" /* http */].get('/alertrules/' + accountCode).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },
  retrieveRuleItemTypes: function retrieveRuleItemTypes() {
    return __WEBPACK_IMPORTED_MODULE_1_lib_httpAxios__["b" /* http */].get('/alertrules/options/appliesto').then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },
  retrieveRuleOperators: function retrieveRuleOperators() {
    return __WEBPACK_IMPORTED_MODULE_1_lib_httpAxios__["b" /* http */].get('/alertrules/options/operators').then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },
  saveAlertRule: function saveAlertRule(parameters) {
    var data = {
      AlertRules: []
    };
    data.AlertRules.push(parameters);
    return __WEBPACK_IMPORTED_MODULE_1_lib_httpAxios__["b" /* http */].post('/alertrules', data).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  }
});

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_httpAxios__ = __webpack_require__(14);



/* harmony default export */ __webpack_exports__["a"] = ({
  retrieveTracking: function retrieveTracking(data) {
    return __WEBPACK_IMPORTED_MODULE_1_lib_httpAxios__["a" /* httpi */].post('/Integration/Tracking/OrderList', data).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error.response);
    });
  },
  retrievePointTracking: function retrievePointTracking(data) {
    return __WEBPACK_IMPORTED_MODULE_1_lib_httpAxios__["a" /* httpi */].post('/Integration/Tracking/LocationCurrent', data).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error.response);
    });
  },
  retrieveUbigeoList: function retrieveUbigeoList(data) {
    return __WEBPACK_IMPORTED_MODULE_1_lib_httpAxios__["a" /* httpi */].post('/Integration/Master/UbigeoList', data).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error.response);
    });
  },
  retrieveOrderTypeList: function retrieveOrderTypeList() {
    return __WEBPACK_IMPORTED_MODULE_1_lib_httpAxios__["a" /* httpi */].post('/Integration/Master/OrderTypeList', {}).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error.response);
    });
  },
  retrieveStatusList: function retrieveStatusList() {
    return __WEBPACK_IMPORTED_MODULE_1_lib_httpAxios__["a" /* httpi */].post('/Integration/Master/StatusList', {}).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error.response);
    });
  },
  retrieveZoneList: function retrieveZoneList() {
    return __WEBPACK_IMPORTED_MODULE_1_lib_httpAxios__["a" /* httpi */].post('/Integration/Master/ZoneList', {}).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error.response);
    });
  },
  retrieveOrderFollowUpList: function retrieveOrderFollowUpList(data, page, size) {
    return __WEBPACK_IMPORTED_MODULE_1_lib_httpAxios__["a" /* httpi */].post('/Integration/Query/OrderFollowUpList/' + page + '/' + size, data).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error.response);
    });
  },
  retrieveOrderDetail: function retrieveOrderDetail(data) {
    return __WEBPACK_IMPORTED_MODULE_1_lib_httpAxios__["a" /* httpi */].post('/Integration/Query/OrderDetail', data).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error.response);
    });
  },
  retrieveGenerateReport: function retrieveGenerateReport(data) {
    return __WEBPACK_IMPORTED_MODULE_1_lib_httpAxios__["a" /* httpi */].post('/Integration/Query/GenerateReport', data).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error.response);
    });
  }
});

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loggedIn", function() { return loggedIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "slideMenuItems", function() { return slideMenuItems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "userInfo", function() { return userInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "userClients", function() { return userClients; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "userPermissions", function() { return userPermissions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "userDefaultMenu", function() { return userDefaultMenu; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "userTimeout", function() { return userTimeout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "dashboardFilter", function() { return dashboardFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "inventoryLines", function() { return inventoryLines; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "inventoryStatuses", function() { return inventoryStatuses; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "productModes", function() { return productModes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "documentTypes", function() { return documentTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "documentSearch", function() { return documentSearch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "documentSearchImage", function() { return documentSearchImage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "orderProgressSeach", function() { return orderProgressSeach; });
var loggedIn = function loggedIn(state) {
  return state.user.token !== null;
};
var slideMenuItems = function slideMenuItems(state) {
  return state.user.slideMenuItems;
};
var userInfo = function userInfo(state) {
  return state.user.info;
};
var userClients = function userClients(state) {
  return state.user.clients;
};
var userPermissions = function userPermissions(state) {
  return state.user.permissions;
};
var userDefaultMenu = function userDefaultMenu(state) {
  return state.user.defaultMenu;
};
var userTimeout = function userTimeout(state) {
  return state.user.timeout;
};
var dashboardFilter = function dashboardFilter(state) {
  return state.dashboardFilter;
};
var inventoryLines = function inventoryLines(state) {
  return state.inventory.lines;
};
var inventoryStatuses = function inventoryStatuses(state) {
  return state.inventory.statuses;
};
var productModes = function productModes(state) {
  return state.product.modes;
};
var documentTypes = function documentTypes(state) {
  return state.monitoring.types;
};
var documentSearch = function documentSearch(state) {
  return state.monitoring.search;
};
var documentSearchImage = function documentSearchImage(state) {
  return state.monitoring.images;
};
var orderProgressSeach = function orderProgressSeach(state) {
  return state.orders.search;
};

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_assets_js_constants_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment_moment_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment_moment_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment_moment_js__);



var _mutations;





var state = JSON.parse(localStorage.getItem('dashboard_filter')) || getDefaultFilter();

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["y" /* DASHBOARD_RESET_FILTER */], function (state) {
  var defaultFilter = getDefaultFilter();
  state.mode = defaultFilter.mode;
  state.startDate = defaultFilter.startDate;
  state.endDate = defaultFilter.endDate;
  state.startDateFmt = defaultFilter.startDateFmt;
  state.endDateFmt = defaultFilter.endDateFmt;
  state.client = defaultFilter.client;
  state.fetchData = defaultFilter.fetchData;
  localStorage.removeItem('dashboard_filter');
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["z" /* DASHBOARD_SET_FILTER_DATE */], function (state, filter) {
  state.mode = filter.mode;
  state.startDate = filter.startDate;
  state.endDate = filter.endDate;
  state.startDateFmt = filter.startDateFmt;
  state.endDateFmt = filter.endDateFmt;
  localStorage.setItem('dashboard_filter', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(state));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["A" /* DASHBOARD_SET_FILTER_CLIENT */], function (state, client) {
  state.client = client;
  localStorage.setItem('dashboard_filter', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(state));
}), _mutations);

function getDefaultFilter() {
  var curentDate = __WEBPACK_IMPORTED_MODULE_4_moment_moment_js___default()();
  return {
    mode: __WEBPACK_IMPORTED_MODULE_3_assets_js_constants_js__["a" /* default */].dashboardFilterModes.today,
    startDate: curentDate.format('YYYYMMDD'),
    endDate: curentDate.format('YYYYMMDD'),
    startDateFmt: curentDate.format('DD/MM/YYYY'),
    endDateFmt: curentDate.format('DD/MM/YYYY'),
    client: null
  };
}

/* harmony default export */ __webpack_exports__["default"] = ({
  state: state,
  mutations: mutations
});

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__(19);



var _mutations;



var state = {
  lines: JSON.parse(localStorage.getItem('inventory_lines')) || {},
  statuses: JSON.parse(localStorage.getItem('inventory_statuses')) || {}
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["u" /* INVENTORY_RESET_VALUES */], function (state) {
  var defaultValues = getDefaultValues();
  state.lines = defaultValues.lines;
  state.statuses = defaultValues.statuses;
  localStorage.removeItem('inventory_lines');
  localStorage.removeItem('inventory_statuses');
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["v" /* INVENTORY_SET_ITEMS */], function (state, types) {
  state.types = types;
  localStorage.setItem('inventory_items', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(types));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["w" /* INVENTORY_SET_LINES */], function (state, lines) {
  state.lines[lines.accountCode] = lines.data;
  localStorage.setItem('inventory_lines', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(state.lines));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["x" /* INVENTORY_SET_STATUSES */], function (state, statuses) {
  state.statuses[statuses.accountCode] = statuses.data;
  localStorage.setItem('inventory_statuses', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(state.statuses));
}), _mutations);

function getDefaultValues() {
  return {
    lines: {},
    statuses: {}
  };
}

/* harmony default export */ __webpack_exports__["default"] = ({
  state: state,
  mutations: mutations
});

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__(19);



var _mutations;



var state = {
  types: JSON.parse(localStorage.getItem('monitoring_document_types')),
  search: JSON.parse(localStorage.getItem('monitoring_document_search')),
  images: JSON.parse(localStorage.getItem('image_document'))
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["o" /* MONITORING_DOCUMENT_TYPES_RESET */], function (state) {
  state.search = null;
  localStorage.removeItem('monitoring_document_types');
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["p" /* MONITORING_SET_DOCUMENT_TYPES */], function (state, types) {
  state.types = types;
  localStorage.setItem('monitoring_document_types', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(types));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["q" /* MONITORING_DOCUMENT_SEARCH_RESET */], function (state) {
  state.search = null;
  localStorage.removeItem('monitoring_document_search');
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["r" /* MONITORING_SET_DOCUMENT_SEARCH */], function (state, search) {
  state.search = {
    filter: search.filter,
    result: search.result,
    page: 1
  };
  localStorage.setItem('monitoring_document_search', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(state.search));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["s" /* MONITORING_SET_DOCUMENT_SEARCH_PAGE */], function (state, page) {
  state.search.page = page;
  localStorage.setItem('monitoring_document_search', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(state.search));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["t" /* MONITORING_SET_DOCUMENT_IMAGE */], function (state, images) {
  state.images = images;
  localStorage.setItem('monitoring_document_images', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(images));
}), _mutations);

/* harmony default export */ __webpack_exports__["default"] = ({
  state: state,
  mutations: mutations
});

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__(19);



var _mutations;



var state = {
  search: JSON.parse(localStorage.getItem('orders_set_order_search'))
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["h" /* ORDERPROGRESS_SET_ORDER_RESET */], function (state) {
  state.search = null;
  localStorage.removeItem('orders_set_order_search');
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["k" /* ORDERPROGRESS_SET_ORDER_SEARCH */], function (state, search) {
  state.search = {
    search: search.result,
    params: search.params
  };
  localStorage.setItem('orders_set_order_search', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(search.result));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["l" /* ORDERPROGRESS_DOCUMENT_SUPPLIERCUSTOMER */], function (state, types) {
  state.types = types;
  localStorage.setItem('orderprogress_document_suppliercustomer', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(types));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["m" /* ORDERPROGRESS_DOCUMENT_STATUS */], function (state, types) {
  state.types = types;
  localStorage.setItem('orderprogress_document_status', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(types));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["n" /* ORDERPROGRESS_TYPES_ORDER */], function (state, types) {
  state.types = types;
  localStorage.setItem('orderprogress_types_order', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(types));
}), _mutations);

/* harmony default export */ __webpack_exports__["default"] = ({
  state: state,
  mutations: mutations
});

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__(19);



var _mutations;



var state = {
  modes: JSON.parse(localStorage.getItem('product_modes'))
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["i" /* PRODUCT_RESET_VALUES */], function (state) {
  var defaultValues = getDefaultValues();
  state.modes = defaultValues.modes;
  localStorage.removeItem('product_modes');
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["j" /* PRODUCT_SET_MODES */], function (state, modes) {
  state.modes = modes;
  localStorage.setItem('product_modes', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(modes));
}), _mutations);

function getDefaultValues() {
  return {
    modes: null
  };
}

/* harmony default export */ __webpack_exports__["default"] = ({
  state: state,
  mutations: mutations
});

/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(19);



var state = {
  search: JSON.parse(localStorage.getItem('orders_set_order_search'))
};

var mutations = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["h" /* ORDERPROGRESS_SET_ORDER_RESET */], function (state) {
  state.search = null;
  localStorage.removeItem('orders_set_order_search');
});

/* harmony default export */ __webpack_exports__["default"] = ({
  state: state,
  mutations: mutations
});

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment_moment_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment_moment_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment_moment_js__);



var _mutations;




var state = {
  token: localStorage.getItem('access_token'),
  info: JSON.parse(localStorage.getItem('user_info')) || {
    userID: '',
    name: '',
    position: '',
    createdAt: ''
  },
  clients: JSON.parse(localStorage.getItem('user_clients')) || [],
  permissions: JSON.parse(localStorage.getItem('user_permissions')) || [],
  defaultMenu: JSON.parse(localStorage.getItem('user_defaultMenu')) || {},
  slideMenuItems: JSON.parse(localStorage.getItem('user_menu_items')) || [],
  timeout: JSON.parse(localStorage.getItem('user_timeout')) || {
    timeLogin: __WEBPACK_IMPORTED_MODULE_3_moment_moment_js___default()().subtract(1, 'days'),
    timeInactivitySession: 1,
    timeEndSession: 1
  }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* AUTH_LOGGED_IN */], function (state, data) {
  state.token = true;
  localStorage.setItem('access_token', true);

  var objTimeout = {
    timeLogin: __WEBPACK_IMPORTED_MODULE_3_moment_moment_js___default()(),
    timeInactivitySession: data.timeInactivitySession,
    timeEndSession: data.timeEndSession
  };

  state.timeout = objTimeout;
  localStorage.setItem('user_timeout', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(objTimeout));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["b" /* AUTH_LOGGED_OUT */], function (state) {
  cleanState(state);
  localStorage.removeItem('access_token');
  localStorage.removeItem('user_info');
  localStorage.removeItem('user_clients');
  localStorage.removeItem('user_permissions');
  localStorage.removeItem('user_defaultMenu');
  localStorage.removeItem('user_menu_items');
  localStorage.removeItem('user_timeout');
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["c" /* USER_SET_PERMISSIONS */], function (state, permissions) {
  state.permissions = JSON.parse(permissions);
  localStorage.setItem('user_permissions', permissions);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["d" /* USER_SET_DEFAULT_MENU_ITEM */], function (state, defaultMenu) {
  state.defaultMenu = JSON.parse(defaultMenu);
  localStorage.setItem('user_defaultMenu', defaultMenu);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["e" /* USER_SET_SLIDE_MENU_ITEMS */], function (state, slideMenuItems) {
  state.slideMenuItems = slideMenuItems;
  localStorage.setItem('user_menu_items', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(slideMenuItems));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["f" /* USER_FETCH_INFO */], function (state, info) {
  state.info = JSON.parse(info);
  localStorage.setItem('user_info', info);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["g" /* USER_FETCH_CLIENTS */], function (state, clients) {
  state.clients = JSON.parse(clients);
  localStorage.setItem('user_clients', clients);
}), _mutations);

function cleanState(state) {
  state.token = null;
  state.userID = '';
  state.info = {};
  state.clients = [];
}

/* harmony default export */ __webpack_exports__["default"] = ({
  state: state,
  mutations: mutations
});

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ((function (x) {
  return x.default || x;
})(__webpack_require__(543)));

/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ((function (x) {
  return x.default || x;
})(__webpack_require__(545)));

/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ((function (x) {
  return x.default || x;
})(__webpack_require__(546)));

/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ((function (x) {
  return x.default || x;
})(__webpack_require__(551)));

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_store_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_layout_DefaultLayout_vue__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_layout_DefaultLayout_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_layout_DefaultLayout_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_layout_Master_vue__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_layout_Master_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_layout_Master_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_layout_MasterOrange_vue__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_layout_MasterOrange_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_layout_MasterOrange_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment_moment_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment_moment_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment_moment_js__);











/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  data: function data() {
    return {
      layout: '',
      timeout: null,
      interval: null
    };
  },

  watch: {
    loggedIn: function loggedIn(newVal, oldVal) {
      this.evaluateLogIn();
    }
  },
  created: function created() {},
  mounted: function mounted() {
    this.evaluateLogIn();
  },

  components: {
    'defaultLayout': __WEBPACK_IMPORTED_MODULE_3__components_layout_DefaultLayout_vue___default.a,
    'master': __WEBPACK_IMPORTED_MODULE_4__components_layout_Master_vue___default.a,
    'masterOrange': __WEBPACK_IMPORTED_MODULE_5__components_layout_MasterOrange_vue___default.a
  },
  methods: {
    evaluateLogIn: function evaluateLogIn() {
      var _this = this;

      var linkForFavicon = document.querySelector('head > link[rel=\'icon\']');

      var isDefault = false;
      if (this.$router.currentRoute.name === 'Login' || this.$router.currentRoute.name === 'Tracking' || this.$router.currentRoute.name === 'TrackingOrder') {
        isDefault = true;
      }
      if (this.loggedIn && !isDefault) {
        this.interval = setInterval(function () {
          _this.checkSessionTimeOut();
        }, 1000);
        document.addEventListener('mousemove', this.refreshIdleTimeOut);
        this.refreshIdleTimeOut();
        this.layout = 'masterOrange';
        linkForFavicon.setAttribute('href', '/static/img/icons/ic_dinet_logo.png');
      } else {
        document.removeEventListener('mousemove', this.refreshIdleTimeOut);
        this.clearTimers();
        this.layout = 'defaultLayout';
        if (this.$router.currentRoute.name === 'Tracking' || this.$router.currentRoute.name === 'TrackingOrder') {
          linkForFavicon.setAttribute('href', '/static/img/logo.png');
        } else {
          linkForFavicon.setAttribute('href', '/static/img/icons/ic_dinet_logo.png');
        }
      }
    },
    refreshIdleTimeOut: function refreshIdleTimeOut() {
      var _this2 = this;

      clearTimeout(this.timeout);
      this.timeout = setTimeout(function () {
        _this2.$router.push({ name: 'Logout' });
      }, this.userTimeout.timeInactivitySession * 1000);
    },
    checkSessionTimeOut: function checkSessionTimeOut() {
      var now = __WEBPACK_IMPORTED_MODULE_6_moment_moment_js___default()();
      var login = __WEBPACK_IMPORTED_MODULE_6_moment_moment_js___default()(this.userTimeout.timeLogin);
      var diff = __WEBPACK_IMPORTED_MODULE_6_moment_moment_js___default.a.duration(now.diff(login)).asSeconds();

      if (diff >= this.userTimeout.timeEndSession) {}
    },
    clearTimers: function clearTimers() {
      clearInterval(this.interval);
      clearTimeout(this.timeout);
    }
  },
  store: __WEBPACK_IMPORTED_MODULE_1__vuex_store_js__["a" /* default */],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['loggedIn', 'userTimeout']))
});

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Home',
  data: function data() {
    return {};
  },

  computed: {},
  created: function created() {},
  mounted: function mounted() {},

  methods: {},
  components: {}
});

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Login2',
  data: function data() {
    return {
      Username: '',
      Password: '',
      submitted: false,
      message: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['loggedIn', 'userDefaultMenu', 'userInfo'])),
  created: function created() {},

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])(['logIn', 'fetchUserInfo', 'fetchUserClients']), {
    handleSubmit: function handleSubmit() {
      var _this = this;

      document.activeElement.blur();
      this.submitted = true;
      if (this.Username && this.Password) {
        var loader = this.$loading.show({
          loader: 'dots'
        });

        var parameters = {
          Username: this.Username.toUpperCase(),
          Password: this.Password
        };

        this.logIn(parameters).then(function () {
          _this.submitted = false;
          _this.message = '';

          if (_this.loggedIn) {
            _this.$router.go({ name: _this.userDefaultMenu.permission });
          } else {
            _this.message = 'Usuario y/o contraseña incorrecto';
            loader.hide();
          }
        });
      } else if (!this.Username || !this.Password) {
        this.submitted = false;
        this.message = 'Usuario y/o contraseña incorrecto';
      }
    }
  })
});

/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Logout',
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])(['logOut'])),
  created: function created() {
    var _this = this;

    this.logOut().then(function (response) {
      _this.$router.push({ name: 'Login' });
    });
  }
});

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_assets_js_constants_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap_daterangepicker_daterangepicker_css__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap_daterangepicker_daterangepicker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_bootstrap_daterangepicker_daterangepicker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_daterangepicker_daterangepicker_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_daterangepicker_daterangepicker_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_bootstrap_daterangepicker_daterangepicker_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_multiselect__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_multiselect_dist_vue_multiselect_min_css__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_multiselect_dist_vue_multiselect_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_multiselect_dist_vue_multiselect_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment_moment_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment_moment_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment_moment_js__);












/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      optionsAccount: null,
      window: {
        width: 0,
        height: 0
      }
    };
  },

  name: 'DashboardFilter',
  components: {
    Multiselect: __WEBPACK_IMPORTED_MODULE_6_vue_multiselect___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])(['dashboardFilter', 'userClients'])),
  created: function created() {
    this.optionsAccount = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(this.userClients);
  },

  mounted: function mounted() {
    $(this.$el).find('#dtDateRange').daterangepicker({
      startDate: this.dashboardFilter.startDateFmt,
      endDate: this.dashboardFilter.endDateFmt,
      opens: 'left',
      locale: __WEBPACK_IMPORTED_MODULE_2_assets_js_constants_js__["a" /* default */].datePickerLocale
    }, function (start, end, label) {
      $('#divModeButtons button.btn-success').click();
    });

    $('#divModeButtons button.btn-success').click();
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])(['setFilterDate', 'setFilterClient']), {
    getClass: function getClass(mode) {
      var classVal = 'btn btn-sm btn-';
      classVal += this.dashboardFilter.mode === mode ? 'success' : 'default';
      return classVal;
    },
    onAccountSelect: function onAccountSelect(account) {
      this.setFilterClient(account);
      this.$parent.filterRefresh();
    },
    onModeSelect: function onModeSelect(mode) {
      document.activeElement.blur();
      this.changeFilter(mode);
    },
    changeFilter: function changeFilter(mode) {
      var startDate = void 0,
          endDate = void 0,
          startDateFmt = void 0,
          endDateFmt = void 0;
      var curentDate = __WEBPACK_IMPORTED_MODULE_8_moment_moment_js___default()();

      switch (mode) {
        case __WEBPACK_IMPORTED_MODULE_2_assets_js_constants_js__["a" /* default */].dashboardFilterModes.today:
          startDate = curentDate.format('YYYYMMDD');
          endDate = curentDate.format('YYYYMMDD');
          startDateFmt = curentDate.format('DD/MM/YYYY');
          endDateFmt = curentDate.format('DD/MM/YYYY');
          break;
        case __WEBPACK_IMPORTED_MODULE_2_assets_js_constants_js__["a" /* default */].dashboardFilterModes.week:
          startDate = curentDate.startOf('isoWeek').format('YYYYMMDD');
          endDate = curentDate.endOf('isoWeek').format('YYYYMMDD');
          startDateFmt = curentDate.startOf('isoWeek').format('DD/MM/YYYY');
          endDateFmt = curentDate.endOf('isoWeek').format('DD/MM/YYYY');
          break;
        case __WEBPACK_IMPORTED_MODULE_2_assets_js_constants_js__["a" /* default */].dashboardFilterModes.month:
          startDate = curentDate.startOf('month').format('YYYYMMDD');
          endDate = curentDate.endOf('month').format('YYYYMMDD');
          startDateFmt = curentDate.startOf('month').format('DD/MM/YYYY');
          endDateFmt = curentDate.endOf('month').format('DD/MM/YYYY');
          break;
        case __WEBPACK_IMPORTED_MODULE_2_assets_js_constants_js__["a" /* default */].dashboardFilterModes.date:
          startDate = $('#dtDateRange').data('daterangepicker').startDate.format('YYYYMMDD');
          endDate = $('#dtDateRange').data('daterangepicker').endDate.format('YYYYMMDD');
          startDateFmt = $('#dtDateRange').data('daterangepicker').startDate.format('DD/MM/YYYY');
          endDateFmt = $('#dtDateRange').data('daterangepicker').endDate.format('DD/MM/YYYY');
          break;
      }

      var dateFilter = {
        mode: mode || this.dashboardFilter.mode,
        startDate: startDate || this.dashboardFilter.startDate,
        endDate: endDate || this.dashboardFilter.endDate,
        startDateFmt: startDateFmt || this.dashboardFilter.startDateFmt,
        endDateFmt: endDateFmt || this.dashboardFilter.endDateFmt
      };

      this.setFilterDate(dateFilter);
      this.$parent.filterRefresh();
    },
    handleResize: function handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    }
  }),
  destroyed: function destroyed() {
    window.removeEventListener('resize', this.handleResize);
  }
});

/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assets_js_constants_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_dashboard_DashboardFilter_vue__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_dashboard_DashboardFilter_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_dashboard_DashboardFilter_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_dashboard_TemporaryDepositSummary_vue__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_dashboard_TemporaryDepositSummary_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_dashboard_TemporaryDepositSummary_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_dashboard_TransportSummary_vue__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_dashboard_TransportSummary_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_components_dashboard_TransportSummary_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_dashboard_EriMain_vue__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_dashboard_EriMain_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_components_dashboard_EriMain_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_dashboard_WarehouseSummary_vue__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_dashboard_WarehouseSummary_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_components_dashboard_WarehouseSummary_vue__);











/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DashboardServices',
  data: function data() {
    return {
      detailMode: '',
      bindService: '',
      layoutMode: '',
      filterMode: '',
      fetchData: null,
      loader: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['dashboardFilter']), {
    bindDetail: function bindDetail() {
      var component = void 0;

      switch (this.detailMode) {
        case 'warehouse':
          component = 'va-summary-warehouse';
          break;
        case 'temporaryDesposit':
          component = 'va-summary-td';
          break;
        case 'transport':
          component = 'va-summary-transport';
          break;
        default:
          component = '';
          break;
      }

      return component;
    }
  }),
  created: function created() {
    this.loader = this.$loading.show({
      loader: 'dots'
    });
    this.loader.hide();
    $('body').addClass('sidebar-collapse').trigger('collapsed.pushMenu');
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])(['fetchDashboardData']), {
    filterRefresh: function filterRefresh() {
      var _this = this;

      this.loader = this.$loading.show({
        loader: 'dots',
        fullPage: true
      });

      if (this.dashboardFilter.mode === __WEBPACK_IMPORTED_MODULE_1_assets_js_constants_js__["a" /* default */].dashboardFilterModes.date && this.dashboardFilter.startDate === this.dashboardFilter.endDate) {
        this.filterMode = __WEBPACK_IMPORTED_MODULE_1_assets_js_constants_js__["a" /* default */].dashboardFilterModes.today;
      } else {
        this.filterMode = this.dashboardFilter.mode;
      }

      this.fetchDashboardData(this.dashboardFilter).then(function (data) {
        if (data != null) {
          _this.fetchData = data;

          _this.detailMode = '';

          if (_this.dashboardFilter.client.hasTemporaryDepositService && _this.dashboardFilter.client.hasTransportService) {
            _this.layoutMode = '3';
          } else if (_this.dashboardFilter.client.hasTemporaryDepositService) {
            _this.layoutMode = '2';
            _this.bindService = 'va-summary-td';
          } else if (_this.dashboardFilter.client.hasTransportService) {
            _this.layoutMode = '2';
            _this.bindService = 'va-summary-transport';
          } else {
            _this.layoutMode = '1';
          }

          _this.loader.hide();
        }
      });
    },
    showDetail: function showDetail(detail) {
      this.detailMode = detail === undefined ? '' : detail;
    }
  }),
  components: {
    'va-dashboard-filter': __WEBPACK_IMPORTED_MODULE_3_components_dashboard_DashboardFilter_vue___default.a,
    'va-summary-td': __WEBPACK_IMPORTED_MODULE_4_components_dashboard_TemporaryDepositSummary_vue___default.a,
    'va-summary-transport': __WEBPACK_IMPORTED_MODULE_5_components_dashboard_TransportSummary_vue___default.a,
    'va-main-eri': __WEBPACK_IMPORTED_MODULE_6_components_dashboard_EriMain_vue___default.a,
    'va-summary-warehouse': __WEBPACK_IMPORTED_MODULE_7_components_dashboard_WarehouseSummary_vue___default.a
  },
  destroyed: function destroyed() {
    if (this.loader !== null) {
      this.loader.hide();
    }
  }
});

/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_assets_js_constants_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_assets_js_util_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_charts_BarChart_js__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_charts_LineChart_js__ = __webpack_require__(36);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'EriMain',
  props: ['mode', 'fetchData'],
  data: function data() {
    return {
      barChartData: {},
      lineChartData: {}
    };
  },

  watch: {
    fetchData: function fetchData(newVal, oldVal) {
      this.fillData();
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['dashboardFilter']), {
    detailLayout: function detailLayout() {
      return this.showDetailLayout();
    }
  }),
  created: function created() {},
  mounted: function mounted() {
    this.fillData();
  },

  methods: {
    fillData: function fillData() {
      this.formatBarChart();

      if (this.showDetailLayout()) {
        this.formatLineChart();
      }
    },
    formatBarChart: function formatBarChart() {
      var skuSquare = this.fetchData.skuSquareQuantityWarehouse;
      var skuInventory = this.fetchData.skuInventoryQuantityWarehouse;

      var chartColors = __WEBPACK_IMPORTED_MODULE_3_assets_js_util_js__["a" /* default */].getChartColors(this.fetchData.eriPercentageWarehouse);

      if (skuSquare === 0 && skuInventory === 0) {
        this.barChartData = {
          datasets: [{
            label: 'Sin Data',
            backgroundColor: chartColors.opaque,
            borderWidth: 1,
            data: [100],
            xAxisID: 'bar-x-axis1'
          }]
        };
      } else {
        this.barChartData = {
          datasets: [{
            label: 'Cuadrado',
            backgroundColor: chartColors.solid,
            borderWidth: 1,
            data: [skuSquare],
            xAxisID: 'bar-x-axis1'
          }, {
            label: 'Inventariado',
            backgroundColor: chartColors.opaque,
            borderWidth: 1,
            data: [skuInventory],
            xAxisID: 'bar-x-axis1'
          }]
        };
      }
    },
    formatLineChart: function formatLineChart() {
      var chartColors = __WEBPACK_IMPORTED_MODULE_3_assets_js_util_js__["a" /* default */].getChartColors(this.fetchData.eriPercentageWarehouse);

      this.lineChartData = {
        labels: __WEBPACK_IMPORTED_MODULE_3_assets_js_util_js__["a" /* default */].getChartLabels(this.mode, this.dashboardFilter.startDate, this.dashboardFilter.endDate),
        datasets: [{
          data: __WEBPACK_IMPORTED_MODULE_3_assets_js_util_js__["a" /* default */].getChartData(this.mode, this.dashboardFilter.startDate, this.dashboardFilter.endDate, this.fetchData.skuSquareQuantitiesWarehouse),
          label: 'Cuadrado',
          borderColor: chartColors.solid,
          fill: false
        }, {
          data: __WEBPACK_IMPORTED_MODULE_3_assets_js_util_js__["a" /* default */].getChartData(this.mode, this.dashboardFilter.startDate, this.dashboardFilter.endDate, this.fetchData.skuInventoryQuantitiesWarehouse),
          label: 'Inventariado',
          borderColor: __WEBPACK_IMPORTED_MODULE_2_assets_js_constants_js__["a" /* default */].colorPalette.Projected,
          fill: false
        }]
      };
    },
    formatAmountColor: function formatAmountColor(percentage) {
      var style = {
        color: __WEBPACK_IMPORTED_MODULE_3_assets_js_util_js__["a" /* default */].getChartColors(percentage).solid
      };

      return style;
    },
    showDetailLayout: function showDetailLayout() {
      if (this.mode === __WEBPACK_IMPORTED_MODULE_2_assets_js_constants_js__["a" /* default */].dashboardFilterModes.today) {
        return false;
      } else {
        return true;
      }
    }
  },
  components: {
    'chart-bar-eri': __WEBPACK_IMPORTED_MODULE_4_charts_BarChart_js__["a" /* default */],
    'chart-line-eri': __WEBPACK_IMPORTED_MODULE_5_charts_LineChart_js__["a" /* default */]
  }
});

/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_assets_js_util_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_assets_js_constants_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_charts_LineChart_js__ = __webpack_require__(36);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TemporaryDepositSummary',
  props: ['mode', 'fetchData'],
  data: function data() {
    return {
      chartData: {},
      colorReceived: '',
      colorShipped: ''
    };
  },

  watch: {
    fetchData: function fetchData(newVal, oldVal) {
      this.fillData();
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['dashboardFilter'])),
  created: function created() {
    this.colorReceived = __WEBPACK_IMPORTED_MODULE_3_assets_js_constants_js__["a" /* default */].colorPalette.TemporaryDepositReceived;
    this.colorShipped = __WEBPACK_IMPORTED_MODULE_3_assets_js_constants_js__["a" /* default */].colorPalette.TemporaryDepositShipped;
  },
  mounted: function mounted() {
    this.fillData();
  },

  methods: {
    fillData: function fillData() {
      this.chartData = {
        labels: __WEBPACK_IMPORTED_MODULE_2_assets_js_util_js__["a" /* default */].getChartLabels(this.mode, this.dashboardFilter.startDate, this.dashboardFilter.endDate),
        datasets: [{
          data: __WEBPACK_IMPORTED_MODULE_2_assets_js_util_js__["a" /* default */].getChartData(this.mode, this.dashboardFilter.startDate, this.dashboardFilter.endDate, this.fetchData.containersReceivedTemporaryValuesDeposit),
          label: 'Recibido',
          borderColor: __WEBPACK_IMPORTED_MODULE_3_assets_js_constants_js__["a" /* default */].colorPalette.TemporaryDepositReceived,
          fill: false
        }, {
          data: __WEBPACK_IMPORTED_MODULE_2_assets_js_util_js__["a" /* default */].getChartData(this.mode, this.dashboardFilter.startDate, this.dashboardFilter.endDate, this.fetchData.containersShippedTemporaryValuesDeposit),
          label: 'Despachado',
          borderColor: __WEBPACK_IMPORTED_MODULE_3_assets_js_constants_js__["a" /* default */].colorPalette.TemporaryDepositShipped,
          fill: false
        }]
      };
    },
    showDetail: function showDetail() {
      this.$parent.showDetail('temporaryDesposit');
    }
  },
  components: {
    'chart-line': __WEBPACK_IMPORTED_MODULE_4_charts_LineChart_js__["a" /* default */]
  }
});

/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_assets_js_util_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_assets_js_constants_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_charts_LineChart_js__ = __webpack_require__(36);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TransportSummary',
  props: ['mode', 'fetchData'],
  data: function data() {
    return {
      chartData: {},
      colorEntered: '',
      colorDelivered: ''
    };
  },

  watch: {
    fetchData: function fetchData(newVal, oldVal) {
      this.fillData();
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    totalGuidesTransit: function totalGuidesTransit() {
      var sumTransit = 0;
      this.fetchData.guidesEnteredValuesTransport.forEach(function (e) {
        sumTransit += e.value;
      });
      console.log(sumTransit);
      return this.$options.filters.formatAmount(sumTransit);
    },
    totalGuidesDelivered: function totalGuidesDelivered() {
      var sumDelivered = 0;
      this.fetchData.guidesDeliveredValuesTransport.forEach(function (e) {
        sumDelivered += e.value;
      });
      console.log(sumDelivered);
      return this.$options.filters.formatAmount(sumDelivered);
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['dashboardFilter'])),
  created: function created() {
    this.colorEntered = __WEBPACK_IMPORTED_MODULE_3_assets_js_constants_js__["a" /* default */].colorPalette.TransportEntered;
    this.colorDelivered = __WEBPACK_IMPORTED_MODULE_3_assets_js_constants_js__["a" /* default */].colorPalette.TransportDelivered;
  },
  mounted: function mounted() {
    this.fillData();
  },

  methods: {
    fillData: function fillData() {
      this.chartData = {
        labels: __WEBPACK_IMPORTED_MODULE_2_assets_js_util_js__["a" /* default */].getChartLabels(this.mode, this.dashboardFilter.startDate, this.dashboardFilter.endDate),
        datasets: [{
          data: __WEBPACK_IMPORTED_MODULE_2_assets_js_util_js__["a" /* default */].getChartData(this.mode, this.dashboardFilter.startDate, this.dashboardFilter.endDate, this.fetchData.guidesEnteredValuesTransport),
          label: 'Ingresado',
          borderColor: __WEBPACK_IMPORTED_MODULE_3_assets_js_constants_js__["a" /* default */].colorPalette.TransportEntered,
          fill: false
        }, {
          data: __WEBPACK_IMPORTED_MODULE_2_assets_js_util_js__["a" /* default */].getChartData(this.mode, this.dashboardFilter.startDate, this.dashboardFilter.endDate, this.fetchData.guidesDeliveredValuesTransport),
          label: 'Entregado',
          borderColor: __WEBPACK_IMPORTED_MODULE_3_assets_js_constants_js__["a" /* default */].colorPalette.TransportDelivered,
          fill: false
        }]
      };
    },
    showDetail: function showDetail() {
      this.$parent.showDetail('transport');
    }
  },
  components: {
    'chart-line': __WEBPACK_IMPORTED_MODULE_4_charts_LineChart_js__["a" /* default */]
  }
});

/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_assets_js_util_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_assets_js_constants_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_charts_DoughnutChart_js__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_charts_LineChart_js__ = __webpack_require__(36);











/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'WarehouseMain',
  props: ['mode', 'fetchData'],
  data: function data() {
    return {
      isMounted: false,

      projectionChartDataReceived: null,
      lineChartDataReceived: null,
      projectionChartDataShipped: null,
      lineChartDataShipped: null,
      lineChartDataReturn: null,

      colorReceived: '',
      colorShipped: '',
      colorProjected: '',
      colorReturned: ''
    };
  },

  watch: {
    fetchData: function fetchData(newVal, oldVal) {
      this.fillData();
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['dashboardFilter'])),
  created: function created() {
    this.colorReceived = __WEBPACK_IMPORTED_MODULE_3_assets_js_constants_js__["a" /* default */].colorPalette.WarehouseReceived;
    this.colorShipped = __WEBPACK_IMPORTED_MODULE_3_assets_js_constants_js__["a" /* default */].colorPalette.WarehouseShipped;
    this.colorProjected = __WEBPACK_IMPORTED_MODULE_3_assets_js_constants_js__["a" /* default */].colorPalette.Projected;
    this.colorReturned = __WEBPACK_IMPORTED_MODULE_3_assets_js_constants_js__["a" /* default */].colorPalette.WarehouseReturned;
  },
  mounted: function mounted() {
    this.isMounted = true;
    this.fillData();
  },

  methods: {
    fillData: function fillData() {
      this.formatChartReceived();
      this.formatChartShipped();
      this.formatChartReturned();
    },
    formatChartReceived: function formatChartReceived() {
      var percentage = this.fetchData.recivedPercentageWarehouse || 0;
      percentage = this.$options.filters.formatDecimal(percentage);

      var chartColors = __WEBPACK_IMPORTED_MODULE_2_assets_js_util_js__["a" /* default */].getChartColors(percentage);

      if (this.fetchData.recivedAmountWarehouse === 0 && this.fetchData.recivedAmountProjectionWarehouse === 0) {
        this.projectionChartDataReceived = {
          centerTextValue: percentage + '%',
          centerTextColor: chartColors.solid,
          labels: ['Sin Data'],
          datasets: [{
            data: [100],
            backgroundColor: [chartColors.opaque]
          }]
        };
      } else {
        this.projectionChartDataReceived = {
          centerTextValue: percentage + '%',
          centerTextColor: chartColors.solid,
          labels: ['Recibido', 'Restante'],
          datasets: [{
            data: [this.fetchData.recivedAmountWarehouse, this.fetchData.recivedAmountProjectionWarehouse - this.fetchData.recivedAmountWarehouse],
            backgroundColor: [chartColors.solid, chartColors.opaque]
          }]
        };
      }

      if (this.$refs.chartReceived) {
        this.$refs.chartReceived.update(percentage + '%', chartColors.solid);
      }

      this.lineChartDataReceived = {
        labels: __WEBPACK_IMPORTED_MODULE_2_assets_js_util_js__["a" /* default */].getChartLabels(this.mode, this.dashboardFilter.startDate, this.dashboardFilter.endDate),
        datasets: [{
          data: __WEBPACK_IMPORTED_MODULE_2_assets_js_util_js__["a" /* default */].getChartData(this.mode, this.dashboardFilter.startDate, this.dashboardFilter.endDate, this.fetchData.recivedAmountValuesWarehouse),
          label: 'Recibido',
          borderColor: chartColors.solid,
          fill: false
        }, {
          data: __WEBPACK_IMPORTED_MODULE_2_assets_js_util_js__["a" /* default */].getChartData(this.mode, this.dashboardFilter.startDate, this.dashboardFilter.endDate, this.fetchData.recivedAmountProjectionValuesWarehouse),
          label: 'Proyectado',
          borderColor: this.colorProjected,
          fill: false
        }]
      };
    },
    formatChartShipped: function formatChartShipped() {
      var percentage = this.fetchData.shippedPercentageWarehouse || 0;
      percentage = this.$options.filters.formatDecimal(percentage);

      var chartColors = __WEBPACK_IMPORTED_MODULE_2_assets_js_util_js__["a" /* default */].getChartColors(percentage);

      if (this.fetchData.shippedAmountWarehouse === 0 && this.fetchData.shippedAmountProjectionWarehouse === 0) {
        this.projectionChartDataShipped = {
          centerTextValue: percentage + '%',
          centerTextColor: chartColors.solid,
          labels: ['Sin Data'],
          datasets: [{
            data: [100],
            backgroundColor: [chartColors.opaque]
          }]
        };
      } else {
        this.projectionChartDataShipped = {
          centerTextValue: percentage + '%',
          centerTextColor: chartColors.solid,
          labels: ['Despachado', 'Restante'],
          datasets: [{
            data: [this.fetchData.shippedAmountWarehouse, this.fetchData.shippedAmountProjectionWarehouse - this.fetchData.shippedAmountWarehouse],
            backgroundColor: [chartColors.solid, chartColors.opaque]
          }]
        };
      }

      if (this.$refs.chartShipped) {
        this.$refs.chartShipped.update(percentage + '%', chartColors.solid);
      }

      this.lineChartDataShipped = {
        labels: __WEBPACK_IMPORTED_MODULE_2_assets_js_util_js__["a" /* default */].getChartLabels(this.mode, this.dashboardFilter.startDate, this.dashboardFilter.endDate),
        datasets: [{
          data: __WEBPACK_IMPORTED_MODULE_2_assets_js_util_js__["a" /* default */].getChartData(this.mode, this.dashboardFilter.startDate, this.dashboardFilter.endDate, this.fetchData.shippedAmountValuesWarehouse),
          label: 'Despachado',
          borderColor: chartColors.solid,
          fill: false
        }, {
          data: __WEBPACK_IMPORTED_MODULE_2_assets_js_util_js__["a" /* default */].getChartData(this.mode, this.dashboardFilter.startDate, this.dashboardFilter.endDate, this.fetchData.shippedAmountProjectionValuesWarehouse),
          label: 'Proyectado',
          borderColor: this.colorProjected,
          fill: false
        }]
      };
    },
    formatChartReturned: function formatChartReturned() {
      this.lineChartDataReturn = {
        labels: __WEBPACK_IMPORTED_MODULE_2_assets_js_util_js__["a" /* default */].getChartLabels(this.mode, this.dashboardFilter.startDate, this.dashboardFilter.endDate),
        datasets: [{
          data: __WEBPACK_IMPORTED_MODULE_2_assets_js_util_js__["a" /* default */].getChartData(this.mode, this.dashboardFilter.startDate, this.dashboardFilter.endDate, this.fetchData.returnedAmountValuesWarehouse),
          label: 'Devoluciones',
          borderColor: this.colorReturned,
          fill: false
        }]
      };
    },
    formatAmountColor: function formatAmountColor(percentage) {
      var style = {
        color: __WEBPACK_IMPORTED_MODULE_2_assets_js_util_js__["a" /* default */].getChartColors(percentage).solid
      };

      return style;
    }
  },
  components: {
    'chart-projection-received': __WEBPACK_IMPORTED_MODULE_4_charts_DoughnutChart_js__["a" /* default */],
    'chart-projection-shipped': __WEBPACK_IMPORTED_MODULE_4_charts_DoughnutChart_js__["a" /* default */],
    'chart-line-return': __WEBPACK_IMPORTED_MODULE_5_charts_LineChart_js__["a" /* default */]
  }
});

/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_multiselect__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_multiselect_dist_vue_multiselect_min_css__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_multiselect_dist_vue_multiselect_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_multiselect_dist_vue_multiselect_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetable_2__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetable_2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuetable_2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment_moment_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment_moment_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment_moment_js__);











/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DispatchAppointments',
  data: function data() {
    return {
      loader: null,
      selectedAccount: null,
      optionsAccount: null,
      tableData: null,
      tableFields: [{
        name: 'accountCode',
        title: 'Cliente',
        callback: 'formatClient'
      }, {
        name: 'filename',
        title: 'Documento'
      }, {
        name: 'uploaded',
        title: 'Fecha de Carga',
        callback: 'formatDate'
      }, {
        name: 'uploadedBy',
        title: 'Cargado Por'
      }],
      tableCSS: {
        table: {
          tableClass: 'table table-striped table-bordered table-hovered',
          ascendingIcon: 'glyphicon glyphicon-chevron-up',
          descendingIcon: 'glyphicon glyphicon-chevron-down',
          handleIcon: 'glyphicon glyphicon-menu-hamburger'
        }
      },
      tableOptions: {
        headings: {
          accountCode: 'Cliente',
          fileName: 'Documento',
          uploaded: 'Fecha de Carga',
          uploadedBy: 'Cargado Por'
        },
        filterable: false,
        texts: {
          count: ''
        }
      }
    };
  },

  components: {
    Multiselect: __WEBPACK_IMPORTED_MODULE_3_vue_multiselect___default.a,
    Vuetable: __WEBPACK_IMPORTED_MODULE_5_vuetable_2___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['userClients'])),
  created: function created() {
    this.optionsAccount = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(this.userClients);
    this.selectedAccount = this.optionsClient[0];
    this.loadTableData();
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])(['fetchDispatchAppointmentDocumentList']), {
    loadTableData: function loadTableData() {
      var _this = this;

      this.loader = this.$loading.show({
        loader: 'dots'
      });

      this.fetchDispatchAppointmentDocumentList(this.selectedAccount.code).then(function (data) {
        if (data != null) {
          _this.tableData = data;
          _this.loader.hide();
        }
      });
    },
    onAccountSelect: function onAccountSelect(account) {
      this.selectedAccount = account;
      this.loadTableData();
    },
    onLoading: function onLoading() {
      this.loader = this.$loading.show({
        loader: 'dots'
      });
    },
    onLoaded: function onLoaded() {
      this.loader.hide();
    },
    formatClient: function formatClient(value) {
      return this.optionsClient.filter(function (item) {
        return item.code === value;
      })[0].name;
    },
    formatDate: function formatDate(value) {
      return __WEBPACK_IMPORTED_MODULE_6_moment_moment_js___default()(value).format('DD/MM/YYYY');
    }
  }),
  destroyed: function destroyed() {
    if (this.loader !== null) {
      this.loader.hide();
    }
  }
});

/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetable_2__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetable_2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuetable_2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment_moment_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment_moment_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment_moment_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_modal_Modal_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_modal_Modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_modal_Modal_vue__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DispatchAppointmentsUpload',
  data: function data() {
    return {
      loader: null,
      accountCode: '',
      accountName: '',
      fileValidation: '',
      file: null,
      uploadData: null,
      tableData: null,
      tableFields: [{
        name: 'accountCode',
        title: 'Cliente',
        callback: 'formatClient'
      }, {
        name: 'clientOrder',
        title: 'Nro. de Orden'
      }, {
        name: 'loadType',
        title: 'Tipo de Carga'
      }, {
        name: 'plate',
        title: 'Placa'
      }, {
        name: 'arrivalDate',
        title: 'Fecha de Llegada',
        callback: 'formatDate'
      }, {
        name: 'arrivalTime',
        title: 'Hora de Llegada'
      }, {
        name: 'appointmentDate',
        title: 'Fecha de Cita',
        callback: 'formatDate'
      }, {
        name: 'appointmentTime',
        title: 'Hora de Cita'
      }, {
        name: 'observations',
        title: 'Observaciones'
      }],
      tableCSS: {
        table: {
          tableClass: 'table table-striped table-bordered table-hovered',
          ascendingIcon: 'glyphicon glyphicon-chevron-up',
          descendingIcon: 'glyphicon glyphicon-chevron-down',
          handleIcon: 'glyphicon glyphicon-menu-hamburger'
        }
      },
      tableOptions: {
        filterable: false,
        texts: {
          count: ''
        }
      }
    };
  },
  created: function created() {
    var code = this.$route.params.accountCode;

    var found = this.userClients.find(function (item) {
      return item.code === code;
    });

    if (found) {
      this.accountCode = found.code;
      this.accountName = found.name;
    }
  },

  components: {
    Vuetable: __WEBPACK_IMPORTED_MODULE_2_vuetable_2___default.a,
    Modal: __WEBPACK_IMPORTED_MODULE_4_components_modal_Modal_vue___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['userClients'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])(['uploadDispatchApointmentFile', 'saveDispatchApointmentFile']), {
    handleFileUpload: function handleFileUpload() {
      this.file = this.$refs.file.files[0];
    },
    handleUpload: function handleUpload() {
      var _this = this;

      document.activeElement.blur();

      if (this.validateFile()) {
        this.loader = this.$loading.show({
          loader: 'dots'
        });

        this.tableData = null;
        this.uploadData = null;

        var params = {
          accountCode: this.accountCode,
          file: this.file
        };

        this.uploadDispatchApointmentFile(params).then(function (data) {
          _this.loader.hide();

          if (data.success) {
            _this.tableData = data.data.items;
            _this.uploadData = data.data;
          } else {
            _this.$bus.$emit('modal-open', {
              title: 'Error',
              description: 'Ocurrió un error al subir o procesar el archivo.',
              type: 'danger',
              confirmText: 'Aceptar',
              cancelText: null,
              confirmBefore: function confirmBefore() {},
              confirmAfter: function confirmAfter() {},
              cancelBefore: function cancelBefore() {},
              cancelAfter: function cancelAfter() {}
            });
          }
        });
      }
    },
    handleSubmit: function handleSubmit() {
      var _this2 = this;

      document.activeElement.blur();

      if (this.uploadData !== null) {
        this.$bus.$emit('modal-open', {
          title: 'Confirmación',
          description: '¿Desea continuar con el registro de citas?',
          type: 'primary',
          confirmText: 'Aceptar',
          cancelText: 'Cancelar',
          confirmBefore: function confirmBefore() {},
          confirmAfter: function confirmAfter() {
            _this2.loader = _this2.$loading.show({
              loader: 'dots'
            });

            var params = {
              accountCode: _this2.accountCode,
              data: _this2.uploadData
            };

            _this2.saveDispatchApointmentFile(params).then(function (data) {
              var title = void 0,
                  description = void 0,
                  type = void 0;
              if (data.success) {
                title = 'Éxito';
                description = 'Se grabó Citas de Despacho exitósamente.';
                type = 'success';
              } else {
                title = 'Error';
                description = 'Ocurrió un error al validar o grabar las citas.';
                type = 'danger';
              }

              _this2.loader.hide();

              _this2.$bus.$emit('modal-open', {
                title: title,
                description: description,
                type: type,
                confirmText: 'Aceptar',
                cancelText: null,
                confirmBefore: function confirmBefore() {},
                confirmAfter: function confirmAfter() {},
                cancelBefore: function cancelBefore() {},
                cancelAfter: function cancelAfter() {}
              });
            });
          },
          cancelBefore: function cancelBefore() {},
          cancelAfter: function cancelAfter() {}
        });
      }
    },
    formatClient: function formatClient(value) {
      return this.userClients.filter(function (item) {
        return item.code === value;
      })[0].name;
    },
    formatDate: function formatDate(value) {
      return __WEBPACK_IMPORTED_MODULE_3_moment_moment_js___default()(value).format('DD/MM/YYYY');
    },
    validateFile: function validateFile() {
      var result = false;

      if (this.file === null) {
        this.fileValidation = 'Debe seleccionar un documento a subir';
      } else if (this.file.type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
        this.fileValidation = 'La extensión del documento a subir debe ser MS Excel .xlsx';
      } else {
        this.fileValidation = '';
        result = true;
      }

      return result;
    }
  }),
  destroyed: function destroyed() {
    if (this.loader !== null) {
      this.loader.hide();
    }
  }
});

/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_multiselect__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_multiselect_dist_vue_multiselect_min_css__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_multiselect_dist_vue_multiselect_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_multiselect_dist_vue_multiselect_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetable_2__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetable_2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuetable_2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_charts_DoughnutChart_js__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_assets_js_util_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_assets_js_constants_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue2_google_maps__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue2_google_maps__);














/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DispatchTracking',
  data: function data() {
    return {
      intervalTime: 120000,
      interval: null,
      loader: null,
      optionsAccount: null,
      selectedTruck: null,
      selectedAccount: null,
      tableKey: 0,
      window: {
        width: 0,
        height: 0
      },
      tableData: null,
      tableFields: [{
        name: '__slot:company',
        title: 'Empresa'
      }, {
        name: '__slot:plate',
        title: 'Placa'
      }, {
        name: '__slot:shippedDocuments',
        title: 'Desp.'
      }, {
        name: '__slot:totalDocuments',
        title: 'Total'
      }, {
        name: '__slot:percentage',
        title: ''
      }, {
        name: '__slot:detail',
        title: ''
      }],
      tableCSS: null,
      tableOptions: {
        filterable: false,
        texts: {
          count: ''
        }
      },
      loadCurrentPage: false,
      currentPage: 0,
      tableFilter: '',
      zoom: null,
      zoomDefault: 10,
      centerDefault: {
        lat: -12.046374,
        lng: -77.042793
      },
      center: null,
      markers: [],
      fetchData: null,
      chartData: null,
      chartColors: {
        solid: '',
        opaque: ''
      },
      colorProjected: ''
    };
  },

  components: {
    Multiselect: __WEBPACK_IMPORTED_MODULE_3_vue_multiselect___default.a,
    Vuetable: __WEBPACK_IMPORTED_MODULE_5_vuetable_2__["Vuetable"],
    'vuetable-pagination': __WEBPACK_IMPORTED_MODULE_5_vuetable_2__["VuetablePagination"],
    'chart-progress': __WEBPACK_IMPORTED_MODULE_6_charts_DoughnutChart_js__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
    google: __WEBPACK_IMPORTED_MODULE_9_vue2_google_maps__["gmapApi"]
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['userClients'])),
  beforeMount: function beforeMount() {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vue2_google_maps__["loadGmapApi"])({
      key: __WEBPACK_IMPORTED_MODULE_8_assets_js_constants_js__["a" /* default */].apiKeyGoogle.vitz
    });
  },
  created: function created() {
    this.tableCSS = __WEBPACK_IMPORTED_MODULE_8_assets_js_constants_js__["a" /* default */].tableCSS;
    this.zoom = this.zoomDefault;
    this.center = this.centerDefault;
    this.colorProjected = __WEBPACK_IMPORTED_MODULE_8_assets_js_constants_js__["a" /* default */].colorPalette.Projected;
    this.optionsAccount = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(this.userClients);
    this.selectedAccount = this.optionsAccount[0];
    this.loadData();
  },
  mounted: function mounted() {
    this.geolocate();
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])(['fetchDispatchVehicleList', 'fetchDispatchVehicleLocation']), {
    handleResize: function handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    loadDataButton: function loadDataButton() {
      var _this = this;

      this.center = this.centerDefault;

      this.loader = this.$loading.show({
        loader: 'dots'
      });

      this.fetchDispatchVehicleList(this.selectedAccount.code).then(function (data) {
        if (data != null) {
          _this.fetchData = data;

          _this.loadMarkersData();
          _this.loadTableData();

          _this.loader.hide();
        }
      });
    },
    loadData: function loadData() {
      var _this2 = this;

      this.center = this.centerDefault;

      this.loader = this.$loading.show({
        loader: 'dots'
      });

      this.fetchDispatchVehicleList(this.selectedAccount.code).then(function (data) {
        if (data != null) {
          _this2.fetchData = data;

          _this2.loadMarkersData();


          _this2.loader.hide();
        }
      });
    },
    loadMarkersData: function loadMarkersData() {
      this.markers = this.fetchData.vehicles.map(function (item) {
        return {
          plate: item.plate,
          company: item.company,
          position: {
            lat: item.latitude,
            lng: item.longitude
          }
        };
      });
    },
    loadTableData: function loadTableData() {
      var filter = this.tableFilter;

      if (filter !== '') {
        var filterData = this.fetchData.vehicles.filter(function (vehicle) {
          var re = new RegExp(filter, 'g');
          return vehicle.documents.filter(function (item) {
            return item.documentNumber.match(re);
          }).length > 0;
        });

        this.tableData = {
          data: filterData.map(function (item) {
            return {
              plate: item.plate,
              company: item.company,
              totalDocuments: item.totalDocuments,
              shippedDocuments: item.shippedDocuments
            };
          })
        };
      } else {
        this.tableData = {
          data: this.fetchData.vehicles.map(function (item) {
            return {
              plate: item.plate,
              company: item.company,
              totalDocuments: item.totalDocuments,
              shippedDocuments: item.shippedDocuments,
              percentageShipped: item.shippedDocuments === 0 ? 0 : item.shippedDocuments * 100 / item.totalDocuments
            };
          })
        };
      }
      this.tableKey++;
    },
    onAccountSelect: function onAccountSelect(account) {
      this.selectedTruck = null;
      this.tableFilter = '';
      this.currentPage = 0;
      this.clearInterval();
      this.selectedAccount = account;
      this.loadData();
    },
    onLoading: function onLoading() {
      if (!this.loader) {
        this.loader = this.$loading.show({
          loader: 'dots'
        });
      }
    },
    onLoaded: function onLoaded() {
      this.loader.hide();

      if (this.loadCurrentPage && this.currentPage !== 1) {
        this.$refs.vuetable.changePage(this.currentPage);
        this.loadCurrentPage = false;
      }
    },
    onRowClick: function onRowClick(row) {
      var selectedTruck = this.markers.filter(function (item) {
        return item.plate === row.plate;
      })[0];
      if (selectedTruck) {
        this.onTruckSelect(selectedTruck);
      }
    },
    filterTruck: function filterTruck(event) {
      this.loadTableData();
    },
    clearFilter: function clearFilter() {
      this.tableFilter = '';
      this.loadTableData();
    },
    onPaginationData: function onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage: function onChangePage(page) {
      this.$refs.vuetable.changePage(page);
      this.currentPage = page;
    },
    dataManager: function dataManager(sortOrder, pagination) {
      var data = [];

      if (this.tableData) {
        data = this.tableData.data;

        pagination = this.$refs.vuetable.makePagination(data.length);
        data = data.slice(pagination.from - 1, pagination.to);
      } else {
        pagination = this.$refs.vuetable.makePagination(0);
      }

      return {
        pagination: pagination,
        data: data
      };
    },

    geolocate: function geolocate() {
      var _this3 = this;

      navigator.geolocation.getCurrentPosition(function (position) {
        _this3.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
      });
    },
    onTruckSelect: function onTruckSelect(marker) {
      var _this4 = this;

      this.$modal.show('truck');
      this.selectedTruck = marker;
      this.markers = [this.selectedTruck];
      this.center = this.selectedTruck.position;
      this.zoom = 14;
      this.loadChartData();

      this.interval = setInterval(function () {
        _this4.getTruckLocation();
      }, this.intervalTime);
    },
    showAllTrucks: function showAllTrucks() {
      this.$modal.hide('truck');
      this.clearInterval();
      this.selectedTruck = null;
      this.loadMarkersData();
      this.center = this.centerDefault;
      this.zoom = this.zoomDefault;
      this.loadCurrentPage = true;
    },
    loadChartData: function loadChartData() {
      var truckOrdersData = this.getSelectedTruckValues();
      var chartPecentage = 0;

      if (truckOrdersData.shippedDocuments > 0 && truckOrdersData.totalDocuments) {
        chartPecentage = 100 * truckOrdersData.shippedDocuments / truckOrdersData.totalDocuments;
      }

      this.chartColors = __WEBPACK_IMPORTED_MODULE_7_assets_js_util_js__["a" /* default */].getChartColors(chartPecentage);

      this.chartData = {
        centerTextValue: chartPecentage,
        centerTextColor: this.chartColors.solid,
        labels: ['Entregado', 'Restante'],
        datasets: [{
          data: [truckOrdersData.shippedDocuments, truckOrdersData.totalDocuments - truckOrdersData.shippedDocuments],
          backgroundColor: [this.chartColors.solid, this.chartColors.opaque]
        }]
      };

      if (this.$refs.chartProgress) {
        this.$refs.chartProgress.update(percentage, chartColors.solid);
      }
    },
    getSelectedTruckValues: function getSelectedTruckValues() {
      var _this5 = this;

      return this.tableData.data.filter(function (item) {
        return item.plate === (_this5.selectedTruck === null ? 'a' : _this5.selectedTruck.plate);
      })[0];
    },
    getTruckLocation: function getTruckLocation() {
      var _this6 = this;

      var truckIndex = void 0;

      for (var index = 0; index < this.fetchData.vehicles.length; index++) {
        if (this.selectedTruck.plate === this.fetchData.vehicles[index].plate) {
          truckIndex = index;
        }
      }

      this.fetchDispatchVehicleLocation(this.selectedTruck.plate).then(function (data) {
        if (data != null) {
          _this6.markers = data.vehicles.map(function (item) {
            return {
              plate: item.plate,
              company: item.company,
              position: {
                lat: item.latitude,
                lng: item.longitude
              }
            };
          });

          _this6.selectedTruck = _this6.markers[0];
          _this6.fetchData.vehicles[truckIndex].latitude = _this6.selectedTruck.position.lat;
          _this6.fetchData.vehicles[truckIndex].longitude = _this6.selectedTruck.position.lng;
        }
      });
    },
    clearInterval: function (_clearInterval) {
      function clearInterval() {
        return _clearInterval.apply(this, arguments);
      }

      clearInterval.toString = function () {
        return _clearInterval.toString();
      };

      return clearInterval;
    }(function () {
      if (this.interval !== null) {
        clearInterval(this.interval);
      }
    })
  }),
  destroyed: function destroyed() {
    if (this.loader !== null) {
      this.loader.hide();
    }

    this.clearInterval();
  }
});

/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_assets_js_util_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_moment_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_moment_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment_moment_js__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'EriDetail',
  props: ['id', 'title', 'unit', 'period', 'data'],
  data: function data() {
    return {
      loader: null,
      formattedData: null,
      totalSkuSquare: 0,
      totalSkuInventory: 0,
      totalEriPercentage: 0
    };
  },

  watch: {
    data: function data(newVal, oldVal) {
      this.loadData();
    }
  },
  created: function created() {
    this.loadData();
  },

  components: {},
  computed: {},
  mounted: function mounted() {
    $('#' + this.id).find('.main-table').clone(true).appendTo('#' + this.id).addClass('clone');
  },

  methods: {
    loadData: function loadData() {
      var rawData = [];
      var formattedData = [];
      var totalSkuSquare = 0;
      var totalSkuInventory = 0;

      if (this.data) {
        this.data.forEach(function (item) {
          var newItem = {
            date: __WEBPACK_IMPORTED_MODULE_1_moment_moment_js___default()(item.date).format('DD/MM'),
            skuSquare: item.squaredSkuCount,
            skuInventory: item.inventoriedSkuCount
          };

          totalSkuSquare += newItem.skuSquare;
          totalSkuInventory += newItem.skuInventory;

          rawData.push(newItem);
        });
      }

      var selectedtMonth = this.period.substr(4, 2);
      var selectedMonthDays = __WEBPACK_IMPORTED_MODULE_1_moment_moment_js___default()().month(selectedtMonth - 1).daysInMonth();

      var _loop = function _loop(index) {
        var dayMonth = index.toString().padStart(2, '0') + '/' + selectedtMonth;

        var dayItem = {
          date: dayMonth,
          skuSquare: 0,
          skuInventory: 0
        };

        var found = rawData.find(function (dataItem) {
          return dataItem.date === dayMonth;
        });

        if (found) {
          dayItem.skuSquare = found.skuSquare;
          dayItem.skuInventory = found.skuInventory;
        }

        formattedData.push(dayItem);
      };

      for (var index = 1; index <= selectedMonthDays; index++) {
        _loop(index);
      }

      this.totalSkuSquare = totalSkuSquare;
      this.totalSkuInventory = totalSkuInventory;
      this.formattedData = formattedData;

      this.totalEriPercentage = this.totalSkuSquare * 100 / this.totalSkuInventory;
      this.totalEriPercentage = this.totalEriPercentage || 0;
      this.totalEriPercentage = this.$options.filters.formatDecimal(this.totalEriPercentage);
    },
    formatAmountColor: function formatAmountColor(percentage) {
      var style = {
        color: __WEBPACK_IMPORTED_MODULE_0_assets_js_util_js__["a" /* default */].getChartColors(percentage).solid
      };

      return style;
    }
  }
});

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_multiselect__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_multiselect_dist_vue_multiselect_min_css__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_multiselect_dist_vue_multiselect_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_multiselect_dist_vue_multiselect_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetable_2__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetable_2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuetable_2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_assets_js_constants_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_assets_js_util_js__ = __webpack_require__(18);











/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Inventory',
  components: {
    Multiselect: __WEBPACK_IMPORTED_MODULE_3_vue_multiselect___default.a,
    Vuetable: __WEBPACK_IMPORTED_MODULE_5_vuetable_2___default.a
  },
  data: function data() {
    return {
      loader: null,
      optionsAccount: null,
      selectedAccount: null,
      optionsYear: [],
      selectedYear: null,
      optionsMonth: [],
      selectedMonth: null,
      tableData: null,
      tableFields: [{
        name: '__slot:accountCode',
        title: 'Cliente',
        callback: 'formatClient'
      }, {
        name: '__slot:cyclicalPercentage',
        title: 'Eri Cíclico',
        callback: 'formatPercentage'
      }, {
        name: '__slot:locationPercentage',
        title: 'Eri Ubicación',
        callback: 'formatPercentage'
      }, {
        name: '__slot:unitPercentage',
        title: 'Eri Unidad',
        callback: 'formatPercentage'
      }],
      tableSortOrder: [{ field: 'name', direction: 'asc' }],
      tableCSS: {
        table: {
          tableClass: 'table table-striped table-bordered table-hovered',
          ascendingIcon: 'glyphicon glyphicon-chevron-up',
          descendingIcon: 'glyphicon glyphicon-chevron-down',
          handleIcon: 'glyphicon glyphicon-menu-hamburger'
        }
      },
      tableOptions: {
        headings: {
          clientName: 'Cliente',
          eriCyclical: 'Eri Cíclico',
          eriLocation: 'Eri Ubicación',
          eriUnit: 'Eri Unidad'
        },
        filterable: false,
        sortable: ['clientName'],
        texts: {
          count: ''
        }
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['userClients'])),
  created: function created() {
    this.loadSelectData();
    this.loadTableData();
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])(['fetchEriSummaryData']), {
    loadSelectData: function loadSelectData() {
      this.optionsAccount = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(this.userClients);
      this.optionsAccount.unshift(__WEBPACK_IMPORTED_MODULE_6_assets_js_constants_js__["a" /* default */].defaultSelectItem);
      this.selectedAccount = this.optionsAccount[0];

      var yearObj = __WEBPACK_IMPORTED_MODULE_7_assets_js_util_js__["a" /* default */].getYearList(2010);

      this.optionsYear = yearObj.list;
      this.selectedYear = yearObj.current;

      var monthObj = __WEBPACK_IMPORTED_MODULE_7_assets_js_util_js__["a" /* default */].getMonthList();

      this.optionsMonth = monthObj.list;
      this.selectedMonth = monthObj.current.value;
    },
    loadTableData: function loadTableData() {
      var _this = this;

      var code = this.selectedAccount.code;

      var params = {
        AccountCodes: [],
        Period: this.selectedYear + '' + this.selectedMonth
      };

      if (code === 'All') {
        for (var index = 1; index < this.optionsAccount.length; index++) {
          params.AccountCodes.push(this.optionsAccount[index].code);
        }
      } else {
        params.AccountCodes.push(code);
      }

      this.loader = this.$loading.show({
        loader: 'dots'
      });

      this.fetchEriSummaryData(params).then(function (data) {
        if (data != null) {
          var tableData = {
            period: _this.selectedYear + '' + _this.selectedMonth,
            data: data
          };

          _this.tableData = tableData;
          _this.loader.hide();
        }
      });
    },
    onAccountSelect: function onAccountSelect(account) {
      this.selectedAccount = account;
      this.loadTableData();
    },
    onLoading: function onLoading() {
      this.loader = this.$loading.show({
        loader: 'dots'
      });
    },
    onLoaded: function onLoaded() {
      this.loader.hide();
    },
    formatClient: function formatClient(value) {
      return this.userClients.filter(function (item) {
        return item.code === value;
      })[0].name;
    },
    formatPercentage: function formatPercentage(value) {
      return this.$options.filters.formatPercentage(value) + '%';
    },
    onClick: function onClick(row) {
      this.$router.push({ name: 'InventoryDetail', params: { accountCode: row.accountCode, period: this.tableData.period } });
    }
  }),
  destroyed: function destroyed() {
    if (this.loader !== null) {
      this.loader.hide();
    }
  }
});

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EriDetail__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EriDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__EriDetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment_moment_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment_moment_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment_moment_js__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'InventoryDetail',
  data: function data() {
    return {
      loader: null,
      period: '',
      periodStr: '',
      accountCode: '',
      accountName: '',
      eriCyclicalData: null,
      eriLocationData: null,
      eriUnitData: null
    };
  },
  created: function created() {
    this.period = this.$route.params.period;
    this.periodStr = this.$options.filters.formatFirstLetter(__WEBPACK_IMPORTED_MODULE_3_moment_moment_js___default()(this.period.substr(4, 2), 'MM').format('MMMM')) + ' ' + this.period.substr(0, 4);

    var code = this.$route.params.accountCode;

    var found = this.userClients.find(function (item) {
      return item.code === code;
    });

    if (found) {
      this.accountCode = found.code;
      this.accountName = found.name;
    }

    this.loadData();
  },

  components: {
    'v-eri': __WEBPACK_IMPORTED_MODULE_2__EriDetail___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['userClients'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])(['fetchEriDetailData', 'exportEriDetailData']), {
    loadData: function loadData() {
      var _this = this;

      var params = {
        accountCode: this.accountCode,
        period: this.period
      };

      this.loader = this.$loading.show({
        loader: 'dots'
      });

      this.fetchEriDetailData(params).then(function (data) {
        if (data != null) {
          _this.eriCyclicalData = data.cyclicalValues;
          _this.eriLocationData = data.locationValues;
          _this.eriUnitData = data.unitValues;
          _this.loader.hide();
        }
      });
    },
    exportData: function exportData() {
      var _this2 = this;

      document.activeElement.blur();

      var params = {
        accountCode: this.accountCode,
        period: this.period
      };

      this.loader = this.$loading.show({
        loader: 'dots'
      });

      this.exportEriDetailData(params).then(function (data) {
        var fileName = 'ERI' + '_' + _this2.accountName + '_' + _this2.period + '.xlsx';
        var url = window.URL.createObjectURL(new Blob([data]));
        var link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        _this2.loader.hide();
      });
    }
  }),
  destroyed: function destroyed() {
    if (this.loader !== null) {
      this.loader.hide();
    }
  }
});

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_daterangepicker_daterangepicker_css__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_daterangepicker_daterangepicker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_bootstrap_daterangepicker_daterangepicker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_daterangepicker_daterangepicker_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_daterangepicker_daterangepicker_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_bootstrap_daterangepicker_daterangepicker_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment_moment_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment_moment_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment_moment_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_assets_js_constants_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_modal_Modal_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_modal_Modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_components_modal_Modal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_multiselect__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_multiselect_dist_vue_multiselect_min_css__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_multiselect_dist_vue_multiselect_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_multiselect_dist_vue_multiselect_min_css__);












/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'InventoryEntry',
  data: function data() {
    return {
      loader: null,
      submitted: false,
      optionsAccount: [],
      selectedAccount: null,
      optionsEriType: null,
      todayDate: '',
      selectedEriType: '',
      selectedDate: '',
      squaredSkuCount: '',
      inventoriedSkuCount: ''
    };
  },
  created: function created() {
    this.loadSelectData();
    this.todayDate = __WEBPACK_IMPORTED_MODULE_4_moment_moment_js___default()().format('MM/DD/YYYY');
    this.selectedDate = this.todayDate;
  },
  mounted: function mounted() {
    $(this.$el).find('#dtDate').daterangepicker({
      singleDatePicker: true,
      showDropdowns: true,
      minYear: 2010,
      maxYear: __WEBPACK_IMPORTED_MODULE_4_moment_moment_js___default()().year(),
      locale: __WEBPACK_IMPORTED_MODULE_5_assets_js_constants_js__["a" /* default */].datePickerLocale
    });

    $(this.$el).find('#numSkuSquare, #numSkuInventory').keydown(function (e) {
      if ($.inArray(e.keyCode, [46, 8, 9, 27, 13]) !== -1 || e.keyCode === 65 && (e.ctrlKey === true || e.metaKey === true) || e.keyCode === 67 && (e.ctrlKey === true || e.metaKey === true) || e.keyCode === 88 && (e.ctrlKey === true || e.metaKey === true) || e.keyCode >= 35 && e.keyCode <= 39) {
        return;
      }

      if ((e.shiftKey || e.keyCode < 48 || e.keyCode > 57) && (e.keyCode < 96 || e.keyCode > 105)) {
        e.preventDefault();
      }
    });
  },

  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_6_components_modal_Modal_vue___default.a,
    Multiselect: __WEBPACK_IMPORTED_MODULE_7_vue_multiselect___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['userClients'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])(['inventoryEntry']), {
    loadSelectData: function loadSelectData() {
      var _this = this;

      var preselectedAccount = this.userClients.filter(function (item) {
        return item.code === _this.$route.params.accountCode;
      });

      if (preselectedAccount.length > 0) {
        this.optionsAccount = preselectedAccount;
        this.selectedAccount = preselectedAccount[0];
      } else {
        this.optionsAccount = this.userClients;
        this.selectedAccount = this.userClients[0];
      }

      this.optionsEriType = __WEBPACK_IMPORTED_MODULE_5_assets_js_constants_js__["a" /* default */].defaultEriTypes;
      this.selectedEriType = this.optionsEriType[0].code;
    },
    onAccountSelect: function onAccountSelect(account) {
      this.selectedAccount = account;
    },
    handleSubmit: function handleSubmit() {
      var _this2 = this;

      document.activeElement.blur();

      this.submitted = true;
      this.selectedDate = $(this.$el).find('#dtDate').data('daterangepicker').startDate.format('MM/DD/YYYY');

      if (this.selectedEriType && this.selectedAccount && this.selectedDate === this.todayDate && this.inventoriedSkuCount > 0 && this.squaredSkuCount > 0) {
        var loader = this.$loading.show({
          loader: 'dots'
        });

        var params = {
          EriType: this.selectedEriType,
          AccountCode: this.selectedAccount.code,
          Date: this.selectedDate + ' ' + __WEBPACK_IMPORTED_MODULE_4_moment_moment_js___default()().format('HH:mm:ss'),
          InventoriedSkuCount: this.inventoriedSkuCount,
          SquaredSkuCount: this.squaredSkuCount
        };

        this.inventoryEntry(params).then(function (response) {
          _this2.submitted = false;

          var title = void 0,
              description = void 0;

          if (response) {
            title = 'Éxito';
            description = 'Se registró ERI exitosamente.';
            _this2.inventoriedSkuCount = '';
            _this2.squaredSkuCount = '';
          } else {
            title = 'Error';
            description = 'Ocurrió un error al momento de registrar ERI.';
          }

          _this2.$bus.$emit('modal-open', {
            title: title,
            description: description,
            type: 'info',
            confirmText: 'Aceptar',
            cancelText: null,
            confirmBefore: function confirmBefore() {},
            confirmAfter: function confirmAfter() {},
            cancelBefore: function cancelBefore() {},
            cancelAfter: function cancelAfter() {}
          });

          loader.hide();
        });
      }
    }
  }),
  destroyed: function destroyed() {
    if (this.loader !== null) {
      this.loader.hide();
    }
  }
});

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_multiselect__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_multiselect_dist_vue_multiselect_min_css__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_multiselect_dist_vue_multiselect_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_multiselect_dist_vue_multiselect_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuetable_2__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuetable_2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vuetable_2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_charts_DoughnutChart_js__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_assets_js_constants_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__InventoryProductStatusLine_vue__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__InventoryProductStatusLine_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__InventoryProductStatusLine_vue__);














__WEBPACK_IMPORTED_MODULE_3_vue___default.a.component('table-detail', __WEBPACK_IMPORTED_MODULE_10__InventoryProductStatusLine_vue___default.a);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'InventoryProductStatus',
  components: {
    Multiselect: __WEBPACK_IMPORTED_MODULE_5_vue_multiselect___default.a,
    'chart-status': __WEBPACK_IMPORTED_MODULE_8_charts_DoughnutChart_js__["a" /* default */],
    'table-status': __WEBPACK_IMPORTED_MODULE_7_vuetable_2__["Vuetable"],
    'vuetable-pagination': __WEBPACK_IMPORTED_MODULE_7_vuetable_2__["VuetablePagination"]
  },
  data: function data() {
    return {
      loader: null,
      selectedAccount: null,
      selectedProduct: { code: '', text: 'Todos' },
      optionsAccount: null,
      optionsProducts: [],
      chartStatusData: null,
      tableStatusData: null,
      tableDetailData: null,
      tableStatusFields: [{
        name: '__slot:statusName',
        title: 'Estado'
      }, {
        name: '__slot:quantity',
        title: 'Cantidad'
      }, {
        name: '__slot:percentage',
        title: '%'
      }],
      tableCSS: {
        table: {
          tableClass: 'table table-striped table-bordered table-hovered'
        }
      },
      tableOptions: {
        filterable: false,
        texts: {
          count: ''
        }
      },
      titleStatus: '',
      titleStatusColor: '',
      titleDetail: '',
      paginationData: null,
      fetchData: {
        inventoryDate: new Date()
      },
      realChartHeight: 0
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])(['userClients'])),
  created: function created() {
    this.optionsAccount = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default()(this.userClients);
    this.selectedAccount = this.optionsAccount[0];
    this.getProducts();
    this.loadProductStatusData();
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapActions */])(['fetchInventoryProductStatusList', 'getItemsForInventory', 'searchDocumentPage']), {
    loadProductStatusData: function loadProductStatusData() {
      var _this = this;

      this.loader = this.$loading.show({
        loader: 'dots'
      });

      this.fetchData = null;
      this.tableStatusData = null;
      this.tableDetailData = null;

      var params = {
        accountCode: this.selectedAccount.code,
        code: this.selectedProduct.code
      };
      this.fetchInventoryProductStatusList(params).then(function (data) {
        if (data != null) {
          data.states.forEach(function (state) {
            state.lines.forEach(function (line) {
              line.percentageFromTotal = 100 * line.quantity / state.quantity;
              line.minimumStockUnit = data.minimumStockUnit;
            });
          });

          _this.fetchData = data;
          _this.loadChartData();
          _this.loader.hide();
        }
      });
    },
    loadChartData: function loadChartData() {
      var _this2 = this;

      var vueContext = this;

      this.chartStatusData = {
        labels: ['Disponible'],
        datasets: [{
          backgroundColor: [__WEBPACK_IMPORTED_MODULE_9_assets_js_constants_js__["a" /* default */].colorPalette.baseGreen],
          data: [this.fetchData.availablePercentage]
        }],
        centerTextValue: '',
        postRender: function postRender(chart) {
          var currentRealChartHeight = chart.chart.height;

          if (currentRealChartHeight !== vueContext.realChartHeight) {
            vueContext.realChartHeight = currentRealChartHeight;
          }
        }
      };

      this.fetchData.states.forEach(function (state) {
        if (!state.isAvailable) {
          _this2.chartStatusData.labels.push(state.state);
          _this2.chartStatusData.datasets[0].data.push(state.percentageFromTotal);
          _this2.chartStatusData.datasets[0].backgroundColor.push(state.stateColor);
        }
      });

      this.loadTableStatus();
      this.selectedSection('No Disponible');
    },
    loadTableStatus: function loadTableStatus() {
      var _this3 = this;

      this.tableStatusData = null;
      this.tableDetailData = null;

      this.tableStatusData = [];

      this.fetchData.states.forEach(function (element) {
        _this3.tableStatusData.push({
          statusName: element.state,
          statusQuantity: element.quantity,
          percentageFromTotal: element.percentageFromTotal,
          color: element.stateColor,
          lines: element.lines
        });
      });
    },
    loadTableDetail: function loadTableDetail(statusName) {
      var _this4 = this;

      this.titleDetail = statusName;

      this.tableDetailData = [];

      this.fetchData.states.forEach(function (element) {
        if (element.state === statusName) {
          element.lines.forEach(function (line) {
            _this4.tableDetailData.push({
              productName: line.line,
              productQuantity: line.quantity
            });
          });
        }
      });
    },
    getProducts: function getProducts() {
      var _this5 = this;

      this.getItemsForInventory(this.selectedAccount.code).then(function (response) {
        _this5.optionsProducts = [{ code: '', text: 'Todos' }].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(response));
      });
    },
    nameWithLang: function nameWithLang(_ref) {
      var code = _ref.code,
          text = _ref.text;

      return code + ' \u2014 ' + text;
    },
    onAccountSelect: function onAccountSelect(account) {
      this.selectedAccount = account;
      this.getProducts();
      this.loadProductStatusData();
    },
    onProductSelect: function onProductSelect(product) {
      this.selectedProduct = product;
      this.loadProductStatusData();
    },
    selectedSection: function selectedSection(selected) {
      this.loadTableStatus();
    },
    onLoading: function onLoading() {
      this.loader = this.$loading.show({
        loader: 'dots'
      });
    },
    onLoaded: function onLoaded() {
      this.loader.hide();

      if (this.$route.params.tracking && !this.loadeadBack) {
        this.loadeadBack = true;
        this.$refs.vuetable.changePage(this.documentSearch.page);
      }
    },
    onClick: function onClick(data, field, event) {
      this.$refs.vuetable.toggleDetailRow(data.statusName);
    },
    renderQuantityField: function renderQuantityField(value, param2) {
      return '<span class="color">' + value + '</span>';
    },
    chartRendered: function chartRendered(event) {},
    summaryInnerStyle: function summaryInnerStyle() {
      return {
        position: 'absolute',
        left: '0px',
        right: '0px',
        width: '60%',
        top: this.realChartHeight / 6 + 'px'
      };
    },
    summaryInnerInnerStyle: function summaryInnerInnerStyle() {
      return {
        backgroundColor: 'white',
        margin: '8px auto',
        borderRadius: '50%',
        height: this.realChartHeight / 1.6 + 'px',
        width: this.realChartHeight / 1.6 + 'px',
        overflow: 'hidden',
        padding: '30px 30px 30px 30px'
      };
    },
    onPaginationData: function onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
      this.paginationData = paginationData;
    },
    onChangePage: function onChangePage(page) {
      this.$refs.vuetable.changePage(page);
      this.searchDocumentPage(page);
    },
    dataManager: function dataManager(sortOrder, pagination) {
      var data = [];

      if (this.tableData) {
        data = this.tableData.data;

        pagination = this.$refs.vuetable.makePagination(data.length);
        data = data.slice(pagination.from - 1, pagination.to);
      } else {
        pagination = this.$refs.vuetable.makePagination(0);
      }

      return {
        pagination: pagination,
        data: data
      };
    },
    formatAmount: function formatAmount(value) {
      return this.$options.filters.formatAmount(value);
    },
    formatPercentage: function formatPercentage(value) {
      return this.$options.filters.formatPercentage(value) + '%';
    }
  }),
  destroyed: function destroyed() {
    if (this.loader !== null) {
      this.loader.hide();
    }
  }
});

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuetable_2__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuetable_2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuetable_2__);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    rowData: { type: Object, required: true },
    rowIndex: { type: Number }
  },
  data: function data() {
    return {
      tableFields: [{
        name: 'line',
        title: 'Línea'
      }, {
        name: '__slot:percentageFromTotal',
        title: 'Porcentaje'
      }, {
        name: '__slot:quantity',
        title: 'Cantidad'
      }],
      tableData: [],
      window: {
        width: 0,
        height: 0
      }
    };
  },

  components: {
    'vue-table': __WEBPACK_IMPORTED_MODULE_0_vuetable_2___default.a
  },
  mounted: function mounted() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },

  methods: {
    onClick: function onClick(event) {},
    formatProgress: function formatProgress(documentProgress) {
      var classVal = '';

      if (documentProgress > 0) {
        classVal = 'success';
      }

      return classVal;
    },
    handleResize: function handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    formatAmount: function formatAmount(value) {
      return this.$options.filters.formatAmount(value);
    },
    formatPercentage: function formatPercentage(value) {
      return this.$options.filters.formatPercentage(value) + '%';
    }
  }
});

/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'defaultLayout',
  data: function data() {
    return {};
  },
  created: function created() {},

  components: {}
});

/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__navigation_NaviBar_vue__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__navigation_NaviBar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__navigation_NaviBar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__navigation_Slider_vue__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__navigation_Slider_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__navigation_Slider_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__navigation_ContentWrap_vue__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__navigation_ContentWrap_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__navigation_ContentWrap_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modal_Modal_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modal_Modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__modal_Modal_vue__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'master',
  data: function data() {
    return {};
  },

  computed: {},
  created: function created() {},

  components: {
    'va-navibar': __WEBPACK_IMPORTED_MODULE_0__navigation_NaviBar_vue___default.a,
    'va-slider': __WEBPACK_IMPORTED_MODULE_1__navigation_Slider_vue___default.a,
    'va-content-wrap': __WEBPACK_IMPORTED_MODULE_2__navigation_ContentWrap_vue___default.a,
    Modal: __WEBPACK_IMPORTED_MODULE_3__modal_Modal_vue___default.a
  }
});

/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__navigation_NaviBarOrange_vue__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__navigation_NaviBarOrange_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__navigation_NaviBarOrange_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__navigation_SliderOrange_vue__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__navigation_SliderOrange_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__navigation_SliderOrange_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__navigation_ContentWrap_vue__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__navigation_ContentWrap_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__navigation_ContentWrap_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modal_Modal_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modal_Modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__modal_Modal_vue__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'masterOrange',
  data: function data() {
    return {};
  },

  computed: {},
  created: function created() {},

  components: {
    'va-navibar-orange': __WEBPACK_IMPORTED_MODULE_0__navigation_NaviBarOrange_vue___default.a,
    'va-slider-orange': __WEBPACK_IMPORTED_MODULE_1__navigation_SliderOrange_vue___default.a,
    'va-content-wrap': __WEBPACK_IMPORTED_MODULE_2__navigation_ContentWrap_vue___default.a,
    Modal: __WEBPACK_IMPORTED_MODULE_3__modal_Modal_vue___default.a
  }
});

/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {
    var _this = this;

    this.$bus.$on('modal-open', function (args) {
      _this.type = args.type;
      _this.title = args.title;
      _this.body = args.body;
      _this.description = args.description;
      _this.confirmText = args.confirmText || 'Aceptar';
      _this.cancelText = args.cancelText;
      _this.confirmBeforeHook = args.confirmBefore;
      _this.confirmAfterHook = args.confirmAfter;
      _this.cancelBeforeHook = args.cancelBefore;
      _this.cancelAfterHook = args.cancelAfter;

      $('#bsModal').modal('show');
    });
    $('#bsModal').on('show.bs.modal', function (e) {});

    $('#bsModal').on('hidden.bs.modal', function (e) {
      _this.confirmAfterHook();
      _this.cancelAfterHook();
      _this.resetProperties();
    });
  },
  data: function data() {
    return {
      type: '',
      title: '',
      body: null,
      description: '',
      confirmText: '',
      cancelText: null,
      confirmBeforeHook: function confirmBeforeHook() {},
      confirmAfterHook: function confirmAfterHook() {},
      cancelBeforeHook: function cancelBeforeHook() {},
      cancelAfterHook: function cancelAfterHook() {}
    };
  },

  methods: {
    confirm: function confirm() {
      this.confirmBeforeHook();
      $('#bsModal').modal('hide');
      this.cancelAfterHook = function () {};
    },
    cancel: function cancel() {
      this.cancelBeforeHook();
      $('#bsModal').modal('hide');
      this.confirmAfterHook = function () {};
    },
    resetProperties: function resetProperties() {
      this.type = '';
      this.title = '';
      this.description = '';
      this.confirmBeforeHook = function () {};
      this.confirmAfterHook = function () {};
      this.cancelBeforeHook = function () {};
      this.cancelAfterHook = function () {};
    }
  }
});

/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_assets_js_constants_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetable_2__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetable_2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetable_2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_carousel__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment_moment_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment_moment_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment_moment_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue2_google_maps__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue2_google_maps__);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DocumentMonitoring',
  data: function data() {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['dummyDocument']), {
      tableKey: 1,
      tableData: null,
      loader: null,
      selectedEvent: 0,
      stateGroups: [],
      fotos: [],
      fotosEnable: false,
      fotoTest: null,
      documentNumber: -1,
      documentStartDate: null,
      documentEndDate: null,
      currentClientCode: null,
      stateFalse: false,
      fotoEnable: false,
      ubicacionStatus: 'ver ubicación',
      ubicationState: false,
      orderDeliveryDateConvert: null,
      stateApply: {
        name: 'nada'
      },
      window: {
        width: 0,
        height: 0
      },
      document: {
        events: [{}]
      },
      detailVisible: {},
      currentClient: {},
      tableFields: [{
        name: '__slot:description',
        title: 'Descripción',
        titleClass: 'text-center'
      }, {
        name: '__slot:provider',
        title: 'Proveedor / Cliente',
        titleClass: 'text-center'
      }, {
        name: '__slot:totalPackages',
        title: 'Cantidad',
        titleClass: 'text-center',
        dataClass: 'text-center'
      }, {
        name: '__slot:weight',
        title: 'Peso',
        callback: 'formatWeightKg',
        titleClass: 'text-center',
        dataClass: 'text-center'
      }, {
        name: '__slot:volume',
        title: 'Volumen',
        callback: 'formatVolM',
        titleClass: 'text-center',
        dataClass: 'text-center'
      }],
      tableCSS: null,
      tableOptions: {
        filterable: false,
        texts: {
          count: ''
        }
      },
      centerDefault: {
        lat: 0,
        lng: 0
      },
      center: null,
      paginationData: null,
      totalPackages: 0,
      totalWeight: 0,
      totalVolume: 0,
      indicatorViewOrder: false,
      indicatorViewAddress: false
    });
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    google: __WEBPACK_IMPORTED_MODULE_6_vue2_google_maps__["gmapApi"]
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['userClients']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['userInfo'])),
  beforeMount: function beforeMount() {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vue2_google_maps__["loadGmapApi"])({
      key: __WEBPACK_IMPORTED_MODULE_2_assets_js_constants_js__["a" /* default */].apiKeyGoogle.vitz
    });
  },
  created: function created() {
    var _this = this;

    this.tableCSS = __WEBPACK_IMPORTED_MODULE_2_assets_js_constants_js__["a" /* default */].tableCSS;
    this.documentNumber = this.$route.params.documentNumber;
    this.documentType = this.$route.params.documentType;
    this.selectedAccount = this.$route.params.selectedAccount;
    this.minimumStockUnit = this.$route.params.minimumStockUnit;
    this.address1 = this.$route.params.address1;
    this.trackingNumber = this.$route.params.trackingNumber;
    this.referenceDocumentNumber1 = this.$route.params.referenceDocumentNumber1;
    this.codeOrderType = this.$route.params.codeOrderType;
    this.orderType = this.$route.params.orderType;
    this.indicatorViewOrder = this.isVisibleViewOrder(this.documentType);
    this.indicatorViewAddress = this.isVisibleViewAddress(this.documentType);

    this.center = this.centerDefault;

    this.loader = this.$loading.show({
      loader: 'dots'
    });

    this.tableData = null;

    this.getDocument({ documentId: this.documentNumber, documentType: this.documentType }).then(function (response) {
      _this.currentClient = _this.userClients.filter(function (x) {
        return x.code === _this.selectedAccount.code;
      })[0];
      _this.document = response.document;
      _this.orderDeliveryDateConvert = __WEBPACK_IMPORTED_MODULE_5_moment_moment_js___default()(_this.document.orderDeliveryDate).format('YYYY');
      if (_this.orderDeliveryDateConvert === '0001') {
        _this.document.orderDeliveryDate === ' ';
      }
      _this.tableData = {
        data: _this.document.events[0].items
      };
      _this.tableKey++;
      _this.showDetail(0, true);
    });
  },
  mounted: function mounted() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])(['getDocument', 'getDocumentImage']), {
    geolocate: function geolocate() {
      var _this2 = this;

      navigator.geolocation.getCurrentPosition(function (position) {
        _this2.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
      });
    },
    onUbicationModal: function onUbicationModal() {
      this.$modal.show('ubication');
    },
    onUbication: function onUbication() {
      var currentEvent = this.document.events[this.selectedEvent];
      this.markers = [this.selectedEvent];
      this.zoom = 14;
      var lati = currentEvent.latitude !== undefined ? currentEvent.latitude : 0;
      var long = currentEvent.longitude !== undefined ? currentEvent.longitude : 0;
      if (lati === 0 && long === 0) {
        this.ubicationState = false;
        return;
      } else {
        this.ubicationState = true;
      }
      this.center = {
        lat: lati,
        lng: long
      };
      this.tableKey++;
    },
    iconFor: function iconFor(mode) {
      switch (mode) {
        case 'BL':
          return '/static/img/icons/ic_recived_containers';
        case 'OC':
        case 'DV':
        case 'PE':
          return '/static/img/icons/ic_storage_arrived';
        case 'GU':
          return '/static/img/icons/ic_delivery_shipped';
        default:
          console.log('Tipo de documento no reconocido: ' + mode);
          return 'undefined';
      }
    },
    stateCondition: function stateCondition(state) {
      if (state.done) {
        return 'arkano-stepper-check-status-true';
      } else {
        if (!this.stateFalse || this.stateApply.name === state.name) {
          this.stateFalse = true;
          this.stateApply = state;
          return 'arkano-stepper-check-status-next';
        } else {
          if (!this.stateApply) {
            return 'arkano-stepper-check-status-next';
          }
          if (this.stateApply.name !== state.name) {
            return 'arkano-stepper-check-status-next';
          }
        }
      }
    },
    modalFotos: function modalFotos() {
      this.$modal.show('fotos');
    },
    labelFor: function labelFor(mode) {
      switch (mode) {
        case 'BL':
          return 'Depósito Temporal';
        case 'OC':
        case 'DV':
        case 'PE':
          return 'Almacén';
        case 'GU':
          return 'Despacho';
        default:
          return '';
      }
    },
    validateUbication: function validateUbication() {},
    colorFor: function colorFor(mode) {
      switch (mode) {
        case 'BL':
          return __WEBPACK_IMPORTED_MODULE_2_assets_js_constants_js__["a" /* default */].colorPalette.TemporaryDepositReceived;
        case 'OC':
        case 'DV':
        case 'PE':
          return '#345570';
        case 'GU':
          return __WEBPACK_IMPORTED_MODULE_2_assets_js_constants_js__["a" /* default */].colorPalette.TransportDelivered;
        default:
          return '';
      }
    },
    handleResize: function handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    toggleVisible: function toggleVisible(index) {
      var _out = !this.detailVisible[index];
      Vue.set(this.detailVisible, index, _out);
      this.$forceUpdate();
    },
    isVisible: function isVisible(index) {
      if (this.detailVisible[index] === undefined) {
        this.detailVisible[index] = false;
      }
      return this.detailVisible[index];
    },
    showDetail: function showDetail(eventIndex, first) {
      var _this3 = this;

      if (!first) {
        this.loader = this.$loading.show({
          loader: 'dots'
        });
      }
      var imageParam = {
        AccountCode: this.selectedAccount.code,
        documentId: this.documentNumber,
        documentType: this.documentType,
        eventCode: this.document.events[eventIndex].code,
        headerToken: this.userInfo.encodedToken
      };
      this.fotos = [];
      if (this.document.events[eventIndex].code === '' || this.document.events[eventIndex].code === null) {
        this.fotoEnable = false;
        setTimeout(function () {
          return _this3.loader.hide();
        }, 500);
      } else {
        this.getDocumentImage(imageParam).then(function (response) {
          if (response.image1 != null) {
            _this3.fotos.push(response.image1);
          }
          if (response.image2 != null) {
            _this3.fotos.push(response.image2);
          }
          if (response.image3 != null) {
            _this3.fotos.push(response.image3);
          }
          if (response.image4 != null) {
            _this3.fotos.push(response.image4);
          }

          if (_this3.fotos.length >= 1) {
            _this3.fotoEnable = true;
          } else {
            _this3.fotoEnable = false;
          }
          _this3.loader.hide();
        }).catch(function (error) {
          _this3.loader.hide();
          console.log('error ' + error);
        });
      }
      this.selectedEvent = eventIndex;
      this.totalPackages = this.document.totalPackages;
      this.totalWeight = this.document.totalWeight;
      this.totalVolume = this.document.totalVolume;
      this.onUbication();
      this.tableData = {
        data: this.document.events[eventIndex].items
      };
      this.tableKey++;
    },
    base64ToBinary: function base64ToBinary(base64EncodedFile, Name, ID) {
      var i;
      var BASE64_MARKER = ';base64,';
      var base64Index = base64EncodedFile.indexOf(BASE64_MARKER) + BASE64_MARKER.length;
      var base64 = base64EncodedFile.substring(base64Index);
      var raw = atob(base64);
      var rawLength = raw.length;
      var array = new Uint8Array(rawLength);
      for (i = 0; i < rawLength; i++) {
        array[i] = raw.charCodeAt(i);
      }
    },
    goSearch: function goSearch() {
      window.location = '/Documento/Busqueda';
    },
    formatWeightKg: function formatWeightKg(value) {
      return this.$options.filters.formatWeightKg(value);
    },
    formatVolM: function formatVolM(value) {
      return this.$options.filters.formatVolM(value);
    },
    formatVolM1: function formatVolM1(value) {
      return this.$options.filters.formatVolM1(value);
    },
    formatProgress: function formatProgress(documentProgress) {
      var classVal = '';

      if (documentProgress >= 90) {
        classVal = 'success';
      } else if (documentProgress >= 50) {
        classVal = 'warning';
      } else {
        classVal = 'danger';
      }

      return classVal;
    },
    onPaginationData: function onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
      this.paginationData = paginationData;
    },
    onChangePage: function onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    dataManager: function dataManager(sortOrder, pagination) {
      var data = [];

      if (this.tableData) {
        data = this.tableData.data;
        pagination = this.$refs.vuetable.makePagination(data.length);
        data = data.slice(pagination.from - 1, pagination.to);
      } else {
        pagination = this.$refs.vuetable.makePagination(0);
      }

      return {
        pagination: pagination,
        data: data
      };
    },
    isVisibleViewOrder: function isVisibleViewOrder(value) {
      switch (value) {
        case 'PE':
          return true;
        default:
          return false;
      }
    },
    isVisibleViewAddress: function isVisibleViewAddress(value) {
      switch (value) {
        case 'PE':
          return true;
        default:
          return false;
      }
    }
  }),
  components: {
    Carousel: __WEBPACK_IMPORTED_MODULE_4_vue_carousel__["Carousel"],
    Slide: __WEBPACK_IMPORTED_MODULE_4_vue_carousel__["Slide"],
    Vuetable: __WEBPACK_IMPORTED_MODULE_3_vuetable_2__["Vuetable"],
    'vuetable-pagination': __WEBPACK_IMPORTED_MODULE_3_vuetable_2__["VuetablePagination"]
  },
  find: function find() {},
  destroyed: function destroyed() {
    if (this.loader !== null) {
      this.loader.hide();
    }
  }
});

/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_multiselect__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetable_2__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetable_2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuetable_2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_multiselect_dist_vue_multiselect_min_css__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_multiselect_dist_vue_multiselect_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_multiselect_dist_vue_multiselect_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_bootstrap_daterangepicker_daterangepicker_css__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_bootstrap_daterangepicker_daterangepicker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_bootstrap_daterangepicker_daterangepicker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_bootstrap_daterangepicker_daterangepicker_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_bootstrap_daterangepicker_daterangepicker_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_bootstrap_daterangepicker_daterangepicker_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment_moment_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment_moment_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment_moment_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_assets_js_constants_js__ = __webpack_require__(5);














/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DocumentSearch',
  data: function data() {
    return {
      showAdvance: false,
      loader: null,
      loader2: null,
      loadeadBack: true,
      optionsAccount: null,
      selectedAccount: null,
      selectedClient: null,
      optionsClient: [{ code: '', text: 'Todos' }],
      optionDocumentType: [],
      documentType: null,
      optionTypeOrder: [],
      typeOrder: null,
      documentNumber: '',
      trackingNumber: '',
      referenceOrder: '',
      documentStartDate: '',
      documentEndDate: '',
      tableKey: 1,
      tableData: {
        data: null
      },
      totalPages: 0,
      pageNumber: 1,
      window: {
        width: 0,
        height: 0
      },
      tableFields: [{
        name: '__slot:documentTypeCode',
        title: '',
        titleClass: 'table-text',
        dataClass: 'table-text'
      }, {
        name: '__slot:documentTypeName',
        title: 'Tipo',
        titleClass: 'table-text',
        dataClass: 'table-text'
      }, {
        name: '__slot:documentNumber',
        title: 'Número',
        titleClass: 'table-text',
        dataClass: 'table-text'
      }, {
        name: '__slot:documentDate',
        title: 'Fecha',
        callback: 'formatDate',
        titleClass: 'table-text',
        dataClass: 'table-text'
      }, {
        name: '__slot:quantitiesDocument',
        title: 'ATENDIDO / SOLICITADO',
        titleClass: 'table-text',
        dataClass: 'table-text'
      }, {
        name: '__slot:supplierCustomerDescription',
        title: 'Cliente / Proveedor',
        titleClass: 'table-text',
        dataClass: 'table-text client-table'
      }, {
        name: '__slot:progress',
        title: 'Progreso',
        titleClass: 'table-text'
      }, {
        name: '__slot:referenceOrder',
        title: 'Nro. Referencia',
        titleClass: 'table-text',
        dataClass: 'table-text'
      }, {
        name: '__slot:trackingNumber',
        title: 'Nro. Tracking',
        titleClass: 'table-text',
        dataClass: 'table-text'
      }, {
        name: '__slot:tracking',
        title: '',
        titleClass: 'table-text'
      }],
      tableCSS: null,
      tableOptions: {
        filterable: false,
        texts: {
          count: ''
        }
      },
      paginationData: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])(['userClients', 'documentSearch'])),
  created: function created() {
    this.tableCSS = __WEBPACK_IMPORTED_MODULE_10_assets_js_constants_js__["a" /* default */].tableCSS;
    this.showAdvance = this.$route.params.showAdvance;
    this.loadSelectData();
  },
  mounted: function mounted() {
    var self = this;
    $(this.$el).find('#dtDateRange').daterangepicker({
      showDropdowns: true,
      startDate: __WEBPACK_IMPORTED_MODULE_9_moment_moment_js___default()().format('DD/MM/YYYY'),
      endDate: __WEBPACK_IMPORTED_MODULE_9_moment_moment_js___default()().format('DD/MM/YYYY'),
      dateLimit: { 'days': 30 },
      locale: __WEBPACK_IMPORTED_MODULE_10_assets_js_constants_js__["a" /* default */].datePickerLocale
    }, function (start, end, label) {
      $('#divModeButtons button.btn-success').click();
    });
    $('#dtDateRange').on('apply.daterangepicker', function (ev, picker) {
      self.getClients();
    });
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
    if (this.$route.params.tracking) {
      $('#dtDateRange').data('daterangepicker').setStartDate(__WEBPACK_IMPORTED_MODULE_9_moment_moment_js___default()(this.documentSearch.filter.params.StartDate).format('DD/MM/YYYY'));
      $('#dtDateRange').data('daterangepicker').setEndDate(__WEBPACK_IMPORTED_MODULE_9_moment_moment_js___default()(this.documentSearch.filter.params.EndDate).format('DD/MM/YYYY'));
    }
    this.getClients();
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])(['searchDocument', 'searchDocument2', 'searchDocumentPage', 'getDocumentTypes', 'getSupplierCustomer', 'getItemsForAccountConfiguration']), {
    loadSelectData: function loadSelectData() {
      this.optionsAccount = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default()(this.userClients);
      this.selectedAccount = this.optionsAccount[0];
      this.selectedClient = this.optionsClient[0];

      this.getTypes();
      this.getTypesOrders();
    },
    onAccountSelect: function onAccountSelect(account) {
      this.selectedAccount = account;
      this.selectedClient = this.optionsClient[0];
      this.getClients();
      this.documentType = null;
      this.getTypes();
      this.typeOrder = null;
      this.getTypesOrders();
      this.documentNumber = '';
      this.trackingNumber = '';
      this.referenceOrder = '';
      $('#dtDateRange').data('daterangepicker').setStartDate(__WEBPACK_IMPORTED_MODULE_9_moment_moment_js___default()().format('DD/MM/YYYY'));
      $('#dtDateRange').data('daterangepicker').setEndDate(__WEBPACK_IMPORTED_MODULE_9_moment_moment_js___default()().format('DD/MM/YYYY'));
      this.tableData = {
        data: null
      };
    },
    onClientSelect: function onClientSelect(client) {
      this.selectedClient = client;
    },
    onDocumentSelect: function onDocumentSelect() {
      this.getClients();
    },
    getClients: function getClients() {
      var _this = this;

      this.onLoading();
      if (this.showAdvance) {
        this.optionsClient = [{ code: '', text: 'Todos' }];
        this.selectedClient = this.optionsClient[0];
        var params = {
          accountCode: this.selectedAccount.code,
          documentType: this.documentType ? this.documentType : '',
          startDate: $(this.$el).find('#dtDateRange').data('daterangepicker').startDate.format('YYYYMMDD'),
          endDate: $(this.$el).find('#dtDateRange').data('daterangepicker').endDate.format('YYYYMMDD')
        };
        this.getSupplierCustomer(params).then(function (response) {
          _this.optionsClient = [{ code: '', text: 'Todos' }].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(response));
          _this.onLoaded();
          _this.reloadData();
        });
      } else {
        this.onLoaded();
        this.reloadData();
      }
    },
    getTypes: function getTypes() {
      var _this2 = this;

      this.optionDocumentType = [];
      var params = {
        params: {
          AccountCode: this.selectedAccount.code
        }
      };
      this.getDocumentTypes(params).then(function (response) {
        _this2.optionDocumentType = [{ code: null, text: 'Todos' }].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(response));
      });
    },
    getTypesOrders: function getTypesOrders() {
      var _this3 = this;

      this.optionTypeOrder = [];
      var params = {
        accountCode: this.selectedAccount.code,
        typeConfigurationId: 3
      };
      this.getItemsForAccountConfiguration(params).then(function (response) {
        _this3.optionTypeOrder = [{ code: null, text: 'Todos' }].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(response));
      });
    },
    reloadData: function reloadData() {
      if (this.$route.params.tracking) {
        this.search();
      }
    },
    search: function search() {
      var _this4 = this;

      this.pageNumber = 1;
      document.activeElement.blur();
      if (this.$route.params.tracking) {
        this.$route.params.tracking = false;
        this.selectedAccount = this.documentSearch.filter.AccountSelect;
        this.documentType = this.documentSearch.filter.params.DocumentType;
        this.documentStartDate = this.documentSearch.filter.params.StartDate;
        this.documentEndDate = this.documentSearch.filter.params.EndDate;
        this.selectedClient = this.documentSearch.filter.ClientSelect;
        this.typeOrder = this.documentSearch.filter.params.CodeOrderType;
        this.documentNumber = this.documentSearch.filter.params.DocumentNumber;
        this.trackingNumber = this.documentSearch.filter.params.TrackingNumber;
        this.referenceOrder = this.documentSearch.filter.params.ReferenceOrder;
      } else {
        this.documentStartDate = '';
        this.documentEndDate = '';
      }

      if (this.documentStartDate === '' && this.documentEndDate === '') {
        this.documentStartDate = $(this.$el).find('#dtDateRange').data('daterangepicker').startDate.format('YYYYMMDD');
        this.documentEndDate = $(this.$el).find('#dtDateRange').data('daterangepicker').endDate.format('YYYYMMDD');
      }

      if (this.documentNumber !== '' || this.documentStartDate !== '' && this.documentEndDate !== '') {
        this.onLoading();
        this.tableData = {
          data: null
        };

        var params = {
          AccountSelect: this.selectedAccount,
          ClientSelect: this.selectedClient,
          params: {
            AccountCode: this.selectedAccount.code,
            DocumentType: this.documentType,
            DocumentNumber: this.documentNumber.trim(),
            SupplierCustomerCode: this.selectedClient.code ? this.selectedClient.code : null,
            CodeOrderType: this.typeOrder,
            TrackingNumber: this.trackingNumber.trim(),
            ReferenceOrder: this.referenceOrder.trim(),
            StartDate: this.documentStartDate,
            EndDate: this.documentEndDate
          },
          page: {
            Page: this.pageNumber
          }
        };
        this.searchDocument2(params).then(function (data) {
          if (data != null) {
            _this4.tableData = {
              data: data.documents
            };
            _this4.totalPages = {
              data: data.totalPages
            };
            _this4.onLoaded();
            _this4.tableKey++;
          }
        });
      } else {
        this.$bus.$emit('modal-open', {
          title: 'Error',
          description: 'Ingrese un Tipo y Número de documento o un Rango de Fechas.',
          type: 'info',
          confirmText: 'Aceptar',
          cancelText: null,
          confirmBefore: function confirmBefore() {},
          confirmAfter: function confirmAfter() {},
          cancelBefore: function cancelBefore() {},
          cancelAfter: function cancelAfter() {}
        });
      }
    },
    handleResize: function handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    onLoading: function onLoading() {
      this.loader = this.$loading.show({
        loader: 'dots'
      });
    },
    onLoaded: function onLoaded() {
      this.loader.hide();
    },
    formatType: function formatType(value) {
      var formattedVal = this.optionDocumentType.filter(function (item) {
        return item.code === value;
      });
      return formattedVal.length > 0 ? formattedVal[0].text : '';
    },
    formatStatus: function formatStatus(statusCode) {
      var classVal = '';

      switch (statusCode) {
        case 1:
          classVal = 'success';
          break;
        default:
          classVal = 'warning';
          break;
      }

      return classVal;
    },
    formatDate: function formatDate(value) {
      return __WEBPACK_IMPORTED_MODULE_9_moment_moment_js___default()(value).format('DD/MM/YYYY');
    },
    formatProgress: function formatProgress(documentProgress) {
      var classVal = '';

      if (documentProgress >= 90) {
        classVal = 'success';
      } else if (documentProgress >= 50) {
        classVal = 'warning';
      } else {
        classVal = 'danger';
      }

      return classVal;
    },
    onPaginationData: function onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
      this.paginationData = paginationData;
    },
    onChangePage: function onChangePage(page) {
      var _this5 = this;

      this.loader2 = this.$loading.show({
        loader: 'dots'
      });

      this.$refs.vuetable.changePage(page);
      if (page > 0) {
        this.pageNumber = page;
      }
      if (page === 'next') {
        this.pageNumber += 1;
        if (this.pageNumber >= this.totalPages.data) {
          this.pageNumber -= 1;
          return;
        }
      }
      if (page === 'prev') {
        this.pageNumber -= 1;
        if (this.pageNumber < 1) {
          this.pageNumber += 1;
          return;
        }
      }
      var params = {
        AccountSelect: this.selectedAccount,
        ClientSelect: this.selectedClient,
        params: {
          AccountCode: this.selectedAccount.code,
          DocumentType: this.documentType,
          DocumentNumber: this.documentNumber.trim(),
          SupplierCustomerCode: this.selectedClient.code ? this.selectedClient.code : null,
          CodeOrderType: this.typeOrder,
          TrackingNumber: this.trackingNumber.trim(),
          ReferenceOrder: this.referenceOrder.trim(),
          StartDate: this.documentStartDate,
          EndDate: this.documentEndDate
        },
        page: {
          Page: this.pageNumber
        }
      };
      this.searchDocument2(params).then(function (data) {
        _this5.tableData = {
          data: data.documents
        };
        _this5.totalPages = {
          data: data.totalPages
        };
        _this5.loader2.hide();
        _this5.tableKey++;
      });
    },
    dataManager: function dataManager(sortOrder, pagination) {
      var data = [];
      data = this.tableData.data;
      if (this.tableData.data && this.totalPages.data > 1) {
        pagination = this.$refs.vuetable.makePagination(data.length);
        pagination.last_page = this.totalPages.data;
        pagination.current_page = this.pageNumber;
        pagination.total = this.totalPages.data > 1 ? this.totalPages.data : this.totalpages.data;
        pagination.next_page_url = pagination.current_page + 1;
        if (pagination.next_page_url > 1) {
          pagination.prev_page_url = pagination.current_page - 1;
        }
        data = data.slice(pagination.from - 1, pagination.to);
      } else {
        pagination = this.$refs.vuetable.makePagination(0);
      }
      return {
        pagination: pagination,
        data: data
      };
    },

    documentTypeClass: function documentTypeClass(type) {
      var typeClass = '';
      switch (type) {
        case 'PE':
          typeClass += 'icon-PE ';
          break;
        case 'DV':
          typeClass += 'icon-DV ';
          break;
        case 'OC':
          typeClass += 'icon-OC ';
          break;
        case 'GU':
          typeClass += 'icon-GU ';
          break;
        case 'BL':
          typeClass += 'icon-BL ';
          break;
        default:
          typeClass += 'default';
          break;
      }

      return typeClass;
    },
    advancedSearch: function advancedSearch() {
      this.optionsClient = [{ code: '', text: 'Todos' }];
      this.selectedClient = this.optionsClient[0];
      this.trackingNumber = '';
      this.referenceOrder = '';

      if (this.showAdvance) {
        this.showAdvance = false;
      } else {
        this.showAdvance = true;
        this.getClients();
      }
    }
  }),
  components: {
    Multiselect: __WEBPACK_IMPORTED_MODULE_4_vue_multiselect___default.a,
    Vuetable: __WEBPACK_IMPORTED_MODULE_5_vuetable_2__["Vuetable"],
    'vuetable-pagination': __WEBPACK_IMPORTED_MODULE_5_vuetable_2__["VuetablePagination"]
  } });

/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'va-content-wrap',
  created: function created() {}
});

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      window: {
        width: 0,
        height: 0
      }
    };
  },

  name: 'va-navibar',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['userInfo'])),
  mounted: function mounted() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },

  methods: {
    handleResize: function handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    }
  },
  destroyed: function destroyed() {
    window.removeEventListener('resize', this.handleResize);
  }
});

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);




var OFFSET = 60;

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      window: {
        width: 0,
        height: 0
      },
      showNavbar: true,
      lastScrollPosition: 0,
      scrollValue: 0
    };
  },

  name: 'va-navibar',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['userInfo'])),
  mounted: function mounted() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
    this.lastScrollPosition = window.pageYOffset;
    window.addEventListener('scroll', this.onScroll);
    var viewportMeta = document.createElement('meta');
    viewportMeta.name = 'viewport';
    viewportMeta.content = 'width=device-width, initial-scale=1';
    document.head.appendChild(viewportMeta);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll);
  },

  methods: {
    handleResize: function handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    onScroll: function onScroll() {
      if (window.pageYOffset < 0) {
        return;
      }
      if (Math.abs(window.pageYOffset - this.lastScrollPosition) < OFFSET) {
        return;
      }

      this.lastScrollPosition = window.pageYOffset;
    },
    showSlider: function showSlider() {
      $('#slider').addClass('div-view div-display');
      $('.close-slider').addClass('div-display');
      $('.main-header').addClass('div-none');
    }
  },
  destroyed: function destroyed() {
    window.removeEventListener('resize', this.handleResize);
  }
});

/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VASlideItem__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VASlideItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__VASlideItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'va-slider',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['slideMenuItems'])),
  created: function created() {},

  components: {
    'va-slide-item': __WEBPACK_IMPORTED_MODULE_1__VASlideItem___default.a
  }
});

/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VASlideOrangeItem__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VASlideOrangeItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__VASlideOrangeItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'va-slider-orange',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['slideMenuItems'])),
  created: function created() {},

  methods: {
    closeSlider: function closeSlider() {
      $('#slider').removeClass('div-view');
      $('#slider').removeClass('div-display');
      $('.close-slider').removeClass('div-display');
      $('.main-header').removeClass('div-none');
    }
  },
  components: {
    'va-slide-orange-item': __WEBPACK_IMPORTED_MODULE_1__VASlideOrangeItem___default.a
  }
});

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'va-slide-item',
  data: function data() {
    return {
      window: {
        width: 0,
        height: 0
      }
    };
  },

  props: {
    type: {
      type: String,
      default: 'item'
    },
    isHeader: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: ''
    },
    name: {
      type: String
    },
    badge: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    router: {
      type: Object,
      default: function _default() {
        return {
          name: ''
        };
      }
    },
    link: {
      type: String,
      default: ''
    }
  },
  created: function created() {},
  mounted: function mounted() {
    $('.treeview').click(function () {
      var thisMenu = $(this).children('.treeview-menu');
      $('.treeview-menu').each(function () {
        if (thisMenu.filter(function (element) {
          return element === $(this);
        }).length) {
          return;
        }
        $(this).css('display', '');
      });
    });

    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },

  methods: {
    handleResize: function handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    }
  },
  computed: {
    getType: function getType() {
      if (this.isHeader) {
        return 'header treeview';
      }
      return this.type === 'item' ? '' : 'treeview';
    }
  }
});

/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'va-slide-orange-item',
  data: function data() {
    return {
      window: {
        width: 0,
        height: 0
      }
    };
  },

  props: {
    type: {
      type: String,
      default: 'item'
    },
    isHeader: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: ''
    },
    name: {
      type: String
    },
    badge: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    router: {
      type: Object,
      default: function _default() {
        return {
          name: ''
        };
      }
    },
    link: {
      type: String,
      default: ''
    }
  },
  created: function created() {},
  mounted: function mounted() {
    $('.treeview').click(function () {
      var thisMenu = $(this).children('.treeview-menu');
      $('.treeview-menu').each(function () {
        if (thisMenu.filter(function (element) {
          return element === $(this);
        }).length) {
          return;
        }
        $(this).css('display', '');
      });
    });

    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },

  methods: {
    handleResize: function handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    }
  },
  filters: {
    abbreviation: function abbreviation(value) {
      if (!value) return '';
      var word = value.split(' ');
      var resul = '';
      if (word.length === 1) {
        resul = word[0].substring(0, 2).toUpperCase();
      } else {
        var count = 0;
        for (var i = 0; i < word.length; i++) {
          if (count > 1) {
            break;
          }
          if (word[i].toLowerCase() !== 'de') {
            resul = resul + word[i].substring(0, 1).toUpperCase();
            count++;
          }
        }
      }
      return resul;
    }
  },
  computed: {
    getType: function getType() {
      if (this.isHeader) {
        return 'header treeview';
      }
      return this.type === 'item' ? '' : 'treeview';
    }
  }
});

/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_multiselect__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_multiselect_dist_vue_multiselect_min_css__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_multiselect_dist_vue_multiselect_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_multiselect_dist_vue_multiselect_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment_moment_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment_moment_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment_moment_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_bootstrap_daterangepicker_daterangepicker_css__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_bootstrap_daterangepicker_daterangepicker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_bootstrap_daterangepicker_daterangepicker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_bootstrap_daterangepicker_daterangepicker_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_bootstrap_daterangepicker_daterangepicker_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_bootstrap_daterangepicker_daterangepicker_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_charts_StackedBarChart_js__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuetable_2__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuetable_2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vuetable_2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_assets_js_constants_js__ = __webpack_require__(5);
















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PerishableProducts',
  components: {
    Multiselect: __WEBPACK_IMPORTED_MODULE_4_vue_multiselect___default.a,
    Vuetable: __WEBPACK_IMPORTED_MODULE_10_vuetable_2___default.a,

    'chart-progress': __WEBPACK_IMPORTED_MODULE_9_charts_StackedBarChart_js__["a" /* default */]
  },
  data: function data() {
    return {
      showAdvance: false,
      loader: null,
      lastSearch: false,
      submitted: false,
      message: '',
      searchParams: null,
      fetchData: null,
      selectedAccount: null,
      optionsAccount: null,
      dtDocStartDate: null,
      dtDocEndDate: null,
      selectedClient: null,
      optionsClient: [{ code: '', text: 'Todos' }],
      optionDocumentStatus: [],
      documentStatus: null,
      optionTypeOrder: [],
      typeOrder: null,
      chartData: null,
      tableAllData: null,
      tableClientData: null,
      window: {
        width: 0,
        height: 0
      },
      tableAllFields: [{
        name: 'accountCode',
        title: 'Código Cliente'
      }, {
        name: 'accountCode',
        title: 'Cliente',
        callback: 'formatClient'
      }, {
        name: 'orderTotal',
        title: 'Total Pedidos'
      }, {
        name: 'orderCompleted',
        title: 'Atendido'
      }, {
        name: 'orderProgress',
        title: 'Proceso'
      }, {
        name: 'orderPending',
        title: 'Pendientes'
      }],
      tableClientFields: [{
        name: '__slot:shippingDate',
        title: 'Fecha',
        callback: 'formatDate'
      }, {
        name: '__slot:orderCompleted',
        title: 'Atendidos'
      }, {
        name: '__slot:orderProgress',
        title: 'Proceso'
      }, {
        name: '__slot:orderPending',
        title: 'Pendientes'
      }, {
        name: '__slot:orderTotal',
        title: 'Total'
      }, {
        name: '__slot:orderBtnDetail',
        title: '',
        titleClass: 'table-text'
      }],
      tableCSS: {
        table: {
          tableClass: 'table table-striped table-bordered table-hovered table-content-color'
        }
      },
      tableOptions: {
        filterable: false,
        texts: {
          count: ''
        }
      },
      headerText: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])(['userClients', 'orderProgressSeach'])),
  created: function created() {
    this.optionsAccount = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default()(this.userClients);
    this.mode = __WEBPACK_IMPORTED_MODULE_11_assets_js_constants_js__["a" /* default */].ordersProgressFilterModes.pending;
    this.showAdvance = this.$route.params.showAdvance;


    this.selectedAccount = this.optionsAccount[0];
    this.selectedClient = this.optionsClient[0];
    this.getTypes();
    this.getStatus();
  },

  mounted: function mounted() {
    var self = this;
    $(this.$el).find('#dtDateRange').daterangepicker({
      showDropdowns: true,
      startDate: __WEBPACK_IMPORTED_MODULE_6_moment_moment_js___default()().format('DD/MM/YYYY'),
      endDate: __WEBPACK_IMPORTED_MODULE_6_moment_moment_js___default()().format('DD/MM/YYYY'),
      dateLimit: { 'days': 6 },
      locale: __WEBPACK_IMPORTED_MODULE_11_assets_js_constants_js__["a" /* default */].datePickerLocale
    }, function (start, end, label) {
      $('#divModeButtons button.btn-success').click();
    });
    $('#dtDateRange').on('apply.daterangepicker', function (ev, picker) {
      self.getClients();
    });

    window.addEventListener('resize', this.handleResize);
    this.handleResize();
    if (this.$route.params.lastSearch) {
      this.selectedAccount = this.orderProgressSeach.params.Account;
      $('#dtDateRange').data('daterangepicker').setStartDate(__WEBPACK_IMPORTED_MODULE_6_moment_moment_js___default()(this.orderProgressSeach.params.StartDate).format('DD/MM/YYYY'));
      $('#dtDateRange').data('daterangepicker').setEndDate(__WEBPACK_IMPORTED_MODULE_6_moment_moment_js___default()(this.orderProgressSeach.params.EndDate).format('DD/MM/YYYY'));
      this.selectedClient = this.orderProgressSeach.params.SupplierCustomer;
      this.typeOrder = this.orderProgressSeach.params.CodeOrderType;
      this.documentStatus = this.orderProgressSeach.params.DocumentStatusCode;
    }
    this.getClients();
    this.loadLastSearch();
  },
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])(['fetchOrdersProgressData', 'getDocumentStatus', 'getSupplierCustomer', 'getItemsForAccountConfiguration']), {
    handleResize: function handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    getClass: function getClass(mode) {
      var classVal = 'btn btn-sm btn-';
      classVal += this.mode === mode ? 'success' : 'default';
      return classVal;
    },
    toggleClasses: function toggleClasses() {
      $('#pendingFilter').removeClass();
      $('#attendedFilter').removeClass();
      if (this.mode === __WEBPACK_IMPORTED_MODULE_11_assets_js_constants_js__["a" /* default */].ordersProgressFilterModes.pending) {
        $('#pendingFilter').addClass('btn btn-sm btn-success');
        $('#attendedFilter').addClass('btn btn-sm btn-default');
      } else {
        $('#pendingFilter').addClass('btn btn-sm btn-default');
        $('#attendedFilter').addClass('btn btn-sm btn-success');
      }
    },
    formatProgress: function formatProgress(documentProgress) {
      var classVal = '';

      if (documentProgress > 0) {
        classVal = 'success';
      }

      return classVal;
    },
    onModeSelect: function onModeSelect(mode) {
      document.activeElement.blur();
      this.changeFilter(mode);
    },
    changeFilter: function changeFilter(mode) {
      this.mode = mode;
      this.toggleClasses();
      this.loadChartData();
    },
    search: function search() {
      var _this = this;

      document.activeElement.blur();
      this.submitted = true;

      if (this.validate()) {
        this.chartData = null;
        this.headerText = '';
        this.tableAllData = null;
        this.tableClientData = null;

        this.searchParams = {
          Account: this.selectedAccount,
          AccountCode: this.selectedAccount.code,
          StartDate: $(this.$el).find('#dtDateRange').data('daterangepicker').startDate.format('YYYYMMDD'),
          EndDate: $(this.$el).find('#dtDateRange').data('daterangepicker').endDate.format('YYYYMMDD'),
          SupplierCustomer: this.selectedClient,
          SupplierCustomerCode: this.selectedClient.code,
          CodeOrderType: this.typeOrder,
          DocumentStatusCode: this.documentStatus
        };
        console.log(this.searchParams);
        this.loader = this.$loading.show({
          loader: 'dots'
        });
        this.fetchOrdersProgressData(this.searchParams).then(function (data) {
          if (data != null) {
            _this.fetchData = data;

            _this.loadClientDetail();

            _this.submitted = false;

            _this.onLoaded();
          }
        });
      }
    },
    loadLastSearch: function loadLastSearch() {
      var _this2 = this;

      if (!this.$route.params.lastSearch) {
        return;
      }
      this.searchParams = {
        Account: this.orderProgressSeach.params.Account,
        AccountCode: this.orderProgressSeach.params.AccountCode,
        StartDate: this.orderProgressSeach.params.StartDate,
        EndDate: this.orderProgressSeach.params.EndDate,
        SupplierCustomer: this.orderProgressSeach.params.SupplierCustomer,
        SupplierCustomerCode: this.orderProgressSeach.params.SupplierCustomerCode,
        DocumentStatusCode: this.orderProgressSeach.params.DocumentStatusCode,
        CodeOrderType: this.orderProgressSeach.params.CodeOrderType
      };
      var filterAccountCode = this.orderProgressSeach.params.AccountCode;
      this.tableClientData = [];
      this.orderProgressSeach.search.orders.forEach(function (element) {
        if (element.accountCode === filterAccountCode) {
          _this2.tableClientData.push({
            shippingDate: element.date,
            orderTotal: element.totalOrders,
            orderCompleted: element.ordersCompleted,
            orderProgress: element.progressOrders,
            orderPending: element.pendingOrders,
            minimumStockUnit: element.minimumStockUnit,
            totalPendingPorcentage: element.pendingPercentage === 0 ? 0 : 100 * element.pendingOrders / element.totalOrders,
            totalProgressPorcentage: element.progressPercentage === 0 ? 0 : 100 * element.progressOrders / element.totalOrders,
            totalShippedPorcentage: element.completedPercentage === 0 ? 0 : 100 * element.ordersCompleted / element.totalOrders,
            detail: element.detail
          });
        }
      });
      this.onLoaded();
    },
    validate: function validate() {
      var startDate = __WEBPACK_IMPORTED_MODULE_6_moment_moment_js___default()($(this.$el).find('#dtDateRange').data('daterangepicker').startDate);
      var endDate = __WEBPACK_IMPORTED_MODULE_6_moment_moment_js___default()($(this.$el).find('#dtDateRange').data('daterangepicker').endDate);
      var days = __WEBPACK_IMPORTED_MODULE_6_moment_moment_js___default.a.duration(endDate.diff(startDate)).asDays();
      if (days < 0 || days > 7) {
        this.message = 'El rango de Fechas permitido es de 7 días.';
        return false;
      } else {
        this.message = '';
        return true;
      }
    },
    loadChartData: function loadChartData() {
      var formattedData = this.formatChartData();

      if (this.mode === __WEBPACK_IMPORTED_MODULE_11_assets_js_constants_js__["a" /* default */].ordersProgressFilterModes.pending) {
        this.chartData = {
          labels: this.formatChartLabels(),
          datasets: [{
            label: 'Pendientes',
            backgroundColor: formattedData.Color,
            data: formattedData.PendingPorcentage
          }, {
            label: 'Total',
            backgroundColor: formattedData.TotalColor,
            data: formattedData.TotalPendingPorcentage
          }]
        };
      } else {
        this.chartData = {
          labels: this.formatChartLabels(),
          datasets: [{
            label: 'Atendidos',
            backgroundColor: formattedData.Color,
            data: formattedData.ShippedPorcentage
          }, {
            label: 'Total',
            backgroundColor: formattedData.TotalColor,
            data: formattedData.TotalShippedPorcentage
          }]
        };
      }
    },
    formatChartLabels: function formatChartLabels() {
      var chartLabels = [];

      var startDate = __WEBPACK_IMPORTED_MODULE_6_moment_moment_js___default()($(this.$el).find('#dtDocStartDate').data('daterangepicker').startDate);
      var endDate = __WEBPACK_IMPORTED_MODULE_6_moment_moment_js___default()($(this.$el).find('#dtDocEndDate').data('daterangepicker').endDate);

      var days = __WEBPACK_IMPORTED_MODULE_6_moment_moment_js___default.a.duration(endDate.diff(startDate)).asDays();

      while (days >= 0) {
        chartLabels.push(startDate.format('DD/MM/YYYY'));
        startDate = startDate.add(1, 'days');
        days = __WEBPACK_IMPORTED_MODULE_6_moment_moment_js___default.a.duration(endDate.diff(startDate)).asDays();
      }

      return chartLabels;
    },
    formatChartData: function formatChartData() {
      var data = this.fetchData.orders;

      var chartData = {
        Total: [],
        Shipped: [],
        Color: [],
        TotalColor: [],
        Pending: [],
        TotalPendingPorcentage: [],
        TotalShippedPorcentage: [],
        PendingPorcentage: [],
        ShippedPorcentage: []
      };

      if (data) {
        data.sort(function (a, b) {
          return new Date(a.date) - new Date(b.date);
        });
      }

      var labels = this.formatChartLabels();

      var formatObj = {};

      labels.forEach(function (element) {
        formatObj[element] = {
          Total: 0,
          Pending: 0
        };
      });

      data.forEach(function (element) {
        var currentDate = __WEBPACK_IMPORTED_MODULE_6_moment_moment_js___default()(element.date).format('DD/MM/YYYY');
        if (formatObj[currentDate] !== undefined) {
          formatObj[currentDate].Total += element.totalOrders;
          formatObj[currentDate].Pending += element.pendingOrders;
          formatObj[currentDate].Color = element.chartColor && element.chartColor != null ? element.chartColor : __WEBPACK_IMPORTED_MODULE_11_assets_js_constants_js__["a" /* default */].colorPalette.baseBlue;
          formatObj[currentDate].TotalColor = element.chartColor && element.chartColor != null ? element.chartColor + '80' : __WEBPACK_IMPORTED_MODULE_11_assets_js_constants_js__["a" /* default */].colorPalette.baseBlue;
        }
      });

      labels.forEach(function (element) {
        var formattedItem = formatObj[element];
        chartData.Total.push(formattedItem.Total);
        chartData.Shipped.push(formattedItem.Total - formattedItem.Pending);
        chartData.Pending.push(formattedItem.Pending);
        chartData.Color.push(formattedItem.Color);
        chartData.TotalColor.push(formattedItem.TotalColor);
        chartData.TotalPendingPorcentage.push(Math.round(100 - formattedItem.Pending * 100 / formattedItem.Total, 2));
        chartData.TotalShippedPorcentage.push(Math.round(100 - (formattedItem.Total - formattedItem.Pending) * 100 / formattedItem.Total, 2));
        chartData.PendingPorcentage.push(Math.round(formattedItem.Pending * 100 / formattedItem.Total, 2));
        chartData.ShippedPorcentage.push(Math.round((formattedItem.Total - formattedItem.Pending) * 100 / formattedItem.Total, 2));
      });

      return chartData;
    },
    onLoading: function onLoading() {
      this.loader = this.$loading.show({
        loader: 'dots'
      });
    },
    onLoaded: function onLoaded() {
      if (this.loader !== null) {
        this.loader.hide();
      }
    },
    formatClient: function formatClient(value) {
      var formattedVal = this.userClients.filter(function (item) {
        return item.code === value;
      });
      return formattedVal.length > 0 ? formattedVal[0].name : '';
    },
    formatDate: function formatDate(value) {
      return value ? __WEBPACK_IMPORTED_MODULE_6_moment_moment_js___default()(value).format('DD/MM/YYYY') : '';
    },
    getClients: function getClients() {
      var _this3 = this;

      if (this.showAdvance) {
        this.onLoading();
        this.optionsClient = [{ code: '', text: 'Todos' }];
        var params = {
          accountCode: this.selectedAccount.code,
          documentType: 'PE',
          startDate: $(this.$el).find('#dtDateRange').data('daterangepicker').startDate.format('YYYYMMDD'),
          endDate: $(this.$el).find('#dtDateRange').data('daterangepicker').endDate.format('YYYYMMDD')
        };
        this.getSupplierCustomer(params).then(function (response) {
          _this3.optionsClient = [{ code: '', text: 'Todos' }].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(response));
          _this3.onLoaded();
        });
      }
    },
    getTypes: function getTypes() {
      var _this4 = this;

      this.optionTypeOrder = [];
      var params = {
        accountCode: this.selectedAccount.code,
        typeConfigurationId: 3
      };
      this.getItemsForAccountConfiguration(params).then(function (response) {
        _this4.optionTypeOrder = [{ code: null, text: 'Todos' }].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(response));
      });
    },
    getStatus: function getStatus() {
      var _this5 = this;

      this.optionDocumentStatus = [];
      this.getDocumentStatus().then(function (response) {
        _this5.optionDocumentStatus = [{ code: null, text: 'Todos' }].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(response));
      });
    },
    resetTableClientData: function resetTableClientData() {
      if (!this.$route.params.lastSearch) {
        this.tableAllData = [];
        this.tableClientData = [];
      }
      this.$route.params.lastSearch = false;
      this.onLoaded();
    },
    onAccountSelect: function onAccountSelect(account) {
      this.selectedAccount = account;
      this.selectedClient = this.optionsClient[0];
      this.getClients();
      this.typeOrder = null;
      this.getTypes();
      this.documentStatus = null;
      this.getStatus();
      $('#dtDateRange').data('daterangepicker').setStartDate(__WEBPACK_IMPORTED_MODULE_6_moment_moment_js___default()().format('DD/MM/YYYY'));
      $('#dtDateRange').data('daterangepicker').setEndDate(__WEBPACK_IMPORTED_MODULE_6_moment_moment_js___default()().format('DD/MM/YYYY'));
      this.resetTableClientData();
    },
    onClientSelect: function onClientSelect(client) {
      this.selectedClient = client;
    },
    loadClientDetail: function loadClientDetail() {
      var _this6 = this;

      var filterAccountCode = this.searchParams.AccountCode;
      this.tableClientData = [];
      this.fetchData.orders.forEach(function (element) {
        if (element.accountCode === filterAccountCode) {
          _this6.tableClientData.push({
            shippingDate: element.date,
            orderTotal: element.totalOrders,
            orderCompleted: element.ordersCompleted,
            orderProgress: element.progressOrders,
            orderPending: element.pendingOrders,
            minimumStockUnit: element.minimumStockUnit,
            totalPendingPorcentage: element.pendingPercentage === 0 ? 0 : 100 * element.pendingOrders / element.totalOrders,
            totalProgressPorcentage: element.progressPercentage === 0 ? 0 : 100 * element.progressOrders / element.totalOrders,
            totalShippedPorcentage: element.completedPercentage === 0 ? 0 : 100 * element.ordersCompleted / element.totalOrders,
            detail: element.detail
          });
        }
      });
    },
    advancedSearch: function advancedSearch() {
      this.optionsClient = [{ code: '', text: 'Todos' }];
      this.selectedClient = this.optionsClient[0];

      this.typeOrder = null;
      this.documentStatus = null;

      if (this.showAdvance) {
        this.showAdvance = false;
      } else {
        this.showAdvance = true;
        this.getClients();
      }
    }
  }),
  destroyed: function destroyed() {
    this.onLoaded();
  }
});

/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_multiselect__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_multiselect_dist_vue_multiselect_min_css__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_multiselect_dist_vue_multiselect_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_multiselect_dist_vue_multiselect_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment_moment_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment_moment_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment_moment_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_bootstrap_daterangepicker_daterangepicker_css__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_bootstrap_daterangepicker_daterangepicker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_bootstrap_daterangepicker_daterangepicker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_bootstrap_daterangepicker_daterangepicker_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_bootstrap_daterangepicker_daterangepicker_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_bootstrap_daterangepicker_daterangepicker_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuetable_2__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuetable_2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vuetable_2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_assets_js_constants_js__ = __webpack_require__(5);














/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PerishableProducts',
  components: {
    Multiselect: __WEBPACK_IMPORTED_MODULE_4_vue_multiselect___default.a,
    Vuetable: __WEBPACK_IMPORTED_MODULE_9_vuetable_2__["Vuetable"],
    'vuetable-pagination': __WEBPACK_IMPORTED_MODULE_9_vuetable_2__["VuetablePagination"]
  },
  data: function data() {
    return {
      loader: null,
      orderDetailTableVue: null,
      orderDetail: null,
      orderDetailTable: null,
      submitted: false,
      message: '',
      order: '',
      searchParams: null,
      fetchData: null,
      selectedClient: null,
      optionsClient: null,
      chartData: null,
      tableAllData: null,
      tableKey: 1,
      tableLoad: false,
      tableClientData: null,
      window: {
        width: 0,
        height: 0
      },
      tableDetail: [{
        name: '__slot:clientName',
        title: 'Cliente'
      }, {
        name: '__slot:completedOrders',
        title: 'Atendido'
      }, {
        name: '__slot:progressOrders',
        title: 'Proceso'
      }, {
        name: '__slot:pendingOrders',
        title: 'Pendientes'
      }],
      tableCSS: {
        table: {
          tableClass: 'table table-striped table-bordered table-hovered table-content-color'
        }
      },
      tableOptions: {
        filterable: false,
        texts: {
          count: ''
        }
      },
      paginationData: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])(['userClients'])),
  created: function created() {
    this.tableCSS = __WEBPACK_IMPORTED_MODULE_10_assets_js_constants_js__["a" /* default */].tableCSS;
    this.optionsClient = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default()(this.userClients);
    this.mode = __WEBPACK_IMPORTED_MODULE_10_assets_js_constants_js__["a" /* default */].ordersProgressFilterModes.pending;

    this.selectedClient = this.optionsClient[0];
  },
  mounted: function mounted() {
    this.dataTableRefres();
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])(['fetchOrdersProgressData']), {
    getClass: function getClass(mode) {
      var classVal = 'btn btn-sm btn-';
      classVal += this.mode === mode ? 'success' : 'default';
      return classVal;
    },
    handleResize: function handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    toggleClasses: function toggleClasses() {
      $('#pendingFilter').removeClass();
      $('#attendedFilter').removeClass();
      if (this.mode === __WEBPACK_IMPORTED_MODULE_10_assets_js_constants_js__["a" /* default */].ordersProgressFilterModes.pending) {
        $('#pendingFilter').addClass('btn btn-sm btn-success');
        $('#attendedFilter').addClass('btn btn-sm btn-default');
      } else {
        $('#pendingFilter').addClass('btn btn-sm btn-default');
        $('#attendedFilter').addClass('btn btn-sm btn-success');
      }
    },
    dataTableRefres: function dataTableRefres() {
      var _this = this;

      this.order = this.$route.params.filterOrdereDate;
      this.orderDetail = this.order.detail;
      this.orderDetailTable = [];
      this.orderDetail.forEach(function (element) {
        _this.orderDetailTable.push({
          clientName: element.clientName,
          completedPercentage: element.completedPercentage,
          pendingPercentage: element.pendingPercentage,
          progressPercentage: element.progressPercentage,
          completedOrders: element.completedOrders,
          progressOrders: element.progressOrders,
          pendingOrders: element.pendingOrders,
          minimumStockUnit: _this.order.minimumStockUnit
        });
      });
      this.orderDetailTableVue = {
        data: this.orderDetailTable
      };
      this.tableKey++;
      this.loader.hide();
    },
    formatProgress: function formatProgress(documentProgress) {
      var classVal = '';

      if (documentProgress > 0) {
        classVal = 'success';
      }

      return classVal;
    },
    onModeSelect: function onModeSelect(mode) {
      document.activeElement.blur();
      this.changeFilter(mode);
    },
    changeFilter: function changeFilter(mode) {
      this.mode = mode;
      this.toggleClasses();
      this.loadChartData();
    },
    search: function search() {
      var _this2 = this;

      document.activeElement.blur();
      this.submitted = true;

      if (this.validate()) {
        this.chartData = null;
        this.headerText = '';
        this.tableAllData = null;
        this.tableClientData = null;

        this.searchParams = {
          AccountCodes: [this.selectedClient.code],
          StartDate: $(this.$el).find('#dtDocStartDate').data('daterangepicker').startDate.format('YYYYMMDD'),
          EndDate: $(this.$el).find('#dtDocEndDate').data('daterangepicker').endDate.format('YYYYMMDD')
        };
        this.loader = this.$loading.show({
          loader: 'dots'
        });

        this.fetchOrdersProgressData(this.searchParams).then(function (data) {
          if (data != null) {
            _this2.fetchData = data;
            _this2.loadChartData();

            if (_this2.searchParams.AccountCodes.length > 1) {
              _this2.loadDetail();
            } else {
              _this2.loadClientDetail();
            }

            _this2.submitted = false;

            _this2.loader.hide();
          }
        });
      }
    },
    goSearch: function goSearch() {
      window.location = '/AvancePedidos';
    },
    validate: function validate() {
      var startDate = __WEBPACK_IMPORTED_MODULE_6_moment_moment_js___default()($(this.$el).find('#dtDocStartDate').data('daterangepicker').startDate);
      var endDate = __WEBPACK_IMPORTED_MODULE_6_moment_moment_js___default()($(this.$el).find('#dtDocEndDate').data('daterangepicker').endDate);
      var days = __WEBPACK_IMPORTED_MODULE_6_moment_moment_js___default.a.duration(endDate.diff(startDate)).asDays();

      if (days < 0 || days > 7) {
        this.message = 'El rango de Fechas permitido es de 7 días.';
        return false;
      } else {
        this.message = '';
        return true;
      }
    },
    onPaginationData: function onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
      this.paginationData = paginationData;
    },
    onChangePage: function onChangePage(page) {
      this.$refs.vuetable.changePage(page);
      this.searchDocumentPage(page);
    },
    loadChartData: function loadChartData() {
      var formattedData = this.formatChartData();

      if (this.mode === __WEBPACK_IMPORTED_MODULE_10_assets_js_constants_js__["a" /* default */].ordersProgressFilterModes.pending) {
        this.chartData = {
          labels: this.formatChartLabels(),
          datasets: [{
            label: 'Pendientes',
            backgroundColor: formattedData.Color,
            data: formattedData.PendingPorcentage
          }, {
            label: 'Total',
            backgroundColor: formattedData.TotalColor,
            data: formattedData.TotalPendingPorcentage
          }]
        };
      } else {
        this.chartData = {
          labels: this.formatChartLabels(),
          datasets: [{
            label: 'Atendidos',
            backgroundColor: formattedData.Color,
            data: formattedData.ShippedPorcentage
          }, {
            label: 'Total',
            backgroundColor: formattedData.TotalColor,
            data: formattedData.TotalShippedPorcentage
          }]
        };
      }
    },
    formatChartLabels: function formatChartLabels() {
      var chartLabels = [];

      var startDate = __WEBPACK_IMPORTED_MODULE_6_moment_moment_js___default()($(this.$el).find('#dtDocStartDate').data('daterangepicker').startDate);
      var endDate = __WEBPACK_IMPORTED_MODULE_6_moment_moment_js___default()($(this.$el).find('#dtDocEndDate').data('daterangepicker').endDate);

      var days = __WEBPACK_IMPORTED_MODULE_6_moment_moment_js___default.a.duration(endDate.diff(startDate)).asDays();

      while (days >= 0) {
        chartLabels.push(startDate.format('DD/MM/YYYY'));
        startDate = startDate.add(1, 'days');
        days = __WEBPACK_IMPORTED_MODULE_6_moment_moment_js___default.a.duration(endDate.diff(startDate)).asDays();
      }

      return chartLabels;
    },
    formatChartData: function formatChartData() {
      var data = this.fetchData;

      var chartData = {
        Total: [],
        Shipped: [],
        Color: [],
        TotalColor: [],
        Pending: [],
        TotalPendingPorcentage: [],
        TotalShippedPorcentage: [],
        PendingPorcentage: [],
        ShippedPorcentage: []
      };

      if (data) {
        data.sort(function (a, b) {
          return new Date(a.date) - new Date(b.date);
        });
      }

      var labels = this.formatChartLabels();

      var formatObj = {};

      labels.forEach(function (element) {
        formatObj[element] = {
          Total: 0,
          Pending: 0
        };
      });

      data.forEach(function (element) {
        var currentDate = __WEBPACK_IMPORTED_MODULE_6_moment_moment_js___default()(element.date).format('DD/MM/YYYY');
        if (formatObj[currentDate] !== undefined) {
          formatObj[currentDate].Total += element.completedOrders;
          formatObj[currentDate].Pending += element.pendingOrders;
          formatObj[currentDate].Color = element.chartColor && element.chartColor != null ? element.chartColor : __WEBPACK_IMPORTED_MODULE_10_assets_js_constants_js__["a" /* default */].colorPalette.baseBlue;
          formatObj[currentDate].TotalColor = element.chartColor && element.chartColor != null ? element.chartColor + '80' : __WEBPACK_IMPORTED_MODULE_10_assets_js_constants_js__["a" /* default */].colorPalette.baseBlue;
        }
      });

      labels.forEach(function (element) {
        var formattedItem = formatObj[element];
        chartData.Total.push(formattedItem.Total);
        chartData.Shipped.push(formattedItem.Total - formattedItem.Pending);
        chartData.Pending.push(formattedItem.Pending);
        chartData.Color.push(formattedItem.Color);
        chartData.TotalColor.push(formattedItem.TotalColor);
        chartData.TotalPendingPorcentage.push(Math.round(100 - formattedItem.Pending * 100 / formattedItem.Total, 2));
        chartData.TotalShippedPorcentage.push(Math.round(100 - (formattedItem.Total - formattedItem.Pending) * 100 / formattedItem.Total, 2));
        chartData.PendingPorcentage.push(Math.round(formattedItem.Pending * 100 / formattedItem.Total, 2));
        chartData.ShippedPorcentage.push(Math.round((formattedItem.Total - formattedItem.Pending) * 100 / formattedItem.Total, 2));
      });

      return chartData;
    },
    onLoading: function onLoading() {
      this.loader = this.$loading.show({
        loader: 'dots'
      });
    },
    onLoaded: function onLoaded() {
      this.loader.hide();
      if (this.$route.params.tracking && !this.loadeadBack) {
        this.loadeadBack = true;
        this.$refs.vuetable.changePage(this.documentSearch.page);
      }
    },
    formatClient: function formatClient(value) {
      var formattedVal = this.userClients.filter(function (item) {
        return item.code === value;
      });
      return formattedVal.length > 0 ? formattedVal[0].name : '';
    },
    formatDate: function formatDate(value) {
      return value ? __WEBPACK_IMPORTED_MODULE_6_moment_moment_js___default()(value).format('DD/MM/YYYY') : '';
    },
    onClientSelect: function onClientSelect(client) {
      this.selectedClient = client;
    },
    dataManager: function dataManager(sortOrder, pagination) {
      var data = [];

      if (this.orderDetailTableVue) {
        data = this.orderDetailTableVue.data;

        pagination = this.$refs.vuetable.makePagination(data.length);

        data = data.slice(pagination.from - 1, pagination.to);
      } else {
        pagination = this.$refs.vuetable.makePagination(0);
      }
      return {
        pagination: pagination,
        data: data
      };
    },
    loadDetail: function loadDetail() {
      var _this3 = this;

      this.headerText = __WEBPACK_IMPORTED_MODULE_6_moment_moment_js___default()(this.shipedDate).format('DD/MM/YYYY') + ' - ' + __WEBPACK_IMPORTED_MODULE_6_moment_moment_js___default()(this.shipedDate).format('DD/MM/YYYY');

      var formatObj = {};

      this.fetchData.forEach(function (element) {
        if (selectedDate === undefined || selectedDate === __WEBPACK_IMPORTED_MODULE_6_moment_moment_js___default()(element.date).format('DD/MM/YYYY')) {
          if (formatObj[element.accountCode]) {
            formatObj[element.accountCode].Total += element.totalOrders;
            formatObj[element.accountCode].Pending += element.pendingOrders;
          } else {
            formatObj[element.accountCode] = {
              Total: element.totalOrders,
              Completed: element.completedOrders,
              Pending: element.pendingOrders,
              Progress: element.progressOrders
            };
          }
        }
      });
      this.tableAllData = [];
      var keys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(formatObj);

      keys.forEach(function (element) {
        var formattedItem = formatObj[element];
        _this3.tableAllData.push({
          accountCode: element,
          orderTotal: formattedItem.Total,
          completedOrders: formattedItem.Completed,
          orderProgress: formattedItem.Progress,
          orderPending: formattedItem.Pending
        });
      });
    },
    loadClientDetail: function loadClientDetail() {
      var _this4 = this;

      var filterClientCode = this.searchParams.AccountCodes[0];
      this.tableClientData = [];
      this.fetchData.forEach(function (element) {
        if (element.accountCode === filterClientCode) {
          _this4.tableClientData.push({
            shippingDate: element.date,
            orderTotal: element.totalOrders,
            completedOrders: element.completedOrders,
            orderProgress: element.progressOrders,
            orderPending: element.pendingOrders,
            totalPendingPorcentage: element.pendingPercentage === 0 ? 0 : 100 * element.pendingOrders / element.totalOrders,
            totalProgressPorcentage: element.progressPercentage === 0 ? 0 : 100 * element.progressOrders / element.totalOrders,
            totalShippedPorcentage: element.completedPercentage === 0 ? 0 : 100 * element.completedOrders / element.totalOrders
          });
        }
      });
    }
  }),
  destroyed: function destroyed() {
    if (this.loader !== null) {
      this.loader.hide();
    }
  }
});

/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_multiselect__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_multiselect_dist_vue_multiselect_min_css__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_multiselect_dist_vue_multiselect_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_multiselect_dist_vue_multiselect_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetable_2__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetable_2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuetable_2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment_moment_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment_moment_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment_moment_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_assets_js_constants_js__ = __webpack_require__(5);











/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PerishableProducts',
  components: {
    Multiselect: __WEBPACK_IMPORTED_MODULE_3_vue_multiselect___default.a,
    Vuetable: __WEBPACK_IMPORTED_MODULE_5_vuetable_2__["Vuetable"],
    'vuetable-pagination': __WEBPACK_IMPORTED_MODULE_5_vuetable_2__["VuetablePagination"]
  },
  data: function data() {
    return {
      loader: null,
      submitted: false,
      selectedAccount: null,
      optionsLine: [],
      selectedLine: null,
      productCode: null,
      optionsStatus: [],
      selectedStatus: null,
      optionsMode: [],
      selectedMode: null,
      tableKey: 1,
      tableData: null,
      tableFields: [{
        name: '__slot:productCode',
        title: 'Código',
        callback: 'formatCode'
      }, {
        name: '__slot:productDescription',
        title: 'Descripción'
      }, {
        name: '__slot:productUnits',
        title: 'Cantidad'
      }, {
        name: '__slot:productStatus',
        title: 'Estado'
      }, {
        name: '__slot:productLot',
        title: 'Lote'
      }, {
        name: '__slot:productLine',
        title: 'Línea'
      }, {
        name: '__slot:productModeCode',
        title: 'Modo',
        callback: 'formatModeCode'
      }, {
        name: '__slot:productExpireDate',
        title: 'Fecha Exp',
        callback: 'formatDate'
      }],
      tableCSS: null,
      tableOptions: {
        filterable: false,
        texts: {
          count: ''
        }
      },
      paginationData: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['userClients'])),
  created: function created() {
    this.tableCSS = __WEBPACK_IMPORTED_MODULE_7_assets_js_constants_js__["a" /* default */].tableCSS;
    this.loadSelectData();
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])(['fetchInventoryLines', 'fetchInventoryStatus', 'fetchPerishableProductsModes', 'fetchPerishableProductsList']), {
    loadSelectData: function loadSelectData() {
      var _this = this;

      this.optionsAccount = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(this.userClients);
      this.selectedAccount = this.optionsAccount[0];

      this.loadStatusOptions();

      this.optionsMode = [];

      this.fetchPerishableProductsModes().then(function (data) {
        if (data != null) {
          _this.optionsMode = data.map(function (item) {
            return {
              code: item.code,
              name: item.text
            };
          });

          if (_this.optionsLine.length === 0) {
            _this.optionsLine.push(__WEBPACK_IMPORTED_MODULE_7_assets_js_constants_js__["a" /* default */].defaultSelectItem);
          }

          _this.selectedMode = _this.optionsMode[0].code;
        }
      });

      this.loadLineOptions();
    },
    search: function search() {
      var _this2 = this;

      document.activeElement.blur();

      var params = {
        ClientCode: this.selectedAccount.code,
        Line: this.selectedLine === 'All' ? '' : this.selectedLine,
        ItemCode: this.productCode,
        Status: this.selectedStatus === 'All' ? '' : this.selectedStatus,
        ExpirationMode: this.selectedMode === 'All' ? '' : this.selectedMode
      };

      this.loader = this.$loading.show({
        loader: 'dots'
      });
      this.fetchPerishableProductsList(params).then(function (data) {
        if (data != null) {
          var formattedData = data.map(function (item) {
            return {
              accountCode: item.clientCode,
              productCode: item.productCode,
              productDescription: item.productDescription,
              productUnits: item.quantity,
              productStatus: item.status,
              productLot: item.batch,
              productExpireDate: item.expiration,
              productLine: item.line,
              productModeCode: item.expirationStatus
            };
          });

          _this2.tableData = {
            data: formattedData
          };
          _this2.tableKey++;
          _this2.loader.hide();
        }
      });
    },
    loadLineOptions: function loadLineOptions() {
      var _this3 = this;

      this.loader = this.$loading.show({
        loader: 'dots'
      });

      this.optionsLine = [];
      this.fetchInventoryLines(this.selectedAccount.code).then(function (data) {
        if (data != null) {
          _this3.optionsLine = data.map(function (item) {
            return {
              code: item.code,
              name: item.line
            };
          });

          _this3.optionsLine.unshift(__WEBPACK_IMPORTED_MODULE_7_assets_js_constants_js__["a" /* default */].defaultSelectItem);

          _this3.selectedLine = _this3.optionsLine[0].code;
          $('.vld-overlay').remove();
        }
      });
    },
    loadStatusOptions: function loadStatusOptions() {
      var _this4 = this;

      this.optionsStatus = [];

      this.fetchInventoryStatus(this.selectedAccount.code).then(function (data) {
        if (data != null) {
          _this4.optionsStatus = data.map(function (item) {
            return {
              code: item.code,
              name: item.text
            };
          });

          _this4.optionsStatus.unshift(__WEBPACK_IMPORTED_MODULE_7_assets_js_constants_js__["a" /* default */].defaultSelectItem);

          _this4.selectedStatus = _this4.optionsStatus[0].code;
        }
      });
    },
    onAccountSelect: function onAccountSelect(account) {
      this.selectedAccount = account;
      this.loadLineOptions();
      this.loadStatusOptions();
    },
    onLoading: function onLoading() {
      this.loader = this.$loading.show({
        loader: 'dots'
      });
    },
    onLoaded: function onLoaded() {
      this.loader.hide();
    },
    formatClient: function formatClient(value) {
      var formattedVal = this.optionsAccount.filter(function (item) {
        return item.code === value;
      });
      return formattedVal.length > 0 ? formattedVal[0].name : '';
    },
    formatStatus: function formatStatus(value) {
      var formattedVal = this.optionsStatus.filter(function (item) {
        return item.code === value;
      });
      return formattedVal.length > 0 ? formattedVal[0].name : '';
    },
    formatDate: function formatDate(value) {
      return __WEBPACK_IMPORTED_MODULE_6_moment_moment_js___default()(value).format('DD/MM/YYYY');
    },
    formatAmount: function formatAmount(value) {
      return this.$options.filters.formatPercentage(value) + '%';
    },
    onPaginationData: function onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
      this.paginationData = paginationData;
    },
    onChangePage: function onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    dataManager: function dataManager(sortOrder, pagination) {
      var data = [];

      if (this.tableData) {
        data = this.tableData.data;

        pagination = this.$refs.vuetable.makePagination(data.length);
        data = data.slice(pagination.from - 1, pagination.to);
      } else {
        pagination = this.$refs.vuetable.makePagination(0);
      }

      return {
        pagination: pagination,
        data: data
      };
    },
    formatCode: function formatCode(value) {
      return '<strong>' + value + '</strong>';
    },
    formatModeCode: function formatModeCode(value) {
      return '<span class="label">' + value + '</span>';
    },
    onRowClass: function onRowClass(dataItem, index) {
      switch (dataItem.productModeCode) {
        case 'Por vencer':
          return 'expiring';
        case 'Vencido':
          return 'expired';
        default:
          return '';
      }
    }
  }),
  destroyed: function destroyed() {
    if (this.loader !== null) {
      this.loader.hide();
    }
  }
});

/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_multiselect__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_multiselect_dist_vue_multiselect_min_css__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_multiselect_dist_vue_multiselect_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_multiselect_dist_vue_multiselect_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetable_2__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetable_2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuetable_2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment_moment_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment_moment_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment_moment_js__);











/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ReceptionAppointments',
  data: function data() {
    return {
      loader: null,
      optionsAccount: null,
      selectedAccount: null,
      tableData: null,
      tableFields: [{
        name: 'accountCode',
        title: 'Cliente',
        callback: 'formatClient'
      }, {
        name: 'filename',
        title: 'Documento'
      }, {
        name: 'uploaded',
        title: 'Fecha de Carga',
        callback: 'formatDate'
      }, {
        name: 'uploadedBy',
        title: 'Cargado Por'
      }],
      tableCSS: {
        table: {
          tableClass: 'table table-striped table-bordered table-hovered'
        }
      },
      tableOptions: {
        headings: {
          accountCode: 'Cliente',
          fileName: 'Documento',
          uploaded: 'Fecha de Carga',
          uploadedBy: 'Cargado Por'
        },
        filterable: false,
        texts: {
          count: ''
        }
      }
    };
  },

  components: {
    Multiselect: __WEBPACK_IMPORTED_MODULE_3_vue_multiselect___default.a,
    Vuetable: __WEBPACK_IMPORTED_MODULE_5_vuetable_2___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['userClients'])),
  created: function created() {
    this.optionsAccount = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(this.userClients);
    this.selectedAccount = this.optionsAccount[0];
    this.loadTableData();
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])(['fetchReceptionAppointmentDocumentList']), {
    loadTableData: function loadTableData() {
      var _this = this;

      this.loader = this.$loading.show({
        loader: 'dots'
      });

      this.fetchReceptionAppointmentDocumentList(this.selectedAccount.code).then(function (data) {
        if (data != null) {
          _this.tableData = data;
          _this.loader.hide();
        }
      });
    },
    onAccountSelect: function onAccountSelect(account) {
      this.selectedAccount = account;
      this.loadTableData();
    },
    onLoading: function onLoading() {
      this.loader = this.$loading.show({
        loader: 'dots'
      });
    },
    onLoaded: function onLoaded() {
      this.loader.hide();
    },
    formatClient: function formatClient(value) {
      return this.optionsAccount.filter(function (item) {
        return item.code === value;
      })[0].name;
    },
    formatDate: function formatDate(value) {
      return __WEBPACK_IMPORTED_MODULE_6_moment_moment_js___default()(value).format('DD/MM/YYYY');
    }
  }),
  destroyed: function destroyed() {
    if (this.loader !== null) {
      this.loader.hide();
    }
  }
});

/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetable_2__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetable_2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuetable_2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment_moment_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment_moment_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment_moment_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_modal_Modal_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_modal_Modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_modal_Modal_vue__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ReceptionAppointmentsUpload',
  data: function data() {
    return {
      loader: null,
      accountCode: '',
      accountName: '',
      fileValidation: '',
      file: null,
      uploadData: null,
      tableData: null,
      tableFields: [{
        name: 'accountCode',
        title: 'Cliente',
        callback: 'formatClient'
      }, {
        name: 'mode',
        title: 'Modalidad'
      }, {
        name: 'appointmentDate',
        title: 'Fecha de Cita',
        callback: 'formatDate'
      }, {
        name: 'appointmentTime',
        title: 'Hora de Cita'
      }, {
        name: 'week',
        title: 'Semana'
      }, {
        name: 'purchaseOrder',
        title: 'Nro. de Orden'
      }, {
        name: 'containerType',
        title: 'Tipo de Container'
      }, {
        name: 'containerNumber',
        title: 'Nro. de Container'
      }, {
        name: 'itemCode',
        title: 'Cod. de Artículo'
      }],
      tableCSS: {
        table: {
          tableClass: 'table table-striped table-bordered table-hovered',
          ascendingIcon: 'glyphicon glyphicon-chevron-up',
          descendingIcon: 'glyphicon glyphicon-chevron-down',
          handleIcon: 'glyphicon glyphicon-menu-hamburger'
        }
      },
      tableOptions: {
        filterable: false,
        texts: {
          count: ''
        }
      }
    };
  },
  created: function created() {
    var code = this.$route.params.accountCode;

    var found = this.userClients.find(function (item) {
      return item.code === code;
    });

    if (found) {
      this.accountCode = found.code;
      this.accountName = found.name;
    }
  },

  components: {
    Vuetable: __WEBPACK_IMPORTED_MODULE_2_vuetable_2___default.a,
    Modal: __WEBPACK_IMPORTED_MODULE_4_components_modal_Modal_vue___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['userClients'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])(['uploadReceptionApointmentFile', 'saveReceptionApointmentFile']), {
    handleFileUpload: function handleFileUpload() {
      this.file = this.$refs.file.files[0];
    },
    handleUpload: function handleUpload() {
      var _this = this;

      document.activeElement.blur();

      if (this.validateFile()) {
        this.loader = this.$loading.show({
          loader: 'dots'
        });

        this.tableData = null;
        this.uploadData = null;

        var params = {
          accountCode: this.accountCode,
          file: this.file
        };

        this.uploadReceptionApointmentFile(params).then(function (data) {
          _this.loader.hide();
          if (data.success) {
            _this.tableData = data.data.items;
            _this.uploadData = data.data;
          } else {
            _this.$bus.$emit('modal-open', {
              title: 'Error',
              description: 'Ocurrió un error al subir o procesar el archivo.',
              type: 'danger',
              confirmText: 'Aceptar',
              cancelText: null,
              confirmBefore: function confirmBefore() {},
              confirmAfter: function confirmAfter() {},
              cancelBefore: function cancelBefore() {},
              cancelAfter: function cancelAfter() {}
            });
          }
        });
      }
    },
    handleSubmit: function handleSubmit() {
      var _this2 = this;

      document.activeElement.blur();

      if (this.uploadData !== null) {
        this.$bus.$emit('modal-open', {
          title: 'Confirmación',
          description: '¿Desea continuar con el registro de citas?',
          type: 'primary',
          confirmText: 'Aceptar',
          cancelText: 'Cancelar',
          confirmBefore: function confirmBefore() {},
          confirmAfter: function confirmAfter() {
            _this2.loader = _this2.$loading.show({
              loader: 'dots'
            });

            var params = {
              accountCode: _this2.accountCode,
              data: _this2.uploadData
            };

            _this2.saveReceptionApointmentFile(params).then(function (data) {
              var title = void 0,
                  description = void 0,
                  type = void 0;
              if (data.success) {
                title = 'Éxito';
                description = 'Se grabó Citas de Recepción exitósamente.';
                type = 'success';
              } else {
                title = 'Error';
                description = 'Ocurrió un error al validar o grabar las citas.';
                type = 'danger';
              }

              _this2.loader.hide();

              _this2.$bus.$emit('modal-open', {
                title: title,
                description: description,
                type: type,
                confirmText: 'Aceptar',
                cancelText: null,
                confirmBefore: function confirmBefore() {},
                confirmAfter: function confirmAfter() {},
                cancelBefore: function cancelBefore() {},
                cancelAfter: function cancelAfter() {}
              });
            });
          },
          cancelBefore: function cancelBefore() {},
          cancelAfter: function cancelAfter() {}
        });
      }
    },
    formatClient: function formatClient(value) {
      return this.userClients.filter(function (item) {
        return item.code === value;
      })[0].name;
    },
    formatDate: function formatDate(value) {
      return __WEBPACK_IMPORTED_MODULE_3_moment_moment_js___default()(value).format('DD/MM/YYYY');
    },
    validateFile: function validateFile() {
      var result = false;

      if (this.file === null) {
        this.fileValidation = 'Debe seleccionar un documento a subir';
      } else if (this.file.type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
        this.fileValidation = 'La extensión del documento a subir debe ser MS Excel .xlsx';
      } else {
        this.fileValidation = '';
        result = true;
      }

      return result;
    }
  }),
  destroyed: function destroyed() {
    if (this.loader !== null) {
      this.loader.hide();
    }
  }
});

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_multiselect__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_multiselect_dist_vue_multiselect_min_css__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_multiselect_dist_vue_multiselect_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_multiselect_dist_vue_multiselect_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetable_2__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetable_2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuetable_2__);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AlertRules',
  components: {
    Multiselect: __WEBPACK_IMPORTED_MODULE_3_vue_multiselect___default.a,
    Vuetable: __WEBPACK_IMPORTED_MODULE_5_vuetable_2___default.a
  },
  data: function data() {
    return {
      loader: null,
      optionsAccount: null,
      selectedAccount: null,
      tableData: null,
      tableFields: [{
        name: '__slot:ruleCode',
        title: 'Código'
      }, {
        name: '__slot:ruleName',
        title: 'Nombre'
      }, {
        name: '__slot:ruleItemType',
        title: 'Tipo',
        callback: 'formatItemType'
      }, {
        name: '__slot:ruleItemCode',
        title: 'Código'
      }, {
        name: '__slot:ruleOperator',
        title: 'Operador',
        callback: 'formatOperator'
      }, {
        name: '__slot:ruleValue',
        title: 'Valor'
      }],
      tableCSS: {
        table: {
          tableClass: 'table table-striped table-bordered table-hovered'
        }
      },
      tableOptions: {
        filterable: false,
        texts: {
          count: ''
        }
      },

      optionsItemType: [],
      optionsOperator: []
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['userClients'])),
  created: function created() {
    var _this = this;

    this.optionsAccount = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(this.userClients);
    if (this.$route.params.accountCode) {
      this.selectedAccount = this.optionsAccount.filter(function (item) {
        return item.code === _this.$route.params.accountCode;
      })[0];
    } else {
      this.selectedAccount = this.optionsAccount[0];
    }

    this.loadSelectData();
    this.loadTableData();
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])(['fetchAlertRulesItemTypes', 'fetchAlertRulesOperators', 'fetchAlertRulesList']), {
    loadSelectData: function loadSelectData() {
      var _this2 = this;

      this.fetchAlertRulesItemTypes().then(function (data) {
        if (data != null) {
          _this2.optionsItemType = data.map(function (item) {
            return {
              code: item.code,
              name: item.text
            };
          });
        }
      });

      this.fetchAlertRulesOperators().then(function (data) {
        if (data != null) {
          _this2.optionsOperator = data.map(function (item) {
            return {
              code: item.code,
              name: item.text
            };
          });
        }
      });
    },
    loadTableData: function loadTableData() {
      var _this3 = this;

      this.loader = this.$loading.show({
        loader: 'dots'
      });

      this.fetchAlertRulesList(this.selectedAccount.code).then(function (data) {
        if (data != null) {
          _this3.tableData = data.map(function (item) {
            return {
              accountCode: item.accountCode,
              ruleCode: item.alertRuleId,
              ruleName: item.name,
              ruleItemType: item.appliesTo,
              ruleItemCode: item.itemValue,
              ruleOperator: item.operator,
              ruleValue: item.targetValue
            };
          });

          _this3.loader.hide();
        }
      });
    },
    onAccountSelect: function onAccountSelect(account) {
      this.selectedAccount = account;
      this.loadTableData();
    },
    onLoading: function onLoading() {
      this.loader = this.$loading.show({
        loader: 'dots'
      });
    },
    onLoaded: function onLoaded() {
      this.loader.hide();
    },
    formatItemType: function formatItemType(value) {
      var formattedVal = this.optionsItemType.filter(function (item) {
        return item.code === value;
      });
      return formattedVal.length > 0 ? formattedVal[0].name : '';
    },
    formatOperator: function formatOperator(value) {
      var formattedVal = this.optionsOperator.filter(function (item) {
        return item.code === value;
      });
      return formattedVal.length > 0 ? formattedVal[0].name : '';
    },
    onClick: function onClick(row) {
      this.$router.push({ name: 'AlertRulesEntry', params: { accountCode: row.accountCode, ruleCode: row.ruleCode } });
    }
  }),
  destroyed: function destroyed() {
    if (this.loader !== null) {
      this.loader.hide();
    }
  }
});

/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_daterangepicker_daterangepicker_css__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_daterangepicker_daterangepicker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_bootstrap_daterangepicker_daterangepicker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap_daterangepicker_daterangepicker_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap_daterangepicker_daterangepicker_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_bootstrap_daterangepicker_daterangepicker_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_modal_Modal_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_modal_Modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_components_modal_Modal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_multiselect__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_multiselect_dist_vue_multiselect_min_css__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_multiselect_dist_vue_multiselect_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_multiselect_dist_vue_multiselect_min_css__);











/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AlertRulesEntry',
  data: function data() {
    return {
      loader: null,
      submitted: false,
      optionsAccount: null,
      ruleList: [],
      currentRule: null,

      selectedAccount: null,
      ruleName: '',
      ruleItemType: '',
      ruleItemCode: '',
      ruleOperator: '',
      ruleValue: 0,
      notifyToValue: '',

      optionsItemType: null,
      optionsOperator: null
    };
  },
  created: function created() {
    var _this = this;

    this.optionsAccount = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default()(this.userClients);
    this.selectedAccount = this.optionsAccount.filter(function (item) {
      return item.code === _this.$route.params.accountCode;
    })[0];

    if (this.$route.params.ruleCode) {
      this.getRuleData(this.$route.params.ruleCode);
    } else {
      this.getRuleList();
    }

    this.loadSelectData();
  },
  mounted: function mounted() {
    $(this.$el).find('#numValue').keydown(function (e) {
      if ($.inArray(e.keyCode, [46, 8, 9, 27, 13]) !== -1 || e.keyCode === 65 && (e.ctrlKey === true || e.metaKey === true) || e.keyCode === 67 && (e.ctrlKey === true || e.metaKey === true) || e.keyCode === 88 && (e.ctrlKey === true || e.metaKey === true) || e.keyCode >= 35 && e.keyCode <= 39) {
        return;
      }

      if ((e.shiftKey || e.keyCode < 48 || e.keyCode > 57) && (e.keyCode < 96 || e.keyCode > 105)) {
        e.preventDefault();
      }
    });
  },

  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_5_components_modal_Modal_vue___default.a,
    Multiselect: __WEBPACK_IMPORTED_MODULE_6_vue_multiselect___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['userClients'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])(['fetchAlertRulesItemTypes', 'fetchAlertRulesOperators', 'fetchAlertRulesList', 'saveAlertRule']), {
    loadSelectData: function loadSelectData() {
      var _this2 = this;

      this.fetchAlertRulesItemTypes().then(function (data) {
        if (data != null) {
          _this2.optionsItemType = data.map(function (item) {
            return {
              code: item.code,
              name: item.text
            };
          });

          if (_this2.ruleItemType === '') {
            _this2.ruleItemType = _this2.optionsItemType[0].code;
          }
        }
      });

      this.fetchAlertRulesOperators().then(function (data) {
        if (data != null) {
          _this2.optionsOperator = data.map(function (item) {
            return {
              code: item.code,
              name: item.text
            };
          });

          if (_this2.ruleOperator === '') {
            _this2.ruleOperator = _this2.optionsOperator[0].code;
          }
        }
      });
    },
    onAccountSelect: function onAccountSelect(account) {
      this.selectedAccount = account;
      this.getRuleList();
    },
    getRuleList: function getRuleList() {
      var _this3 = this;

      this.loader = this.$loading.show({
        loader: 'dots'
      });

      this.fetchAlertRulesList(this.selectedAccount.code).then(function (data) {
        if (data != null) {
          _this3.ruleList = data.map(function (item) {
            return {
              AccountCode: item.accountCode,
              AlertRuleId: item.alertRuleId,
              Name: item.name,
              AppliesTo: item.appliesTo,
              ItemValue: item.itemValue,
              Operator: item.operator,
              TargetValue: item.targetValue,
              NotifyTo: item.notifyTo ? item.notifyTo : ''
            };
          });
          _this3.loader.hide();
        }
      });
    },
    getRuleData: function getRuleData(ruleCode) {
      var _this4 = this;

      this.loader = this.$loading.show({
        loader: 'dots'
      });

      this.fetchAlertRulesList(this.selectedAccount.code).then(function (data) {
        if (data != null) {
          _this4.ruleList = data.map(function (item) {
            return {
              AccountCode: item.accountCode,
              AlertRuleId: item.alertRuleId,
              Name: item.name,
              AppliesTo: item.appliesTo,
              ItemValue: item.itemValue,
              Operator: item.operator,
              TargetValue: item.targetValue,
              NotifyTo: item.notifyTo ? item.notifyTo : ''
            };
          });

          var selectedRule = _this4.ruleList.filter(function (item) {
            return item.AlertRuleId === ruleCode;
          })[0];

          if (selectedRule) {
            _this4.currentRule = selectedRule;
            _this4.ruleName = _this4.currentRule.Name;
            _this4.ruleItemType = _this4.currentRule.AppliesTo;
            _this4.ruleItemCode = _this4.currentRule.ItemValue;
            _this4.ruleOperator = _this4.currentRule.Operator;
            _this4.ruleValue = _this4.currentRule.TargetValue;
            _this4.notifyToValue = _this4.currentRule.NotifyTo;
          }

          _this4.loader.hide();
        }
      });
    },
    handleSubmit: function handleSubmit() {
      var _this5 = this;

      document.activeElement.blur();

      this.submitted = true;

      if (this.selectedAccount && this.ruleName !== '' && this.ruleItemType !== '' && this.ruleItemCode !== '' && this.ruleOperator !== '' && this.ruleValue > 0 && this.validateName() && this.validateEmailString()) {
        this.$bus.$emit('modal-open', {
          title: 'Confirmación',
          description: '¿Desea continuar con ' + (this.currentRule === null ? 'el registro' : 'la actualización') + ' de Regla?',
          type: 'primary',
          confirmText: 'Aceptar',
          cancelText: 'Cancelar',
          confirmBefore: function confirmBefore() {},
          confirmAfter: function confirmAfter() {
            _this5.loader = _this5.$loading.show({
              loader: 'dots'
            });

            var params = {
              AlertRuleId: _this5.currentRule ? _this5.currentRule.AlertRuleId : '',
              AccountCode: _this5.selectedAccount.code,
              Name: _this5.ruleName.trim(),
              AppliesTo: _this5.ruleItemType,
              ItemValue: _this5.ruleItemCode,
              Operator: _this5.ruleOperator,
              TargetValue: _this5.ruleValue,
              NotifyTo: _this5.notifyToValue
            };

            _this5.saveAlertRule(params).then(function (data) {
              var title = void 0,
                  description = void 0,
                  type = void 0;
              if (data.success) {
                title = 'Éxito';
                description = 'Se grabó Regla exitósamente.';
                type = 'success';

                if (params.AlertRuleId === '') {
                  params.AlertRuleId = data.data[0].alertRuleId;
                  _this5.currentRule = params;
                  _this5.ruleList.push(_this5.currentRule);
                } else {
                  _this5.currentRule = params;

                  var index = void 0;

                  for (index = 0; index < _this5.ruleList.length; index++) {
                    var element = _this5.ruleList[index];

                    if (element.AlertRuleId === _this5.currentRule.AlertRuleId) {
                      break;
                    }
                  }

                  _this5.ruleList[index] = _this5.currentRule;
                }
              } else {
                title = 'Error';
                description = 'Ocurrió un error al validar o grabar la Regla.';
                type = 'danger';
              }

              _this5.loader.hide();

              _this5.$bus.$emit('modal-open', {
                title: title,
                description: description,
                type: type,
                confirmText: 'Aceptar',
                cancelText: null,
                confirmBefore: function confirmBefore() {},
                confirmAfter: function confirmAfter() {},
                cancelBefore: function cancelBefore() {},
                cancelAfter: function cancelAfter() {}
              });
            });
          },
          cancelBefore: function cancelBefore() {},
          cancelAfter: function cancelAfter() {}
        });
      }
    },
    validateName: function validateName() {
      var _this6 = this;

      var result = true;
      var matches = void 0;

      if (this.currentRule) {
        matches = this.ruleList.filter(function (item) {
          return item.AlertRuleId !== _this6.currentRule.AlertRuleId;
        });
      } else {
        matches = this.ruleList.slice(0);
      }

      matches.forEach(function (element) {
        if (element.Name.trim().toLowerCase() === _this6.ruleName.trim().toLowerCase()) {
          result = false;
        }
      });

      if (!result) {
        this.$bus.$emit('modal-open', {
          title: 'Validación',
          description: 'Ya existe una regla con el nombre ingresado.',
          type: 'warning',
          confirmText: 'Aceptar',
          cancelText: null,
          confirmBefore: function confirmBefore() {},
          confirmAfter: function confirmAfter() {},
          cancelBefore: function cancelBefore() {},
          cancelAfter: function cancelAfter() {}
        });
      }

      return result;
    },
    validateEmailString: function validateEmailString() {
      var result = true;

      if (this.notifyToValue.trim() !== '') {
        var emailArray = this.notifyToValue.split(';');

        var re = new RegExp('[^@]+@[^@]+\\.[^@]+');

        emailArray.forEach(function (element) {
          if (!re.test(String(element).toLowerCase())) {
            result = false;
          }
        });

        if (!result) {
          this.$bus.$emit('modal-open', {
            title: 'Validación',
            description: 'Alguno de los correos ingresados ',
            type: 'warning',
            confirmText: 'Aceptar',
            cancelText: null,
            confirmBefore: function confirmBefore() {},
            confirmAfter: function confirmAfter() {},
            cancelBefore: function cancelBefore() {},
            cancelAfter: function cancelAfter() {}
          });
        }
      } else {
        result = false;
      }

      return result;
    }
  }),
  destroyed: function destroyed() {
    if (this.loader !== null) {
      this.loader.hide();
    }
  }
});

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_assets_js_constants_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_multiselect__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_multiselect_dist_vue_multiselect_min_css__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_multiselect_dist_vue_multiselect_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_multiselect_dist_vue_multiselect_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_bootstrap_daterangepicker_daterangepicker_css__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_bootstrap_daterangepicker_daterangepicker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_bootstrap_daterangepicker_daterangepicker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_bootstrap_daterangepicker_daterangepicker_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_bootstrap_daterangepicker_daterangepicker_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_bootstrap_daterangepicker_daterangepicker_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment_moment_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment_moment_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_moment_moment_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuetable_2__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuetable_2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vuetable_2__);















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'OrderSearch',
  data: function data() {
    return {
      loader: null,
      mobile: false,
      existe: -1,
      advanced: false,
      showFilter: false,
      parameters: {},
      defualtFilter: false,
      selectIndex: -1,
      defaultSelect: { key: '', description: '-- Todos --' },
      defaultUbigeo: { code: '', name: '-- Todos --' },
      dateRange: null,
      orderTypeList: [],
      orderZoneList: [],
      orderStatusList: [],
      departamentList: [],
      provinceList: [],
      districtList: [],
      accountList: [],
      account: {},
      firstName: '',
      document: '',
      tracking: '',
      showTrack: false,
      showBack: false,
      showModalExport: false,
      fEmail: '',
      isEmail: true,
      submitted: false,
      filter: {
        AccountCode: '',
        CustomerOrderNumber: '',
        TrackingNumber: '',
        StartOrderDate: '',
        EndOrderDate: '',
        OrderType: null,
        Zone: null,
        Status: null,
        Department: null,
        Province: null,
        District: null,
        Page: 1,
        PageSize: 20
      },
      message: {
        title: '',
        description: '',
        type: '',
        show: false
      },
      order: {},
      window: {
        width: 0,
        height: 0
      },
      tableKey: 1,
      tableData: {
        data: null
      },
      totalPages: 0,
      pageNumber: 1,
      tableFields: [{
        name: '__slot:orderType',
        title: 'Tipo',
        titleClass: 'table-text-ora',
        dataClass: 'table-data-ora'
      }, {
        name: '__slot:orderNumber',
        title: 'Nro de Pedido',
        titleClass: 'table-text-ora',
        dataClass: 'table-data-ora'
      }, {
        name: '__slot:issueDate',
        title: 'Fecha de Pedido',
        callback: 'formatDate',
        titleClass: 'table-text-ora',
        dataClass: 'table-data-ora'
      }, {
        name: '__slot:customerName',
        title: 'Nombre del Cliente',
        titleClass: 'table-text-ora',
        dataClass: 'table-data-ora'
      }, {
        name: '__slot:customerAddress',
        title: 'Dirección',
        titleClass: 'table-text-ora',
        dataClass: 'table-data-ora'
      }, {
        name: '__slot:status',
        title: 'Status',
        titleClass: 'table-text-ora',
        dataClass: 'table-data-ora'
      }, {
        name: '__slot:trackingNumber',
        title: '',
        titleClass: 'table-text-ora',
        dataClass: 'table-data-ora'
      }],
      tableCSS: null,
      tableOptions: {
        filterable: false,
        texts: {
          count: ''
        }
      },
      paginationData: null
    };
  },
  mounted: function mounted() {
    if (this.$route.params.Index === undefined) {
      this.iniCalendar();
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])(['userClients'])),
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var calen, self, _self, scrollY;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this.accountList = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default()(_this.userClients);
              _this.account = _this.accountList.length > 0 ? _this.accountList[0] : null;
              _this.tableCSS = __WEBPACK_IMPORTED_MODULE_5_assets_js_constants_js__["a" /* default */].tableCSSOra;
              _this.mobile = _this.isMobile();

              if (!(_this.$route.params.Index === undefined)) {
                _context2.next = 8;
                break;
              }

              _this.loadSelectData();
              _context2.next = 39;
              break;

            case 8:
              _this.defualtFilter = true;
              _this.parameters = _this.$route.params;
              _this.filter.AccountCode = _this.parameters.AccountCode;
              _this.filter.CustomerOrderNumber = _this.parameters.CustomerOrderNumber;
              _this.filter.TrackingNumber = _this.parameters.TrackingNumber;

              _context2.next = 15;
              return _this.getTypes(_this.parameters.OrderType);

            case 15:
              _context2.next = 17;
              return _this.getZones(_this.parameters.Zone);

            case 17:
              _context2.next = 19;
              return _this.getStatus(_this.parameters.Status);

            case 19:

              _this.filter.Department = _this.parameters.Department;
              _this.filter.Province = _this.parameters.Province;
              _this.filter.District = _this.parameters.District;
              _this.selectIndex = _this.parameters.Index;

              _this.advanced = false;
              calen = false;

              if (_this.mobile) {
                if (_this.parameters.StartOrderDate !== null || _this.parameters.EndOrderDate !== null || _this.parameters.OrderType !== null || _this.parameters.CustomerOrderNumber !== '' || _this.parameters.Zone !== null) {
                  if (_this.parameters.StartOrderDate !== null || _this.parameters.EndOrderDate !== null) {
                    calen = true;
                  }
                  _this.showFilter = true;
                }
              } else {
                calen = true;
              }

              if (!calen) {
                _context2.next = 31;
                break;
              }

              self = _this;


              setTimeout(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var date, scrollY;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        self.iniCalendar();
                        if (self.parameters.StartOrderDate !== null && self.parameters.EndOrderDate !== null) {
                          $(self.$el).find('#dtDateRange').data('daterangepicker').startDate = __WEBPACK_IMPORTED_MODULE_10_moment_moment_js___default()(self.parameters.StartOrderDate);
                          $(self.$el).find('#dtDateRange').data('daterangepicker').endDate = __WEBPACK_IMPORTED_MODULE_10_moment_moment_js___default()(self.parameters.EndOrderDate);
                          date = $(self.$el).find('#dtDateRange').data('daterangepicker');

                          $('#dtDateRange').val(date.startDate.format('DD/MM/YYYY') + ' - ' + date.endDate.format('DD/MM/YYYY'));
                        }
                        _context.next = 4;
                        return self.getDePrDi(self.parameters.Department, self.parameters.Province, self.parameters.District);

                      case 4:
                        if (self.parameters.Department !== null || self.parameters.Province !== null || self.parameters.District !== null || self.parameters.TrackingNumber !== '') {
                          if (self.parameters.Department.code !== '' || self.parameters.Department.code !== '' || self.parameters.Department.code !== '' || self.parameters.TrackingNumber !== '') {
                            self.advanced = true;
                          }
                        }

                        scrollY = self.parameters.ScrollY;
                        _context.next = 8;
                        return self.search(self.parameters.Page, false, false);

                      case 8:
                        setTimeout(function () {
                          $(window).scrollTop(scrollY);
                        }, 1000);

                      case 9:
                      case 'end':
                        return _context.stop();
                    }
                  }
                }, _callee, this);
              })), 1000);
              _context2.next = 39;
              break;

            case 31:
              _self = _this;

              _self.iniCalendar();
              _context2.next = 35;
              return _self.getDePrDi(_self.parameters.Department, _self.parameters.Province, _self.parameters.District);

            case 35:
              scrollY = _self.parameters.ScrollY;
              _context2.next = 38;
              return _self.search(_self.parameters.Page, false, false);

            case 38:
              setTimeout(function () {
                $(window).scrollTop(scrollY);
              }, 1000);

            case 39:

              window.onpopstate = function () {
                history.go(1);
              };

            case 40:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }))();
  },

  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapActions */])(['getOrderType', 'getOrderZone', 'getOrderStatus', 'getUbigeo', 'getOrderFollow', 'getOrderReport']), {
    isMobile: function isMobile() {
      if (screen.width <= 760) {
        return true;
      } else {
        return false;
      }
    },
    loadSelectData: function loadSelectData() {
      this.getTypes();
      this.getZones();
      this.getStatus();
      this.getDepartament();
    },
    getTypes: function getTypes() {
      var _this2 = this;

      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      this.orderTypeList.push(this.defaultSelect);
      return this.getOrderType().then(function (response) {
        if (response === undefined) {
          if (type !== null) {
            _this2.orderTypeList.push(type);
          }
        } else {
          _this2.orderTypeList = _this2.orderTypeList.concat(response.typeList);
        }
        _this2.filter.OrderType = type === null ? _this2.defaultSelect : _this2.orderTypeList.find(function (x) {
          return x.key === type.key;
        });
      });
    },
    getZones: function getZones() {
      var _this3 = this;

      var zone = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      this.orderZoneList.push(this.defaultSelect);
      return this.getOrderZone().then(function (response) {
        if (response === undefined) {
          if (zone !== null) {
            _this3.orderZoneList.push(zone);
          }
        } else {
          _this3.orderZoneList = _this3.orderZoneList.concat(response.zoneList);
        }
        _this3.filter.Zone = zone === null ? _this3.defaultSelect : _this3.orderZoneList.find(function (x) {
          return x.key === zone.key;
        });
      });
    },
    getStatus: function getStatus() {
      var _this4 = this;

      var status = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      this.orderStatusList.push(this.defaultSelect);
      return this.getOrderStatus().then(function (response) {
        if (response === undefined) {
          if (status !== null) {
            _this4.orderStatusList.push(status);
          }
        } else {
          _this4.orderStatusList = _this4.orderStatusList.concat(response.statusList);
        }
        _this4.filter.Status = status === null ? _this4.defaultSelect : _this4.orderStatusList.find(function (x) {
          return x.key === status.key;
        });
      });
    },
    getDePrDi: function getDePrDi() {
      var departament = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var _this5 = this;

      var province = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var district = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      this.departamentList = [];
      this.provinceList = [this.defaultUbigeo];
      this.districtList = [this.defaultUbigeo];

      this.departamentList.push(this.defaultUbigeo);
      return this.getUbigeo({ Code: '', Type: __WEBPACK_IMPORTED_MODULE_5_assets_js_constants_js__["a" /* default */].ubigeoType.departament }).then(function (response) {
        if (response === undefined) {
          if (departament !== null) {
            _this5.departamentList.push(departament);
          }
        } else {
          _this5.departamentList = _this5.departamentList.concat(response.ubigeoList);
        }
        _this5.filter.Department = departament === null ? _this5.defaultUbigeo : _this5.departamentList.find(function (x) {
          return x.code === departament.code;
        });
        _this5.filter.Province = _this5.defaultUbigeo;
        _this5.filter.District = _this5.defaultUbigeo;

        if (departament !== null) {
          _this5.provinceList = [];
          _this5.districtList = [_this5.defaultUbigeo];

          _this5.provinceList.push(_this5.defaultUbigeo);
          var depa = departament === null ? _this5.filter.Department.code : departament.code;
          return _this5.getUbigeo({ Code: depa, Type: __WEBPACK_IMPORTED_MODULE_5_assets_js_constants_js__["a" /* default */].ubigeoType.province }).then(function (response) {
            if (response === undefined) {
              if (province !== null) {
                _this5.provinceList.push(province);
              }
            } else {
              _this5.provinceList = _this5.provinceList.concat(response.ubigeoList);
            }
            _this5.filter.Province = province === null ? _this5.defaultUbigeo : _this5.provinceList.find(function (x) {
              return x.code === province.code;
            });
            _this5.filter.District = _this5.defaultUbigeo;

            if (province !== null) {
              _this5.districtList = [];

              _this5.districtList.push(_this5.defaultUbigeo);

              var prov = province === null ? _this5.filter.Province.code : province.code;
              return _this5.getUbigeo({ Code: prov, Type: __WEBPACK_IMPORTED_MODULE_5_assets_js_constants_js__["a" /* default */].ubigeoType.district }).then(function (response) {
                if (response === undefined) {
                  if (district !== null) {
                    _this5.districtList.push(district);
                  }
                } else {
                  _this5.districtList = _this5.districtList.concat(response.ubigeoList);
                }
                _this5.filter.District = district === null ? _this5.defaultUbigeo : _this5.districtList.find(function (x) {
                  return x.code === district.code;
                });
              });
            }
          });
        }
      });
    },
    getDepartament: function getDepartament() {
      var _this6 = this;

      var departament = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      this.departamentList = [];
      this.provinceList = [this.defaultUbigeo];
      this.districtList = [this.defaultUbigeo];

      this.departamentList.push(this.defaultUbigeo);
      this.getUbigeo({ Code: '', Type: __WEBPACK_IMPORTED_MODULE_5_assets_js_constants_js__["a" /* default */].ubigeoType.departament }).then(function (response) {
        if (response === undefined) {
          if (departament !== null) {
            _this6.departamentList.push(departament);
          }
        } else {
          _this6.departamentList = _this6.departamentList.concat(response.ubigeoList);
        }
        _this6.filter.Department = departament === null ? _this6.defaultUbigeo : _this6.departamentList.find(function (x) {
          return x.code === departament.code;
        });
        _this6.filter.Province = _this6.defaultUbigeo;
        _this6.filter.District = _this6.defaultUbigeo;
      });
    },
    getProvince: function getProvince() {
      var _this7 = this;

      var departament = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var province = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      this.provinceList = [];
      this.districtList = [this.defaultUbigeo];

      this.provinceList.push(this.defaultUbigeo);
      var depa = departament === null ? this.filter.Department.code : departament;
      this.getUbigeo({ Code: depa, Type: __WEBPACK_IMPORTED_MODULE_5_assets_js_constants_js__["a" /* default */].ubigeoType.province }).then(function (response) {
        if (response === undefined) {
          if (province !== null) {
            _this7.provinceList.push(province);
          }
        } else {
          _this7.provinceList = _this7.provinceList.concat(response.ubigeoList);
        }
        _this7.filter.Province = province === null ? _this7.defaultUbigeo : _this7.provinceList.find(function (x) {
          return x.code === province.code;
        });
        _this7.filter.District = _this7.defaultUbigeo;
      });
    },
    getDistrict: function getDistrict() {
      var _this8 = this;

      var province = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var district = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      this.districtList = [];

      this.districtList.push(this.defaultUbigeo);

      var prov = province === null ? this.filter.Province.code : province;
      this.getUbigeo({ Code: prov, Type: __WEBPACK_IMPORTED_MODULE_5_assets_js_constants_js__["a" /* default */].ubigeoType.district }).then(function (response) {
        if (response === undefined) {
          if (district !== null) {
            _this8.districtList.push(district);
          }
        } else {
          _this8.districtList = _this8.districtList.concat(response.ubigeoList);
        }
        _this8.filter.District = district === null ? _this8.defaultUbigeo : _this8.districtList.find(function (x) {
          return x.code === district.code;
        });
      });
    },
    reloadTypes: function reloadTypes() {
      if (this.orderTypeList.filter(function (x) {
        return x.key !== '';
      }).length === 1) {
        this.orderTypeList = [];
        this.getTypes(this.filter.OrderType);
      }
    },
    reloadZone: function reloadZone() {
      if (this.orderZoneList.filter(function (x) {
        return x.key !== '';
      }).length === 1) {
        this.orderZoneList = [];
        this.getZones(this.filter.Zone);
      }
    },
    reloadStatus: function reloadStatus() {
      if (this.orderStatusList.filter(function (x) {
        return x.key !== '';
      }).length === 1) {
        this.orderStatusList = [];
        this.getStatus(this.filter.Status);
      }
    },
    reloadDepartament: function reloadDepartament() {
      if (this.departamentList.filter(function (x) {
        return x.code !== '';
      }).length === 1) {
        this.departamentList = [];
        this.getDePrDi(this.filter.Department, this.filter.Province, this.filter.District);
      }
    },
    reloadProvince: function reloadProvince() {
      if (this.provinceList.filter(function (x) {
        return x.code !== '';
      }).length === 1) {
        this.provinceList = [];
        this.getDePrDi(this.filter.Department, this.filter.Province, this.filter.District);
      }
    },
    reloadDistrict: function reloadDistrict() {
      if (this.districtList.filter(function (x) {
        return x.code !== '';
      }).length === 1) {
        this.districtList = [];
        this.getDePrDi(this.filter.Department, this.filter.Province, this.filter.District);
      }
    },
    search: function search(page) {
      var _this9 = this;

      var isPaging = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var flag = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      this.dateRange = null;
      this.pageNumber = page;

      this.filter.AccountCode = this.account.code;
      this.filter.Page = this.pageNumber;

      var filter = {};

      if (isPaging) {
        filter = {
          AccountCode: this.parameters.AccountCode,
          CustomerOrderNumber: this.parameters.CustomerOrderNumber,
          TrackingNumber: this.parameters.TrackingNumber,
          StartOrderDate: this.parameters.StartOrderDate,
          EndOrderDate: this.parameters.EndOrderDate,
          OrderTypeCode: this.parameters.OrderType == null ? '' : this.parameters.OrderType.key,
          ZoneCode: this.parameters.Zone == null ? '' : this.parameters.Zone.key,
          StatusCode: this.parameters.Status == null ? '' : this.parameters.Status.key,
          DepartmentCode: this.parameters.Department == null ? '' : this.parameters.Department.code,
          ProvinceCode: this.parameters.Province == null ? '' : this.parameters.Province.code,
          DistrictCode: this.parameters.District == null ? '' : this.parameters.District.code,
          Page: this.filter.Page,
          PageSize: this.filter.PageSize
        };
      } else {
        if (!this.showFilter && this.mobile) {
          this.filter.StartOrderDate = null;
          this.filter.EndOrderDate = null;
        } else {
          if ($('#dtDateRange').val() === '') {
            this.filter.StartOrderDate = null;
            this.filter.EndOrderDate = null;
          } else {
            this.filter.StartOrderDate = $(this.$el).find('#dtDateRange').data('daterangepicker').startDate.format('YYYY-MM-DD') + 'T00:00:00';
            this.filter.EndOrderDate = $(this.$el).find('#dtDateRange').data('daterangepicker').endDate.format('YYYY-MM-DD') + 'T00:00:00';
          }
        }

        filter = {
          AccountCode: this.filter.AccountCode,
          CustomerOrderNumber: this.filter.CustomerOrderNumber,
          TrackingNumber: this.filter.TrackingNumber,
          StartOrderDate: this.filter.StartOrderDate,
          EndOrderDate: this.filter.EndOrderDate,
          OrderTypeCode: this.filter.OrderType == null ? '' : this.filter.OrderType.key,
          ZoneCode: this.filter.Zone == null ? '' : this.filter.Zone.key,
          StatusCode: this.filter.Status == null ? '' : this.filter.Status.key,
          DepartmentCode: this.filter.Department == null ? '' : this.filter.Department.code,
          ProvinceCode: this.filter.Province == null ? '' : this.filter.Province.code,
          DistrictCode: this.filter.District == null ? '' : this.filter.District.code,
          Page: this.filter.Page,
          PageSize: this.filter.PageSize
        };
      }

      this.parameters = {
        AccountCode: this.filter.AccountCode,
        CustomerOrderNumber: this.filter.CustomerOrderNumber,
        TrackingNumber: this.filter.TrackingNumber,
        StartOrderDate: this.filter.StartOrderDate,
        EndOrderDate: this.filter.EndOrderDate,
        OrderType: this.filter.OrderType,
        Zone: this.filter.Zone,
        Status: this.filter.Status,
        Department: this.filter.Department,
        Province: this.filter.Province,
        District: this.filter.District,
        Page: this.filter.Page,
        PageSize: this.filter.PageSize
      };

      if (filter.StartOrderDate === null && filter.EndOrderDate === null && filter.CustomerOrderNumber === '' && filter.TrackingNumber === '') {
        this.message.title = 'Advertencia';
        this.message.description = 'Debe seleccionar un rango de Fecha Pedido o Nro pedido o Nro Tracking';
        this.message.type = 'warn';
        this.message.show = true;
      } else {
        document.activeElement.blur();

        this.loader = this.$loading.show({
          loader: 'dots'
        });

        this.tableData = {
          data: null
        };

        this.getOrderFollow(filter).then(function (data) {
          if (data != null) {
            if (flag) {
              _this9.defualtFilter = false;
              _this9.selectIndex = -1;
            }

            if (data.orderList != null) {
              _this9.tableData = {
                data: data.orderList
              };
              _this9.totalPages = {
                data: data.pagination.totalItems,
                total: data.pagination.totalPage,
                size: data.pagination.limit
              };
            }
            _this9.loader.hide();
            _this9.tableKey++;
          }
        });
      }
    },
    showExport: function showExport() {
      var mensaje = '';
      if (this.tableData.data === null || this.tableData.data.length === 0) {
        mensaje = 'La lista se encuentra vacia';
      } else if (this.parameters.StartOrderDate === null && this.parameters.EndOrderDate === null && this.parameters.CustomerOrderNumber === '' && this.parameters.TrackingNumber === '') {
        mensaje = 'Debe seleccionar un rango de Fecha Pedido o Nro pedido o Nro Tracking';
      }

      if (mensaje !== '') {
        this.message.title = 'Advertencia';
        this.message.description = mensaje;
        this.message.type = 'warn';
        this.message.show = true;
      } else {
        this.showModalExport = true;
      }
    },
    closeExport: function closeExport() {
      this.fEmail = '';
      this.showModalExport = false;
    },
    exportOrder: function exportOrder() {
      var _this10 = this;

      var mensaje = '';
      if (this.tableData.data === null || this.tableData.data.length === 0) {
        mensaje = 'La lista se encuentra vacia';
      } else if (this.parameters.StartOrderDate === null && this.parameters.EndOrderDate === null && this.parameters.CustomerOrderNumber === '' && this.parameters.TrackingNumber === '') {
        mensaje = 'Debe seleccionar un rango de Fecha Pedido o Nro pedido o Nro Tracking';
      }

      if (mensaje !== '') {
        this.message.title = 'Advertencia';
        this.message.description = mensaje;
        this.message.type = 'warn';
        this.message.show = true;
      } else {
        document.activeElement.blur();

        this.submitted = true;
        this.isEmail = this.validateEmail(this.fEmail);

        if (this.fEmail !== '' && this.isEmail) {
          var filter = {
            AccountCode: this.parameters.AccountCode,
            CustomerOrderNumber: this.parameters.CustomerOrderNumber,
            TrackingNumber: this.parameters.TrackingNumber,
            StartOrderDate: this.parameters.StartOrderDate,
            EndOrderDate: this.parameters.EndOrderDate,
            OrderTypeCode: this.parameters.OrderType == null ? '' : this.parameters.OrderType.key,
            ZoneCode: this.parameters.Zone == null ? '' : this.parameters.Zone.key,
            StatusCode: this.parameters.Status == null ? '' : this.parameters.Status.key,
            DepartmentCode: this.parameters.Department == null ? '' : this.parameters.Department.code,
            ProvinceCode: this.parameters.Province == null ? '' : this.parameters.Province.code,
            DistrictCode: this.parameters.District == null ? '' : this.parameters.District.code,
            EmailRecipient: this.fEmail
          };

          this.loader = this.$loading.show({
            loader: 'dots'
          });

          this.getOrderReport(filter).then(function (data) {
            if (data != null) {
              if (data.errorCode === 0) {
                _this10.fEmail = '';
                _this10.submitted = false;
                _this10.showModalExport = false;

                _this10.message.title = 'Información';
                _this10.message.description = 'El Excel fue enviado con éxito a su correo';
                _this10.message.type = 'info';
                _this10.message.show = true;
              } else {
                _this10.message.title = 'Error';
                _this10.message.description = data.errorDescription;
                _this10.message.type = 'error';
                _this10.message.show = true;
              }
              _this10.loader.hide();
            }
          });
        }
      }
    },
    onPaginationData: function onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
      this.paginationData = paginationData;
    },
    onChangePage: function onChangePage(page) {
      this.$refs.vuetable.changePage(page);

      if (page > 0) {
        this.pageNumber = page;
      }
      if (page === 'next') {
        this.pageNumber += 1;
        if (this.pageNumber >= this.totalPages.total) {
          this.pageNumber -= 1;
          return;
        }
      }
      if (page === 'prev') {
        this.pageNumber -= 1;
        if (this.pageNumber < 1) {
          this.pageNumber += 1;
          return;
        }
      }
      this.search(this.pageNumber, true);
    },
    dataManager: function dataManager(sortOrder, pagination) {
      var data = [];
      data = this.tableData.data;
      if (this.tableData.data && this.totalPages.data > 1) {
        var total = 0;
        if (this.totalPages.data % this.totalPages.size === 0) {
          total = parseInt(this.totalPages.data / this.totalPages.size, 10);
        } else {
          total = parseInt(this.totalPages.data / this.totalPages.size, 10) + 1;
        }
        pagination = this.$refs.vuetable.makePagination(data.length);
        pagination.per_page = this.totalPages.size;
        pagination.to = data.length;
        pagination.last_page = total;
        pagination.current_page = this.pageNumber;
        pagination.total = this.totalPages.data;
        pagination.next_page_url = pagination.current_page + 1;
        if (pagination.next_page_url > 1) {
          pagination.prev_page_url = pagination.current_page - 1;
        }
        data = data.slice(pagination.from - 1, pagination.to);
      } else {
        pagination = this.$refs.vuetable.makePagination(0);
      }
      return {
        pagination: pagination,
        data: data
      };
    },
    clear: function clear() {
      this.filter = {
        AccountCode: '',
        OrderNumber: '',
        TrackingNumber: '',
        CustomerOrderNumber: '',
        StartOrderDate: '',
        EndOrderDate: '',
        OrderType: this.defaultSelect,
        Zone: this.defaultSelect,
        Status: this.defaultSelect,
        Department: this.defaultUbigeo,
        Province: this.defaultUbigeo,
        District: this.defaultUbigeo,
        Page: 1,
        PageSize: 20
      };
      this.tableData = {
        data: null
      };

      this.dateRange = null;
      this.parameters = null;
      this.selectIndex = -1;
      $('#dtDateRange').val('');
      this.iniCalendar();
      this.getDepartament();
    },
    handleResize: function handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    formatDate: function formatDate(value) {
      return __WEBPACK_IMPORTED_MODULE_10_moment_moment_js___default()(value).format('DD/MM/YYYY');
    },
    contact: function contact() {
      window.open(__WEBPACK_IMPORTED_MODULE_5_assets_js_constants_js__["a" /* default */].defaultGeneral.urlHelp, '_blank');
    },
    iniCalendar: function iniCalendar() {
      $('#dtDateRange').daterangepicker({
        showDropdowns: true,
        locale: __WEBPACK_IMPORTED_MODULE_5_assets_js_constants_js__["a" /* default */].datePickerLocale,
        maxDate: __WEBPACK_IMPORTED_MODULE_10_moment_moment_js___default()(),
        autoUpdateInput: false,
        applyClass: 'btn-apply-ora',
        cancelClass: 'btn-cancel-ora',
        autoApply: false
      }, function (start, end, label) {
        $('#dtDateRange').val(start.format('DD/MM/YYYY') + ' - ' + end.format('DD/MM/YYYY'));
      });

      $('#dtDateRange').on('apply.daterangepicker', function (ev, picker) {
        $(this).val(picker.startDate.format('DD/MM/YYYY') + ' - ' + picker.endDate.format('DD/MM/YYYY'));
      });

      $('.daterangepicker').addClass('daterangepicker-ora');
    },
    verFiltros: function verFiltros() {
      this.showFilter = !this.showFilter;
      var self = this;
      setTimeout(function () {
        self.iniCalendar();
      }, 1000);
    },
    hiddenTrack: function hiddenTrack(value) {
      this.showTrack = value;
      var self = this;
      setTimeout(function () {
        self.iniCalendar();
        if (self.parameters.StartOrderDate !== null || self.parameters.EndOrderDate !== null) {
          if (self.dateRange !== null) {
            $(self.$el).find('#dtDateRange').data('daterangepicker').startDate = self.dateRange.startDate;
            $(self.$el).find('#dtDateRange').data('daterangepicker').endDate = self.dateRange.endDate;
            $('#dtDateRange').val(self.dateRange.startDate.format('DD/MM/YYYY') + ' - ' + self.dateRange.endDate.format('DD/MM/YYYY'));
          }
        }

        $(window).scrollTop(self.parameters.ScrollY);
        self.selectIndex = self.parameters.Index;
      }, 1000);
    },
    goTracking: function goTracking(order, index) {
      this.tracking = order.trackingNumber;
      this.firstName = order.customerName;
      this.orderNumber = order.customerOrderNumber;
      this.showTrack = true;
      this.showBack = true;
      this.parameters.Index = index;
      this.parameters.ScrollY = window.scrollY;
      this.dateRange = $(this.$el).find('#dtDateRange').data('daterangepicker');
    },
    optDescription: function optDescription(_ref2) {
      var key = _ref2.key,
          description = _ref2.description;

      return this.$options.filters.firstLetter(description);
    },
    optName: function optName(_ref3) {
      var code = _ref3.code,
          name = _ref3.name;

      return this.$options.filters.firstLetter(name);
    },
    showAdvanced: function showAdvanced() {
      this.advanced = !this.advanced;
      if (!this.advanced && !this.defualtFilter) {
        this.filter.TrackingNumber = '';
        this.filter.Status = this.defaultSelect;
        this.getDepartament();
      }
    },
    validateEmail: function validateEmail(email) {
      if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(.\w{2,3})+$/.test(email)) {
        return true;
      } else {
        return false;
      }
    }
  }),
  components: {
    Tracking: function Tracking() {
      return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 59));
    },
    Multiselect: __WEBPACK_IMPORTED_MODULE_6_vue_multiselect___default.a,
    Vuetable: __WEBPACK_IMPORTED_MODULE_11_vuetable_2__["Vuetable"],
    'vuetable-pagination': __WEBPACK_IMPORTED_MODULE_11_vuetable_2__["VuetablePagination"]
  },
  filters: {
    capitalize: function capitalize(value) {
      if (!value) return '';
      return value.charAt(0).toUpperCase() + value.toLowerCase().slice(1);
    },
    firstLetter: function firstLetter(value) {
      if (!value) return '';
      var pieces = value.toString().toLowerCase().split(' ');
      for (var i = 0; i < pieces.length; i++) {
        var j = pieces[i].charAt(0).toUpperCase();
        pieces[i] = j + pieces[i].substr(1);
      }
      return pieces.join(' ');
    },
    minus: function minus(value) {
      if (!value) return '';
      return value.toString().toLowerCase();
    }
  }
});

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_assets_js_constants_js__ = __webpack_require__(5);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Tracking',
  data: function data() {
    return {
      parameter: '',
      mobile: false,
      exists: false
    };
  },
  created: function created() {
    this.mobile = this.isMobile();
    this.parameter = this.$route.params.id;
    this.name = this.$route.params.name === undefined ? '' : this.$route.params.name;
    this.exists = false;
    if (this.parameter !== undefined) {
      this.exists = true;
      var isTracking = false;
      if (this.parameter.length === 20) {
        var id = this.parameter.substring(0, 5);
        var letter = id.substring(0, 1);
        var number = id.substring(1, 5);

        var isNumber = false;
        if (/^[0-9]+$/.test(number)) {
          isNumber = true;
        }

        var isLetter = false;
        if (/^[A-Z]+$/.test(letter)) {
          isLetter = true;
        }

        if (isLetter && isNumber || id === '90001') {
          isTracking = true;
        }
      }

      if (isTracking) {
        this.$router.push({ name: 'TrackingNumber', params: { tracking: this.parameter, name: this.name } });
      } else {
        this.$router.push({ name: 'TrackingOrder', params: { order: this.parameter, name: this.name } });
      }
    }
  },

  methods: {
    isMobile: function isMobile() {
      if (screen.width <= 760) {
        return true;
      } else {
        return false;
      }
    },
    contact: function contact() {
      window.open(__WEBPACK_IMPORTED_MODULE_0_assets_js_constants_js__["a" /* default */].defaultGeneral.urlHelp, '_blank');
    }
  }
});

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_google_maps__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_google_maps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetable_2__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetable_2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuetable_2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_assets_js_constants_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_inner_image_zoom__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_inner_image_zoom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_inner_image_zoom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue2_leaflet__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_leaflet__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_leaflet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_leaflet__);














delete __WEBPACK_IMPORTED_MODULE_9_leaflet__["Icon"].Default.prototype._getIconUrl;
__WEBPACK_IMPORTED_MODULE_9_leaflet__["Icon"].Default.mergeOptions({
  iconRetinaUrl: __webpack_require__(444),
  iconUrl: __webpack_require__(445),
  shadowUrl: __webpack_require__(64)
});

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TrackingNumber',
  props: ['track', 'showBack', 'firstName', 'document', 'isOrder', 'account', 'orderNumber', 'trackOrder', 'parameters'],
  data: function data() {
    return {
      showModalFotos: false,
      showModalCopiar: false,
      slideIndex: 1,
      loader: null,
      mobile: false,
      existe: -1,
      tracking: '',
      name: '',
      activeItem: 'track',
      iconGP: '/static/img/icons/ic_dinet_48.png',
      iconHE: 36,
      iconWI: 48,
      isPoint: false,
      fName: '',
      doc: '',
      fotos: [],
      order: {},
      eventList: [],
      zoom: null,
      zoomDefault: 17,
      centerDefault: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_leaflet__["latLng"])(-12.0889092, -77.0044656),
      center: null,
      markers: [],
      submitted: false,
      tableKey: 1,
      tableData: {
        data: null
      },
      tableFields: [{
        name: '__slot:itemPos',
        title: 'Nro.',
        titleClass: 'table-text-ora',
        dataClass: 'table-data-ora'
      }, {
        name: '__slot:lpn',
        title: 'LPN / Precintos',
        titleClass: 'table-text-ora',
        dataClass: 'table-data-ora'
      }, {
        name: '__slot:itemCode',
        title: 'Código SKU',
        titleClass: 'table-text-ora',
        dataClass: 'table-data-ora'
      }, {
        name: '__slot:itemDescription',
        title: 'Descripción SKU',
        titleClass: 'table-text-ora',
        dataClass: 'table-data-ora'
      }, {
        name: '__slot:quantityOrder',
        title: 'Cant. Pedido',
        titleClass: 'table-text-ora',
        dataClass: 'table-data-ora'
      }, {
        name: '__slot:quantitySent',
        title: 'Cant. Despachada',
        titleClass: 'table-text-ora',
        dataClass: 'table-data-ora'
      }, {
        name: '__slot:quantityDelivered',
        title: 'Cant. Entregada',
        titleClass: 'table-text-ora',
        dataClass: 'table-data-ora'
      }, {
        name: '__slot:quantityRejected',
        title: 'Cant. Rechazada',
        titleClass: 'table-text-ora',
        dataClass: 'table-data-ora'
      }],
      tableCSS: null,
      tableOptions: {
        filterable: false,
        texts: {
          count: ''
        }
      }
    };
  },

  computed: {
    google: __WEBPACK_IMPORTED_MODULE_4_vue2_google_maps__["gmapApi"]
  },
  beforeMount: function beforeMount() {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vue2_google_maps__["loadGmapApi"])({
      key: __WEBPACK_IMPORTED_MODULE_6_assets_js_constants_js__["a" /* default */].apiKeyGoogle.b2c
    });
  },
  created: function created() {
    var _this = this;

    this.tableCSS = __WEBPACK_IMPORTED_MODULE_6_assets_js_constants_js__["a" /* default */].tableCSSOra;
    this.mobile = this.isMobile();
    this.zoom = this.mobile ? this.zoomDefault - 1 : this.zoomDefault;
    this.center = this.centerDefault;
    this.existe = 2;
    this.isPoint = false;

    if (this.track === undefined) {
      this.tracking = this.$route.params.tracking;
      this.name = this.$route.params.name;
      if (this.name !== undefined && this.name !== '') {
        this.loader = this.$loading.show({
          loader: 'dots'
        });

        var filter = {
          AccountCode: '',
          OrderNumber: '',
          TrackingNumber: this.tracking,
          CustomerName: this.name,
          CustomerDNI: ''
        };

        this.getTracking(filter).then(function (response) {
          _this.loader.hide();

          if (response.order != null) {
            _this.setOrder(response.order);
          } else if (response.errorCode > 0) {
            _this.existe = 0;
          }
        });
      }
    } else {
      this.tracking = this.track;
      if (this.tracking !== '') {
        this.loader = this.$loading.show({
          loader: 'dots'
        });

        var _filter = {
          AccountCode: '',
          OrderNumber: '',
          TrackingNumber: this.tracking,
          CustomerName: this.firstName,
          CustomerDNI: this.document
        };

        this.getTracking(_filter).then(function (response) {
          _this.loader.hide();

          if (response.order != null) {
            _this.setOrder(response.order);
          } else if (response.errorCode > 0) {
            _this.existe = 0;
          }
        });

        if (this.isOrder) {
          this.getDetail();
        }
      } else {
        this.existe = 0;
      }
    }

    window.onpopstate = function () {
      if (_this.isOrder) {
        _this.$router.push({ name: 'EcommerceSearchDocuments', params: _this.parameters });
      } else {
        _this.$router.push({ name: 'TrackingOrder', params: { order: _this.trackOrder, name: _this.name } });
      }
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])(['getTracking', 'getPointTracking', 'getOrderFollowDetail']), {
    copy: function copy() {
      var currentUrl = window.location.origin + '/Tracking/' + this.tracking;
      var el = document.createElement('textarea');
      el.value = currentUrl;
      el.setAttribute('readonly', '');
      el.style.position = 'absolute';
      el.style.left = '-9999px';
      document.body.appendChild(el);
      var selected = document.getSelection().rangeCount > 0 ? document.getSelection().getRangeAt(0) : false;
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      if (selected) {
        document.getSelection().removeAllRanges();
        document.getSelection().addRange(selected);
      }
      $('#divCopy').show();
      $('#divCopy').fadeOut(2000);
    },
    isMobile: function isMobile() {
      if (screen.width <= 760) {
        return true;
      } else {
        return false;
      }
    },
    isActive: function isActive(menuItem) {
      return this.activeItem === menuItem;
    },
    setActive: function setActive(menuItem) {
      this.activeItem = menuItem;
    },
    modalFotos: function modalFotos(event, index) {
      var _this2 = this;

      this.fotos = [];
      event.fotos.forEach(function (x) {
        _this2.fotos.push(x);
      });
      this.showModalFotos = true;
      this.slideIndex = index + 1;
      var self = this;
      setTimeout(function () {
        var widthModal = $(window).width() - 165;
        var heightBody = $(window).height() - 125;
        var heightCarousel = $(window).height() - 200;
        var heightFoto = $(window).height() - 185;
        $('.modal-cus-container').width(widthModal);
        $('.modal-cus-body').height(heightBody);
        $('.VueCarousel-inner').height(heightCarousel);
        $('.iiz__img').height(heightFoto);
        self.showSlides(self.slideIndex);
      }, 250);
    },
    plusSlides: function plusSlides(n) {
      this.showSlides(this.slideIndex += n);
    },
    currentSlide: function currentSlide(n) {
      this.showSlides(this.slideIndex = n);
    },
    showSlides: function showSlides(n) {
      var i = void 0;
      var slides = document.getElementsByClassName('slides-ora');
      var dots = document.getElementsByClassName('dot-ora');
      if (n > slides.length) {
        this.slideIndex = 1;
      }
      if (n < 1) {
        this.slideIndex = slides.length;
      }
      for (i = 0; i < slides.length; i++) {
        slides[i].style.display = 'none';
      }
      for (i = 0; i < dots.length; i++) {
        dots[i].className = dots[i].className.replace(' active-ora', '');
      }
      slides[this.slideIndex - 1].style.display = 'block';
      dots[this.slideIndex - 1].className += ' active-ora';
    },
    getPoint: function getPoint() {
      var _this3 = this;

      this.getPointTracking({ AccountCode: '', TrackingNumber: this.tracking }).then(function (response) {
        var point = response;
        _this3.setPoint(point.latitudY, point.longitudX, point.realTimeFlag);
      });
    },
    setPoint: function setPoint(latitudY, longitudX, realTimeFlag) {
      this.order.latitud = latitudY;
      this.order.longitud = longitudX;
      this.order.realTimeFlag = realTimeFlag === null ? 0 : realTimeFlag;
      if (this.order.latitud !== 0 && this.order.longitud !== 0) {
        this.isPoint = true;
      }

      if (this.order.latitud === 0) {
        this.order.latitud = this.centerDefault.lat;
      }
      if (this.order.longitud === 0) {
        this.order.longitud = this.centerDefault.lng;
      }

      this.center = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_leaflet__["latLng"])(Number(this.order.latitud), Number(this.order.longitud));

      if (this.isPoint) {
        if (this.order.realTimeFlag === 0) {
          if (this.mobile) {
            this.iconGP = '/static/img/icons/ic_destino_32.png';
            this.iconHE = 28;
            this.iconWI = 32;
          } else {
            this.iconGP = '/static/img/icons/ic_destino_48.png';
            this.iconHE = 36;
            this.iconWI = 48;
          }
        } else {
          if (this.mobile) {
            this.iconGP = '/static/img/icons/ic_truck_32.png';
            this.iconHE = 32;
            this.iconWI = 32;
          } else {
            this.iconGP = '/static/img/icons/ic_truck_48.png';
            this.iconHE = 48;
            this.iconWI = 48;
          }
        }
      }
    },
    setOrder: function setOrder(order) {
      this.existe = 1;
      this.setActive('track');
      this.order = order;
      if (this.order.trackingList != null) {
        if (this.order.trackingList.length > 0) {
          this.eventList = this.order.trackingList[0].eventList;
          this.order.tracking = this.order.trackingList[0].trackingNumber;
          this.order.realTimeFlag = this.order.trackingList[0].realTimeFlag;
          this.order.configuration = this.order.trackingList[0].configuration;
          this.order.statusDescription = this.order.trackingList[0].statusDescription;
          this.order.latitud = this.centerDefault.lat;
          this.order.longitud = this.centerDefault.lng;
          var realTimeFlag = this.order.trackingList[0].realTimeFlag;

          if (this.eventList != null) {
            if (this.eventList.length > 0) {
              this.eventList.forEach(function (x) {
                if (x.imageUrl1 !== '' || x.imageUrl2 !== '' || x.imageUrl3 !== '') {
                  x.existImage = true;
                } else {
                  x.existImage = false;
                }

                var fotos = [];
                if (x.imageUrl1 !== '') {
                  fotos.push(x.imageUrl1);
                }
                if (x.imageUrl2 !== '') {
                  fotos.push(x.imageUrl2);
                }
                if (x.imageUrl3 !== '') {
                  fotos.push(x.imageUrl3);
                }

                x.fotos = fotos;
              });
            }
          }

          var event = this.eventList[0];
          this.setPoint(event.latitudY, event.longitudX, realTimeFlag);
        }
      }
    },
    search: function search() {
      var _this4 = this;

      document.activeElement.blur();

      this.submitted = true;
      if (this.fName !== '' || this.doc !== '') {
        this.loader = this.$loading.show({
          loader: 'dots'
        });

        var filter = {
          AccountCode: '',
          OrderNumber: '',
          TrackingNumber: this.tracking,
          CustomerName: this.fName,
          CustomerDNI: this.doc
        };

        this.getTracking(filter).then(function (response) {
          _this4.submitted = true;
          _this4.loader.hide();

          if (response.order != null) {
            _this4.setOrder(response.order);
          } else if (response.errorCode > 0) {
            _this4.existe = 0;
          }
        });
      }
    },
    showDetail: function showDetail() {
      this.$modal.show('detail');
    },
    getDetail: function getDetail() {
      var _this5 = this;

      var filter = {
        AccountCode: this.account,
        OrderNumber: '',
        TrackingNumber: this.tracking
      };

      this.tableData = {
        data: null
      };

      this.getOrderFollowDetail(filter).then(function (data) {
        if (data != null) {
          _this5.tableData = {
            data: data.orderDetail
          };
          _this5.tableKey++;
        }
      });
    },
    contact: function contact() {
      window.open(__WEBPACK_IMPORTED_MODULE_6_assets_js_constants_js__["a" /* default */].defaultGeneral.urlHelp, '_blank');
    },
    toDataURL: function toDataURL(url) {
      return fetch(url).then(function (response) {
        return response.blob();
      }).then(function (blob) {
        return URL.createObjectURL(blob);
      });
    },
    download: function download(images) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var a;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                a = document.createElement('a');
                _context.next = 3;
                return _this6.toDataURL(images);

              case 3:
                a.href = _context.sent;

                a.download = 'Image.png';
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this6);
      }))();
    }
  }),
  components: {
    Vuetable: __WEBPACK_IMPORTED_MODULE_5_vuetable_2__["Vuetable"],
    'inner-image-zoom': __WEBPACK_IMPORTED_MODULE_7_vue_inner_image_zoom___default.a,
    'l-map': __WEBPACK_IMPORTED_MODULE_8_vue2_leaflet__["a" /* LMap */],
    'l-tile-layer': __WEBPACK_IMPORTED_MODULE_8_vue2_leaflet__["b" /* LTileLayer */],
    'l-marker': __WEBPACK_IMPORTED_MODULE_8_vue2_leaflet__["c" /* LMarker */],
    'l-icon': __WEBPACK_IMPORTED_MODULE_8_vue2_leaflet__["d" /* LIcon */]
  },
  filters: {
    capitalize: function capitalize(value) {
      if (!value) return '';
      return value.charAt(0).toUpperCase() + value.toLowerCase().slice(1);
    },
    firstLetter: function firstLetter(value) {
      if (!value) return '';
      var pieces = value.toString().toLowerCase().split(' ');
      for (var i = 0; i < pieces.length; i++) {
        var j = pieces[i].charAt(0).toUpperCase();
        pieces[i] = j + pieces[i].substr(1);
      }
      return pieces.join(' ');
    },
    minus: function minus(value) {
      if (!value) return '';
      return value.toString().toLowerCase();
    }
  }
});

/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_assets_js_constants_js__ = __webpack_require__(5);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TrackingOrder',
  data: function data() {
    return {
      loader: null,
      mobile: false,
      orderNumber: '',
      name: '',
      tracking: '',
      account: '',
      firstName: '',
      document: '',
      existe: -1,
      showTrack: false,
      showBack: false,
      showList: false,
      order: {},
      submitted: false
    };
  },
  created: function created() {
    var _this = this;

    this.mobile = this.isMobile();
    this.existe = 2;

    this.orderNumber = this.$route.params.order;
    this.name = this.$route.params.name;
    if (this.$route.params.acc !== undefined) {
      this.account = this.$route.params.acc;
    }

    if (this.orderNumber !== undefined && this.name !== undefined && this.name !== '') {
      this.firstName = this.name;
      this.loader = this.$loading.show({
        loader: 'dots'
      });

      var filter = {
        AccountCode: this.account,
        OrderNumber: this.orderNumber,
        TrackingNumber: '',
        CustomerName: this.name,
        CustomerDNI: ''
      };

      this.getTracking(filter).then(function (response) {
        _this.loader.hide();

        if (response.order != null) {
          _this.existe = 1;
          _this.order = response.order;
          if (_this.order.trackingList.length === 1) {
            _this.tracking = _this.order.trackingList[0].trackingNumber;
            _this.showTrack = true;
            _this.showBack = true;
          } else {
            _this.showTrack = false;
            _this.showBack = false;
            _this.showList = true;
          }
        } else if (response.errorCode > 0) {
          _this.existe = 0;
        }
      });
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])(['getTracking']), {
    isMobile: function isMobile() {
      if (screen.width <= 760) {
        return true;
      } else {
        return false;
      }
    },
    hiddenTrack: function hiddenTrack(value) {
      this.showTrack = value;
      if (!this.showList) {
        this.existe = 2;
      }
    },
    search: function search() {
      var _this2 = this;

      document.activeElement.blur();

      this.submitted = true;
      if (this.firstName !== '' || this.document !== '') {
        this.loader = this.$loading.show({
          loader: 'dots'
        });

        var filter = {
          AccountCode: this.account,
          OrderNumber: this.orderNumber,
          TrackingNumber: '',
          CustomerName: this.firstName,
          CustomerDNI: this.document
        };

        this.getTracking(filter).then(function (response) {
          _this2.loader.hide();

          if (response.order != null) {
            _this2.existe = 1;
            _this2.order = response.order;
            if (_this2.order.trackingList.length === 1) {
              _this2.tracking = _this2.order.trackingList[0].trackingNumber;
              _this2.showTrack = true;
              _this2.showBack = true;
            } else {
              _this2.showTrack = false;
              _this2.showBack = false;
              _this2.showList = true;
            }
          } else if (response.errorCode > 0) {
            _this2.existe = 0;
          }
        });
      }
    },
    goTracking: function goTracking(track) {
      this.tracking = track.trackingNumber;
      this.showTrack = true;
      this.showBack = true;
    },
    contact: function contact() {
      window.open(__WEBPACK_IMPORTED_MODULE_2_assets_js_constants_js__["a" /* default */].defaultGeneral.urlHelp, '_blank');
    }
  }),
  components: {
    Tracking: function Tracking() {
      return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 59));
    }
  },
  filters: {
    capitalize: function capitalize(value) {
      if (!value) return '';
      return value.charAt(0).toUpperCase() + value.toLowerCase().slice(1);
    },
    firstLetter: function firstLetter(value) {
      if (!value) return '';
      var pieces = value.toString().toLowerCase().split(' ');
      for (var i = 0; i < pieces.length; i++) {
        var j = pieces[i].charAt(0).toUpperCase();
        pieces[i] = j + pieces[i].substr(1);
      }
      return pieces.join(' ');
    },
    minus: function minus(value) {
      if (!value) return '';
      return value.toString().toLowerCase();
    }
  }
});

/***/ }),
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 397 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 398 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 399 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 400 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 401 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 402 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 403 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 404 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 405 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 406 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 407 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 408 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 409 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 410 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 411 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 412 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 413 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 414 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 415 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 416 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 417 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 418 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 419 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 420 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 421 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 422 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 423 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 424 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 425 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 426 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 427 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 428 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 429 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 430 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 431 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 432 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 433 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 434 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 435 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 436 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 437 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 438 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 439 */,
/* 440 */,
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 92,
	"./af.js": 92,
	"./ar": 100,
	"./ar-dz": 93,
	"./ar-dz.js": 93,
	"./ar-kw": 94,
	"./ar-kw.js": 94,
	"./ar-ly": 95,
	"./ar-ly.js": 95,
	"./ar-ma": 96,
	"./ar-ma.js": 96,
	"./ar-ps": 97,
	"./ar-ps.js": 97,
	"./ar-sa": 98,
	"./ar-sa.js": 98,
	"./ar-tn": 99,
	"./ar-tn.js": 99,
	"./ar.js": 100,
	"./az": 101,
	"./az.js": 101,
	"./be": 102,
	"./be.js": 102,
	"./bg": 103,
	"./bg.js": 103,
	"./bm": 104,
	"./bm.js": 104,
	"./bn": 106,
	"./bn-bd": 105,
	"./bn-bd.js": 105,
	"./bn.js": 106,
	"./bo": 107,
	"./bo.js": 107,
	"./br": 108,
	"./br.js": 108,
	"./bs": 109,
	"./bs.js": 109,
	"./ca": 110,
	"./ca.js": 110,
	"./cs": 111,
	"./cs.js": 111,
	"./cv": 112,
	"./cv.js": 112,
	"./cy": 113,
	"./cy.js": 113,
	"./da": 114,
	"./da.js": 114,
	"./de": 117,
	"./de-at": 115,
	"./de-at.js": 115,
	"./de-ch": 116,
	"./de-ch.js": 116,
	"./de.js": 117,
	"./dv": 118,
	"./dv.js": 118,
	"./el": 119,
	"./el.js": 119,
	"./en-au": 120,
	"./en-au.js": 120,
	"./en-ca": 121,
	"./en-ca.js": 121,
	"./en-gb": 122,
	"./en-gb.js": 122,
	"./en-ie": 123,
	"./en-ie.js": 123,
	"./en-il": 124,
	"./en-il.js": 124,
	"./en-in": 125,
	"./en-in.js": 125,
	"./en-nz": 126,
	"./en-nz.js": 126,
	"./en-sg": 127,
	"./en-sg.js": 127,
	"./eo": 128,
	"./eo.js": 128,
	"./es": 132,
	"./es-do": 129,
	"./es-do.js": 129,
	"./es-mx": 130,
	"./es-mx.js": 130,
	"./es-us": 131,
	"./es-us.js": 131,
	"./es.js": 132,
	"./et": 133,
	"./et.js": 133,
	"./eu": 134,
	"./eu.js": 134,
	"./fa": 135,
	"./fa.js": 135,
	"./fi": 136,
	"./fi.js": 136,
	"./fil": 137,
	"./fil.js": 137,
	"./fo": 138,
	"./fo.js": 138,
	"./fr": 141,
	"./fr-ca": 139,
	"./fr-ca.js": 139,
	"./fr-ch": 140,
	"./fr-ch.js": 140,
	"./fr.js": 141,
	"./fy": 142,
	"./fy.js": 142,
	"./ga": 143,
	"./ga.js": 143,
	"./gd": 144,
	"./gd.js": 144,
	"./gl": 145,
	"./gl.js": 145,
	"./gom-deva": 146,
	"./gom-deva.js": 146,
	"./gom-latn": 147,
	"./gom-latn.js": 147,
	"./gu": 148,
	"./gu.js": 148,
	"./he": 149,
	"./he.js": 149,
	"./hi": 150,
	"./hi.js": 150,
	"./hr": 151,
	"./hr.js": 151,
	"./hu": 152,
	"./hu.js": 152,
	"./hy-am": 153,
	"./hy-am.js": 153,
	"./id": 154,
	"./id.js": 154,
	"./is": 155,
	"./is.js": 155,
	"./it": 157,
	"./it-ch": 156,
	"./it-ch.js": 156,
	"./it.js": 157,
	"./ja": 158,
	"./ja.js": 158,
	"./jv": 159,
	"./jv.js": 159,
	"./ka": 160,
	"./ka.js": 160,
	"./kk": 161,
	"./kk.js": 161,
	"./km": 162,
	"./km.js": 162,
	"./kn": 163,
	"./kn.js": 163,
	"./ko": 164,
	"./ko.js": 164,
	"./ku": 166,
	"./ku-kmr": 165,
	"./ku-kmr.js": 165,
	"./ku.js": 166,
	"./ky": 167,
	"./ky.js": 167,
	"./lb": 168,
	"./lb.js": 168,
	"./lo": 169,
	"./lo.js": 169,
	"./lt": 170,
	"./lt.js": 170,
	"./lv": 171,
	"./lv.js": 171,
	"./me": 172,
	"./me.js": 172,
	"./mi": 173,
	"./mi.js": 173,
	"./mk": 174,
	"./mk.js": 174,
	"./ml": 175,
	"./ml.js": 175,
	"./mn": 176,
	"./mn.js": 176,
	"./mr": 177,
	"./mr.js": 177,
	"./ms": 179,
	"./ms-my": 178,
	"./ms-my.js": 178,
	"./ms.js": 179,
	"./mt": 180,
	"./mt.js": 180,
	"./my": 181,
	"./my.js": 181,
	"./nb": 182,
	"./nb.js": 182,
	"./ne": 183,
	"./ne.js": 183,
	"./nl": 185,
	"./nl-be": 184,
	"./nl-be.js": 184,
	"./nl.js": 185,
	"./nn": 186,
	"./nn.js": 186,
	"./oc-lnc": 187,
	"./oc-lnc.js": 187,
	"./pa-in": 188,
	"./pa-in.js": 188,
	"./pl": 189,
	"./pl.js": 189,
	"./pt": 191,
	"./pt-br": 190,
	"./pt-br.js": 190,
	"./pt.js": 191,
	"./ro": 192,
	"./ro.js": 192,
	"./ru": 193,
	"./ru.js": 193,
	"./sd": 194,
	"./sd.js": 194,
	"./se": 195,
	"./se.js": 195,
	"./si": 196,
	"./si.js": 196,
	"./sk": 197,
	"./sk.js": 197,
	"./sl": 198,
	"./sl.js": 198,
	"./sq": 199,
	"./sq.js": 199,
	"./sr": 201,
	"./sr-cyrl": 200,
	"./sr-cyrl.js": 200,
	"./sr.js": 201,
	"./ss": 202,
	"./ss.js": 202,
	"./sv": 203,
	"./sv.js": 203,
	"./sw": 204,
	"./sw.js": 204,
	"./ta": 205,
	"./ta.js": 205,
	"./te": 206,
	"./te.js": 206,
	"./tet": 207,
	"./tet.js": 207,
	"./tg": 208,
	"./tg.js": 208,
	"./th": 209,
	"./th.js": 209,
	"./tk": 210,
	"./tk.js": 210,
	"./tl-ph": 211,
	"./tl-ph.js": 211,
	"./tlh": 212,
	"./tlh.js": 212,
	"./tr": 213,
	"./tr.js": 213,
	"./tzl": 214,
	"./tzl.js": 214,
	"./tzm": 216,
	"./tzm-latn": 215,
	"./tzm-latn.js": 215,
	"./tzm.js": 216,
	"./ug-cn": 217,
	"./ug-cn.js": 217,
	"./uk": 218,
	"./uk.js": 218,
	"./ur": 219,
	"./ur.js": 219,
	"./uz": 221,
	"./uz-latn": 220,
	"./uz-latn.js": 220,
	"./uz.js": 221,
	"./vi": 222,
	"./vi.js": 222,
	"./x-pseudo": 223,
	"./x-pseudo.js": 223,
	"./yo": 224,
	"./yo.js": 224,
	"./zh-cn": 225,
	"./zh-cn.js": 225,
	"./zh-hk": 226,
	"./zh-hk.js": 226,
	"./zh-mo": 227,
	"./zh-mo.js": 227,
	"./zh-tw": 228,
	"./zh-tw.js": 228
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 441;

/***/ }),
/* 442 */,
/* 443 */,
/* 444 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 445 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAApCAYAAADAk4LOAAAFgUlEQVR4Aa1XA5BjWRTN2oW17d3YaZtr2962HUzbDNpjszW24mRt28p47v7zq/bXZtrp/lWnXr337j3nPCe85NcypgSFdugCpW5YoDAMRaIMqRi6aKq5E3YqDQO3qAwjVWrD8Ncq/RBpykd8oZUb/kaJutow8r1aP9II0WmLKLIsJyv1w/kqw9Ch2MYdB++12Onxee/QMwvf4/Dk/Lfp/i4nxTXtOoQ4pW5Aj7wpici1A9erdAN2OH64x8OSP9j3Ft3b7aWkTg/Fm91siTra0f9on5sQr9INejH6CUUUpavjFNq1B+Oadhxmnfa8RfEmN8VNAsQhPqF55xHkMzz3jSmChWU6f7/XZKNH+9+hBLOHYozuKQPxyMPUKkrX/K0uWnfFaJGS1QPRtZsOPtr3NsW0uyh6NNCOkU3Yz+bXbT3I8G3xE5EXLXtCXbbqwCO9zPQYPRTZ5vIDXD7U+w7rFDEoUUf7ibHIR4y6bLVPXrz8JVZEql13trxwue/uDivd3fkWRbS6/IA2bID4uk0UpF1N8qLlbBlXs4Ee7HLTfV1j54APvODnSfOWBqtKVvjgLKzF5YdEk5ewRkGlK0i33Eofffc7HT56jD7/6U+qH3Cx7SBLNntH5YIPvODnyfIXZYRVDPqgHtLs5ABHD3YzLuespb7t79FY34DjMwrVrcTuwlT55YMPvOBnRrJ4VXTdNnYug5ucHLBjEpt30701A3Ts+HEa73u6dT3FNWwflY86eMHPk+Yu+i6pzUpRrW7SNDg5JHR4KapmM5Wv2E8Tfcb1HoqqHMHU+uWDD7zg54mz5/2BSnizi9T1Dg4QQXLToGNCkb6tb1NU+QAlGr1++eADrzhn/u8Q2YZhQVlZ5+CAOtqfbhmaUCS1ezNFVm2imDbPmPng5wmz+gwh+oHDce0eUtQ6OGDIyR0uUhUsoO3vfDmmgOezH0mZN59x7MBi++WDL1g/eEiU3avlidO671bkLfwbw5XV2P8Pzo0ydy4t2/0eu33xYSOMOD8hTf4CrBtGMSoXfPLchX+J0ruSePw3LZeK0juPJbYzrhkH0io7B3k164hiGvawhOKMLkrQLyVpZg8rHFW7E2uHOL888IBPlNZ1FPzstSJM694fWr6RwpvcJK60+0HCILTBzZLFNdtAzJaohze60T8qBzyh5ZuOg5e7uwQppofEmf2++DYvmySqGBuKaicF1blQjhuHdvCIMvp8whTTfZzI7RldpwtSzL+F1+wkdZ2TBOW2gIF88PBTzD/gpeREAMEbxnJcaJHNHrpzji0gQCS6hdkEeYt9DF/2qPcEC8RM28Hwmr3sdNyht00byAut2k3gufWNtgtOEOFGUwcXWNDbdNbpgBGxEvKkOQsxivJx33iow0Vw5S6SVTrpVq11ysA2Rp7gTfPfktc6zhtXBBC+adRLshf6sG2RfHPZ5EAc4sVZ83yCN00Fk/4kggu40ZTvIEm5g24qtU4KjBrx/BTTH8ifVASAG7gKrnWxJDcU7x8X6Ecczhm3o6YicvsLXWfh3Ch1W0k8x0nXF+0fFxgt4phz8QvypiwCCFKMqXCnqXExjq10beH+UUA7+nG6mdG/Pu0f3LgFcGrl2s0kNNjpmoJ9o4B29CMO8dMT4Q5ox8uitF6fqsrJOr8qnwNbRzv6hSnG5wP+64C7h9lp30hKNtKdWjtdkbuPA19nJ7Tz3zR/ibgARbhb4AlhavcBebmTHcFl2fvYEnW0ox9xMxKBS8btJ+KiEbq9zA4RthQXDhPa0T9TEe69gWupwc6uBUphquXgf+/FrIjweHQS4/pduMe5ERUMHUd9xv8ZR98CxkS4F2n3EUrUZ10EYNw7BWm9x1GiPssi3GgiGRDKWRYZfXlON+dfNbM+GgIwYdwAAAAASUVORK5CYII="

/***/ }),
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(293),
  /* template */
  __webpack_require__(499),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(428)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(294),
  /* template */
  __webpack_require__(528),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(295),
  /* template */
  __webpack_require__(498),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(437)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(296),
  /* template */
  __webpack_require__(539),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(404)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(297),
  /* template */
  __webpack_require__(496),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(298),
  /* template */
  __webpack_require__(506),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(299),
  /* template */
  __webpack_require__(513),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(300),
  /* template */
  __webpack_require__(532),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(429)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(301),
  /* template */
  __webpack_require__(529),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(433)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(302),
  /* template */
  __webpack_require__(535),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(417)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(303),
  /* template */
  __webpack_require__(516),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(420)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(304),
  /* template */
  __webpack_require__(519),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(407)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(305),
  /* template */
  __webpack_require__(502),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(410)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(306),
  /* template */
  __webpack_require__(505),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(432)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(307),
  /* template */
  __webpack_require__(533),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(434)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(308),
  /* template */
  __webpack_require__(536),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(418)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(309),
  /* template */
  __webpack_require__(517),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(310),
  /* template */
  __webpack_require__(497),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(311),
  /* template */
  __webpack_require__(525),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(438)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(312),
  /* template */
  __webpack_require__(540),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(426)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(313),
  /* template */
  __webpack_require__(526),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(411)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(315),
  /* template */
  __webpack_require__(507),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(412)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(316),
  /* template */
  __webpack_require__(508),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(424)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(318),
  /* template */
  __webpack_require__(523),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(414)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(319),
  /* template */
  __webpack_require__(512),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(402)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(320),
  /* template */
  __webpack_require__(494),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(409)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(321),
  /* template */
  __webpack_require__(504),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(431)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(322),
  /* template */
  __webpack_require__(531),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(423)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(323),
  /* template */
  __webpack_require__(522),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(408)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(324),
  /* template */
  __webpack_require__(503),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(405)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(325),
  /* template */
  __webpack_require__(500),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(435)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(326),
  /* template */
  __webpack_require__(537),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(436)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(327),
  /* template */
  __webpack_require__(538),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(419)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(328),
  /* template */
  __webpack_require__(518),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(427)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(329),
  /* template */
  __webpack_require__(527),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(401)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(330),
  /* template */
  __webpack_require__(493),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(425)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(331),
  /* template */
  __webpack_require__(524),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(415)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(332),
  /* template */
  __webpack_require__(514),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(422)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(334),
  /* template */
  __webpack_require__(521),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(288),
  /* template */
  __webpack_require__(510),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(289),
  /* template */
  __webpack_require__(534),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(406)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(290),
  /* template */
  __webpack_require__(501),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(335),
  /* template */
  __webpack_require__(511),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(403)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(291),
  /* template */
  __webpack_require__(495),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 493 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "box-header title-boreder"
  }, [_c('h3', {
    staticClass: "box-title title"
  }, [_vm._v(" Reglas "), _c('h3', {
    staticClass: "box-title title"
  }, [(this.currentRule === null) ? _c('span', {
    staticClass: "table-btn-icon"
  }) : _vm._e()]), (this.currentRule === null) ? _c('span', [_vm._v(" Registro")]) : _vm._e(), _vm._v(" "), (this.currentRule !== null) ? _c('h3', {
    staticClass: "box-title title"
  }, [_c('span', {
    staticClass: "table-btn-icon"
  })]) : _vm._e(), _vm._v(" "), (this.currentRule !== null) ? _c('h3', {
    staticClass: "box-title title",
    attrs: {
      "to": {
        name: 'AlertRules',
        params: {
          accountCode: this.selectedAccount.code
        }
      }
    }
  }, [_vm._v(_vm._s(this.selectedAccount.name))]) : _vm._e(), _vm._v(" "), (this.currentRule !== null) ? _c('h3', {
    staticClass: "box-title title"
  }, [_c('span', {
    staticClass: "table-btn-icon"
  })]) : _vm._e(), _vm._v(" "), (this.currentRule !== null) ? _c('h3', {
    staticClass: "box-title title"
  }, [_vm._v(" " + _vm._s(this.currentRule.Name))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "box box-success"
  }, [_vm._m(0), _vm._v(" "), _c('form', {
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.handleSubmit.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "filterContainer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4",
    staticStyle: {
      "padding-bottom": "20px"
    }
  }, [(this.currentRule === null) ? _c('div', {
    staticClass: "form-group",
    attrs: {
      "id": "divAccountSelect"
    }
  }, [_c('label', [_vm._v("Cuenta")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "value": this.selectedAccount,
      "selectLabel": "",
      "selectedLabel": "",
      "deselectLabel": "",
      "track-by": "name",
      "placeholder": this.selectedAccount.name,
      "allow-empty": false,
      "label": "name",
      "options": this.optionsAccount
    },
    on: {
      "input": _vm.onAccountSelect
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("\r\n                  No se encontraron resultados\r\n                ")])])], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "ruleName"
    }
  }, [_vm._v("Nombre")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ruleName),
      expression: "ruleName"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "ruleName",
      "type": "text"
    },
    domProps: {
      "value": (_vm.ruleName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ruleName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.submitted && _vm.ruleName === ''),
      expression: "submitted && ruleName === ''"
    }],
    staticClass: "invalid-feedback"
  }, [_vm._v("Nombre Requerido")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "ddlItemType"
    }
  }, [_vm._v("Criterio")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ruleItemType),
      expression: "ruleItemType"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "ddlItemType"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.ruleItemType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((this.optionsItemType), function(item) {
    return _c('option', {
      key: item.code,
      domProps: {
        "value": item.code
      }
    }, [_vm._v("\r\n                  " + _vm._s(item.name) + "\r\n                ")])
  }), 0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.submitted && !_vm.ruleItemType),
      expression: "submitted && !ruleItemType"
    }],
    staticClass: "invalid-feedback"
  }, [_vm._v("Tipo Requerido")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "txtItemCode"
    }
  }, [_vm._v("Código")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ruleItemCode),
      expression: "ruleItemCode"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "txtItemCode",
      "type": "text"
    },
    domProps: {
      "value": (_vm.ruleItemCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ruleItemCode = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.submitted && !_vm.ruleItemCode),
      expression: "submitted && !ruleItemCode"
    }],
    staticClass: "invalid-feedback"
  }, [_vm._v("Código Requerido")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "ddlOperator"
    }
  }, [_vm._v("Operador")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ruleOperator),
      expression: "ruleOperator"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "ddlOperator"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.ruleOperator = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((this.optionsOperator), function(item) {
    return _c('option', {
      key: item.code,
      domProps: {
        "value": item.code
      }
    }, [_vm._v("\r\n                  " + _vm._s(item.name) + "\r\n                ")])
  }), 0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.submitted && !_vm.ruleOperator),
      expression: "submitted && !ruleOperator"
    }],
    staticClass: "invalid-feedback"
  }, [_vm._v("Operador Requerido")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "numValue"
    }
  }, [_vm._v("Valor")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ruleValue),
      expression: "ruleValue"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "numValue",
      "type": "number",
      "min": "0"
    },
    domProps: {
      "value": (_vm.ruleValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ruleValue = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.submitted && _vm.ruleValue <= 0),
      expression: "submitted && ruleValue <= 0"
    }],
    staticClass: "invalid-feedback"
  }, [_vm._v("Valor Requerido")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "txtEmail"
    }
  }, [_vm._v("Correos de Nottificación")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.notifyToValue),
      expression: "notifyToValue"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "txtEmail",
      "type": "textarea",
      "rows": "4"
    },
    domProps: {
      "value": (_vm.notifyToValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.notifyToValue = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.submitted && _vm.notifyToValue.trim() === ''),
      expression: "submitted && notifyToValue.trim() === ''"
    }],
    staticClass: "invalid-feedback"
  }, [_vm._v("Correo Requerido")]), _vm._v(" "), _c('span', [_vm._v("*Ingrese múltiples correos separados por \";\" (Punto y Coma)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('input', {
    class: ['btn btn-success', {
      'disabled': (_vm.submitted && !_vm.selectedAccount && !_vm.selectedEriType && !_vm.selectedDate && !_vm.squaredSkuCount && !_vm.inventoriedSkuCount)
    }],
    attrs: {
      "type": "submit"
    },
    domProps: {
      "value": this.currentRule === null ? 'Registrar' : 'Actualizar'
    }
  })])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header title-boreder"
  }, [_c('h3', {
    staticClass: "box-title box-title-sub"
  }, [_c('img', {
    staticClass: "icon-space",
    attrs: {
      "src": "/static/img/icons/exclamation-circle-solid-modal.png"
    }
  }), _vm._v(" Crear Regla")])])
}]}

/***/ }),
/* 494 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "main-sidebar",
    attrs: {
      "id": "slider"
    }
  }, [_c('section', {
    staticClass: "sidebar"
  }, [_c('ul', {
    staticClass: "sidebar-menu",
    attrs: {
      "data-widget": "tree"
    }
  }, _vm._l((_vm.slideMenuItems), function(item, index) {
    return _c('va-slide-item', {
      key: index,
      attrs: {
        "data": item,
        "type": item.type,
        "isHeader": item.isHeader,
        "icon": item.icon,
        "name": item.name,
        "badge": item.badge,
        "items": item.items,
        "router": item.router,
        "link": item.link
      }
    })
  }), 1)])])
},staticRenderFns: []}

/***/ }),
/* 495 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-street-view-pano-container"
  }, [_c('div', {
    ref: "vue-street-view-pano",
    staticClass: "vue-street-view-pano"
  }), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 496 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('va-dashboard-filter'), _vm._v(" "), (this.detailMode !== '') ? _c('div', [_c(_vm.bindDetail, {
    tag: "component",
    attrs: {
      "mode": this.filterMode,
      "fetchData": this.fetchData
    }
  })], 1) : (this.layoutMode === '1') ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('va-main-eri', {
    attrs: {
      "mode": this.filterMode,
      "fetchData": this.fetchData
    }
  })], 1)]), _vm._v(" "), _c('va-summary-warehouse', {
    attrs: {
      "mode": this.filterMode,
      "fetchData": this.fetchData
    }
  })], 1) : (this.layoutMode === '2') ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c(_vm.bindService, {
    tag: "component",
    attrs: {
      "mode": this.filterMode,
      "fetchData": this.fetchData
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('va-main-eri', {
    attrs: {
      "mode": this.filterMode,
      "fetchData": this.fetchData
    }
  })], 1)]), _vm._v(" "), _c('va-summary-warehouse', {
    attrs: {
      "mode": this.filterMode,
      "fetchData": this.fetchData
    }
  })], 1) : (this.layoutMode === '3') ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('va-summary-td', {
    attrs: {
      "mode": this.filterMode,
      "fetchData": this.fetchData
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('va-summary-transport', {
    attrs: {
      "mode": this.filterMode,
      "fetchData": this.fetchData
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('va-main-eri', {
    attrs: {
      "mode": this.filterMode,
      "fetchData": this.fetchData
    }
  })], 1)]), _vm._v(" "), _c('va-summary-warehouse', {
    attrs: {
      "mode": this.filterMode,
      "fetchData": this.fetchData
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 497 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('vue-table', {
    attrs: {
      "api-mode": false,
      "fields": _vm.tableFields,
      "data": _vm.rowData.lines,
      "noDataTemplate": "No se encontraron resultados"
    },
    scopedSlots: _vm._u([{
      key: "percentageFromTotal",
      fn: function(props) {
        return [_c('div', {
          staticClass: "progressContainer text-center"
        }, [_c('div', {
          staticClass: "progressBar"
        }, [_c('div', {
          style: ('font-size: 14px;margin:-5px 10px;float:left')
        }, [_vm._v(_vm._s(_vm.formatPercentage(props.rowData.percentageFromTotal)))]), _vm._v(" "), (_vm.window.width > 620) ? _c('div', {
          staticClass: "progress table-bar"
        }, [_c('div', {
          class: 'progress-bar progress-bar-' + _vm.formatProgress(props.rowData.percentageFromTotal),
          style: ('width:' + _vm.formatPercentage(props.rowData.percentageFromTotal)),
          attrs: {
            "role": "progressbar",
            "aria-valuemin": "0",
            "aria-valuemax": "100"
          }
        })]) : _vm._e()])])]
      }
    }, {
      key: "quantity",
      fn: function(props) {
        return [_c('span', [_vm._v(_vm._s(_vm.formatAmount(props.rowData.quantity))), _c('span', {
          staticStyle: {
            "font-size": "12px"
          }
        }, [_vm._v(" " + _vm._s(props.rowData.minimumStockUnit))])])]
      }
    }])
  })
},staticRenderFns: []}

/***/ }),
/* 498 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
},staticRenderFns: []}

/***/ }),
/* 499 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div')
},staticRenderFns: []}

/***/ }),
/* 500 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title title",
    staticStyle: {
      "color": "#959FA9"
    }
  }, [_vm._v(" Detalle de pedido ")]), _vm._v(" "), _c('h3', {
    staticClass: "box-title title"
  }, [(_vm.window.width > 610) ? _c('span', {
    staticClass: "table-btn-icon icon-space"
  }) : _vm._e(), _vm._v(" " + _vm._s(_vm._f("formatDate")(this.$route.params.filterOrdereDate.shippingDate, 'DD/MM/YYYY')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-header",
    staticStyle: {
      "height": "80px !important"
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'OrdersProgress',
        params: {
          lastSearch: true,
          showAdvance: this.$route.params.showAdvanceMain
        }
      }
    }
  }, [_c('button', {
    staticClass: "btn btn-sm btn-success btnAction btn-search",
    staticStyle: {
      "background-color": "#E2E4E6",
      "border": "none",
      "height": "48px !important",
      "margin-bottom": "30px",
      "width": "130px !important"
    }
  }, [_c('img', {
    staticClass: "icon-space",
    staticStyle: {
      "padding-bottom": "7px"
    },
    attrs: {
      "src": "/static/img/icons/ic_back.png"
    }
  }), _vm._v("Regresar")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "box box-success"
  }, [_c('div', {
    staticClass: "box-header title-boreder"
  }, [_c('h3', {
    staticClass: "box-title box-title-sub"
  }, [_c('img', {
    staticStyle: {
      "padding-bottom": "7px"
    },
    attrs: {
      "src": "/static/img/icons/ic_doc2.png"
    }
  }), _vm._v(" Detalle: " + _vm._s(_vm._f("formatDate")(this.$route.params.filterOrdereDate.shippingDate, 'DD/MM/YYYY')))])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "filterContainer"
  }, [_c('div', {
    staticClass: "row title-boreder",
    staticStyle: {
      "padding-bottom": "25px"
    }
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.window.width > 610) ? _c('div', {
    staticClass: "col-xs-1"
  }) : _vm._e(), _vm._v(" "), (_vm.window.width <= 610) ? _c('div', {
    staticClass: "col-xs-9",
    staticStyle: {
      "margin-left": "15px"
    }
  }, [_c('div', {
    staticClass: "progress"
  }, [_c('div', {
    class: 'progress-bar',
    style: ('background-color:#536DFE;width:' + this.$route.params.filterOrdereDate.totalShippedPorcentage + '%'),
    attrs: {
      "role": "progressbar"
    }
  }), _vm._v(" "), _c('div', {
    class: 'progress-bar',
    style: ('background-color:#63CB68;width:' + this.$route.params.filterOrdereDate.totalProgressPorcentage + '%'),
    attrs: {
      "role": "progressbar"
    }
  }), _vm._v(" "), _c('div', {
    class: 'progress-bar',
    style: ('background-color:#4FC3F7;width:' + this.$route.params.filterOrdereDate.totalPendingPorcentage + '%'),
    attrs: {
      "role": "progressbar"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.window.width > 610) ? _c('div', {
    staticClass: "col-xs-9"
  }, [_c('div', {
    staticClass: "progress"
  }, [_c('div', {
    class: 'progress-bar',
    style: ('background-color:#536DFE;width:' + this.$route.params.filterOrdereDate.totalShippedPorcentage + '%'),
    attrs: {
      "role": "progressbar"
    }
  }), _vm._v(" "), _c('div', {
    class: 'progress-bar',
    style: ('background-color:#63CB68;width:' + this.$route.params.filterOrdereDate.totalProgressPorcentage + '%'),
    attrs: {
      "role": "progressbar"
    }
  }), _vm._v(" "), _c('div', {
    class: 'progress-bar',
    style: ('background-color:#4FC3F7;width:' + this.$route.params.filterOrdereDate.totalPendingPorcentage + '%'),
    attrs: {
      "role": "progressbar"
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    staticStyle: {
      "padding-left": "10px",
      "position": "relative",
      "top": "-10px"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#4E6982",
      "font-size": "18px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm._f("formatAmount")(this.$route.params.filterOrdereDate.orderTotal)))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#4E6982",
      "font-size": "16px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(this.$route.params.filterOrdereDate.minimumStockUnit))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#4E6982",
      "display": "block"
    }
  }, [_vm._v("total")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.window.width > 610) ? _c('div', {
    staticClass: "col-xs-1"
  }) : _vm._e(), _vm._v(" "), (_vm.window.width <= 610) ? _c('div', {
    staticClass: "col-xs-3",
    staticStyle: {
      "border-right": "3px solid #F4F6F7",
      "margin-left": "15px"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('span', {
    style: ('background-color:#536DFE;display:inline-block;width:2em;height:2em;line-height:2em;top:10px;')
  }, [_vm._v(" ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('span', {
    staticStyle: {
      "color": "#4E6982",
      "font-size": "14px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm._f("formatAmount")(this.$route.params.filterOrdereDate.orderCompleted)))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#4E6982",
      "font-size": "12px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(this.$route.params.filterOrdereDate.minimumStockUnit))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#4E6982",
      "display": "block"
    }
  }, [_vm._v("Atendidos")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('span', {
    staticStyle: {
      "color": "#536DFE",
      "font-size": "30px"
    }
  }, [_vm._v(_vm._s(_vm._f("currency")(this.$route.params.filterOrdereDate.totalShippedPorcentage)) + "%")])])])]) : _vm._e(), _vm._v(" "), (_vm.window.width > 610) ? _c('div', {
    staticClass: "col-xs-3",
    staticStyle: {
      "border-right": "3px solid #F4F6F7"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('span', {
    style: ('background-color:#536DFE;display:inline-block;width:2em;height:2em;line-height:2em;top:10px;')
  }, [_vm._v(" ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('span', {
    staticStyle: {
      "color": "#4E6982",
      "font-size": "14px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm._f("formatAmount")(this.$route.params.filterOrdereDate.orderCompleted)))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#4E6982",
      "font-size": "12px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(this.$route.params.filterOrdereDate.minimumStockUnit))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#4E6982",
      "display": "block"
    }
  }, [_vm._v("Atendidos")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('span', {
    staticStyle: {
      "color": "#536DFE",
      "font-size": "30px"
    }
  }, [_vm._v(_vm._s(_vm._f("currency")(this.$route.params.filterOrdereDate.totalShippedPorcentage)) + "%")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-3",
    staticStyle: {
      "border-right": "3px solid #F4F6F7"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', {
    staticClass: "col-md-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('span', {
    style: ('background-color:#63CB68;display:inline-block;width:2em;height:2em;line-height:2em;top:10px;')
  }, [_vm._v(" ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('span', {
    staticStyle: {
      "color": "#4E6982",
      "font-size": "14px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm._f("formatAmount")(this.$route.params.filterOrdereDate.orderProgress)))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#4E6982",
      "font-size": "12px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(this.$route.params.filterOrdereDate.minimumStockUnit))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#4E6982",
      "display": "block"
    }
  }, [_vm._v("Proceso")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('span', {
    staticStyle: {
      "color": "#63CB68",
      "font-size": "30px"
    }
  }, [_vm._v(_vm._s(_vm._f("currency")(this.$route.params.filterOrdereDate.totalProgressPorcentage)) + "%")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-3",
    staticStyle: {
      "border-right": "3px"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', {
    staticClass: "col-md-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('span', {
    style: ('background-color:#4FC3F7;display:inline-block;width:2em;height:2em;line-height:2em;top:10px;')
  }, [_vm._v(" ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('span', {
    staticStyle: {
      "color": "#4E6982",
      "font-size": "14px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm._f("formatAmount")(this.$route.params.filterOrdereDate.orderPending)))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#4E6982",
      "font-size": "12px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(this.$route.params.filterOrdereDate.minimumStockUnit))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#4E6982",
      "display": "block"
    }
  }, [_vm._v("Pendientes")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('span', {
    staticStyle: {
      "color": "#4FC3F7",
      "font-size": "30px"
    }
  }, [_vm._v(_vm._s(_vm._f("currency")(this.$route.params.filterOrdereDate.totalPendingPorcentage)) + "%")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    staticStyle: {
      "padding-left": "10px",
      "position": "relative",
      "top": "-10px"
    }
  })])])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12",
    attrs: {
      "id": "ordersDetail"
    }
  }, [_c('Vuetable', {
    key: _vm.tableKey,
    ref: "vuetable",
    attrs: {
      "id": "ordersDetail",
      "api-mode": false,
      "fields": _vm.tableDetail,
      "css": _vm.tableCSS.table,
      "noDataTemplate": "No se encontraron resultados",
      "data": _vm.orderDetailTableVue,
      "data-manager": _vm.dataManager,
      "pagination-path": "pagination"
    },
    on: {
      "vuetable:loading": _vm.onLoading,
      "vuetable:loaded": _vm.onLoaded,
      "vuetable:pagination-data": _vm.onPaginationData
    },
    scopedSlots: _vm._u([{
      key: "clientName",
      fn: function(props) {
        return [_c('div', {
          attrs: {
            "id": "Cliente"
          }
        }, [_c('span', [_vm._v(_vm._s(props.rowData.clientName))])])]
      }
    }, {
      key: "completedOrders",
      fn: function(props) {
        return [_c('div', {
          attrs: {
            "id": "Atendido"
          }
        }, [_c('div', {
          style: ('display: inline-flex;')
        }, [_c('div', {
          staticClass: "progressContainer"
        }, [_c('div', {
          staticClass: "porcentajeTotal",
          style: ('font-size: 16px ;margin:-3px 25px 0 -10px;color:#4E6982;')
        }, [_vm._v(_vm._s(_vm._f("currency")(props.rowData.completedPercentage)) + "%")]), _vm._v(" "), _c('div', {
          staticClass: "progressBar",
          staticStyle: {
            "position": "absolute !important",
            "margin-left": "50px",
            "margin-top": "0px"
          }
        }, [_c('div', {
          staticClass: "progress table-bar percentageA",
          style: ('background-color:#D9DEFB')
        }, [_c('div', {
          class: 'progress-bar progress-bar',
          style: ('background-color:#536DFE;width:' + props.rowData.completedPercentage + '%'),
          attrs: {
            "role": "progressbar",
            "aria-valuemin": "0",
            "aria-valuemax": "100"
          }
        })])]), _vm._v(" "), _c('div', {
          staticClass: "totalPorcentaje",
          style: ('margin:-22px  0 0 190px;color:#506A83')
        }, [_c('span', {
          staticStyle: {
            "font-size": "16px",
            "font-weight": "bold",
            "color": "#4E6982"
          }
        }, [_vm._v(_vm._s(_vm._f("formatAmount")(props.rowData.completedOrders)))]), _vm._v(" "), _c('span', {
          staticStyle: {
            "font-size": "14px",
            "font-weight": "bold",
            "color": "#4E6982"
          }
        }, [_vm._v(_vm._s(props.rowData.minimumStockUnit))])])])])])]
      }
    }, {
      key: "progressOrders",
      fn: function(props) {
        return [_c('div', {
          attrs: {
            "id": "Proceso"
          }
        }, [_c('div', {
          staticClass: "pendiente",
          style: ('display: inline-flex;')
        }, [_c('div', {
          staticClass: "progressContainer"
        }, [_c('div', {
          staticClass: "porcentajeTotal",
          style: ('font-size: 16px ;margin:-3px 25px 0 -10px;color:#4E6982;')
        }, [_vm._v(_vm._s(_vm._f("currency")(props.rowData.progressPercentage)) + "%")]), _vm._v(" "), _c('div', {
          staticClass: "progressBar",
          staticStyle: {
            "position": "absolute !important",
            "margin-left": "60px",
            "margin-top": "0px"
          }
        }, [_c('div', {
          staticClass: "progress table-bar",
          style: ('background-color:#B6F5BB')
        }, [_c('div', {
          class: 'progress-bar progress-bar',
          style: ('background-color:#63CB68;width:' + props.rowData.progressPercentage + '%'),
          attrs: {
            "role": "progressbar",
            "aria-valuemin": "0",
            "aria-valuemax": "100"
          }
        })])]), _vm._v(" "), _c('div', {
          staticClass: "totalPorcentaje",
          style: ('margin:-22px  0 0 200px;color:#4E6982')
        }, [_c('span', {
          staticStyle: {
            "font-size": "16px",
            "font-weight": "bold",
            "color": "#4E6982"
          }
        }, [_vm._v(_vm._s(_vm._f("formatAmount")(props.rowData.progressOrders)))]), _vm._v(" "), _c('span', {
          staticStyle: {
            "font-size": "14px",
            "font-weight": "bold",
            "color": "#4E6982"
          }
        }, [_vm._v(_vm._s(props.rowData.minimumStockUnit))])])])])])]
      }
    }, {
      key: "pendingOrders",
      fn: function(props) {
        return [_c('div', {
          attrs: {
            "id": "Pendientes"
          }
        }, [_c('div', {
          staticClass: "pendiente",
          style: ('display: inline-flex;')
        }, [_c('div', {
          staticClass: "progressContainer"
        }, [_c('div', {
          staticClass: "porcentajeTotal",
          style: ('font-size: 16px ;margin:-3px 25px 0 -10px;color:#4E6982;')
        }, [_vm._v(_vm._s(_vm._f("currency")(props.rowData.pendingPercentage)) + "%")]), _vm._v(" "), _c('div', {
          staticClass: "progressBar",
          staticStyle: {
            "position": "absolute !important",
            "margin-left": "60px",
            "margin-top": "0px"
          }
        }, [_c('div', {
          staticClass: "progress table-bar",
          style: ('background-color:#C6E9F8')
        }, [_c('div', {
          class: 'progress-bar progress-bar',
          style: ('background-color:#4FC3F7;width:' + props.rowData.pendingPercentage + '%'),
          attrs: {
            "role": "progressbar",
            "aria-valuemin": "0",
            "aria-valuemax": "100"
          }
        })])]), _vm._v(" "), _c('div', {
          staticClass: "totalPorcentaje",
          style: ('margin:-22px  0 0 200Px;color:#4E6982')
        }, [_c('span', {
          staticStyle: {
            "font-size": "16px",
            "font-weight": "bold",
            "color": "#4E6982"
          }
        }, [_vm._v(_vm._s(_vm._f("formatAmount")(props.rowData.pendingOrders)))]), _vm._v(" "), _c('span', {
          staticStyle: {
            "font-size": "14px",
            "font-weight": "bold",
            "color": "#4E6982"
          }
        }, [_vm._v(_vm._s(props.rowData.minimumStockUnit))])])])])])]
      }
    }])
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_vm._v("\n           \n          "), (this.paginationData && _vm.paginationData.total > 0) ? [_c('strong', {
    staticStyle: {
      "color": "#364A5D",
      "paddin-left": "15px"
    }
  }, [_vm._v("\n            Mostrando documento " + _vm._s(this.paginationData.from) + " a " + _vm._s(this.paginationData.to) + " de " + _vm._s(this.paginationData.total) + " en Total\n            ")])] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('vuetable-pagination', {
    ref: "pagination",
    attrs: {
      "css": _vm.tableCSS.pagination
    },
    on: {
      "vuetable-pagination:change-page": _vm.onChangePage
    }
  })], 1)])])])])
},staticRenderFns: []}

/***/ }),
/* 501 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-map-container"
  }, [_c('div', {
    ref: "vue-map",
    staticClass: "vue-map"
  }), _vm._v(" "), _c('div', {
    staticClass: "vue-map-hidden"
  }, [_vm._t("default")], 2), _vm._v(" "), _vm._t("visible")], 2)
},staticRenderFns: []}

/***/ }),
/* 502 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "box-header title-boreder"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('h3', {
    staticClass: "box-title box-title-sub"
  }, [_vm._v(_vm._s(this.title) + " ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "relative",
      "top": "-10px !important"
    }
  }, [_c('table', {
    staticClass: "table-summary",
    staticStyle: {
      "padding": "10px !important"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("SKU " + _vm._s(this.unit) + " Cuadradas")]), _vm._v(" "), _c('th', [_vm._v("SKU " + _vm._s(this.unit) + " Inventariadas")]), _vm._v(" "), _c('th', [_vm._v("% " + _vm._s(this.title))])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(_vm._f("formatAmount")(this.totalSkuSquare)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatAmount")(this.totalSkuInventory)))]), _vm._v(" "), _c('td', {
    style: (_vm.formatAmountColor(this.totalEriPercentage))
  }, [_vm._v(_vm._s(this.totalEriPercentage) + "%")])])])])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "table-scroll",
    attrs: {
      "id": this.id
    }
  }, [_c('div', {
    staticClass: "table-wrap"
  }, [_c('table', {
    staticClass: "main-table"
  }, [_c('thead', [_c('tr', [_vm._m(0), _vm._v(" "), _vm._l((this.formattedData), function(item) {
    return _c('th', {
      key: 'header_' + item.date,
      staticClass: "header"
    }, [_vm._v("\n                  " + _vm._s(item.date) + "\n                ")])
  })], 2)]), _vm._v(" "), _c('tbody', [_c('tr', [_c('th', {
    staticClass: "fixed-side"
  }, [_vm._v("\n                  SKU " + _vm._s(this.unit) + " \n                  "), _c('br'), _vm._v("\n                  Cuadradas\n                ")]), _vm._v(" "), _vm._l((this.formattedData), function(item) {
    return _c('td', {
      key: 'skuSquare_' + item.date,
      staticClass: "td-value"
    }, [_vm._v("\n                  " + _vm._s(_vm._f("formatAmount")(item.skuSquare)) + "\n                ")])
  })], 2), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "fixed-side"
  }, [_vm._v("\n                  SKU " + _vm._s(this.unit) + " \n                  "), _c('br'), _vm._v("\n                  Inventariadas\n                ")]), _vm._v(" "), _vm._l((this.formattedData), function(item) {
    return _c('td', {
      key: 'skuInventory_' + item.date,
      staticClass: "td-value"
    }, [_vm._v("\n                  " + _vm._s(_vm._f("formatAmount")(item.skuInventory)) + "\n                ")])
  })], 2), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "fixed-side"
  }, [_vm._v("\n                  %\n                  "), _c('br'), _vm._v("\n                  " + _vm._s(this.title) + " \n                ")]), _vm._v(" "), _vm._l((this.formattedData), function(item) {
    return _c('td', {
      key: 'percentage_' + item.date,
      staticClass: "td-value"
    }, [_c('b', [_vm._v(_vm._s(_vm._f("formatDecimal")((((item.skuSquare * 100) / item.skuInventory) || 0))) + "%")])])
  })], 2)])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "fixed-side",
    attrs: {
      "scope": "col"
    }
  }, [_c('div', {
    staticClass: "sideHeader"
  }, [_vm._v("\n                     \n                  ")])])
}]}

/***/ }),
/* 503 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box box-success"
  }, [_c('div', {
    staticClass: "box-header title-boreder"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('button', {
    staticClass: "btn btn-link btn-lg",
    on: {
      "click": function($event) {
        return _vm.advancedSearch()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-filter"
  }), _vm._v("  Avanzado")])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "filterContainer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticStyle: {
      "padding-bottom": "10px"
    },
    attrs: {
      "id": "divAccountSelect"
    }
  }, [_c('label', [_vm._v("Cuenta")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "value": this.selectedAccount,
      "selectLabel": "",
      "selectedLabel": "",
      "deselectLabel": "",
      "track-by": "name",
      "placeholder": this.selectedAccount.name,
      "allow-empty": false,
      "label": "name",
      "options": this.optionsAccount
    },
    on: {
      "input": _vm.onAccountSelect
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("\n                  No se encontraron resultados\n                ")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "dtDateRange"
    }
  }, [_vm._v("Desde - Hasta")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.submitted && _vm.message !== ''),
      expression: "submitted && message !== ''"
    }],
    staticClass: "invalid-feedback"
  }, [_vm._v(_vm._s(this.message))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [(_vm.showAdvance) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Tipo Pedido")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.typeOrder),
      expression: "typeOrder"
    }],
    staticClass: "form-control minimal",
    attrs: {
      "id": "ddlTypeOrder"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.typeOrder = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((this.optionTypeOrder), function(type) {
    return _c('option', {
      key: type.code,
      domProps: {
        "value": type.code
      }
    }, [_vm._v("\n                    " + _vm._s(type.text) + "\n                  ")])
  }), 0)]) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [(_vm.showAdvance) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Estado")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.documentStatus),
      expression: "documentStatus"
    }],
    staticClass: "form-control minimal",
    attrs: {
      "id": "ddlDocumentStatus"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.documentStatus = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((this.optionDocumentStatus), function(type) {
    return _c('option', {
      key: type.code,
      domProps: {
        "value": type.code
      }
    }, [_vm._v("\n                    " + _vm._s(type.text) + "\n                  ")])
  }), 0)]) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group",
    staticStyle: {
      "padding-top": "25px"
    }
  }, [_c('button', {
    staticClass: "btn btn-success btnAction",
    on: {
      "click": function($event) {
        return _vm.search()
      }
    }
  }, [_vm._v("Buscar")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [(_vm.showAdvance) ? _c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticStyle: {
      "padding-bottom": "10px"
    },
    attrs: {
      "id": "divClientSelect"
    }
  }, [_c('label', [_vm._v("Cliente")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "value": this.selectedClient,
      "selectLabel": "",
      "selectedLabel": "",
      "deselectLabel": "",
      "track-by": "code",
      "placeholder": this.selectedClient.text,
      "allow-empty": false,
      "label": "text",
      "options": this.optionsClient
    },
    on: {
      "input": _vm.onClientSelect
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("\n                  No se encontraron resultados\n                ")])])], 1)]) : _vm._e()])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "box box-success"
  }, [((this.tableAllData && this.tableAllData.length) || (this.tableClientData && this.tableClientData.length)) ? _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title box-title-sub"
  }, [_c('img', {
    staticClass: "icon-space",
    staticStyle: {
      "padding-bottom": "3px"
    },
    attrs: {
      "src": "/static/img/icons/result.png"
    }
  }), _vm._v("\n          PERíODO " + _vm._s(_vm._f("formatDate")(_vm.searchParams.StartDate, 'L')) + " A " + _vm._s(_vm._f("formatDate")(_vm.searchParams.EndDate, 'L')) + " \n        ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    attrs: {
      "id": "ordersClientTable"
    }
  }, [_c('Vuetable', {
    attrs: {
      "id": "ordersClientTable",
      "api-mode": false,
      "fields": _vm.tableClientFields,
      "data": _vm.tableClientData,
      "css": _vm.tableCSS.table,
      "noDataTemplate": "No se encontraron resultados"
    },
    scopedSlots: _vm._u([{
      key: "shippingDate",
      fn: function(props) {
        return [_c('div', {
          attrs: {
            "id": "Fecha"
          }
        }, [_c('span', [_vm._v(_vm._s(_vm._f("formatDate")(props.rowData.shippingDate, "DD/MM/YYYY")))])])]
      }
    }, {
      key: "orderCompleted",
      fn: function(props) {
        return [_c('div', {
          attrs: {
            "id": "Atendido"
          }
        }, [_c('div', {
          staticClass: "progressContainer"
        }, [_c('div', {
          staticClass: "porcentajeTotal",
          style: ('font-size: 14px ;margin:-3px 25px 0 -85px;color:#4E6982;')
        }, [_vm._v(_vm._s(_vm._f("currency")(props.rowData.totalShippedPorcentage)) + "%\n                    ")]), _vm._v(" "), _c('div', {
          staticClass: "progressBar",
          staticStyle: {
            "position": "absolute !important",
            "margin-left": "-35px",
            "margin-top": "1px"
          }
        }, [_c('div', {
          staticClass: "progress table-bar percentageA",
          style: ('background-color:#D9DEFB')
        }, [_c('div', {
          class: 'progress-bar progress-bar ',
          style: ('background-color:#536DFE;width:' + props.rowData.totalShippedPorcentage + '%'),
          attrs: {
            "role": "progressbar",
            "aria-valuemin": "0",
            "aria-valuemax": "100"
          }
        })]), _vm._v(" "), _c('div', {
          staticClass: "totalPorcentaje",
          style: ('margin:-16px 0px 0px 135px;color:#506A83')
        }, [_c('span', {
          staticStyle: {
            "font-size": "14px",
            "font-weight": "bold",
            "color": "#4E6982"
          }
        }, [_vm._v(_vm._s(_vm._f("formatAmount")(props.rowData.orderCompleted)))]), _vm._v(" "), _c('span', {
          staticStyle: {
            "font-size": "12px",
            "color": "#4E6982",
            "font-weight": "bold"
          }
        }, [_vm._v(_vm._s(props.rowData.minimumStockUnit))])])])])])]
      }
    }, {
      key: "orderProgress",
      fn: function(props) {
        return [_c('div', {
          attrs: {
            "id": "Proceso"
          }
        }, [_c('div', {
          staticClass: "progressContainer"
        }, [_c('div', {
          staticClass: "porcentajeTotal",
          style: ('font-size: 14px ;margin: -3px 25px 0 -70px; color:#4E6982')
        }, [_vm._v(_vm._s(_vm._f("currency")(props.rowData.totalProgressPorcentage)) + "%\n                    ")]), _vm._v(" "), _c('div', {
          staticClass: "progressBar",
          staticStyle: {
            "position": "absolute !important",
            "margin-left": "-20px",
            "margin-top": "1px"
          }
        }, [_c('div', {
          staticClass: "progress table-bar percentageA",
          style: ('background-color:#B6F5BB')
        }, [_c('div', {
          class: 'progress-bar progress-bar',
          style: ('background-color:#63CB68;width:' + props.rowData.totalProgressPorcentage + '%'),
          attrs: {
            "role": "progressbar",
            "aria-valuemin": "0",
            "aria-valuemax": "100"
          }
        })]), _vm._v(" "), _c('div', {
          staticClass: "totalPorcentaje",
          style: ('margin:-16px 0px 0px 135px;color:#4E6982')
        }, [_c('span', {
          staticStyle: {
            "font-size": "14px",
            "font-weight": "bold",
            "color": "#4E6982"
          }
        }, [_vm._v(_vm._s(_vm._f("formatAmount")(props.rowData.orderProgress)))]), _vm._v(" "), _c('span', {
          staticStyle: {
            "font-size": "12px",
            "color": "#4E6982",
            "font-weight": "bold"
          }
        }, [_vm._v(_vm._s(props.rowData.minimumStockUnit))])])])])])]
      }
    }, {
      key: "orderPending",
      fn: function(props) {
        return [_c('div', {
          attrs: {
            "id": "Pendientes"
          }
        }, [_c('div', {
          staticClass: "progressContainer"
        }, [_c('div', {
          staticClass: "porcentajeTotal",
          style: ('font-size: 14px ;margin:-3px 25px 0 -40px; color:#4E6982')
        }, [_vm._v(_vm._s(_vm._f("currency")(props.rowData.totalPendingPorcentage)) + "%\n                    ")]), _vm._v(" "), _c('div', {
          staticClass: "progressBar",
          staticStyle: {
            "position": "absolute !important",
            "margin-left": "12px",
            "margin-top": "4px"
          }
        }, [_c('div', {
          staticClass: "progress table-bar percentageA",
          style: ('background-color:#C6E9F8')
        }, [_c('div', {
          class: 'progress-bar progress-bar',
          style: ('background-color:#4FC3F7;width:' + props.rowData.totalPendingPorcentage + '%'),
          attrs: {
            "role": "progressbar",
            "aria-valuemin": "0",
            "aria-valuemax": "100"
          }
        })]), _vm._v(" "), _c('div', {
          staticClass: "totalPorcentaje",
          style: ('margin:-15px  0 0 140px;color:#4E6982')
        }, [_c('span', {
          staticStyle: {
            "font-size": "14px",
            "font-weight": "bold",
            "color": "#4E6982"
          }
        }, [_vm._v(_vm._s(_vm._f("formatAmount")(props.rowData.orderPending)))]), _vm._v(" "), _c('span', {
          staticStyle: {
            "font-size": "12px",
            "color": "#4E6982",
            "font-weight": "bold"
          }
        }, [_vm._v(_vm._s(props.rowData.minimumStockUnit))])])])])])]
      }
    }, {
      key: "orderTotal",
      fn: function(props) {
        return [_c('div', {
          attrs: {
            "id": "Total"
          }
        }, [_c('span', {
          staticStyle: {
            "font-size": "16px",
            "font-weight": "bold",
            "position": "relative"
          }
        }, [_vm._v(_vm._s(_vm._f("formatAmount")(props.rowData.orderTotal)))]), _vm._v(" "), _c('span', {
          staticStyle: {
            "font-size": "14px",
            "color": "#4E6982",
            "font-weight": "bold"
          }
        }, [_vm._v(_vm._s(props.rowData.minimumStockUnit))])])]
      }
    }, {
      key: "orderBtnDetail",
      fn: function(props) {
        return [_c('div', [_c('div', {
          staticClass: "text-center botonVerDetalle",
          staticStyle: {
            "margin-top": "-5px"
          }
        }, [(_vm.window.width > 1200) ? _c('router-link', {
          staticClass: "btn table-btn",
          attrs: {
            "to": {
              name: 'OrdersProgressDetail',
              params: {
                filterOrdereDate: props.rowData,
                showAdvanceMain: _vm.showAdvance
              }
            },
            "tag": "button"
          }
        }, [_c('span', {
          staticClass: "table-btn-icon"
        })]) : _vm._e(), _vm._v(" "), (_vm.window.width < 1200) ? _c('router-link', {
          staticClass: "btn table-btn verDetalle",
          attrs: {
            "to": {
              name: 'OrdersProgressDetail',
              params: {
                filterOrdereDate: props.rowData,
                showAdvanceMain: _vm.showAdvance
              }
            },
            "tag": "button"
          }
        }, [_c('span', {
          staticStyle: {
            "color": "#364A5D",
            "font-size": "14px",
            "font-weight": "bold"
          }
        }, [_vm._v("Ver detalles")])]) : _vm._e()], 1)])]
      }
    }])
  })], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header title-boreder"
  }, [_c('h3', {
    staticClass: "box-title title"
  }, [_vm._v("Avance de pedidos")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "box-title box-title-sub"
  }, [_c('img', {
    staticClass: "icon-space",
    staticStyle: {
      "padding-bottom": "7px"
    },
    attrs: {
      "src": "/static/img/icons/search.png"
    }
  }), _vm._v("Buscar Resultados\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "icon-calendar"
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "dtDateRange",
      "mode": "text"
    }
  })])
}]}

/***/ }),
/* 504 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('aside', {
    staticClass: "main-sidebar",
    attrs: {
      "id": "slider"
    }
  }, [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "sidebar"
  }, [_c('ul', {
    staticClass: "sidebar-menu",
    attrs: {
      "data-widget": "tree"
    }
  }, _vm._l((_vm.slideMenuItems), function(item, index) {
    return _c('va-slide-orange-item', {
      key: index,
      attrs: {
        "data": item,
        "type": item.type,
        "isHeader": item.isHeader,
        "icon": item.icon,
        "name": item.name,
        "badge": item.badge,
        "items": item.items,
        "router": item.router,
        "link": item.link
      }
    })
  }), 1)]), _vm._v(" "), _c('div', {
    staticClass: "logout"
  }, [_c('ul', {
    staticClass: "sidebar-menu"
  }, [_c('li', {
    staticClass: "menu-logout"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Logout'
      }
    }
  }, [_c('div', [_c('img', {
    staticClass: "logout-icon"
  })]), _vm._v(" "), _c('span', {
    staticClass: "side-parent"
  }, [_vm._v("Cerrar Sesión")])])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "close-slider"
  }, [_c('img', {
    staticClass: "ico-close",
    attrs: {
      "src": "/static/img/svg/close.svg"
    },
    on: {
      "click": function($event) {
        return _vm.closeSlider()
      }
    }
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('img', {
    staticClass: "logo-icon",
    attrs: {
      "src": "/static/img/icons/ic_dinet_logo.png"
    }
  })])
}]}

/***/ }),
/* 505 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box box-success"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "filterContainer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 divAccountSelectInventory"
  }, [_c('div', {
    staticClass: "form-group",
    attrs: {
      "id": "divAccountSelect"
    }
  }, [_c('label', [_vm._v("Cuenta")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "value": this.selectedAccount,
      "selectLabel": "",
      "selectedLabel": "",
      "deselectLabel": "",
      "track-by": "name",
      "placeholder": this.selectedAccount.name,
      "allow-empty": false,
      "label": "name",
      "options": this.optionsAccount
    },
    on: {
      "input": _vm.onAccountSelect
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("\r\n                  No se encontraron resultados\r\n                ")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 form-interspace"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "ddlYear"
    }
  }, [_vm._v("Año")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedYear),
      expression: "selectedYear"
    }],
    staticClass: "form-control minimal",
    attrs: {
      "id": "ddlYear"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedYear = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.loadTableData()
      }]
    }
  }, _vm._l((this.optionsYear), function(year) {
    return _c('option', {
      key: year,
      domProps: {
        "value": year
      }
    }, [_vm._v("\r\n                  " + _vm._s(year) + "\r\n                ")])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 form-interspace"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "ddlMonth"
    }
  }, [_vm._v("Mes")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedMonth),
      expression: "selectedMonth"
    }],
    staticClass: "form-control minimal",
    attrs: {
      "id": "ddlMonth"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedMonth = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.loadTableData()
      }]
    }
  }, _vm._l((this.optionsMonth), function(month) {
    return _c('option', {
      key: month.value,
      domProps: {
        "value": month.value
      }
    }, [_vm._v("\r\n                  " + _vm._s(month.name) + "\r\n                ")])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 form-interspace"
  }, [_c('div', {
    staticClass: "form-group pull-left",
    staticStyle: {
      "padding-top": "25px"
    }
  }, [_c('router-link', {
    staticClass: "btn btn-success",
    attrs: {
      "to": {
        name: 'InventoryEntry',
        params: {
          period: (this.selectedYear + '' + this.selectedMonth),
          accountCode: this.selectedAccount.code
        }
      },
      "tag": "button"
    }
  }, [_vm._v("Registrar ERI")])], 1)])])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12",
    attrs: {
      "id": "clientTable"
    }
  }, [_c('vuetable', {
    ref: "vuetable",
    attrs: {
      "id": "clientTable",
      "api-mode": false,
      "fields": _vm.tableFields,
      "data": _vm.tableData,
      "sort-order": _vm.tableSortOrder,
      "css": _vm.tableCSS.table,
      "noDataTemplate": "No se encontraron resultados"
    },
    on: {
      "vuetable:row-clicked": _vm.onClick,
      "vuetable:loading": _vm.onLoading,
      "vuetable:loaded": _vm.onLoaded
    },
    scopedSlots: _vm._u([{
      key: "accountCode",
      fn: function(props) {
        return _c('div', {
          attrs: {
            "id": "Cliente"
          }
        }, [_c('span', [_vm._v(_vm._s(props.rowData.accountCode))])])
      }
    }, {
      key: "cyclicalPercentage",
      fn: function(props) {
        return _c('div', {
          attrs: {
            "id": "Eri Cíclico"
          }
        }, [_c('span', [_vm._v(_vm._s(props.rowData.cyclicalPercentage))])])
      }
    }, {
      key: "locationPercentage",
      fn: function(props) {
        return _c('div', {
          attrs: {
            "id": "Eri Ubicación"
          }
        }, [_c('span', [_vm._v(_vm._s(props.rowData.locationPercentage))])])
      }
    }, {
      key: "unitPercentage",
      fn: function(props) {
        return _c('div', {
          attrs: {
            "id": "Eri Unidad"
          }
        }, [_c('span', [_vm._v(_vm._s(props.rowData.unitPercentage))])])
      }
    }])
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title title"
  }, [_vm._v("Inventario")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header title-boreder"
  }, [_c('h3', {
    staticClass: "box-title box-title-sub"
  }, [_c('img', {
    staticClass: "icon-space",
    staticStyle: {
      "padding-bottom": "7px"
    },
    attrs: {
      "src": "/static/img/icons/search.png"
    }
  }), _vm._v(" Buscar Inventario")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('br')])])
}]}

/***/ }),
/* 506 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "box box-success"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [(_vm.detailLayout) ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3 leftChart"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('chart-bar-eri', {
    attrs: {
      "chart-data": _vm.barChartData,
      "width": 50,
      "height": 280
    }
  })], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 text-center"
  }, [_c('i', {
    staticClass: "fa fa-tag",
    style: (_vm.formatAmountColor(this.fetchData.eriPercentageWarehouse))
  }), _vm._v(" "), _c('span', {
    staticClass: "span-value",
    style: (_vm.formatAmountColor(this.fetchData.eriPercentageWarehouse))
  }, [_vm._v("\n                  " + _vm._s(_vm._f("formatDecimal")((this.fetchData.eriPercentageWarehouse || 0))) + "%\n                ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 chartPadding"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('chart-line-eri', {
    attrs: {
      "chart-data": _vm.lineChartData,
      "height": 240
    }
  })], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "center-block",
    staticStyle: {
      "width": "240px"
    }
  }, [_c('div', {
    staticClass: "pull-left text-center",
    staticStyle: {
      "width": "120px",
      "border-right": "1px solid #eee"
    }
  }, [_c('img', {
    staticStyle: {
      "vertical-align": "text-bottom"
    },
    attrs: {
      "src": "/static/img/icons/ic_storage_arrived@3x.png",
      "alt": "Recibidos",
      "height": "20",
      "width": "20"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "span-value",
    style: (_vm.formatAmountColor(this.fetchData.eriPercentageWarehouse))
  }, [_vm._v("\n                      " + _vm._s(_vm._f("formatAmount")(this.fetchData.skuSquareQuantityWarehouse))), _c('span', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v(" " + _vm._s(this.fetchData.minimumStockUnit))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "span-status"
  }, [_vm._v("SKU Cant.")]), _vm._v(" "), _c('span', {
    staticClass: "span-status"
  }, [_vm._v("Cuadradas")])]), _vm._v(" "), _c('div', {
    staticClass: "pull-right text-center",
    staticStyle: {
      "width": "120px"
    }
  }, [_c('i', {
    staticClass: "fa fa-bullseye"
  }), _vm._v(" "), _c('span', {
    staticClass: "span-value"
  }, [_vm._v("\n                      " + _vm._s(_vm._f("formatAmount")(this.fetchData.skuInventoryQuantityWarehouse))), _c('span', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v(" " + _vm._s(this.fetchData.minimumStockUnit))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "span-status"
  }, [_vm._v("SKU Cant.")]), _vm._v(" "), _c('span', {
    staticClass: "span-status"
  }, [_vm._v("Inventariadas")])])])])])])])]) : _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('chart-bar-eri', {
    attrs: {
      "chart-data": _vm.barChartData,
      "width": 50,
      "height": 280
    }
  })], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 text-center"
  }, [_c('i', {
    staticClass: "fa fa-tag",
    style: (_vm.formatAmountColor(this.fetchData.eriPercentageWarehouse))
  }), _vm._v(" "), _c('span', {
    staticClass: "span-value",
    style: (_vm.formatAmountColor(this.fetchData.eriPercentageWarehouse))
  }, [_vm._v("\n                  " + _vm._s(_vm._f("formatDecimal")((this.fetchData.eriPercentageWarehouse || 0))) + "%\n                ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('div', {
    staticClass: "center-block",
    staticStyle: {
      "width": "240px",
      "padding-top": "120px"
    }
  }, [_c('div', {
    staticClass: "pull-left text-center",
    staticStyle: {
      "width": "120px",
      "border-right": "1px solid #eee"
    }
  }, [_c('img', {
    staticStyle: {
      "vertical-align": "text-bottom"
    },
    attrs: {
      "src": "/static/img/icons/ic_storage_arrived@3x.png",
      "alt": "ERI",
      "height": "20",
      "width": "20"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "span-value",
    style: (_vm.formatAmountColor(this.fetchData.eriPercentageWarehouse))
  }, [_vm._v("\n                  " + _vm._s(_vm._f("formatAmount")(this.fetchData.skuSquareQuantityWarehouse))), _c('span', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v(" " + _vm._s(this.fetchData.minimumStockUnit))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "span-status"
  }, [_vm._v("SKU Cant.")]), _vm._v(" "), _c('span', {
    staticClass: "span-status"
  }, [_vm._v("Cuadradas")])]), _vm._v(" "), _c('div', {
    staticClass: "pull-right text-center",
    staticStyle: {
      "width": "120px"
    }
  }, [_c('i', {
    staticClass: "fa fa-bullseye"
  }), _vm._v(" "), _c('span', {
    staticClass: "span-value"
  }, [_vm._v("\n                  " + _vm._s(_vm._f("formatAmount")(this.fetchData.skuInventoryQuantityWarehouse))), _c('span', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v(" " + _vm._s(this.fetchData.minimumStockUnit))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "span-status"
  }, [_vm._v("SKU Cant.")]), _vm._v(" "), _c('span', {
    staticClass: "span-status"
  }, [_vm._v("Inventariadas")])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title box-title-sub"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/icons/eri_ciclico.png"
    }
  }), _vm._v(" ERI Cíclico")])])
}]}

/***/ }),
/* 507 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('modal', {
    attrs: {
      "id": "fotos",
      "name": "fotos"
    }
  }, [_c('div', {
    staticClass: "box-header title-boreder"
  }, [_c('div', {
    staticClass: "box-title box-title-sub"
  }, [_c('img', {
    staticStyle: {
      "padding-bottom": "6px",
      "padding-right": "8px"
    },
    attrs: {
      "src": "/static/img/icons/ic_photos.png"
    }
  }), _vm._v(" "), _c('span', [_vm._v("ver fotos")])]), _vm._v(" "), _c('button', {
    staticClass: "close",
    staticStyle: {
      "padding": "5px"
    },
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.$modal.hide('fotos')
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body text-center"
  }, [(_vm.window.width > 768) ? _c('carousel', {
    attrs: {
      "perPageCustom": [
        [768, 1],
        [1024, 1]
      ],
      "paginationSize": 12,
      "paginationActiveColor": '#D3D8DC'
    }
  }, _vm._l((_vm.fotos), function(foto, fotosIndex) {
    return _c('slide', {
      key: fotosIndex
    }, [_c('img', {
      staticClass: "textUbication foto-style",
      attrs: {
        "src": 'data:image/png;base64,' + foto
      }
    })])
  }), 1) : _vm._e(), _vm._v(" "), (_vm.window.width < 768) ? _c('carousel', {
    attrs: {
      "perPageCustom": [
        [320, 1],
        [320 ]
      ],
      "paginationSize": 12,
      "paginationActiveColor": '#D3D8DC'
    }
  }, _vm._l((_vm.fotos), function(foto, fotosIndex) {
    return _c('slide', {
      key: fotosIndex
    }, [_c('img', {
      staticClass: "textUbication foto-style",
      attrs: {
        "src": 'data:image/png;base64,' + foto
      }
    })])
  }), 1) : _vm._e()], 1)]), _vm._v(" "), (_vm.window.width > 510) ? _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title title",
    staticStyle: {
      "color": "#959FA9"
    }
  }, [_vm._v("Seguimiento de documento")]), _vm._v(" "), _c('h3', {
    staticClass: "box-title title"
  }, [(_vm.window.width > 501) ? _c('span', {
    staticClass: "table-btn-icon"
  }) : _vm._e(), _vm._v(" " + _vm._s(_vm.document.documentTypeName))])]) : _vm._e(), _vm._v(" "), (_vm.window.width < 510) ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('h3', {
    staticClass: "box-title title",
    staticStyle: {
      "margin-top": "0px"
    }
  }, [_vm._v(_vm._s(_vm.document.documentTypeName))])])])]) : _vm._e(), _vm._v(" "), _c('div', {}, [_c('router-link', {
    attrs: {
      "to": {
        name: 'DocumentSearch',
        params: {
          selectedAccount: this.selectedAccount,
          tracking: true,
          showAdvance: this.$route.params.showAdvanceMain
        }
      }
    }
  }, [_c('button', {
    class: 'btn btn-sm btn-success btnAction btn-search',
    staticStyle: {
      "margin-bottom": "30px",
      "width": "130px !important"
    }
  }, [_c('img', {
    staticClass: "icon-space",
    staticStyle: {
      "padding-bottom": "7px"
    },
    attrs: {
      "src": "/static/img/icons/ic_back.png"
    }
  }), _vm._v("Regresar")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "box box-success"
  }, [_c('div', {
    staticClass: "box-header title-boreder",
    staticStyle: {
      "padding-top": "12px !important",
      "height": "50px !important"
    }
  }, [_c('h3', {
    staticClass: "box-title box-title-sub"
  }, [_c('img', {
    staticStyle: {
      "padding-bottom": "6px"
    },
    attrs: {
      "src": "/static/img/icons/ic_doc2.png"
    }
  }), _vm._v(" "), _c('strong', {
    staticStyle: {
      "text-tranform": "uppercase"
    }
  }, [_vm._v(_vm._s(_vm.document.documentTypeName + ' :'))]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.document.documentNumber))])])]), _vm._v(" "), _c('div', {
    staticClass: "title-boreder",
    staticStyle: {
      "padding-top": "12px !important",
      "height": "70px !important"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('span', {
    staticClass: "client-box-title-side",
    staticStyle: {
      "color": "#009D00"
    }
  }, [_vm._v(_vm._s(_vm.document.supplierCustomerDescription))])])])]), _vm._v(" "), _c('div', {
    staticClass: "title-boreder",
    staticStyle: {
      "padding-top": "12px",
      "padding-bottom": "12px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4",
    staticStyle: {
      "font-size": "18px",
      "text-align": "center",
      "color": "#364A5D"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "18px",
      "color": "#364A5D"
    }
  }, [_vm._v(_vm._s(_vm.totalPackages)), _c('span', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v(" " + _vm._s(_vm.minimumStockUnit))])]), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    staticStyle: {
      "font-size": "18px",
      "text-align": "center",
      "color": "#364A5D"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "18px",
      "color": "#364A5D"
    }
  }, [_vm._v(_vm._s(_vm._f("formatWeightKg")(_vm.totalWeight)))]), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    staticStyle: {
      "font-size": "18px",
      "text-align": "center",
      "color": "#364A5D"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "18px",
      "color": "#364A5D"
    }
  }, [_vm._v(_vm._s(_vm._f("formatVolM")(_vm.totalVolume)))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "block",
      "font-size": "10px",
      "font-weight": "bold"
    }
  }, [_vm._v(" Volumen ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "title-boreder",
    staticStyle: {
      "font-size": "18px",
      "text-align": "center",
      "color": "#364A5D",
      "padding-top": "12px",
      "padding-bottom": "12px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('span', [_c('img', {
    staticStyle: {
      "padding-bottom": "5px"
    },
    attrs: {
      "src": "/static/img/icons/ic_calendar.png"
    }
  }), _vm._v(" " + _vm._s(_vm._f("formatDate")(_vm.document.documentDate, 'DD/MM/YYYY')))]), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [(_vm.orderDeliveryDateConvert >= '2000') ? _c('span', [_c('img', {
    staticStyle: {
      "padding-bottom": "4px"
    },
    attrs: {
      "src": "/static/img/icons/ic_car.png"
    }
  }), _vm._v(" " + _vm._s(_vm._f("formatDate")(_vm.document.orderDeliveryDate, 'DD/MM/YYYY')))]) : _c('span', [_c('img', {
    staticStyle: {
      "padding-bottom": "4px"
    },
    attrs: {
      "src": "/static/img/icons/ic_car.png"
    }
  }), _vm._v(" __/__/____")]), _vm._v(" "), _vm._m(5)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [(_vm.orderDeliveryDateConvert >= '2000') ? _c('span', [_c('img', {
    staticStyle: {
      "padding-bottom": "3px"
    },
    attrs: {
      "src": "/static/img/icons/ic_time.png"
    }
  }), _vm._v(" " + _vm._s(_vm._f("formatDate")(_vm.document.orderDeliveryDate, 'HH:mm')))]) : _c('span', [_c('img', {
    staticStyle: {
      "padding-bottom": "3px"
    },
    attrs: {
      "src": "/static/img/icons/ic_time.png"
    }
  }), _vm._v("__:__")]), _vm._v(" "), _vm._m(6)])])])])]), _vm._v(" "), ((this.indicatorViewOrder)) ? _c('div', {
    staticClass: "title-boreder",
    staticStyle: {
      "padding-top": "12px",
      "padding-bottom": "12px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4",
    staticStyle: {
      "font-size": "18px",
      "text-align": "center",
      "color": "#364A5D"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "18px",
      "color": "#364A5D"
    }
  }, [_vm._v(_vm._s(_vm.orderType))]), _vm._v(" "), _vm._m(7)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8",
    staticStyle: {
      "font-size": "18px",
      "text-align": "center",
      "color": "#364A5D"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "18px",
      "color": "#364A5D"
    }
  }, [_vm._v(_vm._s(_vm.trackingNumber))]), _vm._v(" "), _vm._m(8)])])]) : _vm._e(), _vm._v(" "), ((this.indicatorViewAddress)) ? _c('div', {
    staticClass: "title-boreder",
    staticStyle: {
      "padding-top": "12px",
      "padding-bottom": "12px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4",
    staticStyle: {
      "font-size": "18px",
      "text-align": "center",
      "color": "#364A5D"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "18px",
      "color": "#364A5D"
    }
  }, [_vm._v(_vm._s(_vm.referenceDocumentNumber1))]), _vm._v(" "), _vm._m(9)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8",
    staticStyle: {
      "font-size": "18px",
      "text-align": "center",
      "color": "#364A5D"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "18px",
      "color": "#364A5D"
    }
  }, [_vm._v(_vm._s(_vm.address1))]), _vm._v(" "), _vm._m(10)])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('div', {
    staticClass: "box box-success",
    staticStyle: {
      "height": "385px !important"
    }
  }, [_vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('div', {
    staticStyle: {
      "border-bottom": "solid",
      "border-color": "#F6F6F6",
      "height": "100px !important"
    }
  }, [_c('div', {
    staticClass: "status-bar-"
  }, [_c('strong', {
    staticClass: "status-bar-title-percentage"
  }, [_vm._v(_vm._s(_vm.document.progress) + "%")]), _vm._v(" "), _c('strong', {
    staticClass: "status-bar-title"
  }, [_vm._v(_vm._s(_vm.document.status))])]), _vm._v(" "), (_vm.document.progress) ? _c('div', {
    staticClass: "progress status-bar"
  }, [_c('div', {
    class: 'progress-bar progress-bar-' + _vm.formatProgress(_vm.document.progress),
    style: ('width:' + _vm.document.progress + '%'),
    attrs: {
      "role": "progressbar",
      "aria-valuenow": _vm.document.progress,
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "arkano-stepper",
    staticStyle: {
      "padding-top": "18px"
    }
  }, _vm._l((_vm.document.states), function(state, stateIndex) {
    return _c('div', {
      key: stateIndex,
      staticClass: "arkano-stepper-item"
    }, [_c('div', {
      staticClass: "arkano-stepper-label estateLine",
      staticStyle: {
        "color": "#364A5D"
      }
    }, [_c('strong', [_vm._v(_vm._s(state.name))])]), _vm._v(" "), _c('div', {
      class: _vm.stateCondition(state)
    }, [(state.done) ? _c('div', {
      staticClass: "arkano-stepper-check-border-true",
      staticStyle: {
        "background": "#364A5D"
      }
    }, [_c('img', {
      attrs: {
        "src": "/static/img/icons/ic_check_blue.png"
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.stateApply.name === state.name) ? _c('div', {
      staticClass: "arkano-stepper-check-border-next"
    }, [_c('img', {
      attrs: {
        "src": "/static/img/icons/oval_2x.png"
      }
    })]) : _vm._e(), _vm._v(" "), (!state.done && _vm.stateApply.name !== state.name) ? _c('div', {
      staticClass: "arkano-stepper-check-border-next"
    }, [_c('img', {
      attrs: {
        "src": "/static/img/icons/oval_2x.png"
      }
    })]) : _vm._e()]), _vm._v(" "), (state.done) ? _c('div', {
      staticClass: "arkano-stepper-label-bottom"
    }, [_c('strong', {
      staticStyle: {
        "color": "#364A5D"
      }
    }, [_vm._v(_vm._s(_vm._f("formatDate")(state.date, 'DD/MM/YYYY')))]), _c('br'), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "#364A5D"
      }
    }, [_vm._v(_vm._s(_vm._f("formatDate")(state.date, 'HH:mm')))])]) : _vm._e(), _vm._v(" "), (!state.done) ? _c('div', {
      staticClass: "arkano-stepper-label-bottom"
    }, [_c('strong', {
      staticStyle: {
        "color": "#364A5D",
        "opacity": "0.3"
      }
    }, [_vm._v("__/__/____")]), _c('br'), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "#364A5D",
        "opacity": "0.3"
      }
    }, [_vm._v("__:__")])]) : _vm._e()])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "box-success"
  }, [_vm._m(13), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('carousel', {
    class: 'stepper-principal-box title-boreder',
    attrs: {
      "perPageCustom": [
        [768, 1],
        [1024, 6]
      ],
      "paginationSize": 12,
      "paginationActiveColor": '#D3D8DC'
    }
  }, _vm._l((_vm.document.events), function(event, eventIndex) {
    return _c('slide', {
      key: eventIndex,
      staticClass: "stepper-events-item"
    }, [_c('div', {
      staticClass: "stepper-check-events"
    }, [_c('div', {
      staticClass: "stepper-top-circle"
    }, [_c('div', {
      class: ((_vm.selectedEvent === eventIndex) ? 'stepper-item-circle-btn-select selected' : 'stepper-item-circle-btn-noselect'),
      on: {
        "click": function($event) {
          return _vm.showDetail(eventIndex, false)
        }
      }
    }, [_c('img', {
      staticStyle: {
        "vertical-align": "middle"
      },
      attrs: {
        "src": (_vm.selectedEvent === eventIndex) ? '/static/img/icons/ic_calendar_white.png' : '/static/img/icons/ic_calendar_black.png'
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "vl"
    }), _vm._v(" "), _c('div', {
      class: 'stepper-item-box ' + ((_vm.selectedEvent === eventIndex) ? ' stepper-box-back-select' : ' stepper-box-back-noselect'),
      on: {
        "click": function($event) {
          return _vm.showDetail(eventIndex, false)
        }
      }
    }, [_c('div', {
      staticStyle: {
        "padding-top": "8px"
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "24px"
      }
    }, [_vm._v(_vm._s(_vm._f("formatDate")(event.date, 'DD/MM/YYYY')))]), _c('br'), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-size": "15px"
      }
    }, [_vm._v(_vm._s(_vm._f("formatDate")(event.date, 'HH:mm')))]), _c('br'), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-size": "12px",
        "font-weight": "900"
      }
    }, [_vm._v(_vm._s(event.name))]), _c('br')])]), _vm._v(" "), _c('div', {
      class: 'stepper-item-box-arrow ' + ((_vm.selectedEvent === eventIndex) ? 'stepper-item-box-arrow-bg' : '')
    })])
  }), 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('h3', {
    staticClass: "box-title-sub",
    staticStyle: {
      "texrt-transform": "uppercase",
      "color": "#009D00",
      "font-weight": "bold",
      "font-family": "'Avenir', 'Arial'"
    }
  }, [_c('strong', [_vm._v("EVENTO: " + _vm._s(_vm.document.events[_vm.selectedEvent].name))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticStyle: {
      "text-align": "center",
      "padding-top": "20px !important"
    }
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('img', {
    staticStyle: {
      "padding-bottom": "10px",
      "padding-right": "8px"
    },
    attrs: {
      "src": "/static/img/icons/ic_calendar.png"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "26px"
    }
  }, [_vm._v(_vm._s(_vm._f("formatDate")(_vm.document.events[_vm.selectedEvent].date, 'DD/MM/YYYY')))]), _c('br'), _vm._v(" "), _vm._m(14)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('img', {
    staticStyle: {
      "padding-bottom": "10px",
      "padding-right": "8px"
    },
    attrs: {
      "src": "/static/img/icons/ic_time.png"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "26px"
    }
  }, [_vm._v(_vm._s(_vm._f("formatDate")(_vm.document.events[_vm.selectedEvent].date, 'HH:mm')))]), _c('br'), _vm._v(" "), _vm._m(15)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [(_vm.ubicationState) ? _c('div', [_c('img', {
    staticStyle: {
      "padding-bottom": "10px",
      "padding-right": "8px"
    },
    attrs: {
      "src": "/static/img/icons/ic_location.png"
    }
  }), _c('a', {
    staticClass: "modal-fotos",
    staticStyle: {
      "font-size": "26px"
    },
    on: {
      "click": function($event) {
        return _vm.onUbicationModal()
      }
    }
  }, [_vm._v(_vm._s(_vm.ubicacionStatus))])]) : _vm._e(), _vm._v(" "), (!_vm.ubicationState) ? _c('div', [_c('img', {
    staticStyle: {
      "padding-bottom": "10px",
      "padding-right": "8px"
    },
    attrs: {
      "src": "/static/img/icons/ic_location.png"
    }
  }), _c('a', {
    staticClass: "modal-fotos",
    staticStyle: {
      "font-size": "26px",
      "color": "black !important"
    }
  }, [_vm._v("Ubicación no disponible")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', [(!_vm.fotoEnable) ? _c('img', {
    staticStyle: {
      "padding-bottom": "10px",
      "padding-right": "8px"
    },
    attrs: {
      "src": "/static/img/icons/ic_photos.png"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.fotoEnable) ? _c('span', {
    staticClass: "modal-fotos",
    staticStyle: {
      "font-size": "26px"
    }
  }, [_vm._v("Fotos no disponible")]) : _vm._e(), _vm._v(" "), (_vm.fotoEnable) ? _c('img', {
    staticStyle: {
      "padding-bottom": "10px",
      "padding-right": "8px"
    },
    attrs: {
      "src": "/static/img/icons/ic_photos.png"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.fotoEnable) ? _c('a', {
    staticClass: "modal-fotos",
    staticStyle: {
      "font-size": "26px"
    },
    on: {
      "click": function($event) {
        return _vm.modalFotos()
      }
    }
  }, [_vm._v("ver fotos")]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "20px !important"
    }
  }, [_c('h3', {
    staticClass: "box-title box-title-sub",
    staticStyle: {
      "text-transform": "uppercase",
      "color": "#4F6071",
      "font-size": "15px",
      "font-weight": "bold"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.document.events[0].name + ': PRODUCTOS'))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12",
    attrs: {
      "id": "detail"
    }
  }, [_c('vuetable', {
    key: _vm.tableKey,
    ref: "vuetable",
    attrs: {
      "id": "detail",
      "api-mode": false,
      "fields": _vm.tableFields,
      "css": _vm.tableCSS.table,
      "noDataTemplate": "No se encontraron resultados",
      "data": _vm.tableData,
      "data-manager": _vm.dataManager,
      "pagination-path": "pagination"
    },
    on: {
      "vuetable:pagination-data": _vm.onPaginationData
    },
    scopedSlots: _vm._u([{
      key: "description",
      fn: function(props) {
        return _c('div', {
          attrs: {
            "id": "Descripción"
          }
        }, [_c('span', [_vm._v(_vm._s(props.rowData.description))])])
      }
    }, {
      key: "provider",
      fn: function(props) {
        return _c('div', {
          attrs: {
            "id": "Proveedor"
          }
        }, [_c('span', [_vm._v(_vm._s(props.rowData.provider))])])
      }
    }, {
      key: "totalPackages",
      fn: function(props) {
        return _c('div', {
          attrs: {
            "id": "Cantidad"
          }
        }, [_c('span', [_vm._v(_vm._s(props.rowData.amount)), _c('span', {
          staticStyle: {
            "font-size": "12px"
          }
        }, [_vm._v(" " + _vm._s(_vm.minimumStockUnit))])])])
      }
    }, {
      key: "weight",
      fn: function(props) {
        return _c('div', {
          attrs: {
            "id": "Peso"
          }
        }, [_c('span', [_vm._v(_vm._s(_vm.formatWeightKg(props.rowData.weight)))])])
      }
    }, {
      key: "volume",
      fn: function(props) {
        return _c('div', {
          attrs: {
            "id": "Volumen"
          }
        }, [_c('span', [_vm._v(_vm._s(_vm.formatVolM1(props.rowData.volume)))])])
      }
    }])
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_vm._v("\n             \n            "), (this.paginationData && _vm.paginationData.total > 0) ? [_c('strong', {
    staticStyle: {
      "color": "#364A5D",
      "paddin-left": "15px"
    }
  }, [_vm._v("\n              Mostrando documento " + _vm._s(this.paginationData.from) + " a " + _vm._s(this.paginationData.to) + " de " + _vm._s(this.paginationData.total) + " en Total\n              ")])] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('vuetable-pagination', {
    ref: "pagination",
    attrs: {
      "css": _vm.tableCSS.pagination
    },
    on: {
      "vuetable-pagination:change-page": _vm.onChangePage
    }
  })], 1)])], 1)]), _vm._v(" "), _c('modal', {
    attrs: {
      "id": "ubication",
      "name": "ubication"
    }
  }, [_c('div', {
    staticClass: "box-header title-boreder"
  }, [_c('div', {
    staticClass: "box-title box-title-sub"
  }, [_c('img', {
    staticStyle: {
      "padding-bottom": "6px",
      "padding-right": "8px"
    },
    attrs: {
      "src": "/static/img/icons/ic_location.png"
    }
  }), _vm._v(" "), _c('span', [_vm._v("ver ubicación")])]), _vm._v(" "), _c('button', {
    staticClass: "close",
    staticStyle: {
      "padding": "5px"
    },
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.$modal.hide('ubication')
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), (_vm.ubicationState) ? _c('div', [_c('gmap-map', {
    staticStyle: {
      "width": "100%",
      "height": "475px"
    },
    attrs: {
      "center": _vm.center,
      "zoom": _vm.zoom
    }
  }, [_c('gmap-marker', {
    attrs: {
      "position": this.center,
      "icon": "/static/img/icons/ic_truck_50.png"
    }
  })], 1)], 1) : _vm._e()])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-6"
  }, [_c('h3', {
    staticClass: "box-title title",
    staticStyle: {
      "color": "#959FA9",
      "margin-top": "0px"
    }
  }, [_vm._v("Seguimiento de documento")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-5"
  }, [_c('span', {
    staticClass: "box-title box-title-sub client-pro-side cliente-prov-size-respo"
  }, [_vm._v("Cliente/Proveedor: ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "display": "block",
      "font-size": "10px"
    }
  }, [_vm._v("Total"), _c('span', {
    staticStyle: {
      "font-size": "10px",
      "font-weight": "bold"
    }
  }, [_vm._v(" Cantidad ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "display": "block",
      "font-size": "10px"
    }
  }, [_vm._v(" Total "), _c('span', {
    staticStyle: {
      "font-size": "10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Peso ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "display": "block",
      "font-size": "10px"
    }
  }, [_vm._v("Fecha "), _c('span', {
    staticStyle: {
      "font-size": "10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Emisión")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "display": "block",
      "font-size": "10px"
    }
  }, [_vm._v("Fecha de "), _c('span', {
    staticStyle: {
      "font-size": "10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Entrega")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "display": "block",
      "font-size": "10px"
    }
  }, [_vm._v("Hora de "), _c('span', {
    staticStyle: {
      "font-size": "10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Entrega")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "display": "block",
      "font-size": "10px"
    }
  }, [_vm._v("Tipo"), _c('span', {
    staticStyle: {
      "font-size": "10px",
      "font-weight": "bold"
    }
  }, [_vm._v(" Pedido")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "display": "block",
      "font-size": "10px"
    }
  }, [_vm._v(" Número "), _c('span', {
    staticStyle: {
      "font-size": "10px",
      "font-weight": "bold"
    }
  }, [_vm._v(" Tracking")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "display": "block",
      "font-size": "10px"
    }
  }, [_vm._v("Número"), _c('span', {
    staticStyle: {
      "font-size": "10px",
      "font-weight": "bold"
    }
  }, [_vm._v(" Referencia")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "display": "block",
      "font-size": "10px"
    }
  }, [_vm._v(" Dirección "), _c('span', {
    staticStyle: {
      "font-size": "10px",
      "font-weight": "bold"
    }
  }, [_vm._v(" Despacho")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header title-boreder"
  }, [_c('h3', {
    staticClass: "box-title box-title-sub"
  }, [_c('img', {
    staticStyle: {
      "padding-bottom": "5px",
      "padding-right": "8px"
    },
    attrs: {
      "src": "/static/img/icons/ic_estado.png"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("ESTADO")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header",
    staticStyle: {
      "height": "65px !important"
    }
  }, [_c('h3', {
    staticClass: "box-title box-title-sub"
  }, [_vm._v("AVANCE ESTADO")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title-boreder"
  }, [_c('h3', {
    staticClass: "box-title-sub",
    staticStyle: {
      "padding-top": "0px !important"
    }
  }, [_c('img', {
    staticStyle: {
      "padding-bottom": "4px",
      "padding-right": "5px"
    },
    attrs: {
      "src": "/static/img/icons/ic_time.png"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("EVENTOS")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "eventBorder"
  }, [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_vm._v("Fecha")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "eventBorder"
  }, [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_vm._v("Hora")])])
}]}

/***/ }),
/* 508 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box box-success"
  }, [_c('div', {
    staticClass: "box-header title-boreder"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('button', {
    staticClass: "btn btn-link btn-lg",
    on: {
      "click": function($event) {
        return _vm.advancedSearch()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-filter"
  }), _vm._v("  Avanzado")])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "filterContainer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group",
    attrs: {
      "id": "divAccount"
    }
  }, [_c('label', [_vm._v("Cuenta")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "value": this.selectedAccount,
      "selectLabel": "",
      "selectedLabel": "",
      "deselectLabel": "",
      "track-by": "name",
      "placeholder": this.selectedAccount.name,
      "allow-empty": false,
      "label": "name",
      "options": this.optionsAccount
    },
    on: {
      "input": _vm.onAccountSelect
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("\n                  No se encontraron resultados\n                ")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Tipo de Documento")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.documentType),
      expression: "documentType"
    }],
    staticClass: "form-control minimal",
    attrs: {
      "id": "ddlDocumentType"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.documentType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.onDocumentSelect]
    }
  }, _vm._l((this.optionDocumentType), function(type) {
    return _c('option', {
      key: type.code,
      domProps: {
        "value": type.code
      }
    }, [_vm._v("\n                  " + _vm._s(type.text) + "\n                ")])
  }), 0)])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Tipo Pedido")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.typeOrder),
      expression: "typeOrder"
    }],
    staticClass: "form-control minimal",
    attrs: {
      "id": "ddlTypeOrder"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.typeOrder = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((this.optionTypeOrder), function(type) {
    return _c('option', {
      key: type.code,
      domProps: {
        "value": type.code
      }
    }, [_vm._v("\n                  " + _vm._s(type.text) + "\n                ")])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Nro. de Documento")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.documentNumber),
      expression: "documentNumber"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "documentNumber"
    },
    domProps: {
      "value": (_vm.documentNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.documentNumber = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 pull-center",
    staticStyle: {
      "padding-top": "25px"
    }
  }, [_c('button', {
    staticClass: "btn btn-sm btn-success btnAction btn-search",
    on: {
      "click": function($event) {
        return _vm.search()
      }
    }
  }, [_vm._v(" Buscar")])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.showAdvance) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Nro. de Tracking")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.trackingNumber),
      expression: "trackingNumber"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "trackingNumber"
    },
    domProps: {
      "value": (_vm.trackingNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.trackingNumber = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Referencia de Pedido")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.referenceOrder),
      expression: "referenceOrder"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "referenceOrder"
    },
    domProps: {
      "value": (_vm.referenceOrder)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.referenceOrder = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group",
    attrs: {
      "id": "divClientSelect"
    }
  }, [_c('label', [_vm._v("Cliente/Proveedor")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "value": this.selectedClient,
      "selectLabel": "",
      "selectedLabel": "",
      "deselectLabel": "",
      "track-by": "code",
      "placeholder": this.selectedClient.text,
      "allow-empty": false,
      "label": "text",
      "options": this.optionsClient
    },
    on: {
      "input": _vm.onClientSelect
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("\n                    No se encontraron resultados\n                  ")])])], 1)])]) : _vm._e()])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "box box-success"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    attrs: {
      "id": "resultTable"
    }
  }, [_c('vuetable', {
    key: _vm.tableKey,
    ref: "vuetable",
    attrs: {
      "id": "resultTable",
      "api-mode": false,
      "fields": _vm.tableFields,
      "css": _vm.tableCSS.table,
      "noDataTemplate": "No se encontraron resultados",
      "data": _vm.tableData,
      "data-manager": _vm.dataManager,
      "pagination-path": "pagination"
    },
    on: {
      "vuetable:pagination-data": _vm.onPaginationData
    },
    scopedSlots: _vm._u([{
      key: "documentTypeCode",
      fn: function(props) {
        return [_c('div', {
          staticClass: "text-center"
        }, [(_vm.window.width > 750) ? _c('span', {
          class: _vm.documentTypeClass(props.rowData.documentTypeCode)
        }) : _vm._e()])]
      }
    }, {
      key: "documentTypeName",
      fn: function(props) {
        return [_c('div', {
          attrs: {
            "id": "TIPO"
          }
        }, [_c('span', [_vm._v(_vm._s(props.rowData.documentTypeName))])])]
      }
    }, {
      key: "documentNumber",
      fn: function(props) {
        return [_c('div', {
          attrs: {
            "id": "Número"
          }
        }, [_c('span', [_vm._v(_vm._s(props.rowData.documentNumber))])])]
      }
    }, {
      key: "documentDate",
      fn: function(props) {
        return [_c('div', {
          attrs: {
            "id": "Fecha"
          }
        }, [_c('span', [_vm._v(_vm._s(_vm._f("formatDate")(props.rowData.documentDate, "DD/MM/YYYY", true)))])])]
      }
    }, {
      key: "referenceOrder",
      fn: function(props) {
        return [_c('div', {
          attrs: {
            "id": "NumeroReferencia"
          }
        }, [_c('span', [_vm._v(_vm._s(props.rowData.referenceDocumentNumber1))])])]
      }
    }, {
      key: "trackingNumber",
      fn: function(props) {
        return [_c('div', {
          attrs: {
            "id": "NumeroTracking"
          }
        }, [_c('span', [_vm._v(_vm._s(props.rowData.trackingNumber))])])]
      }
    }, {
      key: "quantitiesDocument",
      fn: function(props) {
        return [_c('div', {
          attrs: {
            "id": "Cantidades",
            "align": "center"
          }
        }, [_c('span', [_vm._v(_vm._s(props.rowData.quantityComplete) + " / " + _vm._s(props.rowData.quantityTotal)), _c('span', {
          staticStyle: {
            "font-size": "12px"
          }
        }, [_vm._v(" " + _vm._s(props.rowData.minimumStockUnit))])])])]
      }
    }, {
      key: "supplierCustomerDescription",
      fn: function(props) {
        return [_c('div', {
          attrs: {
            "id": "Cliente"
          }
        }, [_c('span', [_vm._v(_vm._s(props.rowData.supplierCustomerDescription))])])]
      }
    }, {
      key: "progress",
      fn: function(props) {
        return [_c('div', {
          staticClass: "progressContainer text-center"
        }, [_c('div', [_c('strong', {
          staticClass: "progressInfo"
        }, [_vm._v(_vm._s(props.rowData.status) + " (" + _vm._s(props.rowData.progress) + "%)")])]), _vm._v(" "), _c('div', {
          staticClass: "progressBar"
        }, [(props.rowData.progress) ? _c('div', {
          staticClass: "progress table-bar-document"
        }, [_c('div', {
          class: 'progress-bar progress-bar-' + _vm.formatProgress(props.rowData.progress),
          style: ('width:' + props.rowData.progress + '%'),
          attrs: {
            "role": "progressbar",
            "aria-valuenow": props.rowData.progress,
            "aria-valuemin": "0",
            "aria-valuemax": "100"
          }
        })]) : _vm._e()])])]
      }
    }, {
      key: "tracking",
      fn: function(props) {
        return [(props.rowData.documentNumber) ? _c('div', {
          staticClass: "text-center botonVerDetalle2"
        }, [(_vm.window.width > 750) ? _c('router-link', {
          staticClass: "btn table-btn",
          attrs: {
            "to": {
              name: 'DocumentMonitoring',
              params: {
                selectedAccount: _vm.selectedAccount,
                documentNumber: props.rowData.documentNumber,
                documentType: props.rowData.documentTypeCode,
                minimumStockUnit: props.rowData.minimumStockUnit,
                address1: props.rowData.address1,
                trackingNumber: props.rowData.trackingNumber,
                referenceDocumentNumber1: props.rowData.referenceDocumentNumber1,
                codeOrderType: props.rowData.codeOrderType,
                orderType: props.rowData.orderType,
                showAdvanceMain: _vm.showAdvance
              }
            },
            "tag": "button"
          }
        }, [_c('span', {
          staticClass: "table-btn-icon"
        })]) : _vm._e(), _vm._v(" "), (_vm.window.width < 750) ? _c('router-link', {
          staticClass: "btn table-btn",
          attrs: {
            "to": {
              name: 'DocumentMonitoring',
              params: {
                selectedAccount: _vm.selectedAccount,
                documentNumber: props.rowData.documentNumber,
                documentType: props.rowData.documentTypeCode,
                minimumStockUnit: props.rowData.minimumStockUnit,
                address1: props.rowData.address1,
                trackingNumber: props.rowData.trackingNumber,
                referenceDocumentNumber1: props.rowData.referenceDocumentNumber1,
                codeOrderType: props.rowData.codeOrderType,
                orderType: props.rowData.orderType,
                showAdvanceMain: _vm.showAdvance
              }
            },
            "tag": "button"
          }
        }, [_c('span', {
          staticStyle: {
            "color": "#364A5D",
            "font-size": "14px",
            "font-weight": "bold"
          }
        }, [_vm._v("Ver detalles")])]) : _vm._e()], 1) : _vm._e()]
      }
    }])
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_vm._v("\n       \n      "), (this.paginationData && _vm.paginationData.total > 0) ? [_c('strong', {
    staticStyle: {
      "color": "#364A5D",
      "paddin-left": "15px"
    }
  }, [_vm._v("\n        Mostrando documento " + _vm._s(this.paginationData.from > 1 ? this.paginationData.from : this.paginationData.from + (_vm.pageNumber - 1) * 10) + " a " + _vm._s(this.paginationData.to * this.pageNumber) + " de " + _vm._s(this.paginationData.total) + " en Total\n        ")])] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('vuetable-pagination', {
    ref: "pagination",
    attrs: {
      "css": _vm.tableCSS.pagination
    },
    on: {
      "vuetable-pagination:change-page": _vm.onChangePage
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header title-boreder"
  }, [_c('h3', {
    staticClass: "box-title title"
  }, [_vm._v(" Seguimiento de documento")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "box-title box-title-sub"
  }, [_c('img', {
    staticClass: "icon-space",
    staticStyle: {
      "padding-bottom": "7px"
    },
    attrs: {
      "src": "/static/img/icons/search.png"
    }
  }), _vm._v("Buscar Documento\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', {
    attrs: {
      "for": "dtDateRange"
    }
  }, [_vm._v("Desde - Hasta")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "icon-calendar"
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "dtDateRange",
      "mode": "text"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header title-boreder"
  }, [_c('h3', {
    staticClass: "box-title box-title-sub"
  }, [_c('img', {
    staticClass: "icon-space",
    staticStyle: {
      "padding-bottom": "3px"
    },
    attrs: {
      "src": "/static/img/icons/result.png"
    }
  }), _vm._v(" "), _c('span', [_vm._v("BUSCAR DOCUMENTO")])])])
}]}

/***/ }),
/* 509 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper ati-wrapper",
    attrs: {
      "id": "content-wrap"
    }
  }, [_c('section', {
    ref: "contentContainer",
    staticClass: "content vld-parent"
  }, [_c('transition', {
    attrs: {
      "name": "page",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 510 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', _vm._g(_vm._b({
    ref: "input"
  }, 'input', _vm.$attrs, false), _vm.$listeners))
},staticRenderFns: []}

/***/ }),
/* 511 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.label)
    }
  }), _vm._v(" "), _c('input', {
    ref: "input",
    class: _vm.className,
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 512 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "main-header"
  }, [_c('nav', {
    staticClass: "navbar navbar-static-top",
    class: {
      'hidden-navbar': !_vm.showNavbar
    }
  }, [_c('img', {
    staticClass: "menu-ora",
    attrs: {
      "src": "/static/img/svg/menu.svg"
    },
    on: {
      "click": function($event) {
        return _vm.showSlider()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "navbar-custom-menu"
  }, [(_vm.window.width > 400) ? _c('label', {
    staticClass: "fechaNav",
    staticStyle: {
      "text-transform": "capitalize"
    }
  }, [_vm._v(_vm._s(_vm._f("formatDate")(new Date(), 'dddd DD')))]) : _vm._e(), _vm._v(" "), (_vm.window.width > 400) ? _c('label', {
    staticClass: "fechaNav",
    staticStyle: {
      "padding-left": "5px",
      "padding-right": "5px"
    }
  }, [_vm._v("de")]) : _vm._e(), _vm._v(" "), (_vm.window.width > 400) ? _c('label', {
    staticClass: "fechaNav",
    staticStyle: {
      "text-transform": "capitalize"
    }
  }, [_vm._v(_vm._s(_vm._f("formatDate")(new Date(), 'MMM YYYY')))]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav"
  }, [_c('li', {
    staticClass: "dropdown user user-menu dropdown-per"
  }, [_c('a', {
    staticClass: "dropdown-toggle nav-user-info",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown"
    }
  }, [_c('img', {
    staticClass: "user-image img-color",
    attrs: {
      "src": "/static/img/svg/people.svg",
      "alt": "User Image"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-xs user-label"
  }, [_vm._v(_vm._s(_vm.userInfo.name.toLowerCase().trim()) + " ")])])])])])])])
},staticRenderFns: []}

/***/ }),
/* 513 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "box box-success"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('chart-line', {
    attrs: {
      "chart-data": _vm.chartData,
      "height": 240
    }
  })], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "center-block",
    staticStyle: {
      "width": "300px"
    }
  }, [_c('div', {
    staticClass: "pull-left text-center",
    staticStyle: {
      "width": "150px",
      "border-right": "1px solid #eee"
    }
  }, [_c('img', {
    staticStyle: {
      "vertical-align": "text-bottom"
    },
    attrs: {
      "src": "/static/img/icons/ic_recived_containers@3x.png",
      "alt": "Recibidos",
      "height": "20",
      "width": "20"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "span-value",
    style: ({
      color: this.colorReceived
    })
  }, [_vm._v("\n                    " + _vm._s(_vm._f("formatAmount")(this.fetchData.containersReceivedTemporaryDeposit)) + "\n                  ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "span-unit"
  }, [_vm._v("Contenedores")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "span-status"
  }, [_vm._v("Recibidos")])]), _vm._v(" "), _c('div', {
    staticClass: "pull-right text-center",
    staticStyle: {
      "width": "150px"
    }
  }, [_c('img', {
    staticStyle: {
      "vertical-align": "text-bottom"
    },
    attrs: {
      "src": "/static/img/icons/ic_recived_shipped@3x.png",
      "alt": "Despachados",
      "height": "20",
      "width": "20"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "span-value",
    style: ({
      color: this.colorShipped
    })
  }, [_vm._v("\n                    " + _vm._s(_vm._f("formatAmount")(this.fetchData.containersShippedTemporaryDeposit)) + "\n                  ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "span-unit"
  }, [_vm._v("Contenedores")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "span-status"
  }, [_vm._v("Despachados")])])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title box-title-sub"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/icons/deposito_legal.png"
    }
  }), _vm._v(" Depósito Temporal")])])
}]}

/***/ }),
/* 514 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.exists) ? _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "container-tra"
  }, [_c('div', {
    staticClass: "msg-order"
  }, [(_vm.mobile) ? _c('div', [_c('img', {
    staticClass: "img-nf",
    attrs: {
      "src": "/static/img/noencontrado.png"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "title-nf"
  }, [_vm._v("\n            No hemos podido encontrar tu pedido\n          ")]), _vm._v(" "), _c('p', {
    staticClass: "p-nf"
  }, [_vm._v("\n            Comunicate con nosotros para brindarte información de tu pedido\n          ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-ora",
    staticStyle: {
      "width": "200px"
    },
    on: {
      "click": function($event) {
        return _vm.contact()
      }
    }
  }, [_vm._v("Contáctate con nosotros")])]), _vm._v(" "), (!_vm.mobile) ? _c('div', [_c('img', {
    staticClass: "img-nf",
    attrs: {
      "src": "/static/img/noencontrado.png"
    }
  })]) : _vm._e()])])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 515 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c(_vm.layout, {
    tag: "component"
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 516 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "box-header title-boreder"
  }, [_c('h3', {
    staticClass: "box-title title"
  }, [_vm._v(" Citas de Despacho  "), _vm._m(0), _vm._v(" " + _vm._s(this.accountName))])]), _vm._v(" "), _c('div', {
    staticClass: "box box-success"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Seleccione un archivo")]), _vm._v(" "), _c('input', {
    ref: "file",
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "id": "file"
    },
    on: {
      "change": function($event) {
        return _vm.handleFileUpload()
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fileValidation !== ''),
      expression: "fileValidation !== ''"
    }],
    staticClass: "invalid-feedback"
  }, [_vm._v(_vm._s(this.fileValidation))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1 form-interspace"
  }, [_c('div', {
    staticClass: "form-group",
    staticStyle: {
      "padding-top": "25px"
    }
  }, [_c('button', {
    staticClass: "btn btn-sm btn-success",
    staticStyle: {
      "width": "70px"
    },
    on: {
      "click": function($event) {
        return _vm.handleUpload()
      }
    }
  }, [_vm._v("Cargar")])])]), _vm._v(" "), (this.uploadData !== null) ? _c('div', {
    staticClass: "col-md-1 form-interspace"
  }, [_c('div', {
    staticClass: "form-group",
    staticStyle: {
      "padding-top": "25px"
    }
  }, [_c('button', {
    staticClass: "btn btn-sm btn-success",
    staticStyle: {
      "width": "70px"
    },
    on: {
      "click": function($event) {
        return _vm.handleSubmit()
      }
    }
  }, [_vm._v("Registrar")])])]) : _vm._e()]), _vm._v(" "), (this.tableData) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('vuetable', {
    ref: "vuetable",
    attrs: {
      "id": "dispatchTable",
      "api-mode": false,
      "fields": _vm.tableFields,
      "data": _vm.tableData,
      "css": _vm.tableCSS.table
    }
  })], 1)])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "box-title title"
  }, [_c('span', {
    staticClass: "table-btn-icon"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header title-boreder"
  }, [_c('h3', {
    staticClass: "box-title box-title-sub"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/icons/entregadas.png"
    }
  }), _vm._v(" Cargar Citas ")])])
}]}

/***/ }),
/* 517 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box box-success"
  }, [(_vm.fetchData !== null) ? _c('div', {
    staticClass: "box-header title-boreder"
  }, [_c('h3', {
    staticClass: "box-title box-title-sub"
  }, [_c('i', {
    staticClass: "Inventory-icon",
    staticStyle: {
      "padding-bottom": "20px"
    }
  }), _vm._v(" INVENTARIO AL " + _vm._s(_vm._f("formatDate")(_vm.fetchData.inventoryDate, 'L')))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group",
    attrs: {
      "id": "divAccountSelect"
    }
  }, [_c('label', [_vm._v("Cuenta")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "value": this.selectedAccount,
      "selectLabel": "",
      "selectedLabel": "",
      "deselectLabel": "",
      "track-by": "name",
      "placeholder": this.selectedAccount.name,
      "allow-empty": false,
      "label": "name",
      "options": this.optionsAccount
    },
    on: {
      "input": _vm.onAccountSelect
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("\r\n                No se encontraron resultados\r\n              ")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group",
    attrs: {
      "id": "divInvProductSelect"
    }
  }, [_c('label', [_vm._v("Producto")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "value": this.selectedProduct,
      "selectLabel": "Seleccionar producto",
      "selectedLabel": "Producto seleccionado",
      "deselectLabel": "",
      "track-by": "code",
      "placeholder": this.selectedProduct.text,
      "allow-empty": false,
      "label": "text",
      "options": _vm.optionsProducts
    },
    on: {
      "input": _vm.onProductSelect
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("\r\n                No se encontraron resultados. Considere cambiar los datos de busqueda\r\n              ")])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [(_vm.chartStatusData !== null) ? _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    attrs: {
      "id": "asd"
    }
  }, [_c('chart-status', {
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "id": "statusChart",
      "chart-data": _vm.chartStatusData
    }
  })], 1), _vm._v(" "), (_vm.fetchData && _vm.fetchData.inventoryDate && !isNaN(_vm.fetchData.availablePercentage)) ? _c('div', {
    staticStyle: {
      "position": "absolute",
      "right": "7%",
      "top": "12px"
    }
  }, [_c('table', {
    staticClass: "arkano-chart-legend"
  }, [_vm._m(1), _vm._v(" "), _c('td', [_vm._v(" Disponible: ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.formatPercentage(_vm.fetchData.availablePercentage)))]), _vm._v(" "), _vm._l((_vm.fetchData.states), function(state, stateIndex) {
    return [(!state.isAvailable) ? _c('tr', {
      key: stateIndex
    }, [_c('td', [_c('span', {
      style: ('background-color: ' + state.stateColor + '; border-radius: 50%; display: inline-block; width: 1em; height: 1em; line-height: 1em;margin: 7px')
    }, [_vm._v(" ")])]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(state.state) + ": ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "right",
        "font-weight": "bold"
      }
    }, [_vm._v(_vm._s(_vm.formatPercentage(state.percentageFromTotal)))])]) : _vm._e()]
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.fetchData && _vm.fetchData.inventoryDate && !isNaN(_vm.fetchData.availablePercentage)) ? _c('div', {
    staticClass: "text-center summary-inner",
    style: (this.summaryInnerStyle()),
    attrs: {
      "id": "centroGrafico",
      "data-rHeight": this.realChartHeight
    }
  }, [_c('div', {
    style: (this.summaryInnerInnerStyle())
  }, [_c('div', {
    staticClass: "series-summary",
    staticStyle: {
      "color": "#009d00"
    }
  }, [_c('h4', [_vm._v(_vm._s(_vm.formatAmount(_vm.fetchData.available)) + " "), _c('span', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v(_vm._s(_vm.fetchData.minimumStockUnit))])]), _vm._v(" "), _c('h4', [_vm._v("(" + _vm._s(_vm.formatPercentage(_vm.fetchData.availablePercentage)) + ")")]), _vm._v("\r\n                  Disponible\r\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "series-summary",
    staticStyle: {
      "color": "#00224c"
    }
  }, [_c('h4', [_vm._v(_vm._s(_vm.formatAmount(_vm.fetchData.unAvailable)) + " "), _c('span', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v(_vm._s(_vm.fetchData.minimumStockUnit))])]), _vm._v(" "), _c('h4', [_vm._v("(" + _vm._s(_vm.formatPercentage(_vm.fetchData.unAvailablePercentage)) + ")")]), _vm._v("\r\n                  No Disponible\r\n                ")])])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [(_vm.tableStatusData !== null) ? _c('div', {
    attrs: {
      "id": "divDetalle"
    }
  }, [_c('strong', {
    staticClass: "box-title"
  }, [_vm._v("DETALLE POR ESTADO")]), _vm._v(" "), _c('table-status', {
    ref: "vuetable",
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "id": "statusTable",
      "api-mode": false,
      "fields": _vm.tableStatusFields,
      "data": _vm.tableStatusData,
      "css": _vm.tableCSS.table,
      "pagination-path": "pagination",
      "noDataTemplate": "No se encontraron resultados",
      "detail-row-component": "table-detail",
      "track-by": "statusName"
    },
    on: {
      "vuetable:row-clicked": _vm.onClick,
      "vuetable:loading": _vm.onLoading,
      "vuetable:loaded": _vm.onLoaded,
      "vuetable:pagination-data": _vm.onPaginationData
    },
    scopedSlots: _vm._u([{
      key: "statusName",
      fn: function(props) {
        return [_c('span', {
          style: ('font-weight: bold;')
        }, [_vm._v(_vm._s(props.rowData.statusName))])]
      }
    }, {
      key: "quantity",
      fn: function(props) {
        return [_c('span', {
          style: ('color: ' + props.rowData.color)
        }, [_vm._v(_vm._s(_vm.formatAmount(props.rowData.statusQuantity))), _c('span', {
          staticStyle: {
            "font-size": "12px"
          }
        }, [_vm._v(" " + _vm._s(_vm.fetchData.minimumStockUnit))])])]
      }
    }, {
      key: "percentage",
      fn: function(props) {
        return [_c('span', {
          style: ('color: ' + props.rowData.color)
        }, [_vm._v(_vm._s(_vm.formatPercentage(props.rowData.percentageFromTotal)))]), _vm._v("\r\n                  "), _c('img', {
          attrs: {
            "src": "/static/img/arrow-logo.png"
          }
        })]
      }
    }], null, false, 1511286069)
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [(this.paginationData && _vm.paginationData.total > 0) ? [_c('strong', {
    staticStyle: {
      "color": "#364A5D",
      "paddin-left": "15px"
    }
  }, [_vm._v("\r\n                    Mostrando documento " + _vm._s(this.paginationData.from) + " a " + _vm._s(this.paginationData.to) + " de " + _vm._s(this.paginationData.total) + " en Total\r\n                  ")])] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('vuetable-pagination', {
    ref: "pagination",
    attrs: {
      "css": _vm.tableCSS.pagination
    },
    on: {
      "vuetable-pagination:change-page": _vm.onChangePage
    }
  })], 1)])], 1) : _vm._e()])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header title-boreder"
  }, [_c('h3', {
    staticClass: "box-title title"
  }, [_vm._v(" Inventario por Estado")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('span', {
    staticStyle: {
      "background-color": "#009d00",
      "border-radius": "50%",
      "display": "inline-block",
      "width": "1em",
      "height": "1em",
      "line-height": "1em",
      "margin": "7px"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('br')])])
}]}

/***/ }),
/* 518 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "box-header title-boreder"
  }, [_c('h3', {
    staticClass: "box-title title"
  }, [_vm._v(" Citas de Recepción "), _vm._m(0), _vm._v(" " + _vm._s(this.accountName))])]), _vm._v(" "), _c('div', {
    staticClass: "box box-success"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Seleccione un archivo")]), _vm._v(" "), _c('input', {
    ref: "file",
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "id": "file"
    },
    on: {
      "change": function($event) {
        return _vm.handleFileUpload()
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fileValidation !== ''),
      expression: "fileValidation !== ''"
    }],
    staticClass: "invalid-feedback"
  }, [_vm._v(_vm._s(this.fileValidation))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1 form-interspace"
  }, [_c('div', {
    staticClass: "form-group",
    staticStyle: {
      "padding-top": "25px"
    }
  }, [_c('button', {
    staticClass: "btn btn-sm btn-success form-interspace",
    staticStyle: {
      "width": "70px"
    },
    on: {
      "click": function($event) {
        return _vm.handleUpload()
      }
    }
  }, [_vm._v("Cargar")])])]), _vm._v(" "), (this.uploadData !== null) ? _c('div', {
    staticClass: "col-md-1 form-interspace"
  }, [_c('div', {
    staticClass: "form-group",
    staticStyle: {
      "padding-top": "25px"
    }
  }, [_c('button', {
    staticClass: "btn btn-sm btn-success form-interspace",
    staticStyle: {
      "width": "70px"
    },
    on: {
      "click": function($event) {
        return _vm.handleSubmit()
      }
    }
  }, [_vm._v("Registrar")])])]) : _vm._e()]), _vm._v(" "), (this.tableData) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "tableContainer",
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('vuetable', {
    ref: "vuetable",
    attrs: {
      "id": "receptionTable",
      "api-mode": false,
      "fields": _vm.tableFields,
      "data": _vm.tableData,
      "css": _vm.tableCSS.table
    }
  })], 1)])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "box-title title"
  }, [_c('span', {
    staticClass: "table-btn-icon"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header title-boreder"
  }, [_c('h3', {
    staticClass: "box-title box-title-sub"
  }, [_c('img', {
    staticStyle: {
      "padding-bottom": "3px"
    },
    attrs: {
      "src": "/static/img/icons/deposito_legal.png"
    }
  }), _vm._v(" Cargar Citas ")]), _vm._v(" "), _c('h3', {
    staticClass: "box-title box-title-sub",
    staticStyle: {
      "padding-left": "5px"
    }
  })])
}]}

/***/ }),
/* 519 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box box-success"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [(this.optionsAccount.length > 1) ? _c('div', {
    staticClass: "filterContainer"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group",
    attrs: {
      "id": "divAccountSelect"
    }
  }, [_c('label', [_vm._v("Cuenta")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "value": this.selectedAccount,
      "selectLabel": "",
      "selectedLabel": "",
      "deselectLabel": "",
      "track-by": "name",
      "placeholder": this.selectedAccount.name,
      "allow-empty": false,
      "label": "name",
      "options": this.optionsAccount
    },
    on: {
      "input": _vm.onAccountSelect
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("\r\n                No se encontraron resultados\r\n              ")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-3 documentSearch"
  }, [_c('label', [_vm._v("Documento:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableFilter),
      expression: "tableFilter"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.tableFilter)
    },
    on: {
      "keyup": _vm.filterTruck,
      "paste": _vm.filterTruck,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.tableFilter = $event.target.value
      }
    }
  }), _vm._v(" "), (this.tableFilter !== '') ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.clearFilter
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })]) : _vm._e()]), _c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "margin": "24px",
      "width": "100px"
    },
    on: {
      "click": function($event) {
        return _vm.loadDataButton()
      }
    }
  }, [_vm._v("Buscar")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "box box-success"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    attrs: {
      "id": "truckTable"
    }
  }, [_c('vuetable', {
    key: _vm.tableKey,
    ref: "vuetable",
    attrs: {
      "id": "truckTable",
      "api-mode": false,
      "fields": _vm.tableFields,
      "data": _vm.tableData,
      "css": _vm.tableCSS.table,
      "noDataTemplate": "No se encontraron resultados",
      "data-manager": _vm.dataManager,
      "pagination-path": "pagination",
      "per-page": 7
    },
    on: {
      "vuetable:loading": _vm.onLoading,
      "vuetable:loaded": _vm.onLoaded,
      "vuetable:pagination-data": _vm.onPaginationData
    },
    scopedSlots: _vm._u([{
      key: "company",
      fn: function(props) {
        return [_c('div', {
          attrs: {
            "id": "Empresa"
          }
        }, [(_vm.window.width > 600) ? _c('img', {
          staticStyle: {
            "padding-bottom": "7px"
          },
          attrs: {
            "src": "/static/img/icons/ic_car.png"
          }
        }) : _vm._e(), _vm._v(" \r\n                        " + _vm._s(props.rowData.company) + " \r\n                    ")])]
      }
    }, {
      key: "plate",
      fn: function(props) {
        return [_c('div', {
          attrs: {
            "id": "Placa"
          }
        }, [_c('span', [_vm._v(_vm._s(props.rowData.plate))])])]
      }
    }, {
      key: "shippedDocuments",
      fn: function(props) {
        return [_c('div', {
          attrs: {
            "id": "Desp."
          }
        }, [_c('span', [_vm._v(_vm._s(props.rowData.shippedDocuments))])])]
      }
    }, {
      key: "totalDocuments",
      fn: function(props) {
        return [_c('div', {
          attrs: {
            "id": "Total"
          }
        }, [_c('span', [_vm._v(_vm._s(props.rowData.totalDocuments))])])]
      }
    }, {
      key: "percentage",
      fn: function(props) {
        return [_c('div', {
          style: ('display: inline-flex;')
        }, [_c('div', {
          style: ('font-size: 18px;margin:0 10px')
        }, [_vm._v(_vm._s(_vm._f("formatDecimal")(props.rowData.percentageShipped)) + "%")]), _vm._v(" "), _c('div', {
          staticClass: "progressContainer text-center"
        }, [_c('div', {
          staticClass: "progressBar",
          style: ('position:inherit')
        }, [_c('div', {
          staticClass: "progress table-bar",
          style: ('background-color:#D9DEFB;')
        }, [_c('div', {
          class: 'progress-bar progress-bar',
          style: ('background-color:#536DFE;width:' + props.rowData.percentageShipped + '%'),
          attrs: {
            "role": "progressbar",
            "aria-valuemin": "0",
            "aria-valuemax": "100"
          }
        })])])])])]
      }
    }, {
      key: "detail",
      fn: function(props) {
        return [_c('button', {
          staticClass: "btn table-btn",
          on: {
            "click": function($event) {
              return _vm.onRowClick(props.rowData)
            }
          }
        }, [(_vm.window.width > 1000) ? _c('img', {
          attrs: {
            "src": "static\\img\\icons\\loc_arrow.png"
          }
        }) : _vm._e(), (false) ? _c('span', [_vm._v(_vm._s(props.rowData.percentageShipped))]) : _vm._e()]), _vm._v(" "), _c('div', {
          staticClass: "text-center botonVerDetalle"
        }, [(_vm.window.width < 1000) ? _c('span', {
          staticStyle: {
            "color": "#364A5D",
            "font-size": "14px",
            "font-weight": "bold"
          },
          on: {
            "click": function($event) {
              return _vm.onRowClick(props.rowData)
            }
          }
        }, [_vm._v("Ver detalles")]) : _vm._e()])]
      }
    }])
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('vuetable-pagination', {
    ref: "pagination",
    attrs: {
      "css": _vm.tableCSS.pagination
    },
    on: {
      "vuetable-pagination:change-page": _vm.onChangePage
    }
  })], 1)]), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('modal', {
    attrs: {
      "id": "truck",
      "name": "truck",
      "click-to-close": false
    }
  }, [_c('div', {
    staticClass: "box-header title-boreder",
    staticStyle: {
      "height": "60px !important"
    }
  }, [(_vm.window.width < 600) ? _c('div', {
    staticClass: "box-title box-title-sub"
  }, [_c('img', {
    staticStyle: {
      "padding-bottom": "6px",
      "padding-right": "8px"
    },
    attrs: {
      "src": "/static/img/icons/ic_location.png"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "12px !important"
    }
  }, [_vm._v("Servicio de Distribución")])]) : _vm._e(), _vm._v(" "), (_vm.window.width > 600) ? _c('div', {
    staticClass: "box-title box-title-sub"
  }, [_c('img', {
    staticStyle: {
      "padding-bottom": "6px",
      "padding-right": "8px"
    },
    attrs: {
      "src": "/static/img/icons/ic_location.png"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Servicio de Distribución - " + _vm._s(this.selectedTruck === null ? 0 : this.selectedTruck.company))])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "close",
    staticStyle: {
      "padding": "5px"
    },
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.showAllTrucks()
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', [_c('gmap-map', {
    staticStyle: {
      "width": "100%",
      "height": "300px"
    },
    attrs: {
      "center": _vm.center,
      "zoom": _vm.zoom
    }
  }, _vm._l((_vm.markers), function(m, index) {
    return _c('gmap-marker', {
      key: index,
      attrs: {
        "position": m.position,
        "icon": "/static/img/icons/ic_truck_50.png"
      },
      on: {
        "click": function($event) {
          return _vm.onTruckSelect(m)
        }
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "margin": "0 80px"
    }
  }, [_c('div', {
    staticClass: "centroModal",
    staticStyle: {
      "display": "inline-flex"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0 0px",
      "width": "300px"
    }
  }, [_c('h4', {
    staticStyle: {
      "font-weight": "bold",
      "color": "#70869A"
    }
  }, [_vm._v("Empresa")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#70869A"
    }
  }, [_vm._v(_vm._s(this.selectedTruck === null ? 0 : this.selectedTruck.company))])]), _vm._v(" "), _c('div', [_c('h4', {
    staticStyle: {
      "font-weight": "bold",
      "color": "#70869A"
    }
  }, [_vm._v("PLACA")]), _vm._v(" "), _c('div', {
    staticClass: "callout callout-success",
    staticStyle: {
      "width": "80px",
      "height": "30px",
      "padding-left": "10px",
      "padding-right": "10px",
      "border-left-width": "0px",
      "margin-bottom": "0px",
      "background-color": "rgb(83, 109, 254) !important",
      "padding-top": "5px",
      "padding-bottom": "5px"
    }
  }, [_c('h4', {
    staticStyle: {
      "font-weight": "normal !important"
    }
  }, [_vm._v(_vm._s(this.selectedTruck === null ? 'asd' : this.selectedTruck.plate))])])]), _vm._v(" "), _c('div', {
    staticClass: "porcentajeModal",
    staticStyle: {
      "margin": "0px 80px -30px"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "30px -10px 20px",
      "display": "inline-flex"
    }
  }, [_c('h3', {
    staticStyle: {
      "margin": "-3px 10px !important",
      "color": "#70869A"
    }
  }, [_vm._v(_vm._s(_vm._f("formatDecimal")((this.chartData === null ? 0 : this.chartData.centerTextValue))) + "%")]), _vm._v(" "), _c('div', {
    staticClass: "progressContainer text-center"
  }, [_c('div', {
    staticClass: "progressBar"
  }, [_c('div', {
    staticClass: "progress table-bar",
    style: ('background-color:#D9DEFB;height: 20px !important;width: 200px !important')
  }, [_c('div', {
    class: 'progress-bar progress-bar',
    style: ('background-color:#536DFE;width:' + (this.chartData === null ? 0 : this.chartData.centerTextValue) + '%'),
    attrs: {
      "role": "progressbar",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "center-block",
    staticStyle: {
      "width": "200px",
      "margin-top": "10px",
      "margin-left": "530px"
    }
  }, [_c('div', {
    staticClass: "pull-left text-center",
    staticStyle: {
      "width": "100px",
      "border-right": "1px solid #eee"
    }
  }, [_c('img', {
    staticStyle: {
      "vertical-align": "text-bottom"
    },
    attrs: {
      "src": "/static/img/icons/camion.png",
      "alt": "Ingresadas",
      "height": "20",
      "width": "22"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "span-value",
    style: ({
      color: this.chartColors.solid
    })
  }, [_vm._v("\r\n                        " + _vm._s(this.fetchData.shippedDocuments) + "\r\n                      ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "span-status"
  }, [_vm._v("Despachados")])]), _vm._v(" "), _c('div', {
    staticClass: "pull-right text-center",
    staticStyle: {
      "width": "100px"
    }
  }, [_c('img', {
    staticStyle: {
      "vertical-align": "text-bottom"
    },
    attrs: {
      "src": "/static/img/icons/proyectado.png",
      "alt": "Ingresadas",
      "height": "18",
      "width": "18"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "span-value",
    style: ({
      color: this.colorProjected
    })
  }, [_vm._v("\r\n                        " + _vm._s(this.fetchData.totalDocuments) + "\r\n                      ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "span-status"
  }, [_vm._v("Proyectado")])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header title-boreder"
  }, [_c('h3', {
    staticClass: "box-title title"
  }, [_vm._v("Servicio de Distribución")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header title-boreder"
  }, [_c('h3', {
    staticClass: "box-title box-title-sub"
  }, [_c('img', {
    staticStyle: {
      "padding-bottom": "7px"
    },
    attrs: {
      "src": "/static/img/icons/search.png"
    }
  }), _vm._v(" BUSCAR SERVICIO DE DISTRIBUCIÓN")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header title-boreder"
  }, [_c('h3', {
    staticClass: "box-title box-title-sub"
  }, [_c('img', {
    staticStyle: {
      "padding-bottom": "7px"
    },
    attrs: {
      "src": "/static/img/icons/result.png"
    }
  }), _vm._v(" RESULTADO BÚSQUEDA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('br')])])
}]}

/***/ }),
/* 520 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    class: 'modal fade modal-' + this.type,
    attrs: {
      "id": "bsModal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "bsModalLabel",
      "data-toggle": "modal",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content box-success"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('i', {
    staticClass: "icon-modal"
  }), _vm._m(0), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "bsModalLabel"
    }
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('p', {
    staticClass: "modal-description"
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-description"
  }, [_vm._v("\n             " + _vm._s(_vm.description) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [(this.cancelText) ? _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.cancelText))]) : _vm._e(), _vm._v(" "), _c('button', {
    class: 'btn btn-' + this.type,
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v(_vm._s(_vm.confirmText))])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
}]}

/***/ }),
/* 521 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.showTrack) ? _c('div', [_c('Tracking', {
    attrs: {
      "track": _vm.tracking,
      "firstName": _vm.firstName,
      "document": _vm.document,
      "showBack": _vm.showBack,
      "isOrder": false,
      "trackOrder": _vm.orderNumber
    },
    on: {
      "hiddenTrack": _vm.hiddenTrack
    }
  })], 1) : _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "container-tra"
  }, [_c('div', {
    staticClass: "nav-tra"
  }, [_c('img', {
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "src": "/static/img/logo-tra.png"
    }
  }), _vm._v(" "), (_vm.existe == 1 && _vm.order.accountLogo != null) ? _c('img', {
    staticStyle: {
      "height": "35px"
    },
    attrs: {
      "src": ("data:image/png;base64," + (_vm.order.accountLogo))
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.existe == 0) ? _c('div', {
    staticClass: "msg-order"
  }, [(_vm.mobile) ? _c('div', [_c('img', {
    staticClass: "img-nf",
    attrs: {
      "src": "/static/img/noencontrado.png"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "title-nf"
  }, [_vm._v("\n            No hemos podido encontrar tu pedido\n          ")]), _vm._v(" "), _c('p', {
    staticClass: "p-nf"
  }, [_vm._v("\n            Comunicate con nosotros para brindarte información de tu pedido\n          ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-ora",
    staticStyle: {
      "width": "200px"
    },
    on: {
      "click": function($event) {
        return _vm.contact()
      }
    }
  }, [_vm._v("Contáctate con nosotros")])]), _vm._v(" "), (!_vm.mobile) ? _c('div', [_c('img', {
    staticClass: "img-nf",
    attrs: {
      "src": "/static/img/noencontrado.png"
    }
  })]) : _vm._e()]) : (_vm.existe == 2) ? _c('div', {
    staticClass: "msg-order"
  }, [(_vm.mobile) ? _c('div', [_c('img', {
    staticClass: "img-bus",
    attrs: {
      "src": "/static/img/buscar.png"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "title-bus"
  }, [_vm._v("\n            Hola,\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "subtitle-bus"
  }, [_vm._v("\n            Bienvenido a Dinet\n          ")]), _vm._v(" "), _c('p', {
    staticClass: "p-bus"
  }, [_vm._v("\n            Para ver el estado de su pedido necesitamos que se identifique:\n          ")]), _vm._v(" "), _c('p', {
    staticClass: "p-bus"
  }, [_vm._v("\n              Ingrese tus datos\n          ")]), _vm._v(" "), _c('form', {
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.search()
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.firstName),
      expression: "firstName"
    }],
    staticClass: "form-control form-control-ora",
    class: {
      'is-invalid': _vm.submitted && !_vm.firstName
    },
    attrs: {
      "placeholder": "Nombres"
    },
    domProps: {
      "value": (_vm.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.firstName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.submitted && _vm.firstName === ''),
      expression: "submitted && firstName===''"
    }],
    staticClass: "invalid-feedback"
  }, [_vm._v("Los nombres o DNI es requerido")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6 col-lg-6"
  }, [_c('button', {
    class: ['btn btn-ora', {
      'disabled': (_vm.submitted && _vm.firstName === '')
    }],
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Continuar "), _c('i', {
    staticClass: "fa fa-angle-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])])]), _vm._v(" "), (!_vm.mobile) ? _c('div', [_c('img', {
    staticClass: "img-bus",
    attrs: {
      "src": "/static/img/buscar.png"
    }
  })]) : _vm._e()]) : (_vm.showList) ? _c('div', {
    staticClass: "msg-order"
  }, [(_vm.mobile) ? _c('img', {
    staticClass: "img-bus",
    attrs: {
      "src": "/static/img/buscar.png"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "title-bus"
  }, [_vm._v("\n              Hola,\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "subtitle-bus"
  }, [_vm._v("\n            " + _vm._s(_vm._f("firstLetter")(_vm.order.customerName)) + "\n          ")]), _vm._v(" "), _c('p', {
    staticClass: "p-bus"
  }, [_vm._v("\n            Seleccione su pedido:\n          ")]), _vm._v(" "), _vm._l((_vm.order.trackingList), function(track, index) {
    return _c('div', {
      key: index,
      staticClass: "row row-list"
    }, [(!_vm.mobile) ? _c('div', {
      staticClass: "col-md-12"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-1 col-lg-1 data-top"
    }, [_c('img', {
      class: {
        'data-type': track.orderTypeCode === 'ENT' ? true : false,
        'data-type-orange': track.orderTypeCode === 'DEV' ? true : false
      },
      attrs: {
        "src": track.orderTypeCode === 'DEV' ? '/static/img/svg/return.svg' : '/static/img/svg/delivery.svg'
      }
    }), _vm._v(" "), _c('span', {
      class: {
        'data-type-label': track.orderTypeCode === 'ENT' ? true : false,
        'data-type-orange-label': track.orderTypeCode === 'DEV' ? true : false
      }
    }, [_vm._v(" " + _vm._s(track.orderTypeCode === 'DEV' ? 'Devolución' : 'Entrega') + " ")])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-7 col-md-6 col-lg-7 data-top"
    }, [_c('span', {
      staticClass: "data-label"
    }, [_vm._v("N° Pedido:")]), _c('span', {
      staticClass: "data-value"
    }, [_vm._v(_vm._s(track.customerOrderNumber == null ? _vm.orderNumber : track.customerOrderNumber))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "data-label"
    }, [_vm._v("N° Tracking:")]), _c('span', {
      staticClass: "data-value"
    }, [_vm._v(_vm._s(track.trackingNumber))])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-3 col-md-4 col-lg-3"
    }, [_c('span', {
      staticClass: "data-label"
    }, [_vm._v("Estado")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
      staticClass: "data-status",
      style: ({
        background: track.configuration.minTextFundColor == '' ? 'black' : track.configuration.minTextFundColor,
        color: track.configuration.minTextColor == '' ? 'white' : track.configuration.minTextColor
      })
    }, [_vm._v("\n                    " + _vm._s(_vm._f("firstLetter")(track.statusDescription)) + "\n                  ")])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-1 col-lg-1 data-top"
    }, [_c('a', {
      staticClass: "data-arrow",
      attrs: {
        "data-toggle": "collapse"
      },
      on: {
        "click": function($event) {
          return _vm.goTracking(track)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-chevron-right",
      attrs: {
        "aria-hidden": "true"
      }
    })])])])]) : (_vm.mobile) ? _c('div', {
      staticClass: "col-xs-12 col-md-12",
      on: {
        "click": function($event) {
          return _vm.goTracking(track)
        }
      }
    }, [_c('div', {
      staticStyle: {
        "padding-bottom": "10px"
      }
    }, [_c('img', {
      class: {
        'data-type': track.orderTypeCode === 'ENT' ? true : false,
        'data-type-orange': track.orderTypeCode === 'DEV' ? true : false
      },
      attrs: {
        "src": track.orderTypeCode === 'DEV' ? '/static/img/svg/return.svg' : '/static/img/svg/delivery.svg'
      }
    }), _vm._v(" "), _c('span', {
      class: {
        'data-type-label': track.orderTypeCode === 'ENT' ? true : false,
        'data-type-orange-label': track.orderTypeCode === 'DEV' ? true : false
      }
    }, [_vm._v(_vm._s(track.orderTypeCode === 'DEV' ? 'Devolución' : 'Entrega') + " ")])]), _vm._v(" "), _c('div', {
      staticClass: "data-status",
      style: ({
        background: track.configuration.minTextFundColor == '' ? 'black' : track.configuration.minTextFundColor,
        color: track.configuration.minTextColor == '' ? 'white' : track.configuration.minTextColor
      })
    }, [_vm._v("\n                " + _vm._s(_vm._f("firstLetter")(track.statusDescription)) + "\n              ")]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-xs-12 data-mo",
      staticStyle: {
        "padding-top": "10px"
      }
    }, [_c('span', {
      staticClass: "data-label"
    }, [_vm._v("N° Pedido:")]), _c('span', {
      staticClass: "data-value"
    }, [_vm._v(_vm._s(_vm.orderNumber))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "data-label"
    }, [_vm._v("N° Tracking:")]), _c('span', {
      staticClass: "data-value"
    }, [_vm._v(_vm._s(track.trackingNumber))])])])]) : _vm._e()])
  })], 2), _vm._v(" "), (!_vm.mobile) ? _c('img', {
    staticClass: "img-bus",
    attrs: {
      "src": "/static/img/buscar.png"
    }
  }) : _vm._e()]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 522 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.router && _vm.router.name) ? _c('router-link', {
    staticClass: "treeview",
    attrs: {
      "tag": "li",
      "to": _vm.router
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('div', [_c('img', {
    class: _vm.icon
  })]), _vm._v(" "), _c('span', {
    staticClass: "side-parent"
  }, [_vm._v(_vm._s(_vm.name))])])]) : _c('li', {
    class: _vm.getType
  }, [_vm._v("\n  " + _vm._s(_vm.isHeader ? _vm.name : '') + "\n  "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('div', [_c('img', {
    class: _vm.icon
  })]), _c('span', {
    staticClass: "side-sub"
  }, [_vm._v(_vm._s(_vm.name))])]), _vm._v(" "), (_vm.items.length > 0) ? _c('ul', {
    staticClass: "treeview-menu",
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "id": "treeMenu"
    }
  }, [_vm._l((_vm.items), function(item, index) {
    return (item.router && item.router.name) ? _c('router-link', {
      key: index,
      attrs: {
        "tag": "li",
        "data": item,
        "to": item.router
      }
    }, [(_vm.window.width < 450) ? _c('a', [_c('div', {
      staticClass: "sub-menu"
    }, [_vm._v(_vm._s(_vm._f("abbreviation")(item.name)))])]) : _c('a', [_c('div', {
      staticClass: "sub-menu"
    }, [_c('img', {
      class: _vm.icon,
      staticStyle: {
        "width": "32px"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "sub-menu-label"
    }, [_vm._v(_vm._s(item.name))])])])]) : _c('li', [_c('a', [_c('div', {
      staticClass: "sub-menu"
    }, [_c('img', {
      class: _vm.icon,
      staticStyle: {
        "width": "32px"
      }
    }), _c('div', {
      staticClass: "sub-menu-label"
    }, [_vm._v(_vm._s(item.name))])])])])
  }), _vm._v(" "), (_vm.window.width > 450) ? _c('li', {
    staticClass: "li-end"
  }) : _vm._e()], 2) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 523 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "main-header"
  }, [_c('nav', {
    staticClass: "navbar navbar-static-top"
  }, [_c('router-link', {
    staticClass: "logo-side2",
    attrs: {
      "to": {
        name: 'ServiceMonitoring'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "\\static\\img\\icons\\logo-navbar.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "navbar-custom-menu"
  }, [(_vm.window.width > 400) ? _c('label', {
    staticClass: "fechaNav",
    staticStyle: {
      "text-transform": "capitalize"
    }
  }, [_vm._v(_vm._s(_vm._f("formatDate")(new Date(), 'dddd DD')))]) : _vm._e(), _vm._v(" "), (_vm.window.width > 400) ? _c('label', {
    staticClass: "fechaNav",
    staticStyle: {
      "padding-left": "5px",
      "padding-right": "5px"
    }
  }, [_vm._v("de")]) : _vm._e(), _vm._v(" "), (_vm.window.width > 400) ? _c('label', {
    staticClass: "fechaNav",
    staticStyle: {
      "text-transform": "capitalize"
    }
  }, [_vm._v(_vm._s(_vm._f("formatDate")(new Date(), 'MMM YYYY')))]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav"
  }, [_c('li', {
    staticClass: "dropdown user user-menu dropdown-per"
  }, [_c('a', {
    staticClass: "dropdown-toggle nav-user-info",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown"
    }
  }, [_c('img', {
    staticClass: "user-image",
    attrs: {
      "src": "/static/img/icons/icon-user-default.png",
      "alt": "User Image"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-xs user-info"
  }, [_vm._v(_vm._s(_vm.userInfo.name.toLowerCase().trim()) + " ")]), _c('img', {
    attrs: {
      "src": "/static/img/arrow-logo.png"
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu dropdown-menu-per",
    attrs: {
      "aria-labelledby": "dropdownMenuLink",
      "aria-expanded": "false",
      "id": "dropdownMenuButton"
    }
  }, [_c('li', [_c('div', {
    staticClass: "pull-right"
  }, [_c('router-link', {
    staticClass: "btn rectangle",
    attrs: {
      "to": {
        name: 'Logout'
      }
    }
  }, [_c('i', {
    staticClass: "exit-icon"
  }), _c('p', {
    staticClass: "user-close"
  }, [_vm._v("Cerrar Sesión")])])], 1)])])])])])], 1)])
},staticRenderFns: []}

/***/ }),
/* 524 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.showTrack) ? _c('div', [_c('Tracking', {
    attrs: {
      "track": _vm.tracking,
      "firstName": _vm.firstName,
      "document": _vm.document,
      "showBack": _vm.showBack,
      "account": _vm.account.code,
      "isOrder": true,
      "orderNumber": _vm.orderNumber,
      "parameters": _vm.parameters
    },
    on: {
      "hiddenTrack": _vm.hiddenTrack
    }
  })], 1) : _c('div', {
    staticStyle: {
      "margin-top": "-70px"
    }
  }, [(_vm.showModalExport) ? _c('transition', {
    attrs: {
      "id": "exportar",
      "name": "exportar"
    }
  }, [_c('div', {
    staticClass: "modal-cus-mask"
  }, [_c('div', {
    staticClass: "modal-cus-wrapper"
  }, [_c('div', {
    staticClass: "modal-cus-container",
    staticStyle: {
      "width": "450px"
    }
  }, [_c('div', {
    staticClass: "modal-cus-header"
  }, [_vm._t("header", function() {
    return [_c('div', {
      staticClass: "title-boreder"
    }, [_c('div', {
      staticClass: "box-title box-title-sub"
    }, [_c('span', [_vm._v("Exportar Reporte")])]), _vm._v(" "), _c('button', {
      staticClass: "close",
      staticStyle: {
        "padding": "5px",
        "position": "relative !important",
        "top": "-35px !important"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.closeExport()
        }
      }
    }, [_c('span', {
      attrs: {
        "aria-hidden": "true"
      }
    }, [_vm._v("×")])])])]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-cus-body",
    staticStyle: {
      "margin": "10px"
    }
  }, [_vm._t("body", function() {
    return [_c('div', {
      staticClass: "row"
    }, [_c('p', {
      staticClass: "p-bus",
      staticStyle: {
        "text-align": "left",
        "padding-left": "20px"
      }
    }, [_vm._v("\n                  Indique su correo donde le llegará su reporte con el listado de pedidos:\n                  "), _c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
      staticClass: "col-md-12"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('form', {
      attrs: {
        "autocomplete": "off"
      },
      on: {
        "submit": function($event) {
          $event.preventDefault();
          return _vm.exportOrder()
        }
      }
    }, [_c('div', {
      staticClass: "col-lg-1 col-md-1 col-xs-2",
      staticStyle: {
        "font-size": "24px",
        "color": "#3D77FF"
      }
    }, [_c('i', {
      ref: "atrack",
      staticClass: "fa fa-paper-plane a-icon",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-8 col-md-8 col-xs-10 text-left"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.fEmail),
        expression: "fEmail"
      }],
      staticClass: "form-control form-control-ora",
      class: {
        'is-invalid': _vm.submitted && (!_vm.fEmail || !_vm.isEmail)
      },
      attrs: {
        "placeholder": "Correo"
      },
      domProps: {
        "value": (_vm.fEmail)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.fEmail = $event.target.value
        }
      }
    }), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.submitted && _vm.fEmail === ''),
        expression: "submitted && fEmail===''"
      }],
      staticClass: "invalid-feedback"
    }, [_vm._v("El correo es requerido")]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.submitted && !_vm.isEmail),
        expression: "submitted && !isEmail"
      }],
      staticClass: "invalid-feedback"
    }, [_vm._v("El correo es invalido")])])]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-3 col-md-3 col-xs-12 text-center"
    }, [_c('button', {
      class: ['btn btn-ora-blue', {
        'disabled': (_vm.submitted && (_vm.fEmail === '' || !_vm.isEmail))
      }],
      attrs: {
        "type": "submit"
      }
    }, [_vm._v("\n                          Enviar\n                        ")])])])])])])]
  })], 2)])])])]) : _vm._e(), _vm._v(" "), (_vm.message.show) ? _c('transition', {
    attrs: {
      "id": "message",
      "name": "message"
    }
  }, [_c('div', {
    staticClass: "modal-cus-mask"
  }, [_c('div', {
    staticClass: "modal-cus-wrapper"
  }, [_c('div', {
    staticClass: "modal-cus-container",
    staticStyle: {
      "width": "450px"
    }
  }, [_c('div', {
    staticClass: "modal-cus-header"
  }, [_vm._t("header", function() {
    return [_c('div', {
      staticClass: "title-boreder"
    }, [_c('div', {
      staticClass: "box-title box-title-sub"
    }, [_c('span', [_vm._v(_vm._s(_vm.message.title))])]), _vm._v(" "), _c('button', {
      staticClass: "close",
      staticStyle: {
        "padding": "5px",
        "position": "relative !important",
        "top": "-35px !important"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.message.show = false
        }
      }
    }, [_c('span', {
      attrs: {
        "aria-hidden": "true"
      }
    }, [_vm._v("×")])])])]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-cus-body",
    staticStyle: {
      "margin": "10px"
    }
  }, [_vm._t("body", function() {
    return [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-12"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-lg-1 col-md-1 col-xs-2",
      class: {
        'msg-info': _vm.message.type === 'info',
        'msg-warn': _vm.message.type === 'warn',
        'msg-error': _vm.message.type === 'error'
      }
    }, [_c('i', {
      ref: "atrack",
      class: {
        'fa fa-info-circle a-icon': _vm.message.type === 'info',
        'fa fa-exclamation-triangle a-icon': _vm.message.type === 'warn',
        'fa fa-window-close a-icon': _vm.message.type === 'error'
      },
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-8 col-md-8 col-xs-10 text-left"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_vm._v("                  \n                            " + _vm._s(_vm.message.description) + "\n                        ")])]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-3 col-md-3 col-xs-12 text-center"
    }, [_c('button', {
      staticClass: "btn btn-ora-msg",
      class: {
        'btn-ora-msg-info': _vm.message.type === 'info',
        'btn-ora-msg-warn': _vm.message.type === 'warn',
        'btn-ora-msg-error': _vm.message.type === 'error'
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.message.show = false
        }
      }
    }, [_vm._v("\n                        Aceptar\n                      ")])])])])])]
  })], 2)])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "-15px !important"
    }
  }, [_c('div', {
    staticClass: "nav-order"
  }, [_vm._m(0), _vm._v(" "), (_vm.existe == 1 && _vm.order.accountLogo != null) ? _c('img', {
    staticStyle: {
      "height": "35px"
    },
    attrs: {
      "src": ("data:image/png;base64," + (_vm.order.accountLogo))
    }
  }) : _vm._e()]), _vm._v(" "), (!_vm.mobile) ? _c('div', {
    staticClass: "doc-filter"
  }, [_c('div', {
    staticClass: "ati-flex ati-pb"
  }, [_vm._m(1), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn-sm btnAction btn-ora btn-ora-auto",
    staticStyle: {
      "width": "120px"
    },
    on: {
      "click": function($event) {
        return _vm.showAdvanced()
      }
    }
  }, [_vm._v(" Avanzado")])])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "filterContainer"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-md-2 col-lg-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group input-group-ora"
  }, [_vm._m(3), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.CustomerOrderNumber),
      expression: "filter.CustomerOrderNumber"
    }],
    staticClass: "form-control form-control-ora-sin",
    attrs: {
      "type": "text",
      "id": "txtPedido",
      "name": "txtPedido",
      "placeholder": "Nro de Pedido",
      "maxlength": "30",
      "aria-labelledby": "label-pedido"
    },
    domProps: {
      "value": (_vm.filter.CustomerOrderNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filter, "CustomerOrderNumber", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._m(4)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-md-2 col-lg-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group input-group-ora"
  }, [_vm._m(5), _vm._v(" "), _c('multiselect', {
    staticClass: "multiselect-ora multiselect-ora-layer",
    attrs: {
      "id": "cboTipo",
      "name": "cboTipo",
      "selectLabel": "",
      "selectedLabel": "",
      "deselectLabel": "",
      "track-by": "description",
      "label": "description",
      "placeholder": "Tipo",
      "customLabel": _vm.optDescription,
      "show-labels": false,
      "close-on-select": true,
      "options": _vm.orderTypeList
    },
    on: {
      "open": function($event) {
        return _vm.reloadTypes()
      }
    },
    model: {
      value: (_vm.filter.OrderType),
      callback: function($$v) {
        _vm.$set(_vm.filter, "OrderType", $$v)
      },
      expression: "filter.OrderType"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noOptions"
    },
    slot: "noOptions"
  }, [_vm._v("La lista esta vacia.")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("No se encontró el elemento buscado.")])]), _vm._v(" "), _vm._m(6)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-md-2 col-lg-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group input-group-ora"
  }, [_vm._m(7), _vm._v(" "), _c('multiselect', {
    staticClass: "multiselect-ora multiselect-ora-point",
    attrs: {
      "id": "cboZona",
      "name": "cboZona",
      "selectLabel": "",
      "selectedLabel": "",
      "deselectLabel": "",
      "placeholder": "Zona",
      "track-by": "description",
      "label": "description",
      "customLabel": _vm.optDescription,
      "show-labels": false,
      "close-on-select": true,
      "options": _vm.orderZoneList
    },
    on: {
      "open": function($event) {
        return _vm.reloadZone()
      }
    },
    model: {
      value: (_vm.filter.Zone),
      callback: function($$v) {
        _vm.$set(_vm.filter, "Zone", $$v)
      },
      expression: "filter.Zone"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noOptions"
    },
    slot: "noOptions"
  }, [_vm._v("La lista esta vacia.")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("No se encontró el elemento buscado.")])]), _vm._v(" "), _vm._m(8)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-md-2 col-lg-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group input-group-ora"
  }, [_vm._m(9), _vm._v(" "), _c('multiselect', {
    staticClass: "multiselect-ora multiselect-ora-bar",
    attrs: {
      "id": "cboEstado",
      "name": "cboEstado",
      "selectLabel": "",
      "selectedLabel": "",
      "deselectLabel": "",
      "placeholder": "Estado",
      "track-by": "description",
      "label": "description",
      "customLabel": _vm.optDescription,
      "show-labels": false,
      "close-on-select": true,
      "options": _vm.orderStatusList
    },
    on: {
      "open": function($event) {
        return _vm.reloadStatus()
      }
    },
    model: {
      value: (_vm.filter.Status),
      callback: function($$v) {
        _vm.$set(_vm.filter, "Status", $$v)
      },
      expression: "filter.Status"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noOptions"
    },
    slot: "noOptions"
  }, [_vm._v("La lista esta vacia.")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("No se encontró el elemento buscado.")])]), _vm._v(" "), _vm._m(10)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-md-2 col-lg-2 text-right"
  }, [_c('button', {
    staticClass: "btn btn-sm btnAction btn-ora btn-ora-auto",
    staticStyle: {
      "width": "70px"
    },
    on: {
      "click": function($event) {
        return _vm.clear()
      }
    }
  }, [_vm._v(" Limpiar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btnAction btn-ora btn-ora-auto",
    staticStyle: {
      "width": "70px"
    },
    on: {
      "click": function($event) {
        return _vm.search(1)
      }
    }
  }, [_vm._v(" Buscar")])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.advanced) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6 col-md-2 col-lg-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group input-group-ora"
  }, [_c('div', {
    staticClass: "input-group-addon input-group-addon-ico"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/svg/hash.svg"
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.TrackingNumber),
      expression: "filter.TrackingNumber"
    }],
    staticClass: "form-control form-control-ora-sin",
    attrs: {
      "mode": "text",
      "id": "txtTracking",
      "name": "txtTracking",
      "placeholder": "Nro Tracking",
      "maxlength": "20"
    },
    domProps: {
      "value": (_vm.filter.TrackingNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filter, "TrackingNumber", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "label-ora",
    attrs: {
      "for": "txtTracking",
      "id": "label-tracking"
    }
  }, [_c('div', {
    staticClass: "text-ora"
  }, [_vm._v("Nro Tracking")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-md-2 col-lg-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group input-group-ora"
  }, [_c('div', {
    staticClass: "input-group-addon input-group-addon-ico",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/svg/zone.svg"
    }
  })]), _vm._v(" "), _c('multiselect', {
    staticClass: "multiselect-ora multiselect-ora-point",
    attrs: {
      "id": "cboDepartamento",
      "name": "cboDepartamento",
      "selectLabel": "",
      "selectedLabel": "",
      "deselectLabel": "",
      "placeholder": "Departamento",
      "track-by": "name",
      "label": "name",
      "customLabel": _vm.optName,
      "show-labels": false,
      "close-on-select": true,
      "options": _vm.departamentList
    },
    on: {
      "input": function($event) {
        return _vm.getProvince()
      },
      "open": function($event) {
        return _vm.reloadDepartament()
      }
    },
    model: {
      value: (_vm.filter.Department),
      callback: function($$v) {
        _vm.$set(_vm.filter, "Department", $$v)
      },
      expression: "filter.Department"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noOptions"
    },
    slot: "noOptions"
  }, [_vm._v("La lista esta vacia.")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("No se encontró el elemento buscado.")])]), _vm._v(" "), _c('label', {
    staticClass: "label-ora",
    attrs: {
      "for": "cboDepartamento",
      "id": "label-departamento"
    }
  }, [_c('div', {
    staticClass: "text-ora"
  }, [_vm._v("Departamento")])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-md-2 col-lg-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group input-group-ora"
  }, [_c('div', {
    staticClass: "input-group-addon input-group-addon-ico",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/svg/zone.svg"
    }
  })]), _vm._v(" "), _c('multiselect', {
    staticClass: "multiselect-ora multiselect-ora-point",
    attrs: {
      "id": "cboProvincia",
      "name": "cboProvincia",
      "selectLabel": "",
      "selectedLabel": "",
      "deselectLabel": "",
      "placeholder": "Provincia",
      "track-by": "name",
      "label": "name",
      "customLabel": _vm.optName,
      "show-labels": false,
      "close-on-select": true,
      "options": _vm.provinceList
    },
    on: {
      "input": function($event) {
        return _vm.getDistrict()
      },
      "open": function($event) {
        return _vm.reloadProvince()
      }
    },
    model: {
      value: (_vm.filter.Province),
      callback: function($$v) {
        _vm.$set(_vm.filter, "Province", $$v)
      },
      expression: "filter.Province"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noOptions"
    },
    slot: "noOptions"
  }, [_vm._v("La lista esta vacia.")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("No se encontró el elemento buscado.")])]), _vm._v(" "), _c('label', {
    staticClass: "label-ora",
    attrs: {
      "for": "cboProvincia",
      "id": "label-provincia"
    }
  }, [_c('div', {
    staticClass: "text-ora"
  }, [_vm._v("Provincia")])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-md-2 col-lg-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group input-group-ora"
  }, [_c('div', {
    staticClass: "input-group-addon input-group-addon-ico",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/svg/zone.svg"
    }
  })]), _vm._v(" "), _c('multiselect', {
    staticClass: "multiselect-ora multiselect-ora-point",
    attrs: {
      "id": "cboDistrito",
      "name": "cboDistrito",
      "selectLabel": "",
      "selectedLabel": "",
      "deselectLabel": "",
      "placeholder": "Distrito",
      "track-by": "name",
      "label": "name",
      "customLabel": _vm.optName,
      "show-labels": false,
      "close-on-select": true,
      "options": _vm.districtList
    },
    on: {
      "open": function($event) {
        return _vm.reloadDistrict()
      }
    },
    model: {
      value: (_vm.filter.District),
      callback: function($$v) {
        _vm.$set(_vm.filter, "District", $$v)
      },
      expression: "filter.District"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noOptions"
    },
    slot: "noOptions"
  }, [_vm._v("La lista esta vacia.")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("No se encontró el elemento buscado.")])]), _vm._v(" "), _c('label', {
    staticClass: "label-ora",
    attrs: {
      "for": "cboDistrito",
      "id": "label-distrito"
    }
  }, [_c('div', {
    staticClass: "text-ora"
  }, [_vm._v("Distrito")])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-md-4 col-lg-4 pull-center"
  })]) : _vm._e()])], 1)])]) : _c('div', [_c('div', {
    staticClass: "filterContainer",
    staticStyle: {
      "padding-top": "20px"
    }
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-8",
    staticStyle: {
      "padding-right": "5px"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group input-group-ora"
  }, [_vm._m(11), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.CustomerOrderNumber),
      expression: "filter.CustomerOrderNumber"
    }],
    staticClass: "form-control form-control-ora-sin-blank",
    attrs: {
      "mode": "text",
      "id": "txtPedido",
      "name": "txtPedido",
      "placeholder": "Nro de Pedido",
      "maxlength": "30"
    },
    domProps: {
      "value": (_vm.filter.CustomerOrderNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filter, "CustomerOrderNumber", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._m(12)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 text-right",
    staticStyle: {
      "padding-left": "0px"
    }
  }, [_c('button', {
    staticClass: "btn btn-sm btnAction btn-ora btn-ora-auto",
    staticStyle: {
      "width": "40px"
    },
    on: {
      "click": function($event) {
        return _vm.clear()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/svg/eraser.svg"
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btnAction btn-ora btn-ora-auto",
    staticStyle: {
      "width": "40px"
    },
    on: {
      "click": function($event) {
        return _vm.search(1)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/svg/search-solid.svg"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-4 text-left"
  }, [_c('button', {
    staticClass: "btn btn-sm btnAction btn-ora btn-ora-auto",
    on: {
      "click": function($event) {
        return _vm.verFiltros()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/svg/filter.svg"
    }
  }), _c('span', {
    staticStyle: {
      "padding-left": "5px"
    }
  }, [_vm._v("Filtros")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-3 text-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-5 text-right"
  }, [_c('button', {
    staticClass: "btn btn-sm btnAction btn-ora btn-ora-auto",
    on: {
      "click": function($event) {
        return _vm.showExport()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/svg/excel.svg"
    }
  }), _c('span', {
    staticStyle: {
      "padding-left": "5px"
    }
  }, [_vm._v("Exportar")])])])]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.showFilter) ? _c('div', {
    staticClass: "div-filtro"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 text-right"
  }, [_c('button', {
    staticClass: "btn btn-sm btnAction btn-ora btn-ora-auto",
    on: {
      "click": function($event) {
        return _vm.showAdvanced()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/svg/filter.svg"
    }
  }), _c('span', {
    staticStyle: {
      "padding-left": "5px"
    }
  }, [_vm._v("Búsqueda Avanzada")])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(13), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group input-group-ora"
  }, [_vm._m(14), _vm._v(" "), _c('multiselect', {
    staticClass: "multiselect-ora multiselect-ora-layer",
    attrs: {
      "id": "cboTipo",
      "name": "cboTipo",
      "selectLabel": "",
      "selectedLabel": "",
      "deselectLabel": "",
      "placeholder": "Tipo",
      "track-by": "description",
      "label": "description",
      "customLabel": _vm.optDescription,
      "show-labels": false,
      "close-on-select": true,
      "options": _vm.orderTypeList
    },
    on: {
      "open": function($event) {
        return _vm.reloadTypes()
      }
    },
    model: {
      value: (_vm.filter.OrderType),
      callback: function($$v) {
        _vm.$set(_vm.filter, "OrderType", $$v)
      },
      expression: "filter.OrderType"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noOptions"
    },
    slot: "noOptions"
  }, [_vm._v("La lista esta vacia.")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("No se encontró el elemento buscado.")])]), _vm._v(" "), _vm._m(15)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group input-group-ora"
  }, [_vm._m(16), _vm._v(" "), _c('multiselect', {
    staticClass: "multiselect-ora multiselect-ora-point",
    attrs: {
      "id": "cboZona",
      "name": "cboZona",
      "selectLabel": "",
      "selectedLabel": "",
      "deselectLabel": "",
      "placeholder": "Zona",
      "track-by": "description",
      "label": "description",
      "customLabel": _vm.optDescription,
      "show-labels": false,
      "close-on-select": true,
      "options": _vm.orderZoneList
    },
    on: {
      "open": function($event) {
        return _vm.reloadZone()
      }
    },
    model: {
      value: (_vm.filter.Zone),
      callback: function($$v) {
        _vm.$set(_vm.filter, "Zone", $$v)
      },
      expression: "filter.Zone"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noOptions"
    },
    slot: "noOptions"
  }, [_vm._v("La lista esta vacia.")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("No se encontró el elemento buscado.")])]), _vm._v(" "), _vm._m(17)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group input-group-ora"
  }, [_vm._m(18), _vm._v(" "), _c('multiselect', {
    staticClass: "multiselect-ora multiselect-ora-bar",
    attrs: {
      "id": "cboEstado",
      "name": "cboEstado",
      "selectLabel": "",
      "selectedLabel": "",
      "deselectLabel": "",
      "placeholder": "Estado",
      "track-by": "description",
      "label": "description",
      "customLabel": _vm.optDescription,
      "show-labels": false,
      "close-on-select": true,
      "options": _vm.orderStatusList
    },
    on: {
      "open": function($event) {
        return _vm.reloadStatus()
      }
    },
    model: {
      value: (_vm.filter.Status),
      callback: function($$v) {
        _vm.$set(_vm.filter, "Status", $$v)
      },
      expression: "filter.Status"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noOptions"
    },
    slot: "noOptions"
  }, [_vm._v("La lista esta vacia.")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("No se encontró el elemento buscado.")])]), _vm._v(" "), _vm._m(19)], 1)])]), _vm._v(" "), (_vm.advanced) ? _c('div', [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group input-group-ora"
  }, [_vm._m(20), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.TrackingNumber),
      expression: "filter.TrackingNumber"
    }],
    staticClass: "form-control form-control-ora-sin",
    attrs: {
      "mode": "text",
      "id": "txtTacking",
      "name": "txtTacking",
      "placeholder": "Nro Tracking",
      "maxlength": "20"
    },
    domProps: {
      "value": (_vm.filter.TrackingNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filter, "TrackingNumber", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._m(21)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group input-group-ora"
  }, [_vm._m(22), _vm._v(" "), _c('multiselect', {
    staticClass: "multiselect-ora multiselect-ora-point",
    attrs: {
      "id": "cboDepartamento",
      "name": "cboDepartamento",
      "selectLabel": "",
      "selectedLabel": "",
      "deselectLabel": "",
      "placeholder": "Departamento",
      "track-by": "name",
      "label": "name",
      "customLabel": _vm.optName,
      "show-labels": false,
      "close-on-select": true,
      "options": _vm.departamentList
    },
    on: {
      "input": function($event) {
        return _vm.getProvince()
      },
      "open": function($event) {
        return _vm.reloadDepartament()
      }
    },
    model: {
      value: (_vm.filter.Department),
      callback: function($$v) {
        _vm.$set(_vm.filter, "Department", $$v)
      },
      expression: "filter.Department"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noOptions"
    },
    slot: "noOptions"
  }, [_vm._v("La lista esta vacia.")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("No se encontró el elemento buscado.")])]), _vm._v(" "), _vm._m(23)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group input-group-ora"
  }, [_vm._m(24), _vm._v(" "), _c('multiselect', {
    staticClass: "multiselect-ora multiselect-ora-point",
    attrs: {
      "id": "cboProvincia",
      "name": "cboProvincia",
      "selectLabel": "",
      "selectedLabel": "",
      "deselectLabel": "",
      "placeholder": "Provincia",
      "track-by": "name",
      "label": "name",
      "customLabel": _vm.optName,
      "show-labels": false,
      "close-on-select": true,
      "options": _vm.provinceList
    },
    on: {
      "input": function($event) {
        return _vm.getDistrict()
      },
      "open": function($event) {
        return _vm.reloadProvince()
      }
    },
    model: {
      value: (_vm.filter.Province),
      callback: function($$v) {
        _vm.$set(_vm.filter, "Province", $$v)
      },
      expression: "filter.Province"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noOptions"
    },
    slot: "noOptions"
  }, [_vm._v("La lista esta vacia.")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("No se encontró el elemento buscado.")])]), _vm._v(" "), _vm._m(25)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group input-group-ora"
  }, [_vm._m(26), _vm._v(" "), _c('multiselect', {
    staticClass: "multiselect-ora multiselect-ora-point",
    attrs: {
      "id": "cboDistrito",
      "name": "cboDistrito",
      "selectLabel": "",
      "selectedLabel": "",
      "deselectLabel": "",
      "placeholder": "Distrito",
      "track-by": "name",
      "label": "name",
      "customLabel": _vm.optName,
      "show-labels": false,
      "close-on-select": true,
      "options": _vm.districtList
    },
    on: {
      "open": function($event) {
        return _vm.reloadDistrict()
      }
    },
    model: {
      value: (_vm.filter.District),
      callback: function($$v) {
        _vm.$set(_vm.filter, "District", $$v)
      },
      expression: "filter.District"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noOptions"
    },
    slot: "noOptions"
  }, [_vm._v("La lista esta vacia.")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("No se encontró el elemento buscado.")])]), _vm._v(" "), _vm._m(27)], 1)])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 text-center"
  }, [_c('button', {
    staticClass: "btn btn-sm btnAction btn-ora btn-ora-auto",
    on: {
      "click": function($event) {
        return _vm.clear()
      }
    }
  }, [_vm._v(" Limpiar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btnAction btn-ora btn-ora-auto",
    on: {
      "click": function($event) {
        return _vm.search(1)
      }
    }
  }, [_vm._v(" Buscar")])])])]) : _vm._e()])]), _vm._v(" "), (!_vm.mobile) ? _c('div', {
    staticClass: "doc-filter"
  }, [_c('div', {
    staticClass: "ati-flex ati-pb"
  }, [_vm._m(28), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn-sm btnAction btn-ora btn-ora-auto",
    on: {
      "click": function($event) {
        return _vm.showExport()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/svg/excel.svg"
    }
  }), _c('span', {
    staticStyle: {
      "padding-left": "5px"
    }
  }, [_vm._v("Exportar")])])])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "filterContainer"
  }, [_c('vuetable', {
    key: _vm.tableKey,
    ref: "vuetable",
    attrs: {
      "id": "resultTable",
      "api-mode": false,
      "fields": _vm.tableFields,
      "css": _vm.tableCSS.table,
      "noDataTemplate": "No se encontraron resultados",
      "data": _vm.tableData,
      "data-manager": _vm.dataManager,
      "pagination-path": "pagination"
    },
    on: {
      "vuetable:pagination-data": _vm.onPaginationData
    },
    scopedSlots: _vm._u([{
      key: "orderType",
      fn: function(props) {
        return [_c('div', [_c('span', [_vm._v(_vm._s(_vm._f("firstLetter")(props.rowData.orderType)))])])]
      }
    }, {
      key: "orderNumber",
      fn: function(props) {
        return [_c('div', {
          staticStyle: {
            "min-width": "100px"
          }
        }, [_c('span', [_vm._v(_vm._s(props.rowData.customerOrderNumber))])])]
      }
    }, {
      key: "issueDate",
      fn: function(props) {
        return [_c('div', {
          staticStyle: {
            "min-width": "120px",
            "text-align": "center"
          }
        }, [_c('span', [_vm._v(_vm._s(_vm._f("formatDateOnly")(props.rowData.issueDate, "DD/MM/YYYY", true)))])])]
      }
    }, {
      key: "customerName",
      fn: function(props) {
        return [_c('div', [_c('span', [_vm._v(_vm._s(_vm._f("firstLetter")(props.rowData.customerName)))])])]
      }
    }, {
      key: "customerAddress",
      fn: function(props) {
        return [_c('div', [_c('span', [_vm._v(_vm._s(_vm._f("firstLetter")(props.rowData.customerAddress)))])])]
      }
    }, {
      key: "status",
      fn: function(props) {
        return [_c('div', {
          staticClass: "data-status-ora"
        }, [_vm._v("\n                " + _vm._s(_vm._f("firstLetter")(props.rowData.status)) + "\n              ")])]
      }
    }, {
      key: "trackingNumber",
      fn: function(props) {
        return [_c('div', {
          class: {
            'selected-row': _vm.selectIndex === props.rowIndex
          }
        }, [_c('a', {
          staticClass: "data-arrow",
          attrs: {
            "data-toggle": "collapse"
          },
          on: {
            "click": function($event) {
              return _vm.goTracking(props.rowData, props.rowIndex)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-chevron-right",
          attrs: {
            "aria-hidden": "true"
          }
        })])])]
      }
    }], null, false, 438030318)
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_vm._v("                \n               \n              "), (this.paginationData && _vm.paginationData.total > 0) ? [_c('strong', {
    staticStyle: {
      "color": "#364A5D",
      "paddin-left": "15px"
    }
  }, [_vm._v("\n                Mostrando documento " + _vm._s(this.paginationData.from > 1 ? this.paginationData.from : this.paginationData.from + (_vm.pageNumber - 1) * 20) + " a " + _vm._s(this.paginationData.to < this.paginationData.per_page ? this.paginationData.total : this.paginationData.to * this.pageNumber) + " de " + _vm._s(this.paginationData.total) + " en Total\n                ")])] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('vuetable-pagination', {
    ref: "pagination",
    attrs: {
      "css": _vm.tableCSS.pagination
    },
    on: {
      "vuetable-pagination:change-page": _vm.onChangePage
    }
  })], 1)])], 1)])]) : _c('div', {
    staticStyle: {
      "padding": "20px 5px 20px 5px"
    }
  }, [_vm._m(29), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "filterContainer"
  }, [(_vm.tableData.data === null || _vm.tableData.data.length === 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("No se encontraron resultados")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.tableData.data), function(order, index) {
    return _c('div', {
      key: index,
      ref: "detailsitem",
      refInFor: true,
      staticClass: "div-data",
      class: {
        'selected-row-mov': _vm.selectIndex === index
      }
    }, [_c('div', {
      staticClass: "row",
      on: {
        "click": function($event) {
          return _vm.goTracking(order, index)
        }
      }
    }, [_c('div', {
      staticClass: "col-xs-4 div-data-space"
    }, [_c('div', {
      staticClass: "form-group div-data-bottom"
    }, [_c('label', {
      staticClass: "div-data-title"
    }, [_vm._v("Tipo")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "div-data-value"
    }, [_vm._v(_vm._s(_vm._f("firstLetter")(order.orderType)))])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-4 div-data-space"
    }, [_c('div', {
      staticClass: "form-group div-data-bottom"
    }, [_c('label', {
      staticClass: "div-data-title"
    }, [_vm._v("Nro. Pedido")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "div-data-value-limit"
    }, [_vm._v(_vm._s(order.customerOrderNumber))])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-4 div-data-space"
    }, [_c('div', {
      staticClass: "form-group div-data-bottom"
    }, [_c('label', {
      staticClass: "div-data-title"
    }, [_vm._v("Fecha Pedido")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "div-data-value"
    }, [_vm._v(_vm._s(_vm._f("formatDate")(order.issueDate, "DD/MM/YYYY", true)))])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 div-data-space"
    }, [_c('div', {
      staticClass: "form-group div-data-bottom"
    }, [_c('label', {
      staticClass: "div-data-title"
    }, [_vm._v("Nombre del Cliente")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "div-data-value"
    }, [_vm._v(_vm._s(_vm._f("firstLetter")(order.customerName)))])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 div-data-space"
    }, [_c('div', {
      staticClass: "form-group div-data-bottom"
    }, [_c('label', {
      staticClass: "div-data-title"
    }, [_vm._v("Dirección")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "div-data-value"
    }, [_vm._v(_vm._s(_vm._f("firstLetter")(order.customerAddress)))])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 div-data-space"
    }, [_c('div', {
      staticClass: "form-group div-data-bottom"
    }, [_c('label', {
      staticClass: "div-data-title"
    }, [_vm._v("Status")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "div-data-status",
      staticStyle: {
        "color": "#3D77FF"
      }
    }, [_vm._v(_vm._s(_vm._f("firstLetter")(order.status)))])])])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 text-center"
  }, [_c('vuetable', {
    key: _vm.tableKey,
    ref: "vuetable",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "api-mode": false,
      "fields": _vm.tableFields,
      "data": _vm.tableData,
      "data-manager": _vm.dataManager,
      "pagination-path": "pagination"
    },
    on: {
      "vuetable:pagination-data": _vm.onPaginationData
    }
  }), _vm._v(" "), (this.paginationData && _vm.paginationData.total > 0) ? [_c('strong', {
    staticStyle: {
      "color": "#364A5D",
      "paddin-left": "15px"
    }
  }, [_vm._v("\n                  Mostrando documento " + _vm._s(this.paginationData.from > 1 ? this.paginationData.from : this.paginationData.from + (_vm.pageNumber - 1) * 20) + " a " + _vm._s(this.paginationData.to < this.paginationData.per_page ? this.paginationData.total : this.paginationData.to * this.pageNumber) + " de " + _vm._s(this.paginationData.total) + " en Total\n                ")])] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 text-center"
  }, [_c('vuetable-pagination', {
    ref: "pagination",
    staticStyle: {
      "float": "none !important"
    },
    attrs: {
      "css": _vm.tableCSS.pagination
    },
    on: {
      "vuetable-pagination:change-page": _vm.onChangePage
    }
  })], 1)])], 2)])]), _vm._v(" "), (_vm.existe == 0) ? _c('div', {
    staticClass: "msg-order"
  }, [(_vm.mobile) ? _c('div', [_c('img', {
    staticClass: "img-nf",
    attrs: {
      "src": "/static/img/noencontrado.png"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "title-nf"
  }, [_vm._v("\n          No hemos podido encontrar tu pedido\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "p-nf"
  }, [_vm._v("\n          Comunicate con nosotros para brindarte información de tu pedido\n        ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-ora",
    staticStyle: {
      "width": "200px"
    },
    on: {
      "click": function($event) {
        return _vm.contact()
      }
    }
  }, [_vm._v("Contáctate con nosotros")])]), _vm._v(" "), (!_vm.mobile) ? _c('div', [_c('img', {
    staticClass: "img-nf",
    attrs: {
      "src": "/static/img/noencontrado.png"
    }
  })]) : _vm._e()]) : _vm._e()])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ati-flex ati-header"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/svg/search.svg"
    }
  }), _c('span', {
    staticClass: "nav-header-title-label"
  }, [_vm._v("Seguimiento de Pedido")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ati-flex"
  }, [_c('div', {
    staticClass: "title-filter"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/svg/doc-search.svg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "label-filter"
  }, [_vm._v("Buscar Documento")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-6 col-md-2 col-lg-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group input-group-ora"
  }, [_c('div', {
    staticClass: "input-group-addon input-group-addon-ico"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/svg/calendar.svg"
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control form-control-ora-sin",
    attrs: {
      "id": "dtDateRange",
      "name": "dtDateRange",
      "mode": "text",
      "placeholder": "Fecha Pedido",
      "aria-labelledby": "label-fecha",
      "readOnly": ""
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "label-ora",
    attrs: {
      "for": "dtDateRange",
      "id": "label-fecha"
    }
  }, [_c('div', {
    staticClass: "text-ora"
  }, [_vm._v("Fecha Pedido")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon input-group-addon-ico"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/svg/hash.svg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "label-ora",
    attrs: {
      "for": "txtPedido",
      "id": "label-pedido"
    }
  }, [_c('div', {
    staticClass: "text-ora"
  }, [_vm._v("Nro de Pedido")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon input-group-addon-ico",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/svg/layers.svg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "label-ora",
    attrs: {
      "for": "cboTipo",
      "id": "label-tipo"
    }
  }, [_c('div', {
    staticClass: "text-ora"
  }, [_vm._v("Tipo")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon input-group-addon-ico",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/svg/zone.svg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "label-ora",
    attrs: {
      "for": "cboZona",
      "id": "label-zona"
    }
  }, [_c('div', {
    staticClass: "text-ora"
  }, [_vm._v("Zona")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon input-group-addon-ico",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/svg/bar.svg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "label-ora",
    attrs: {
      "for": "cboEstado",
      "id": "label-estado"
    }
  }, [_c('div', {
    staticClass: "text-ora"
  }, [_vm._v("Estado")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon input-group-addon-ico"
  }, [_c('img', {
    staticClass: "ico-seach-input",
    attrs: {
      "src": "/static/img/svg/search-solid.svg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "label-ora",
    attrs: {
      "for": "txtPedido",
      "id": "label-pedido"
    }
  }, [_c('div', {
    staticClass: "text-ora"
  }, [_vm._v("Nro de Pedido")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group input-group-ora"
  }, [_c('div', {
    staticClass: "input-group-addon input-group-addon-ico"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/svg/calendar.svg"
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control form-control-ora-sin",
    attrs: {
      "id": "dtDateRange",
      "name": "dtDateRange",
      "placeholder": "Fecha Pedido",
      "mode": "text",
      "readOnly": ""
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "label-ora",
    attrs: {
      "for": "dtDateRange",
      "id": "label-fecha"
    }
  }, [_c('div', {
    staticClass: "text-ora"
  }, [_vm._v("Fecha Pedido")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon input-group-addon-ico",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/svg/layers.svg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "label-ora",
    attrs: {
      "for": "cboTipo",
      "id": "label-tipo"
    }
  }, [_c('div', {
    staticClass: "text-ora"
  }, [_vm._v("Tipo")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon input-group-addon-ico",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/svg/zone.svg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "label-ora",
    attrs: {
      "for": "cboZona",
      "id": "label-zona"
    }
  }, [_c('div', {
    staticClass: "text-ora"
  }, [_vm._v("Zona")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon input-group-addon-ico",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/svg/bar.svg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "label-ora",
    attrs: {
      "for": "cboEstado",
      "id": "label-estado"
    }
  }, [_c('div', {
    staticClass: "text-ora"
  }, [_vm._v("Estado")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon input-group-addon-ico"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/svg/hash.svg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "label-ora",
    attrs: {
      "for": "txtTacking",
      "id": "label-tracking"
    }
  }, [_c('div', {
    staticClass: "text-ora"
  }, [_vm._v("Nro Tracking")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon input-group-addon-ico",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/svg/zone.svg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "label-ora",
    attrs: {
      "for": "cboDepartamento",
      "id": "label-departamento"
    }
  }, [_c('div', {
    staticClass: "text-ora"
  }, [_vm._v("Departamento")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon input-group-addon-ico",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/svg/zone.svg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "label-ora",
    attrs: {
      "for": "cboProvincia",
      "id": "label-provincia"
    }
  }, [_c('div', {
    staticClass: "text-ora"
  }, [_vm._v("Provincia")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon input-group-addon-ico",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/svg/zone.svg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "label-ora",
    attrs: {
      "for": "cboDistrito",
      "id": "label-distrito"
    }
  }, [_c('div', {
    staticClass: "text-ora"
  }, [_vm._v("Distrito")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ati-flex"
  }, [_c('div', {
    staticClass: "title-filter"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/svg/list.svg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "label-filter"
  }, [_vm._v("Pedidos")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ati-flex ati-pb"
  }, [_c('div', {
    staticClass: "ati-flex"
  }, [_c('div', {
    staticClass: "title-filter"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/svg/list.svg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "label-filter"
  }, [_vm._v("Pedidos")])])])
}]}

/***/ }),
/* 525 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 526 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "skin-green sidebar-mini"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('va-navibar-orange'), _vm._v(" "), _c('va-slider-orange'), _vm._v(" "), _c('va-content-wrap', {
    staticStyle: {
      "background-color": "#F6F6F6"
    }
  }), _vm._v(" "), _c('Modal')], 1)])
},staticRenderFns: []}

/***/ }),
/* 527 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box box-success"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "filterContainer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group",
    attrs: {
      "id": "divAccountSelect"
    }
  }, [_c('label', [_vm._v("Cuenta")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "value": this.selectedAccount,
      "selectLabel": "",
      "selectedLabel": "",
      "deselectLabel": "",
      "track-by": "name",
      "placeholder": this.selectedAccount.name,
      "allow-empty": false,
      "label": "name",
      "options": this.optionsAccount
    },
    on: {
      "input": _vm.onAccountSelect
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("\n                No se encontraron resultados\n              ")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 form-interspace"
  }, [_c('div', {
    staticClass: "form-group pull-left",
    staticStyle: {
      "padding-top": "25px"
    }
  }, [_c('router-link', {
    staticClass: "btn btn-success",
    attrs: {
      "to": {
        name: 'AlertRulesEntry',
        params: {
          accountCode: this.selectedAccount.code
        }
      },
      "tag": "button"
    }
  }, [_vm._v("Registrar Regla")])], 1)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box box-success"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    attrs: {
      "id": "tablaReglas"
    }
  }, [_c('div', {
    attrs: {
      "id": "ruleTable"
    }
  }, [_c('vuetable', {
    ref: "vuetable",
    attrs: {
      "id": "ruleTable",
      "api-mode": false,
      "fields": _vm.tableFields,
      "data": _vm.tableData,
      "css": _vm.tableCSS.table,
      "noDataTemplate": "No se encontraron resultados"
    },
    on: {
      "vuetable:row-clicked": _vm.onClick,
      "vuetable:loading": _vm.onLoading,
      "vuetable:loaded": _vm.onLoaded
    },
    scopedSlots: _vm._u([{
      key: "ruleCode",
      fn: function(props) {
        return [_c('div', {
          attrs: {
            "id": "Codigo"
          }
        }, [_c('span', [_vm._v(_vm._s(props.rowData.ruleCode))])])]
      }
    }, {
      key: "ruleName",
      fn: function(props) {
        return [_c('div', {
          attrs: {
            "id": "Nombre"
          }
        }, [_c('span', [_vm._v(_vm._s(props.rowData.ruleName))])])]
      }
    }, {
      key: "ruleItemType",
      fn: function(props) {
        return [_c('div', {
          attrs: {
            "id": "Tipo"
          }
        }, [_c('span', [_vm._v(_vm._s(props.rowData.ruleItemType))])])]
      }
    }, {
      key: "ruleItemCode",
      fn: function(props) {
        return [_c('div', {
          attrs: {
            "id": "Codigo"
          }
        }, [_c('span', [_vm._v(_vm._s(props.rowData.ruleItemCode))])])]
      }
    }, {
      key: "ruleOperator",
      fn: function(props) {
        return [_c('div', {
          attrs: {
            "id": "Operador"
          }
        }, [_c('span', [_vm._v(_vm._s(props.rowData.ruleOperator))])])]
      }
    }, {
      key: "ruleValue",
      fn: function(props) {
        return [_c('div', {
          attrs: {
            "id": "Valor"
          }
        }, [_c('span', [_vm._v(_vm._s(props.rowData.ruleValue))])])]
      }
    }])
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title title"
  }, [_vm._v("Reglas de negocio")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header title-boreder"
  }, [_c('h3', {
    staticClass: "box-title box-title-sub"
  }, [_c('img', {
    staticClass: "icon-space",
    staticStyle: {
      "padding-bottom": "5px"
    },
    attrs: {
      "src": "/static/img/icons/exclamation-circle-solid-modal.png"
    }
  }), _vm._v(" Reglas de Negocio")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header title-boreder"
  }, [_c('h3', {
    staticClass: "box-title box-title-sub"
  }, [_c('img', {
    staticClass: "icon-space",
    staticStyle: {
      "padding-bottom": "3px"
    },
    attrs: {
      "src": "/static/img/icons/result.png"
    }
  }), _vm._v(" RESULTADO BÚSQUEDA")])])
}]}

/***/ }),
/* 528 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "div1"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "d-flex justify-content-center h-100"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.handleSubmit.apply(null, arguments)
      }
    }
  }, [_c('fieldset', [_c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('label', [_vm._v("Usuario")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Username),
      expression: "Username"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.submitted && !_vm.Username
    },
    attrs: {
      "type": "text",
      "placeholder": "Usuario",
      "maxlength": "20"
    },
    domProps: {
      "value": (_vm.Username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.Username = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Contraseña")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Password),
      expression: "Password"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.submitted && !_vm.Password
    },
    attrs: {
      "type": "Password",
      "name": "Password",
      "placeholder": "Contraseña",
      "maxlength": "100"
    },
    domProps: {
      "value": (_vm.Password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.Password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.submitted && _vm.message),
      expression: "!submitted && message"
    }],
    staticClass: "invalid-feedback",
    staticStyle: {
      "padding-top": "5%"
    }
  }, [_vm._v(_vm._s(_vm.message))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "right",
      "padding-top": "10px"
    }
  }, [_c('button', {
    class: ['btn btn-sm btn-success btnAction btn-login'],
    staticStyle: {
      "padding-right": "10px",
      "width": "107px !important"
    },
    attrs: {
      "value": "Iniciar sesión"
    }
  }, [_c('span', {
    staticStyle: {
      "position": "relative",
      "left": "-2px"
    }
  }, [_vm._v("Iniciar sesión")])])])])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('img', {
    staticClass: "dinet-logo",
    attrs: {
      "src": "/static/img/dinet.png"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "acces-title"
  }, [_c('i', {
    staticClass: "login-logo"
  }), _vm._v("Iniciar Sesión")])])
}]}

/***/ }),
/* 529 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-success"
  }, [_vm._m(0), _vm._v(" "), (_vm.isMounted) ? _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4"
  }, [_c('b', [_vm._v("Recibido")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "padding-top": "30px"
    }
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "center-block",
    staticStyle: {
      "width": "150px"
    }
  }, [_c('chart-projection-received', {
    ref: "chartReceived",
    attrs: {
      "chart-data": _vm.projectionChartDataReceived,
      "width": 100,
      "height": 100
    }
  })], 1)])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('div', {
    staticClass: "text-center center-block",
    staticStyle: {
      "width": "150px"
    }
  }, [_c('img', {
    staticStyle: {
      "vertical-align": "text-bottom"
    },
    attrs: {
      "src": "/static/img/icons/ic_storage_arrived@3x.png",
      "alt": "Ingresadas",
      "height": "20",
      "width": "20"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "span-value",
    style: (_vm.formatAmountColor(this.fetchData.recivedPercentageWarehouse))
  }, [_vm._v("\n                    " + _vm._s(_vm._f("formatAmount")(this.fetchData.recivedAmountWarehouse))), _c('span', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v(" " + _vm._s(this.fetchData.minimumStockUnit))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "span-status"
  }, [_vm._v("Recibido")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('div', {
    staticClass: "text-center center-block",
    staticStyle: {
      "width": "150px"
    }
  }, [_c('i', {
    staticClass: "fa fa-bullseye",
    style: ({
      color: this.colorProjected
    })
  }), _vm._v(" "), _c('span', {
    staticClass: "span-value",
    style: ({
      color: this.colorProjected
    })
  }, [_vm._v("\n                    " + _vm._s(_vm._f("formatAmount")(this.fetchData.recivedAmountProjectionWarehouse))), _c('span', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v(" " + _vm._s(this.fetchData.minimumStockUnit))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "span-status"
  }, [_vm._v("Proyectado")])])])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-lg-9 chartPadding"
  }, [_c('chart-line-return', {
    attrs: {
      "chart-data": _vm.lineChartDataReceived,
      "height": 240
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('b', [_vm._v("Despachado")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "padding-top": "30px"
    }
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "center-block",
    staticStyle: {
      "width": "150px"
    }
  }, [_c('chart-projection-shipped', {
    ref: "chartShipped",
    attrs: {
      "chart-data": _vm.projectionChartDataShipped,
      "width": 100,
      "height": 100
    }
  })], 1)])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('div', {
    staticClass: "text-center center-block",
    staticStyle: {
      "width": "150px"
    }
  }, [_c('img', {
    staticStyle: {
      "vertical-align": "text-bottom"
    },
    attrs: {
      "src": "/static/img/icons/ic_storage_shipped@3x.png",
      "alt": "Ingresadas",
      "height": "20",
      "width": "20"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "span-value",
    style: (_vm.formatAmountColor(this.fetchData.shippedPercentageWarehouse))
  }, [_vm._v("\n                    " + _vm._s(_vm._f("formatAmount")(this.fetchData.shippedAmountWarehouse))), _c('span', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v(" " + _vm._s(this.fetchData.minimumStockUnit))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "span-status"
  }, [_vm._v("Despachado")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('div', {
    staticClass: "text-center center-block",
    staticStyle: {
      "width": "150px"
    }
  }, [_c('i', {
    staticClass: "fa fa-bullseye",
    style: ({
      color: this.colorProjected
    })
  }), _vm._v(" "), _c('span', {
    staticClass: "span-value",
    style: ({
      color: this.colorProjected
    })
  }, [_vm._v("\n                    " + _vm._s(_vm._f("formatAmount")(this.fetchData.shippedAmountProjectionWarehouse))), _c('span', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v(" " + _vm._s(this.fetchData.minimumStockUnit))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "span-status"
  }, [_vm._v("Proyectado")])])])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-lg-9 chartPadding"
  }, [_c('chart-line-return', {
    attrs: {
      "chart-data": _vm.lineChartDataShipped,
      "height": 240
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('b', [_vm._v("Devolución")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "padding-top": "100px"
    }
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "center-block",
    staticStyle: {
      "width": "170px"
    }
  }, [_c('div', {
    staticClass: "pull-left text-center",
    staticStyle: {
      "width": "170px"
    }
  }, [_c('img', {
    staticStyle: {
      "vertical-align": "text-bottom"
    },
    attrs: {
      "src": "/static/img/icons/ic_returned@3x.png",
      "alt": "Ingresadas",
      "height": "20",
      "width": "20"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "span-value",
    style: ({
      color: this.colorReturned
    })
  }, [_vm._v("\n                      " + _vm._s(_vm._f("formatAmount")(this.fetchData.returnedAmountWarehouse))), _c('span', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v(" " + _vm._s(this.fetchData.minimumStockUnit))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "span-status"
  }, [_vm._v("Devoluciones")])])])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-lg-9 chartPadding"
  }, [_c('chart-line-return', {
    attrs: {
      "chart-data": _vm.lineChartDataReturn,
      "height": 240
    }
  })], 1)])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title box-title-sub"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/icons/almacen-verde.png"
    }
  }), _vm._v(" Almacén")])])
}]}

/***/ }),
/* 530 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [(_vm.showModalFotos) ? _c('transition', {
    attrs: {
      "id": "fotos",
      "name": "fotos"
    }
  }, [_c('div', {
    staticClass: "modal-cus-mask"
  }, [_c('div', {
    staticClass: "modal-cus-wrapper"
  }, [_c('div', {
    staticClass: "modal-cus-container"
  }, [_c('div', {
    staticClass: "modal-cus-header"
  }, [_vm._t("header", function() {
    return [_c('div', {
      staticClass: "title-boreder"
    }, [_c('div', {
      staticClass: "box-title box-title-sub"
    }, [_c('img', {
      staticStyle: {
        "padding-bottom": "6px",
        "padding-right": "8px"
      },
      attrs: {
        "src": "/static/img/svg/photo.svg"
      }
    }), _vm._v(" "), _c('span', [_vm._v("ver fotos")])]), _vm._v(" "), _c('button', {
      staticClass: "close",
      staticStyle: {
        "padding": "5px",
        "position": "relative !important",
        "top": "-35px !important"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.showModalFotos = false
        }
      }
    }, [_c('span', {
      attrs: {
        "aria-hidden": "true"
      }
    }, [_vm._v("×")])])])]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-cus-body"
  }, [_vm._t("body", function() {
    return [_c('div', {
      staticClass: "slideshow-container-ora"
    }, _vm._l((_vm.fotos), function(foto, fotosIndex) {
      return _c('div', {
        key: fotosIndex,
        staticClass: "slides-ora fade-ora"
      }, [_c('button', {
        staticClass: "close",
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            return _vm.download(foto)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-download",
        attrs: {
          "aria-hidden": "true"
        }
      })]), _vm._v(" "), _c('inner-image-zoom', {
        attrs: {
          "src": foto,
          "zoomSrc": foto
        }
      })], 1)
    }), 0), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
      staticStyle: {
        "text-align": "center"
      }
    }, _vm._l((_vm.fotos), function(foto, fotosIndex) {
      return _c('span', {
        key: fotosIndex,
        staticClass: "dot-ora",
        on: {
          "click": function($event) {
            return _vm.currentSlide(fotosIndex + 1)
          }
        }
      })
    }), 0)]
  })], 2)])])])]) : _vm._e(), _vm._v(" "), (_vm.showModalCopiar) ? _c('transition', {
    attrs: {
      "id": "copiar",
      "name": "copiar"
    }
  }, [_c('div', {
    staticClass: "modal-cus-mask"
  }, [_c('div', {
    staticClass: "modal-cus-wrapper"
  }, [_c('div', {
    staticClass: "modal-cus-container",
    staticStyle: {
      "width": "450px"
    }
  }, [_c('div', {
    staticClass: "modal-cus-header"
  }, [_vm._t("header", function() {
    return [_c('div', {
      staticClass: "title-boreder"
    }, [_c('div', {
      staticClass: "box-title box-title-sub"
    }, [_c('span', [_vm._v("Enviar Vínculo")])]), _vm._v(" "), _c('button', {
      staticClass: "close",
      staticStyle: {
        "padding": "5px",
        "position": "relative !important",
        "top": "-35px !important"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.showModalCopiar = false
        }
      }
    }, [_c('span', {
      attrs: {
        "aria-hidden": "true"
      }
    }, [_vm._v("×")])])])]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-cus-body",
    staticStyle: {
      "margin": "10px"
    }
  }, [_vm._t("body", function() {
    return [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-12"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-lg-1 col-md-1 col-xs-2",
      staticStyle: {
        "font-size": "24px",
        "padding-top": "15px",
        "color": "#3D77FF"
      }
    }, [_c('i', {
      ref: "atrack",
      staticClass: "fa fa-link a-icon",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-8 col-md-8 col-xs-10 text-left"
    }, [_vm._v("\n                        Comparte el seguimiento de tu pedido, pídele a la otra persona que ingrese tu nombre para ver el tracking\n                      ")]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-3 col-md-3 col-xs-12 text-center"
    }, [_c('button', {
      staticClass: "btn btn-ora-blue",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.copy()
        }
      }
    }, [_vm._v("\n                          Copiar\n                        ")]), _vm._v(" "), _c('div', {
      staticClass: "div-copy",
      staticStyle: {
        "display": "none"
      },
      attrs: {
        "id": "divCopy"
      }
    }, [_vm._v("Copiado")])])])])])]
  })], 2)])])])]) : _vm._e(), _vm._v(" "), _c('modal', {
    staticClass: "modal-ora",
    attrs: {
      "id": "detail",
      "name": "detail"
    }
  }, [_c('div', {
    staticClass: "box-header title-boreder"
  }, [_c('div', {
    staticClass: "box-title box-title-sub"
  }, [_c('img', {
    staticStyle: {
      "padding-bottom": "6px",
      "padding-right": "8px"
    },
    attrs: {
      "src": "/static/img/svg/list.svg"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Detalle de Pedido")])]), _vm._v(" "), _c('button', {
    staticClass: "close",
    staticStyle: {
      "padding": "5px"
    },
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.$modal.hide('detail')
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "filterContainer"
  }, [(!_vm.mobile) ? _c('vuetable', {
    key: _vm.tableKey,
    ref: "vuetable",
    attrs: {
      "id": "resultTable",
      "api-mode": false,
      "fields": _vm.tableFields,
      "css": _vm.tableCSS.table,
      "noDataTemplate": "No se encontraron resultados",
      "data": _vm.tableData
    },
    scopedSlots: _vm._u([{
      key: "itemPos",
      fn: function(props) {
        return [_c('div', {
          staticClass: "text-right"
        }, [_vm._v("\n              " + _vm._s(props.rowData.itemPos) + "\n            ")])]
      }
    }, {
      key: "lpn",
      fn: function(props) {
        return [_c('div', [_c('span', [_vm._v(_vm._s(props.rowData.lpn))])])]
      }
    }, {
      key: "itemCode",
      fn: function(props) {
        return [_c('div', [_vm._v("\n              " + _vm._s(props.rowData.itemCode) + "\n            ")])]
      }
    }, {
      key: "itemDescription",
      fn: function(props) {
        return [_c('div', [_vm._v("\n              " + _vm._s(props.rowData.itemDescription) + "\n            ")])]
      }
    }, {
      key: "quantityOrder",
      fn: function(props) {
        return [_c('div', {
          staticClass: "text-center"
        }, [_vm._v("\n              " + _vm._s(props.rowData.quantityOrder) + "\n            ")])]
      }
    }, {
      key: "quantitySent",
      fn: function(props) {
        return [_c('div', {
          staticClass: "text-center"
        }, [_vm._v("\n              " + _vm._s(props.rowData.quantitySent) + "\n            ")])]
      }
    }, {
      key: "quantityDelivered",
      fn: function(props) {
        return [_c('div', {
          staticClass: "text-center"
        }, [_vm._v("\n              " + _vm._s(props.rowData.quantityDelivered) + "\n            ")])]
      }
    }, {
      key: "quantityRejected",
      fn: function(props) {
        return [_c('div', {
          staticClass: "text-center"
        }, [_vm._v("\n              " + _vm._s(props.rowData.quantityRejected) + "\n            ")])]
      }
    }], null, false, 2414204964)
  }) : _c('div', {
    staticClass: "col-12"
  }, _vm._l((this.tableData.data), function(detail, index) {
    return _c('div', {
      key: index
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-xs-6"
    }, [_c('span', {
      staticClass: "data-field"
    }, [_vm._v("Nro")])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-6",
      style: ({
        background: index % 2 === 0 ? 'white' : '#FAFBFF'
      })
    }, [_c('span', {
      staticClass: "data-title"
    }, [_vm._v(_vm._s(detail.itemPos))])])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-xs-6"
    }, [_c('span', {
      staticClass: "data-field"
    }, [_vm._v("LPN / Precintos")])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-6",
      style: ({
        background: index % 2 === 0 ? 'white' : '#FAFBFF'
      })
    }, [_c('span', {
      staticClass: "data-title"
    }, [_vm._v(_vm._s(detail.lpn))])])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-xs-6"
    }, [_c('span', {
      staticClass: "data-field"
    }, [_vm._v("Código SKU")])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-6",
      style: ({
        background: index % 2 === 0 ? 'white' : '#FAFBFF'
      })
    }, [_c('span', {
      staticClass: "data-title"
    }, [_vm._v(_vm._s(detail.itemCode))])])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-xs-6"
    }, [_c('span', {
      staticClass: "data-field"
    }, [_vm._v("Descripción SKU")])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-6",
      style: ({
        background: index % 2 === 0 ? 'white' : '#FAFBFF'
      })
    }, [_c('span', {
      staticClass: "data-title"
    }, [_vm._v(_vm._s(detail.itemDescription))])])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-xs-6"
    }, [_c('span', {
      staticClass: "data-field"
    }, [_vm._v("Cant. Pedido")])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-6",
      style: ({
        background: index % 2 === 0 ? 'white' : '#FAFBFF'
      })
    }, [_c('span', {
      staticClass: "data-title"
    }, [_vm._v(_vm._s(detail.quantityOrder))])])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-xs-6"
    }, [_c('span', {
      staticClass: "data-field"
    }, [_vm._v("Cant. Despachada")])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-6",
      style: ({
        background: index % 2 === 0 ? 'white' : '#FAFBFF'
      })
    }, [_c('span', {
      staticClass: "data-title"
    }, [_vm._v(_vm._s(detail.quantitySent))])])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-xs-6"
    }, [_c('span', {
      staticClass: "data-field"
    }, [_vm._v("Cant. Entregada")])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-6",
      style: ({
        background: index % 2 === 0 ? 'white' : '#FAFBFF'
      })
    }, [_c('span', {
      staticClass: "data-title"
    }, [_vm._v(_vm._s(detail.quantityDelivered))])])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-xs-6"
    }, [_c('span', {
      staticClass: "data-field"
    }, [_vm._v("Cant. Rechazada")])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-6",
      style: ({
        background: index % 2 === 0 ? 'white' : '#FAFBFF'
      })
    }, [_c('span', {
      staticClass: "data-title"
    }, [_vm._v(_vm._s(detail.quantityRejected))])])]), _vm._v(" "), _c('br')])
  }), 0)], 1)]), _vm._v(" "), _c('div', {
    class: _vm.isOrder ? 'container-order' : 'container-tra'
  }, [_c('div', {
    class: _vm.isOrder ? 'nav-tra-order' : 'nav-tra'
  }, [(_vm.existe && _vm.order.accountLogo != null && _vm.isOrder) ? _c('img', {
    staticClass: "ico-account",
    attrs: {
      "src": ("data:image/png;base64," + (_vm.order.accountLogo))
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isOrder) ? _c('img', {
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "src": "/static/img/logo-tra.png"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.existe && _vm.order.accountLogo != null && !_vm.isOrder) ? _c('img', {
    staticStyle: {
      "height": "35px"
    },
    attrs: {
      "src": ("data:image/png;base64," + (_vm.order.accountLogo))
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.existe == 1) ? _c('div', {
    staticClass: "col"
  }, [(_vm.order.realTimeFlag == 1) ? _c('div', {
    staticClass: "row row-button"
  }, [_c('span', {
    staticClass: "ub-actual",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.getPoint()
      }
    }
  }, [_c('img', {
    staticClass: "ub-icon",
    attrs: {
      "src": "/static/img/svg/pointer.svg"
    }
  }), _vm._v(" "), (!_vm.mobile) ? _c('span', [_vm._v("Ver ubicación actual")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.isPoint) ? _c('l-map', {
    staticStyle: {
      "width": "100%",
      "height": "400px"
    },
    attrs: {
      "zoom": _vm.zoom,
      "center": _vm.center
    }
  }, [_c('l-tile-layer', {
    attrs: {
      "url": "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
    }
  }), _vm._v(" "), _c('l-marker', {
    attrs: {
      "lat-lng": _vm.center
    }
  }, [_c('l-icon', {
    attrs: {
      "icon-url": _vm.iconGP,
      "icon-size": [_vm.iconHE, _vm.iconWI],
      "icon-anchor": [_vm.iconHE, _vm.iconWI]
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.isPoint && !_vm.isOrder) ? _c('div', {
    staticStyle: {
      "height": "70px"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.mobile) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-10"
  }, [_c('div', {
    class: _vm.isPoint ? 'box-tra' : 'box-tra-sm'
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row div-ora-flex"
  }, [_c('div', {
    staticClass: "col-md-6 img-back"
  }, [(_vm.showBack) ? _c('img', {
    staticStyle: {
      "cursor": "pointer",
      "padding-right": "5px"
    },
    attrs: {
      "src": "/static/img/svg/arrow-left.svg"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('hiddenTrack', false)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "label-bold-tra"
  }, [_vm._v("N° Pedido : " + _vm._s(_vm.order.customerOrderNumber == null ? _vm.order.orderNumber : _vm.order.customerOrderNumber))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 text-right"
  }, [(_vm.isOrder) ? _c('button', {
    staticClass: "btn btn-ora-blue",
    on: {
      "click": function($event) {
        return _vm.showDetail()
      }
    }
  }, [_vm._v("Ver Detalle")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6 col-lg-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card-tra"
  }, [_c('div', {
    staticClass: "card-header-tra"
  }, [_vm._m(0), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "status",
    style: ({
      background: _vm.order.configuration.minTextFundColor == '' ? 'black' : _vm.order.configuration.minTextFundColor,
      color: _vm.order.configuration.minTextColor == '' ? 'white' : _vm.order.configuration.minTextColor
    })
  }, [_vm._v(_vm._s(_vm._f("firstLetter")(_vm.order.statusDescription)))])])]), _vm._v(" "), _c('div', {
    staticClass: "timeline"
  }, [_c('div', {
    staticClass: "outer"
  }, _vm._l((_vm.eventList), function(event, index) {
    return _c('div', {
      key: index,
      staticClass: "card-tl"
    }, [_c('div', {
      staticClass: "info"
    }, [_c('div', {
      staticClass: "card-lt-title"
    }, [_c('span', [_vm._v(_vm._s(_vm._f("capitalize")((event.reason == '' ? event.event : event.reason))))]), (event.existImage) ? _c('a', {
      staticClass: "arrow-tra",
      attrs: {
        "data-toggle": "collapse",
        "href": ("#col" + index)
      }
    }, [_c('i', {
      staticClass: "fa fa-chevron-down",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _vm._e()]), _vm._v(" "), _c('p', {
      staticClass: "p-tra"
    }, [_vm._v("\n                                      " + _vm._s(_vm._f("formatDate")(event.eventDate, "LLL")) + "\n                                      "), _c('br'), _vm._v(" "), (event.location != '' && event.location.trim() != '-') ? _c('span', [_vm._v(_vm._s(_vm._f("firstLetter")(event.location)))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "panel-collapse collapse",
      staticStyle: {
        "padding-bottom": "10px"
      },
      attrs: {
        "id": ("col" + index)
      }
    }, [(event.imageUrl1 != '') ? _c('img', {
      staticClass: "img-event",
      attrs: {
        "src": ("" + (event.imageUrl1))
      },
      on: {
        "click": function($event) {
          return _vm.modalFotos(event, 0)
        }
      }
    }) : _vm._e(), _vm._v(" "), (event.imageUrl2 != '') ? _c('img', {
      staticClass: "img-event",
      attrs: {
        "src": ("" + (event.imageUrl2))
      },
      on: {
        "click": function($event) {
          return _vm.modalFotos(event, 1)
        }
      }
    }) : _vm._e(), _vm._v(" "), (event.imageUrl3 != '') ? _c('img', {
      staticClass: "img-event",
      attrs: {
        "src": ("" + (event.imageUrl3))
      },
      on: {
        "click": function($event) {
          return _vm.modalFotos(event, 2)
        }
      }
    }) : _vm._e()])])])
  }), 0)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-lg-6"
  }, [(!_vm.mobile) ? _c('div', {
    staticClass: "row"
  }, [(!_vm.isOrder) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "msg-tra",
    style: ({
      background: _vm.order.configuration.fundColor
    })
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between"
    }
  }, [_c('div', [_c('div', {
    staticClass: "msg-icono",
    style: ({
      background: _vm.order.configuration.iconFundColor
    })
  }, [_c('img', {
    staticClass: "msg-img",
    attrs: {
      "src": ("data:image/png;base64," + (_vm.order.configuration.icon))
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "msg-title",
    style: ({
      color: _vm.order.configuration.higherTextColor
    })
  }, [_vm._v("Hola, " + _vm._s(_vm._f("firstLetter")(_vm.order.customerName)))]), _vm._v(" "), _c('p', {
    staticClass: "msg-p",
    style: ({
      color: _vm.order.configuration.lowerTextColor
    })
  }, [_vm._v("Tu pedido tiene un estado de " + _vm._s(_vm._f("minus")(_vm.order.statusDescription)))])])])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card-tra"
  }, [_c('div', {
    staticClass: "card-header-tra"
  }, [_vm._m(1), _vm._v(" "), _c('div', [_c('span', [_c('a', {
    staticClass: "a-tra",
    attrs: {
      "rel": "noopener noreferrer"
    },
    on: {
      "click": function($event) {
        _vm.showModalCopiar = true
      }
    }
  }, [_c('i', {
    ref: "atrack",
    staticClass: "fa fa-link a-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("Compartir Pedido")])])])]), _vm._v(" "), _c('div', {
    staticClass: "card-body-tra"
  }, [_c('div', {
    staticClass: "row data-space"
  }, [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6 col-lg-6"
  }, [_c('span', {
    staticClass: "data-field"
  }, [_vm._v(_vm._s(this.order.tracking))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6 col-lg-6"
  }, [_c('span', {
    staticClass: "data-field"
  }, [_vm._v(_vm._s(_vm.order.customerOrderNumber == null ? _vm.order.orderNumber : _vm.order.customerOrderNumber))])])]), _vm._v(" "), _c('div', {
    staticClass: "row data-space"
  }, [_vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6 col-lg-6"
  }, [_c('label', {
    staticClass: "data-field",
    staticStyle: {
      "margin-top": "4px"
    }
  }, [_vm._v(_vm._s(_vm._f("firstLetter")(this.order.customerName)))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6 col-lg-6"
  }, [_c('span', {
    staticClass: "data-field"
  }, [_vm._v(_vm._s(_vm.order.destinyContactPhone))])])]), _vm._v(" "), _c('div', {
    staticClass: "row data-space"
  }, [_vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6 col-lg-6"
  }, [_c('label', {
    staticClass: "data-field",
    staticStyle: {
      "margin-top": "4px"
    }
  }, [_vm._v(_vm._s(_vm._f("firstLetter")(this.order.sourceAddress)) + " "), _c('br'), _vm._v(_vm._s(_vm._f("firstLetter")(this.order.sourceNameUbigeo)) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6 col-lg-6"
  }, [_c('label', {
    staticClass: "data-field",
    staticStyle: {
      "margin-top": "4px"
    }
  }, [_vm._v(_vm._s(_vm._f("firstLetter")(_vm.order.destinyAddress)) + " "), _c('br'), _vm._v(" " + _vm._s(_vm._f("firstLetter")(this.order.destinyNameUbigeo)))])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "help-tra"
  }, [_c('div', {
    staticClass: "row help-container"
  }, [_vm._m(8), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "help-title"
  }, [_vm._v(_vm._s(_vm.order.helpQuestion.trim() === '' ? '¿Necesitas ayuda con tu pedido?' : _vm.order.helpQuestion.trim()))]), _vm._v(" "), (_vm.order.contactType == 'TELF') ? _c('a', {
    staticClass: "help-p",
    attrs: {
      "href": ("tel:" + (_vm.order.contactValue))
    }
  }, [_vm._v("Contáctate con nosotros")]) : (_vm.order.contactType == 'MAIL') ? _c('a', {
    staticClass: "help-p",
    attrs: {
      "href": ("mailto:" + (_vm.order.contactValue))
    }
  }, [_vm._v("Contáctate con nosotros")]) : _c('a', {
    staticClass: "help-p",
    attrs: {
      "href": ("" + (_vm.order.contactValue)),
      "target": "_blank"
    }
  }, [_vm._v("Contáctate con nosotros")])])])])])])])])])])]), _vm._v(" "), (!_vm.mobile) ? _c('div', {
    staticClass: "col-xs-1"
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.mobile) ? _c('div', {
    staticClass: "row"
  }, [(!_vm.isOrder) ? _c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "padding-left": "0px"
    }
  }, [_c('div', {
    class: _vm.order.statusDescription.length > 10 ? (_vm.isPoint ? 'msg-tra-high' : 'msg-tra-high-vacio') : (_vm.isPoint ? 'msg-tra' : 'msg-tra-vacio'),
    style: ({
      background: _vm.order.configuration.fundColor
    })
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-2 col-md-3",
    staticStyle: {
      "padding-left": "0px"
    }
  }, [_c('div', {
    staticClass: "msg-icono",
    style: ({
      color: _vm.order.configuration.iconFundColor
    })
  }, [_c('img', {
    staticClass: "msg-img",
    attrs: {
      "src": ("data:image/png;base64," + (_vm.order.configuration.icon))
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-10 col-md-9",
    staticStyle: {
      "padding-left": "0px",
      "padding-right": "0px"
    }
  }, [_c('div', {
    staticClass: "msg-title",
    style: ({
      color: _vm.order.configuration.higherTextColor
    })
  }, [_vm._v("Hola, " + _vm._s(_vm._f("firstLetter")(_vm.order.customerName)))]), _vm._v(" "), _c('p', {
    staticClass: "msg-p",
    style: ({
      color: _vm.order.configuration.lowerTextColor
    })
  }, [_vm._v("Tu pedido tiene un estado de " + _vm._s(_vm._f("minus")(_vm.order.statusDescription)))])])])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.mobile) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "padding-left": "0px"
    }
  }, [_c('div', {
    class: _vm.isPoint ? 'box-tra' : 'box-tra-sm'
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 img-back"
  }, [(_vm.showBack) ? _c('img', {
    staticStyle: {
      "padding-right": "5px"
    },
    attrs: {
      "src": "/static/img/svg/arrow-left.svg"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('hiddenTrack', false)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "label-bold-tra"
  }, [_vm._v("N° Pedido : " + _vm._s(_vm.order.customerOrderNumber == null ? _vm.order.orderNumber : _vm.order.customerOrderNumber))])])]), _vm._v(" "), _c('ul', {
    staticClass: "nav nav-tabs",
    attrs: {
      "role": "tablist"
    }
  }, [_c('li', {
    staticClass: "active"
  }, [_c('a', {
    staticClass: "a-tab",
    class: {
      active: _vm.isActive('track')
    },
    attrs: {
      "role": "tab",
      "data-toggle": "tab",
      "href": "#track",
      "aria-expanded": "true"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.setActive('track')
      }
    }
  }, [_vm._v("Tracking")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "a-tab",
    class: {
      active: _vm.isActive('info')
    },
    attrs: {
      "role": "tab",
      "data-toggle": "tab",
      "href": "#info"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.setActive('info')
      }
    }
  }, [_vm._v("Información del Pedido")])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content",
    attrs: {
      "id": "tabTrack"
    }
  }, [_c('div', {
    staticClass: "tab-pane fade active in",
    class: {
      'active': _vm.isActive('track')
    },
    attrs: {
      "id": "track"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "padding-left": "0px",
      "padding-right": "0px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "padding-left": "0px",
      "padding-right": "0px"
    }
  }, [_c('div', {
    staticClass: "nav-tra"
  }, [_vm._m(9), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "status",
    style: ({
      background: _vm.order.configuration.minTextFundColor == '' ? 'black' : _vm.order.configuration.minTextFundColor,
      color: _vm.order.configuration.minTextColor == '' ? 'white' : _vm.order.configuration.minTextColor
    })
  }, [_vm._v(_vm._s(_vm._f("firstLetter")(_vm.order.statusDescription)))])])]), _vm._v(" "), _c('div', {
    staticClass: "timeline"
  }, [_c('div', {
    staticClass: "outer"
  }, _vm._l((_vm.eventList), function(event, index) {
    return _c('div', {
      key: index,
      staticClass: "card-tl"
    }, [_c('div', {
      staticClass: "info"
    }, [_c('div', {
      staticClass: "card-lt-title"
    }, [_c('span', [_vm._v(_vm._s(_vm._f("capitalize")((event.reason == '' ? event.event : event.reason))))]), (event.existImage) ? _c('a', {
      staticClass: "arrow-tra",
      attrs: {
        "data-toggle": "collapse",
        "href": ("#col" + index)
      }
    }, [_c('i', {
      staticClass: "fa fa-chevron-down",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _vm._e()]), _vm._v(" "), _c('p', {
      staticClass: "p-tra"
    }, [_vm._v(_vm._s(_vm._f("formatDate")(event.eventDate, "LLL")) + "\n                                            "), _c('br'), _vm._v(" "), (event.location != '' && event.location.trim() != '-') ? _c('span', [_vm._v(_vm._s(_vm._f("firstLetter")(event.location)))]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "panel-collapse collapse",
      staticStyle: {
        "padding-bottom": "10px"
      },
      attrs: {
        "id": ("col" + index)
      }
    }, [(event.imageUrl1 != '') ? _c('img', {
      staticClass: "img-event",
      attrs: {
        "src": ("" + (event.imageUrl1))
      },
      on: {
        "click": function($event) {
          return _vm.modalFotos(event, 0)
        }
      }
    }) : _vm._e(), _vm._v(" "), (event.imageUrl2 != '') ? _c('img', {
      staticClass: "img-event",
      attrs: {
        "src": ("" + (event.imageUrl2))
      },
      on: {
        "click": function($event) {
          return _vm.modalFotos(event, 1)
        }
      }
    }) : _vm._e(), _vm._v(" "), (event.imageUrl3 != '') ? _c('img', {
      staticClass: "img-event",
      attrs: {
        "src": ("" + (event.imageUrl3))
      },
      on: {
        "click": function($event) {
          return _vm.modalFotos(event, 2)
        }
      }
    }) : _vm._e()])])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "help-tra"
  }, [_c('div', {
    staticClass: "row help-container"
  }, [_vm._m(10), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "help-title"
  }, [_vm._v(_vm._s(_vm.order.helpQuestion.trim() === '' ? '¿Necesitas ayuda con tu pedido?' : _vm.order.helpQuestion.trim()))]), _vm._v(" "), (_vm.order.contactType == 'TELF') ? _c('a', {
    staticClass: "help-p",
    attrs: {
      "href": ("tel:" + (_vm.order.contactValue))
    }
  }, [_vm._v("Contáctate con nosotros")]) : (_vm.order.contactType == 'MAIL') ? _c('a', {
    staticClass: "help-p",
    attrs: {
      "href": ("mailto:" + (_vm.order.contactValue))
    }
  }, [_vm._v("Contáctate con nosotros")]) : _c('a', {
    staticClass: "help-p",
    attrs: {
      "href": ("" + (_vm.order.contactValue)),
      "target": "_blank"
    }
  }, [_vm._v("Contáctate con nosotros")])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade",
    class: {
      'active': _vm.isActive('info')
    },
    attrs: {
      "id": "info"
    }
  }, [(_vm.isOrder) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-right"
  }, [_c('button', {
    staticClass: "btn btn-ora-blue",
    staticStyle: {
      "margin": "15px 0px"
    },
    on: {
      "click": function($event) {
        return _vm.showDetail()
      }
    }
  }, [_vm._v("Ver Detalle")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "padding-left": "0px",
      "padding-right": "0px"
    }
  }, [_c('div', {
    staticClass: "row data-space"
  }, [_vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7 col-md-6 col-lg-6 data-mob text-right"
  }, [_c('span', {
    staticClass: "data-field"
  }, [_vm._v(_vm._s(this.order.tracking))])])]), _vm._v(" "), _c('div', {
    staticClass: "row data-space"
  }, [_vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7 col-md-6 col-lg-6 data-mob text-right"
  }, [_c('span', {
    staticClass: "data-field"
  }, [_vm._v(_vm._s(_vm.order.customerOrderNumber == null ? _vm.order.orderNumber : _vm.order.customerOrderNumber))])])]), _vm._v(" "), _c('div', {
    staticClass: "row data-space"
  }, [_vm._m(13), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8 col-md-8 col-lg-8 data-mob text-right"
  }, [_c('span', {
    staticClass: "data-field"
  }, [_vm._v(_vm._s(_vm._f("firstLetter")(this.order.customerName)))])])]), _vm._v(" "), _c('div', {
    staticClass: "row data-space"
  }, [_vm._m(14), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7 col-md-6 col-lg-6 data-mob text-right"
  }, [_c('span', {
    staticClass: "data-field"
  }, [_vm._v(_vm._s(_vm.order.destinyContactPhone))])])]), _vm._v(" "), _c('div', {
    staticClass: "row data-space-border"
  }, [_vm._m(15), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7 col-md-6 col-lg-6 data-mob text-right"
  }, [_c('span', {
    staticClass: "data-field"
  }, [_vm._v(_vm._s(_vm._f("firstLetter")(this.order.sourceAddress)) + " "), _c('br'), _vm._v(" " + _vm._s(_vm._f("firstLetter")(this.order.sourceNameUbigeo)))])])]), _vm._v(" "), _c('div', {
    staticClass: "row data-space-border",
    staticStyle: {
      "border-top": "1px solid #DBDFE3",
      "margin-top": "10px"
    }
  }, [_vm._m(16), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7 data-mob text-right"
  }, [_c('span', {
    staticClass: "data-field"
  }, [_vm._v(_vm._s(_vm._f("firstLetter")(this.order.destinyAddress)) + " "), _c('br'), _vm._v(_vm._s(_vm._f("firstLetter")(this.order.destinyNameUbigeo)))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 text-center",
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('span', [_c('a', {
    staticClass: "a-tra",
    attrs: {
      "rel": "noopener noreferrer"
    },
    on: {
      "click": function($event) {
        _vm.showModalCopiar = true
      }
    }
  }, [_c('i', {
    ref: "atrack",
    staticClass: "fa fa-link a-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("Compartir Pedido")])])])])])])])])])]) : _vm._e()], 1) : (_vm.existe == 2 && !_vm.isOrder) ? _c('div', {
    staticClass: "msg-order"
  }, [(_vm.mobile) ? _c('div', [_c('img', {
    staticClass: "img-bus",
    attrs: {
      "src": "/static/img/buscar.png"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "title-bus"
  }, [_vm._v("\n            Hola,\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "subtitle-bus"
  }, [_vm._v("\n            Bienvenido a Dinet\n          ")]), _vm._v(" "), _c('p', {
    staticClass: "p-bus"
  }, [_vm._v("\n            Para ver el estado de su pedido necesitamos que se identifique:\n          ")]), _vm._v(" "), _c('p', {
    staticClass: "p-bus"
  }, [_vm._v("\n              Ingrese tus datos\n          ")]), _vm._v(" "), _c('form', {
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.search()
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fName),
      expression: "fName"
    }],
    staticClass: "form-control form-control-ora",
    class: {
      'is-invalid': _vm.submitted && !_vm.fName
    },
    attrs: {
      "placeholder": "Apellidos y/o Nombres"
    },
    domProps: {
      "value": (_vm.fName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.submitted && _vm.fName === ''),
      expression: "submitted && fName===''"
    }],
    staticClass: "invalid-feedback"
  }, [_vm._v("Los apellidos y/o nombres es requerido")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6 col-lg-6"
  }, [_c('button', {
    class: ['btn btn-ora', {
      'disabled': (_vm.submitted && _vm.fName === '')
    }],
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Continuar "), _c('i', {
    staticClass: "fa fa-angle-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])])]), _vm._v(" "), (!_vm.mobile) ? _c('div', [_c('img', {
    staticClass: "img-bus",
    attrs: {
      "src": "/static/img/buscar.png"
    }
  })]) : _vm._e()]) : (_vm.existe == 0) ? _c('div', {
    class: _vm.isOrder ? 'msg-nf-order' : 'msg-nf'
  }, [(_vm.mobile) ? _c('div', [_c('img', {
    staticClass: "img-nf",
    attrs: {
      "src": "/static/img/noencontrado.png"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "title-nf"
  }, [_vm._v("\n            No hemos podido encontrar tu pedido\n          ")]), _vm._v(" "), _c('p', {
    staticClass: "p-nf"
  }, [_vm._v("\n            Comunicate con nosotros para brindarte información de tu pedido\n          ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-ora",
    staticStyle: {
      "width": "200px"
    },
    on: {
      "click": function($event) {
        return _vm.contact()
      }
    }
  }, [_vm._v("Contáctate con nosotros")])]), _vm._v(" "), (!_vm.mobile) ? _c('div', [_c('img', {
    staticClass: "img-nf",
    attrs: {
      "src": "/static/img/noencontrado.png"
    }
  })]) : _vm._e()]) : _vm._e()])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticClass: "icon-tracking"
  }, [_c('i', {
    staticClass: "fa fa-clock-o",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "label-bold-tra"
  }, [_vm._v("Tracking")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticClass: "icon-tracking"
  }, [_c('img', {
    staticClass: "icon-tracking-img",
    attrs: {
      "src": "/static/img/svg/document.svg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "label-bold-tra"
  }, [_vm._v("Información del Pedido")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-md-6 col-lg-6"
  }, [_c('span', {
    staticClass: "data-icon"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/svg/document.svg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "data-title"
  }, [_vm._v("Tracking del Pedido")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-md-6 col-lg-6"
  }, [_c('span', {
    staticClass: "data-icon"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/svg/document.svg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "data-title"
  }, [_vm._v("Número del Pedido")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-md-6 col-lg-6"
  }, [_c('span', {
    staticClass: "data-icon"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/svg/user.svg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "data-title"
  }, [_vm._v("Cliente")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-md-6 col-lg-6"
  }, [_c('span', {
    staticClass: "data-icon"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/svg/phone.svg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "data-title"
  }, [_vm._v("Número de Celular")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-md-6 col-lg-6"
  }, [_c('span', {
    staticClass: "data-icon"
  }, [_c('img', {
    staticStyle: {
      "width": "16px"
    },
    attrs: {
      "src": "/static/img/svg/location.svg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "data-title"
  }, [_vm._v("Dirección de origen")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-md-6 col-lg-6"
  }, [_c('span', {
    staticClass: "data-icon"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/svg/destiny.svg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "data-title"
  }, [_vm._v("Dirección de entrega")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "help-icono"
  }, [_c('img', {
    staticClass: "help-img",
    attrs: {
      "src": "/static/img/help.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticClass: "label-bold-tra"
  }, [_vm._v("Estado")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "help-icono"
  }, [_c('img', {
    staticClass: "help-img",
    attrs: {
      "src": "/static/img/help.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-5 col-md-6 col-lg-6 data-mob"
  }, [_c('span', {
    staticClass: "data-icon"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/svg/document.svg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "data-title"
  }, [_vm._v("Tracking Pedido")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-5 col-md-6 col-lg-6 data-mob"
  }, [_c('span', {
    staticClass: "data-icon"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/svg/document.svg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "data-title"
  }, [_vm._v("Número Pedido")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-4 col-md-4 col-lg-4 data-mob"
  }, [_c('span', {
    staticClass: "data-icon"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/svg/user.svg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "data-title"
  }, [_vm._v("Cliente")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-5 col-md-6 col-lg-6 data-mob"
  }, [_c('span', {
    staticClass: "data-icon"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/svg/phone.svg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "data-title"
  }, [_vm._v("Número Celular")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-5 col-md-6 col-lg-6 data-mob"
  }, [_c('span', {
    staticClass: "data-icon"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/svg/location.svg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "data-title"
  }, [_vm._v("Dirección origen")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-5 data-mob"
  }, [_c('span', {
    staticClass: "data-icon"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/svg/destiny.svg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "data-title"
  }, [_vm._v("Dirección entrega")])])
}]}

/***/ }),
/* 531 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.router && _vm.router.name) ? _c('router-link', {
    staticClass: "treeview",
    attrs: {
      "tag": "li",
      "to": _vm.router
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    class: _vm.icon
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "width": "228px",
      "background": "#183764"
    }
  }, [_vm._v(_vm._s(_vm.name))])])]) : _c('li', {
    class: _vm.getType
  }, [_vm._v("\n  " + _vm._s(_vm.isHeader ? _vm.name : '') + "\n  "), (_vm.window.width < 770) ? _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    class: _vm.icon
  }), _vm._v(" "), _c('span', {
    staticClass: "side-sub"
  }, [_vm._v(_vm._s(_vm.name))])]) : _vm._e(), _vm._v(" "), (!_vm.isHeader && _vm.window.width > 770) ? _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    class: _vm.icon
  }), _vm._v(" "), _c('span', {
    staticClass: "side-sub"
  }, [_vm._v(_vm._s(_vm.name))])]) : _vm._e(), _vm._v(" "), (_vm.items.length > 0) ? _c('ul', {
    staticClass: "treeview-menu",
    staticStyle: {
      "width": "228px"
    },
    attrs: {
      "id": "treeMenu"
    }
  }, _vm._l((_vm.items), function(item, index) {
    return (item.router && item.router.name) ? _c('router-link', {
      key: index,
      attrs: {
        "tag": "li",
        "data": item,
        "to": item.router
      }
    }, [_c('a', [_c('i', {
      class: item.icon
    }), _vm._v(" " + _vm._s(item.name) + "\n      ")])]) : _c('li', [_c('a', [_c('i', {
      class: item.icon
    }), _vm._v(" " + _vm._s(item.name) + "\n      ")])])
  }), 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 532 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "box box-success no-padding"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('chart-line', {
    attrs: {
      "chart-data": _vm.chartData,
      "height": 240
    }
  })], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "center-block",
    staticStyle: {
      "width": "300px"
    }
  }, [_c('div', {
    staticClass: "pull-left text-center",
    staticStyle: {
      "width": "150px",
      "border-right": "1px solid #eee"
    }
  }, [_c('img', {
    staticStyle: {
      "vertical-align": "text-bottom"
    },
    attrs: {
      "src": "/static/img/icons/ic_delivery_system@3x.png",
      "alt": "Ingresadas",
      "height": "20",
      "width": "20"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "span-value",
    style: ({
      color: this.colorEntered
    })
  }, [_vm._v("\n                    " + _vm._s(_vm.totalGuidesTransit)), _c('span', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v(" " + _vm._s(this.fetchData.minimumStockUnit))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "span-unit"
  }, [_vm._v("Guías de Remisión")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "span-status"
  }, [_vm._v("en Tránsito")])]), _vm._v(" "), _c('div', {
    staticClass: "pull-right text-center",
    staticStyle: {
      "width": "150px"
    }
  }, [_c('img', {
    staticStyle: {
      "vertical-align": "text-bottom"
    },
    attrs: {
      "src": "/static/img/icons/ic_delivery_shipped@3x.png",
      "alt": "Ingresadas",
      "height": "20",
      "width": "22"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "span-value",
    style: ({
      color: this.colorDelivered
    })
  }, [_vm._v("\n                    " + _vm._s(_vm.totalGuidesDelivered)), _c('span', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v(" " + _vm._s(this.fetchData.minimumStockUnit))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "span-unit"
  }, [_vm._v("Guías de Remisión")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "span-status"
  }, [_vm._v("Entregadas")])])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title box-title-sub"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/icons/entregadas.png"
    }
  }), _vm._v(" Transporte")])])
}]}

/***/ }),
/* 533 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title title",
    staticStyle: {
      "color": "#959FA9"
    }
  }, [_vm._v("Inventario ")]), _vm._v(" "), _c('h3', {
    staticClass: "box-title title"
  }, [_c('span', {
    staticClass: "table-btn-icon"
  }), _vm._v(" " + _vm._s('ERI ' + this.accountName + ' - ' + this.periodStr))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "btn btn-success pull-right exportar",
    on: {
      "click": _vm.exportData
    }
  }, [_vm._v("Exportar "), _c('img', {
    attrs: {
      "src": "/static/img/arrow-logo.png"
    }
  })]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-success pull-right",
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "to": {
        name: 'InventoryEntry',
        params: {
          accountCode: this.$route.params.accountCode
        }
      },
      "tag": "button"
    }
  }, [_vm._v("Registrar ERI")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "box box-success"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('v-eri', {
    attrs: {
      "id": "eriCyclical",
      "title": "ERI Cíclico",
      "unit": "Cant",
      "period": this.period,
      "data": this.eriCyclicalData
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "box box-success"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('v-eri', {
    attrs: {
      "id": "eriLocation",
      "title": "ERI Ubicaciones",
      "unit": "Ubicaciones",
      "period": this.period,
      "data": this.eriLocationData
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "box box-success"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('v-eri', {
    attrs: {
      "id": "eriUnit",
      "title": "ERI Unidades",
      "unit": "Unidades",
      "period": this.period,
      "data": this.eriUnitData
    }
  })], 1)])])])])
},staticRenderFns: []}

/***/ }),
/* 534 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    ref: "flyaway"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),
/* 535 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box box-success"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "filterContainer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group",
    attrs: {
      "id": "divAccountSelect"
    }
  }, [_c('label', [_vm._v("Cuenta")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "value": this.selectedAccount,
      "selectLabel": "",
      "selectedLabel": "",
      "deselectLabel": "",
      "track-by": "name",
      "placeholder": this.selectedAccount.name,
      "allow-empty": false,
      "label": "name",
      "options": this.optionsAccount
    },
    on: {
      "input": _vm.onAccountSelect
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("\r\n                  No se encontraron resultados\r\n                ")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 form-interspace"
  }, [_c('div', {
    staticClass: "form-group pull-left",
    staticStyle: {
      "padding-top": "25px"
    }
  }, [_c('router-link', {
    staticClass: "btn btn-success",
    attrs: {
      "to": {
        name: 'DispatchAppointmentsUpload',
        params: {
          accountCode: this.selectedAccount.code
        }
      },
      "tag": "button"
    }
  }, [_vm._v("Nuevo Documento")])], 1)])])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12",
    attrs: {
      "id": "dispatchTable"
    }
  }, [_c('vuetable', {
    ref: "vuetable",
    attrs: {
      "id": "dispatchTable",
      "api-mode": false,
      "fields": _vm.tableFields,
      "data": _vm.tableData,
      "css": _vm.tableCSS.table,
      "noDataTemplate": "No se encontraron resultados"
    },
    on: {
      "vuetable:loading": _vm.onLoading,
      "vuetable:loaded": _vm.onLoaded
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title title"
  }, [_vm._v("Citas de Despacho")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header title-boreder"
  }, [_c('h3', {
    staticClass: "box-title box-title-sub"
  }, [_c('img', {
    staticClass: "icon-space",
    staticStyle: {
      "padding-bottom": "7px"
    },
    attrs: {
      "src": "/static/img/icons/search.png"
    }
  }), _vm._v(" Buscar Cita")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('br')])])
}]}

/***/ }),
/* 536 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-success"
  }, [_c('div', {
    staticClass: "box-header title-boreder"
  }, [_vm._m(0), _vm._v(" "), _c('i', {
    staticClass: "fa fa-caret-right"
  }), _vm._v(" "), _c('h3', {
    staticClass: "box-title box-title-sub",
    staticStyle: {
      "padding-left": "5px"
    },
    attrs: {
      "to": {
        name: 'InventoryDetail',
        params: {
          accountCode: this.selectedAccount.code
        }
      }
    }
  }, [_vm._v(" " + _vm._s(this.selectedAccount.name))]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-caret-right"
  }), _vm._v(" "), _c('h3', {
    staticClass: "box-title box-title-sub",
    staticStyle: {
      "padding-left": "5px"
    }
  }, [_vm._v(" Registro")])]), _vm._v(" "), _c('form', {
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.handleSubmit.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "filterContainer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group",
    attrs: {
      "id": "divAccountSelect"
    }
  }, [_c('label', [_vm._v("Cuenta")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "value": this.selectedAccount,
      "selectLabel": "Presione enter para seleccionar",
      "selectedLabel": "Seleccionado",
      "deselectLabel": "Seleccionado",
      "track-by": "name",
      "placeholder": this.selectedAccount.name,
      "allow-empty": false,
      "label": "name",
      "options": this.optionsAccount
    },
    on: {
      "input": _vm.onAccountSelect
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("\n                No se encontraron resultados\n              ")])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding-top": "25px"
    }
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "ddlType"
    }
  }, [_vm._v("Tipo de Conteo")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedEriType),
      expression: "selectedEriType"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "ddlType"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedEriType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((this.optionsEriType), function(type) {
    return _c('option', {
      key: type.code,
      domProps: {
        "value": type.code
      }
    }, [_vm._v("\n                " + _vm._s(type.name) + "\n              ")])
  }), 0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.submitted && !_vm.selectedEriType),
      expression: "submitted && !selectedEriType"
    }],
    staticClass: "invalid-feedback"
  }, [_vm._v("Tipo Requerido")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "dtDate"
    }
  }, [_vm._v("Fecha")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "dtDate",
      "type": "text",
      "name": "dtpFecha",
      "disabled": ""
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.submitted && !_vm.selectedDate),
      expression: "submitted && !selectedDate"
    }],
    staticClass: "invalid-feedback"
  }, [_vm._v("Fecha Requerida")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.submitted && _vm.selectedDate !== _vm.todayDate),
      expression: "submitted && selectedDate !== todayDate"
    }],
    staticClass: "invalid-feedback"
  }, [_vm._v("Fecha Incorrecta")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "numSkuSquare"
    }
  }, [_vm._v("SKU Cantidad Cuadrada")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.squaredSkuCount),
      expression: "squaredSkuCount"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "numSkuSquare",
      "type": "number",
      "min": "0"
    },
    domProps: {
      "value": (_vm.squaredSkuCount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.squaredSkuCount = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.submitted && _vm.squaredSkuCount <= 0),
      expression: "submitted && squaredSkuCount <= 0"
    }],
    staticClass: "invalid-feedback"
  }, [_vm._v("Cant. Cuadrada Requerida")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "numSkuInventory"
    }
  }, [_vm._v("SKU Cantidad Inventariada")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inventoriedSkuCount),
      expression: "inventoriedSkuCount"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "numSkuInventory",
      "type": "number",
      "min": "0"
    },
    domProps: {
      "value": (_vm.inventoriedSkuCount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inventoriedSkuCount = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.submitted && _vm.inventoriedSkuCount <= 0),
      expression: "submitted && inventoriedSkuCount <= 0"
    }],
    staticClass: "invalid-feedback"
  }, [_vm._v("Cant. Inventariada Requerida")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('input', {
    class: ['btn btn-success', {
      'disabled': (_vm.submitted && !_vm.selectedAccount && !_vm.selectedEriType && !_vm.selectedDate && !_vm.squaredSkuCount && !_vm.inventoriedSkuCount)
    }],
    attrs: {
      "type": "submit",
      "value": "Registrar"
    }
  })])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "box-title box-title-sub"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/icons/almacen-verde.png"
    }
  }), _vm._v(" Reglas")])
}]}

/***/ }),
/* 537 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box box-success"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "filterContainer"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "padding-bottom": "20px"
    }
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group",
    attrs: {
      "id": "divAccountSelect"
    }
  }, [_c('label', [_vm._v("Cuenta")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "value": this.selectedAccount,
      "selectLabel": "",
      "selectedLabel": "",
      "deselectLabel": "",
      "track-by": "name",
      "placeholder": this.selectedAccount.name,
      "allow-empty": false,
      "label": "name",
      "options": this.optionsAccount
    },
    on: {
      "input": _vm.onAccountSelect
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("No se encontraron resultados")])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "ddlLine"
    }
  }, [_vm._v("Línea")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedLine),
      expression: "selectedLine"
    }],
    staticClass: "form-control minimal",
    attrs: {
      "id": "ddlLine"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedLine = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((this.optionsLine), function(item) {
    return _c('option', {
      key: item.code,
      domProps: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 form-interspace"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "productCode"
    }
  }, [_vm._v("Producto")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.productCode),
      expression: "productCode"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "productCode",
      "type": "text"
    },
    domProps: {
      "value": (_vm.productCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.productCode = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.submitted && _vm.productCode === ''),
      expression: "submitted && productCode === ''"
    }],
    staticClass: "invalid-feedback"
  }, [_vm._v("Producto Requerido")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 form-interspace"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "ddlStatus"
    }
  }, [_vm._v("Estado")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedStatus),
      expression: "selectedStatus"
    }],
    staticClass: "form-control minimal",
    attrs: {
      "id": "ddlStatus"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedStatus = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((this.optionsStatus), function(item) {
    return _c('option', {
      key: item.code,
      domProps: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 form-interspace"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "ddlMode"
    }
  }, [_vm._v("Modo")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedMode),
      expression: "selectedMode"
    }],
    staticClass: "form-control minimal",
    attrs: {
      "id": "ddlMode"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedMode = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((this.optionsMode), function(item) {
    return _c('option', {
      key: item.code,
      domProps: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 form-interspace"
  }, [_c('div', {
    staticClass: "form-group",
    staticStyle: {
      "padding-top": "25px"
    }
  }, [_c('button', {
    class: ['btn btn-success btnAction', {
      'disabled': (_vm.submitted && !_vm.productCode)
    }],
    on: {
      "click": function($event) {
        return _vm.search()
      }
    }
  }, [_vm._v(" Buscar")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-success"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12",
    attrs: {
      "id": "productsTable"
    }
  }, [_c('vuetable', {
    key: _vm.tableKey,
    ref: "vuetable",
    attrs: {
      "id": "productsTable",
      "api-mode": false,
      "fields": _vm.tableFields,
      "css": _vm.tableCSS.table,
      "row-class": _vm.onRowClass,
      "noDataTemplate": "No se encontraron resultados",
      "data": _vm.tableData,
      "data-manager": _vm.dataManager,
      "pagination-path": "pagination"
    },
    on: {
      "vuetable:loading": _vm.onLoading,
      "vuetable:loaded": _vm.onLoaded,
      "vuetable:pagination-data": _vm.onPaginationData
    },
    scopedSlots: _vm._u([{
      key: "productCode",
      fn: function(props) {
        return [_c('div', {
          attrs: {
            "id": "Código"
          }
        }, [_c('span', [_c('strong', [_vm._v(_vm._s(props.rowData.productCode))])])])]
      }
    }, {
      key: "productDescription",
      fn: function(props) {
        return [_c('div', {
          attrs: {
            "id": "Descripción"
          }
        }, [_c('span', [_vm._v(_vm._s(props.rowData.productDescription))])])]
      }
    }, {
      key: "productUnits",
      fn: function(props) {
        return [_c('div', {
          attrs: {
            "id": "Cantidad"
          }
        }, [_c('span', [_vm._v(_vm._s(props.rowData.productUnits))])])]
      }
    }, {
      key: "productStatus",
      fn: function(props) {
        return [_c('div', {
          attrs: {
            "id": "Estado"
          }
        }, [_c('span', [_vm._v(_vm._s(props.rowData.productStatus))])])]
      }
    }, {
      key: "productLot",
      fn: function(props) {
        return [_c('div', {
          attrs: {
            "id": "Lote"
          }
        }, [_c('span', [_vm._v(_vm._s(props.rowData.productLot))])])]
      }
    }, {
      key: "productExpireDate",
      fn: function(props) {
        return [_c('div', {
          attrs: {
            "id": "FechaExp"
          }
        }, [_c('span', [_vm._v(_vm._s(_vm._f("formatDate")(props.rowData.productExpireDate, "DD/MM/YYYY")))])])]
      }
    }, {
      key: "productLine",
      fn: function(props) {
        return [_c('div', {
          attrs: {
            "id": "Lìnea"
          }
        }, [_c('span', [_vm._v(_vm._s(props.rowData.productLine))])])]
      }
    }, {
      key: "productModeCode",
      fn: function(props) {
        return [_c('div', {
          attrs: {
            "id": "Modo"
          }
        }, [_c('span', [_vm._v(_vm._s(props.rowData.productModeCode))])])]
      }
    }])
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_vm._v("\r\n           \r\n          "), (this.paginationData && _vm.paginationData.total > 0) ? [_c('strong', [_vm._v("\r\n            Mostrando producto " + _vm._s(this.paginationData.from) + " a " + _vm._s(this.paginationData.to) + " de " + _vm._s(this.paginationData.total) + " en Total\r\n            ")])] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('vuetable-pagination', {
    ref: "pagination",
    attrs: {
      "css": _vm.tableCSS.pagination
    },
    on: {
      "vuetable-pagination:change-page": _vm.onChangePage
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title title"
  }, [_vm._v("Productos Perecibles")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header title-boreder"
  }, [_c('h3', {
    staticClass: "box-title box-title-sub"
  }, [_c('img', {
    staticClass: "icon-space",
    staticStyle: {
      "padding-bottom": "7px"
    },
    attrs: {
      "src": "/static/img/icons/search.png"
    }
  }), _vm._v(" Buscar Productos")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header title-boreder"
  }, [_c('h3', {
    staticClass: "box-title box-title-sub"
  }, [_c('img', {
    staticClass: "icon-space",
    staticStyle: {
      "padding-bottom": "4px"
    },
    attrs: {
      "src": "/static/img/icons/result.png"
    }
  }), _vm._v(" Resultado de busqueda")])])
}]}

/***/ }),
/* 538 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box box-success"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "filterContainer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group",
    attrs: {
      "id": "divAccountSelect"
    }
  }, [_c('label', [_vm._v("Cuenta")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "value": this.selectedAccount,
      "selectLabel": "",
      "selectedLabel": "",
      "deselectLabel": "",
      "track-by": "name",
      "placeholder": this.selectedAccount.name,
      "allow-empty": false,
      "label": "name",
      "options": this.optionsAccount
    },
    on: {
      "input": _vm.onAccountSelect
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("\r\n                  No se encontraron resultados\r\n                ")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 form-interspace"
  }, [_c('div', {
    staticClass: "form-group pull-left",
    staticStyle: {
      "padding-top": "25px"
    }
  }, [_c('router-link', {
    staticClass: "btn btn-success",
    attrs: {
      "to": {
        name: 'ReceptionAppointmentsUpload',
        params: {
          accountCode: this.selectedAccount.code
        }
      },
      "tag": "button"
    }
  }, [_vm._v("Nuevo Documento")])], 1)])])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12",
    attrs: {
      "id": "receptionTable"
    }
  }, [_c('vuetable', {
    ref: "vuetable",
    attrs: {
      "id": "receptionTable",
      "api-mode": false,
      "fields": _vm.tableFields,
      "data": _vm.tableData,
      "css": _vm.tableCSS.table,
      "noDataTemplate": "No se encontraron resultados"
    },
    on: {
      "vuetable:loading": _vm.onLoading,
      "vuetable:loaded": _vm.onLoaded
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title title"
  }, [_vm._v("Citas de Recepción")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header title-boreder"
  }, [_c('h3', {
    staticClass: "box-title box-title-sub"
  }, [_c('img', {
    staticClass: "icon-space",
    staticStyle: {
      "padding-bottom": "7px"
    },
    attrs: {
      "src": "/static/img/icons/search.png"
    }
  }), _vm._v(" Buscar Cita")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('br')])])
}]}

/***/ }),
/* 539 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box box-success"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', [_c('div', {}, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group",
    attrs: {
      "id": "divDashAccountSelect"
    }
  }, [_c('label', [_vm._v("Cuenta")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "value": this.dashboardFilter.client,
      "selectLabel": "",
      "selectedLabel": "",
      "deselectLabel": "",
      "track-by": "name",
      "placeholder": this.dashboardFilter.client.name,
      "allow-empty": false,
      "label": "name",
      "options": _vm.optionsAccount
    },
    on: {
      "input": _vm.onAccountSelect
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("\n                    No se encontraron resultados\n                  ")])])], 1)]), _vm._v(" "), (_vm.window.width > 950) ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Período")]), _vm._v(" "), _c('div', {
    staticClass: "btn-group",
    attrs: {
      "id": "divModeButtons"
    }
  }, [_c('button', {
    class: _vm.getClass('today'),
    on: {
      "click": function($event) {
        return _vm.onModeSelect('today')
      }
    }
  }, [_vm._v("Hoy")]), _vm._v(" "), _c('button', {
    class: _vm.getClass('week'),
    on: {
      "click": function($event) {
        return _vm.onModeSelect('week')
      }
    }
  }, [_c('span', {
    staticClass: "segundo-btn"
  }, [_vm._v("Semana")])]), _vm._v(" "), _c('button', {
    class: _vm.getClass('month'),
    on: {
      "click": function($event) {
        return _vm.onModeSelect('month')
      }
    }
  }, [_vm._v("Mes")]), _vm._v(" "), _c('button', {
    class: _vm.getClass('date'),
    on: {
      "click": function($event) {
        return _vm.onModeSelect('date')
      }
    }
  }, [_vm._v("Fecha")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    style: (this.dashboardFilter.mode === 'date' ? 'display:block;' : 'display:none;')
  }, [_c('label', {
    attrs: {
      "for": "dtDocEndDate"
    }
  }, [_vm._v("Desde - Hasta")]), _vm._v(" "), _vm._m(1)])])])]), _vm._v(" "), (_vm.window.width < 950) ? _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Período")]), _vm._v(" "), _c('div', {
    staticClass: "btn-group",
    attrs: {
      "id": "divModeButtons"
    }
  }, [_c('button', {
    class: _vm.getClass('today'),
    on: {
      "click": function($event) {
        return _vm.onModeSelect('today')
      }
    }
  }, [_vm._v("Hoy")]), _vm._v(" "), _c('button', {
    class: _vm.getClass('week'),
    on: {
      "click": function($event) {
        return _vm.onModeSelect('week')
      }
    }
  }, [_c('span', {
    staticClass: "segundo-btn"
  }, [_vm._v("Semana")])]), _vm._v(" "), _c('button', {
    class: _vm.getClass('month'),
    on: {
      "click": function($event) {
        return _vm.onModeSelect('month')
      }
    }
  }, [_vm._v("Mes")]), _vm._v(" "), _c('button', {
    class: _vm.getClass('date'),
    on: {
      "click": function($event) {
        return _vm.onModeSelect('date')
      }
    }
  }, [_vm._v("Fecha")])])])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title title"
  }, [_vm._v("Monitoreo de Servicio")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "icon-calendar"
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "dtDateRange",
      "mode": "text"
    }
  })])])
}]}

/***/ }),
/* 540 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "skin-green sidebar-mini"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('va-navibar'), _vm._v(" "), _c('va-slider'), _vm._v(" "), _c('va-content-wrap', {
    staticStyle: {
      "background-color": "#F6F6F6"
    }
  }), _vm._v(" "), _c('Modal')], 1)])
},staticRenderFns: []}

/***/ }),
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./dashboardFilter.js": 281,
	"./index.js": 72,
	"./inventory.js": 282,
	"./monitoring.js": 283,
	"./orders.js": 284,
	"./product.js": 285,
	"./tracking.js": 286,
	"./user.js": 287
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 594;

/***/ })
],[265]);


// WEBPACK FOOTER //
// static/js/app.306b3b2ef9bf93598d71.js